(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var Backbone;

Backbone = require('backbone');

Backbone.$ = window.$;

window.Backbone = require("backbone");



},{"backbone":56}],2:[function(require,module,exports){
require('$.slider');



},{"$.slider":5}],3:[function(require,module,exports){
(function (global){
(typeof _ !== "undefined" && _ !== null ? _ : (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null)).mixin({
  omitUndefined: function(obj) {
    var filteredObj, key, value;
    filteredObj = {};
    for (key in obj) {
      value = obj[key];
      if (value != null) {
        filteredObj[key] = value;
      }
    }
    return filteredObj;
  },
  indexBy: function(list, iterator) {
    var listItem, returnedHash, _i, _len, _ref;
    returnedHash = {};
    _ref = list || [];
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      listItem = _ref[_i];
      returnedHash[listItem[iterator]] = listItem;
    }
    return returnedHash;
  },
  hasSubstring: function(str, subString) {
    return typeof str === "string" && str.indexOf(subString) >= 0;
  }
});


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],4:[function(require,module,exports){
var BackToTop, BrowseApplication, BrowsePageEvents, ThirdPartyAdsView, TrackingHelper;

require('../common/underscore_mixins');

require('../common/backbone_init');

require('../common/jquery_plugin_init');

BrowseApplication = require('../../modules/browse/frontend/application');

TrackingHelper = require('../../modules/browse/frontend/helpers/tracking');

BackToTop = require('../../modules/browse/frontend/views/back_to_top');

ThirdPartyAdsView = require('../../modules/third_party_ads/frontend/views/third_party_ads');

BrowsePageEvents = require('../../modules/browse/frontend/page_events');

Groupon.BrowseTracking = new TrackingHelper();

$(document).ready(function() {
  var _ref, _ref1, _ref2;
  $('body').removeClass('no-js');
  Groupon.browseApp = new BrowseApplication({
    isLeftBarVisible: !!Groupon.RefinementBar.isLeftBarVisible,
    isOnNoDealsPage: !!Groupon.onNoDealsPage,
    goodsBrowsePageLayoutValue: Groupon.goodsBrowsePageLayoutValue,
    inNewHomepage: !!((_ref = Groupon.enabledFeatures) != null ? _ref.inNewHomepage : void 0),
    carouselConfig: !!((_ref1 = Groupon.enabledFeatures) != null ? _ref1.inNewHomepage : void 0) ? Groupon.carouselConfig : void 0,
    homeWidgetPreview: !!((_ref2 = Groupon.enabledFeatures) != null ? _ref2.inNewHomepage : void 0) ? Groupon.homeWidgetPreview : void 0,
    showFreeShippingModal: !!Groupon.showFreeShippingModal,
    selectedCategory: Groupon.Categories.selectedCategory,
    isSeoEnabled: !!Groupon.isSeoEnabled,
    isVanityUrl: !!Groupon.isVanityUrl,
    inRAPI: !!Groupon.inRAPI,
    collection: Groupon.collection,
    showClearanceWidget: !!Groupon.showClearanceWidget,
    dealTileAds: Groupon.dealTileAds,
    useNewGAPIConnector: Groupon.useNewGAPIConnector
  });
  Groupon.browseApp.startApp();
  return BackToTop.render();
});

$(window).load(function() {
  var _ref;
  Groupon.BrowseTracking.pageReady();
  BrowsePageEvents.trigger('pageReady');
  if ((_ref = Groupon.browseApp.dealTileAds) != null ? _ref.inDealTileAds : void 0) {
    return ThirdPartyAdsView.hideDealTileIfAdBlocked();
  }
});



},{"../../modules/browse/frontend/application":14,"../../modules/browse/frontend/helpers/tracking":19,"../../modules/browse/frontend/page_events":22,"../../modules/browse/frontend/views/back_to_top":25,"../../modules/third_party_ads/frontend/views/third_party_ads":55,"../common/backbone_init":1,"../common/jquery_plugin_init":2,"../common/underscore_mixins":3}],5:[function(require,module,exports){
(function (global){

; require("/var/groupon/home/michchen/napistrano/build/1473902691243-29884/perf-2016.09.15_01.04/goods/core/frontend/vendor_modules/jquery.widget.js");
; var __browserify_shim_require__=require;(function browserifyShim(module, define, require) {
/*! jQuery UI - v1.11.0 - 2014-06-26
* http://jqueryui.com
* Includes: core.js, widget.js, mouse.js, position.js, accordion.js, autocomplete.js, button.js, datepicker.js, dialog.js, draggable.js, droppable.js, effect.js, effect-blind.js, effect-bounce.js, effect-clip.js, effect-drop.js, effect-explode.js, effect-fade.js, effect-fold.js, effect-highlight.js, effect-puff.js, effect-pulsate.js, effect-scale.js, effect-shake.js, effect-size.js, effect-slide.js, effect-transfer.js, menu.js, progressbar.js, resizable.js, selectable.js, selectmenu.js, slider.js, sortable.js, spinner.js, tabs.js, tooltip.js
* Copyright 2014 jQuery Foundation and other contributors; Licensed MIT */

(function( factory ) {
  if ( typeof define === "function" && define.amd ) {

    // AMD. Register as an anonymous module.
    define([ "jquery" ], factory );
  } else {

    // Browser globals
    factory( jQuery );
  }
}(function( $ ) {

/*!
 * jQuery UI Widget 1.11.0
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/jQuery.widget/
 */


var widget_uuid = 0,
  widget_slice = Array.prototype.slice;

$.cleanData = (function( orig ) {
  return function( elems ) {
    for ( var i = 0, elem; (elem = elems[i]) != null; i++ ) {
      try {
        $( elem ).triggerHandler( "remove" );
      // http://bugs.jquery.com/ticket/8235
      } catch( e ) {}
    }
    orig( elems );
  };
})( $.cleanData );

$.widget2 = function( name, base, prototype ) {
  var fullName, existingConstructor, constructor, basePrototype,
    // proxiedPrototype allows the provided prototype to remain unmodified
    // so that it can be used as a mixin for multiple widgets (#8876)
    proxiedPrototype = {},
    namespace = name.split( "." )[ 0 ];

  name = name.split( "." )[ 1 ];
  fullName = namespace + "-" + name;

  if ( !prototype ) {
    prototype = base;
    base = $.Widget2;
  }

  // create selector for plugin
  $.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
    return !!$.data( elem, fullName );
  };

  $[ namespace ] = $[ namespace ] || {};
  existingConstructor = $[ namespace ][ name ];
  constructor = $[ namespace ][ name ] = function( options, element ) {
    // allow instantiation without "new" keyword
    if ( !this._createWidget ) {
      return new constructor( options, element );
    }

    // allow instantiation without initializing for simple inheritance
    // must use "new" keyword (the code above always passes args)
    if ( arguments.length ) {
      this._createWidget( options, element );
    }
  };
  // extend with the existing constructor to carry over any static properties
  $.extend( constructor, existingConstructor, {
    version: prototype.version,
    // copy the object used to create the prototype in case we need to
    // redefine the widget later
    _proto: $.extend( {}, prototype ),
    // track widgets that inherit from this widget in case this widget is
    // redefined after a widget inherits from it
    _childConstructors: []
  });

  basePrototype = new base();
  // we need to make the options hash a property directly on the new instance
  // otherwise we'll modify the options hash on the prototype that we're
  // inheriting from
  basePrototype.options = $.widget2.extend( {}, basePrototype.options );
  $.each( prototype, function( prop, value ) {
    if ( !$.isFunction( value ) ) {
      proxiedPrototype[ prop ] = value;
      return;
    }
    proxiedPrototype[ prop ] = (function() {
      var _super = function() {
          return base.prototype[ prop ].apply( this, arguments );
        },
        _superApply = function( args ) {
          return base.prototype[ prop ].apply( this, args );
        };
      return function() {
        var __super = this._super,
          __superApply = this._superApply,
          returnValue;

        this._super = _super;
        this._superApply = _superApply;

        returnValue = value.apply( this, arguments );

        this._super = __super;
        this._superApply = __superApply;

        return returnValue;
      };
    })();
  });
  constructor.prototype = $.widget2.extend( basePrototype, {
    // TODO: remove support for widgetEventPrefix
    // always use the name + a colon as the prefix, e.g., draggable:start
    // don't prefix for widgets that aren't DOM-based
    widgetEventPrefix: existingConstructor ? (basePrototype.widgetEventPrefix || name) : name
  }, proxiedPrototype, {
    constructor: constructor,
    namespace: namespace,
    widgetName: name,
    widgetFullName: fullName
  });

  // If this widget is being redefined then we need to find all widgets that
  // are inheriting from it and redefine all of them so that they inherit from
  // the new version of this widget. We're essentially trying to replace one
  // level in the prototype chain.
  if ( existingConstructor ) {
    $.each( existingConstructor._childConstructors, function( i, child ) {
      var childPrototype = child.prototype;

      // redefine the child widget using the same prototype that was
      // originally used, but inherit from the new version of the base
      $.widget2( childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto );
    });
    // remove the list of existing child constructors from the old constructor
    // so the old child constructors can be garbage collected
    delete existingConstructor._childConstructors;
  } else {
    base._childConstructors.push( constructor );
  }

  $.widget2.bridge( name, constructor );

  return constructor;
};

$.widget2.extend = function( target ) {
  var input = widget_slice.call( arguments, 1 ),
    inputIndex = 0,
    inputLength = input.length,
    key,
    value;
  for ( ; inputIndex < inputLength; inputIndex++ ) {
    for ( key in input[ inputIndex ] ) {
      value = input[ inputIndex ][ key ];
      if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
        // Clone objects
        if ( $.isPlainObject( value ) ) {
          target[ key ] = $.isPlainObject( target[ key ] ) ?
            $.widget2.extend( {}, target[ key ], value ) :
            // Don't extend strings, arrays, etc. with objects
            $.widget2.extend( {}, value );
        // Copy everything else by reference
        } else {
          target[ key ] = value;
        }
      }
    }
  }
  return target;
};

$.widget2.bridge = function( name, object ) {
  var fullName = object.prototype.widgetFullName || name;
  $.fn[ name ] = function( options ) {
    var isMethodCall = typeof options === "string",
      args = widget_slice.call( arguments, 1 ),
      returnValue = this;

    // allow multiple hashes to be passed on init
    options = !isMethodCall && args.length ?
      $.widget2.extend.apply( null, [ options ].concat(args) ) :
      options;

    if ( isMethodCall ) {
      this.each(function() {
        var methodValue,
          instance = $.data( this, fullName );
        if ( options === "instance" ) {
          returnValue = instance;
          return false;
        }
        if ( !instance ) {
          return $.error( "cannot call methods on " + name + " prior to initialization; " +
            "attempted to call method '" + options + "'" );
        }
        if ( !$.isFunction( instance[options] ) || options.charAt( 0 ) === "_" ) {
          return $.error( "no such method '" + options + "' for " + name + " widget instance" );
        }
        methodValue = instance[ options ].apply( instance, args );
        if ( methodValue !== instance && methodValue !== undefined ) {
          returnValue = methodValue && methodValue.jquery ?
            returnValue.pushStack( methodValue.get() ) :
            methodValue;
          return false;
        }
      });
    } else {
      this.each(function() {
        var instance = $.data( this, fullName );
        if ( instance ) {
          instance.option( options || {} );
          if ( instance._init ) {
            instance._init();
          }
        } else {
          $.data( this, fullName, new object( options, this ) );
        }
      });
    }

    return returnValue;
  };
};

$.Widget2 = function( /* options, element */ ) {};
$.Widget2._childConstructors = [];

$.Widget2.prototype = {
  widgetName: "widget",
  widgetEventPrefix: "",
  defaultElement: "<div>",
  options: {
    disabled: false,

    // callbacks
    create: null
  },
  _createWidget: function( options, element ) {
    element = $( element || this.defaultElement || this )[ 0 ];
    this.element = $( element );
    this.uuid = widget_uuid++;
    this.eventNamespace = "." + this.widgetName + this.uuid;
    this.options = $.widget2.extend( {},
      this.options,
      this._getCreateOptions(),
      options );

    this.bindings = $();
    this.hoverable = $();
    this.focusable = $();

    if ( element !== this ) {
      $.data( element, this.widgetFullName, this );
      this._on( true, this.element, {
        remove: function( event ) {
          if ( event.target === element ) {
            this.destroy();
          }
        }
      });
      this.document = $( element.style ?
        // element within the document
        element.ownerDocument :
        // element is window or document
        element.document || element );
      this.window = $( this.document[0].defaultView || this.document[0].parentWindow );
    }

    this._create();
    this._trigger( "create", null, this._getCreateEventData() );
    this._init();
  },
  _getCreateOptions: $.noop,
  _getCreateEventData: $.noop,
  _create: $.noop,
  _init: $.noop,

  destroy: function() {
    this._destroy();
    // we can probably remove the unbind calls in 2.0
    // all event bindings should go through this._on()
    this.element
      .unbind( this.eventNamespace )
      .removeData( this.widgetFullName )
      // support: jquery <1.6.3
      // http://bugs.jquery.com/ticket/9413
      .removeData( $.camelCase( this.widgetFullName ) );
    this.widget()
      .unbind( this.eventNamespace )
      .removeAttr( "aria-disabled" )
      .removeClass(
        this.widgetFullName + "-disabled " +
        "ui-state-disabled" );

    // clean up events and states
    this.bindings.unbind( this.eventNamespace );
    this.hoverable.removeClass( "ui-state-hover" );
    this.focusable.removeClass( "ui-state-focus" );
  },
  _destroy: $.noop,

  widget: function() {
    return this.element;
  },

  option: function( key, value ) {
    var options = key,
      parts,
      curOption,
      i;

    if ( arguments.length === 0 ) {
      // don't return a reference to the internal hash
      return $.widget2.extend( {}, this.options );
    }

    if ( typeof key === "string" ) {
      // handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
      options = {};
      parts = key.split( "." );
      key = parts.shift();
      if ( parts.length ) {
        curOption = options[ key ] = $.widget2.extend( {}, this.options[ key ] );
        for ( i = 0; i < parts.length - 1; i++ ) {
          curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
          curOption = curOption[ parts[ i ] ];
        }
        key = parts.pop();
        if ( arguments.length === 1 ) {
          return curOption[ key ] === undefined ? null : curOption[ key ];
        }
        curOption[ key ] = value;
      } else {
        if ( arguments.length === 1 ) {
          return this.options[ key ] === undefined ? null : this.options[ key ];
        }
        options[ key ] = value;
      }
    }

    this._setOptions( options );

    return this;
  },
  _setOptions: function( options ) {
    var key;

    for ( key in options ) {
      this._setOption( key, options[ key ] );
    }

    return this;
  },
  _setOption: function( key, value ) {
    this.options[ key ] = value;

    if ( key === "disabled" ) {
      this.widget()
        .toggleClass( this.widgetFullName + "-disabled", !!value );

      // If the widget is becoming disabled, then nothing is interactive
      if ( value ) {
        this.hoverable.removeClass( "ui-state-hover" );
        this.focusable.removeClass( "ui-state-focus" );
      }
    }

    return this;
  },

  enable: function() {
    return this._setOptions({ disabled: false });
  },
  disable: function() {
    return this._setOptions({ disabled: true });
  },

  _on: function( suppressDisabledCheck, element, handlers ) {
    var delegateElement,
      instance = this;

    // no suppressDisabledCheck flag, shuffle arguments
    if ( typeof suppressDisabledCheck !== "boolean" ) {
      handlers = element;
      element = suppressDisabledCheck;
      suppressDisabledCheck = false;
    }

    // no element argument, shuffle and use this.element
    if ( !handlers ) {
      handlers = element;
      element = this.element;
      delegateElement = this.widget();
    } else {
      element = delegateElement = $( element );
      this.bindings = this.bindings.add( element );
    }

    $.each( handlers, function( event, handler ) {
      function handlerProxy() {
        // allow widgets to customize the disabled handling
        // - disabled as an array instead of boolean
        // - disabled class as method for disabling individual parts
        if ( !suppressDisabledCheck &&
            ( instance.options.disabled === true ||
              $( this ).hasClass( "ui-state-disabled" ) ) ) {
          return;
        }
        return ( typeof handler === "string" ? instance[ handler ] : handler )
          .apply( instance, arguments );
      }

      // copy the guid so direct unbinding works
      if ( typeof handler !== "string" ) {
        handlerProxy.guid = handler.guid =
          handler.guid || handlerProxy.guid || $.guid++;
      }

      var match = event.match( /^([\w:-]*)\s*(.*)$/ ),
        eventName = match[1] + instance.eventNamespace,
        selector = match[2];
      if ( selector ) {
        delegateElement.delegate( selector, eventName, handlerProxy );
      } else {
        element.bind( eventName, handlerProxy );
      }
    });
  },

  _off: function( element, eventName ) {
    eventName = (eventName || "").split( " " ).join( this.eventNamespace + " " ) + this.eventNamespace;
    element.unbind( eventName ).undelegate( eventName );
  },

  _delay: function( handler, delay ) {
    function handlerProxy() {
      return ( typeof handler === "string" ? instance[ handler ] : handler )
        .apply( instance, arguments );
    }
    var instance = this;
    return setTimeout( handlerProxy, delay || 0 );
  },

  _hoverable: function( element ) {
    this.hoverable = this.hoverable.add( element );
    this._on( element, {
      mouseenter: function( event ) {
        $( event.currentTarget ).addClass( "ui-state-hover" );
      },
      mouseleave: function( event ) {
        $( event.currentTarget ).removeClass( "ui-state-hover" );
      }
    });
  },

  _focusable: function( element ) {
    this.focusable = this.focusable.add( element );
    this._on( element, {
      focusin: function( event ) {
        $( event.currentTarget ).addClass( "ui-state-focus" );
      },
      focusout: function( event ) {
        $( event.currentTarget ).removeClass( "ui-state-focus" );
      }
    });
  },

  _trigger: function( type, event, data ) {
    var prop, orig,
      callback = this.options[ type ];

    data = data || {};
    event = $.Event( event );
    event.type = ( type === this.widgetEventPrefix ?
      type :
      this.widgetEventPrefix + type ).toLowerCase();
    // the original event may come from any element
    // so we need to reset the target on the new event
    event.target = this.element[ 0 ];

    // copy original event properties over to the new event
    orig = event.originalEvent;
    if ( orig ) {
      for ( prop in orig ) {
        if ( !( prop in event ) ) {
          event[ prop ] = orig[ prop ];
        }
      }
    }

    this.element.trigger( event, data );
    return !( $.isFunction( callback ) &&
      callback.apply( this.element[0], [ event ].concat( data ) ) === false ||
      event.isDefaultPrevented() );
  }
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
  $.Widget2.prototype[ "_" + method ] = function( element, options, callback ) {
    if ( typeof options === "string" ) {
      options = { effect: options };
    }
    var hasOptions,
      effectName = !options ?
        method :
        options === true || typeof options === "number" ?
          defaultEffect :
          options.effect || defaultEffect;
    options = options || {};
    if ( typeof options === "number" ) {
      options = { duration: options };
    }
    hasOptions = !$.isEmptyObject( options );
    options.complete = callback;
    if ( options.delay ) {
      element.delay( options.delay );
    }
    if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
      element[ method ]( options );
    } else if ( effectName !== method && element[ effectName ] ) {
      element[ effectName ]( options.duration, options.easing, callback );
    } else {
      element.queue(function( next ) {
        $( this )[ method ]();
        if ( callback ) {
          callback.call( element[ 0 ] );
        }
        next();
      });
    }
  };
});

var widget = $.widget2;


/*!
 * jQuery UI Mouse 1.11.0
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/mouse/
 */


var mouseHandled = false;
$( document ).mouseup( function() {
  mouseHandled = false;
});

var mouse = $.widget2("ui.mouse", {
  version: "1.11.0",
  options: {
    cancel: "input,textarea,button,select,option",
    distance: 1,
    delay: 0
  },
  _mouseInit: function() {
    var that = this;

    this.element
      .bind("mousedown." + this.widgetName, function(event) {
        return that._mouseDown(event);
      })
      .bind("click." + this.widgetName, function(event) {
        if (true === $.data(event.target, that.widgetName + ".preventClickEvent")) {
          $.removeData(event.target, that.widgetName + ".preventClickEvent");
          event.stopImmediatePropagation();
          return false;
        }
      });

    this.started = false;
  },

  // TODO: make sure destroying one instance of mouse doesn't mess with
  // other instances of mouse
  _mouseDestroy: function() {
    this.element.unbind("." + this.widgetName);
    if ( this._mouseMoveDelegate ) {
      this.document
        .unbind("mousemove." + this.widgetName, this._mouseMoveDelegate)
        .unbind("mouseup." + this.widgetName, this._mouseUpDelegate);
    }
  },

  _mouseDown: function(event) {
    // don't let more than one widget handle mouseStart
    if ( mouseHandled ) {
      return;
    }

    // we may have missed mouseup (out of window)
    (this._mouseStarted && this._mouseUp(event));

    this._mouseDownEvent = event;

    var that = this,
      btnIsLeft = (event.which === 1),
      // event.target.nodeName works around a bug in IE 8 with
      // disabled inputs (#7620)
      elIsCancel = (typeof this.options.cancel === "string" && event.target.nodeName ? $(event.target).closest(this.options.cancel).length : false);
    if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) {
      return true;
    }

    this.mouseDelayMet = !this.options.delay;
    if (!this.mouseDelayMet) {
      this._mouseDelayTimer = setTimeout(function() {
        that.mouseDelayMet = true;
      }, this.options.delay);
    }

    if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
      this._mouseStarted = (this._mouseStart(event) !== false);
      if (!this._mouseStarted) {
        event.preventDefault();
        return true;
      }
    }

    // Click event may never have fired (Gecko & Opera)
    if (true === $.data(event.target, this.widgetName + ".preventClickEvent")) {
      $.removeData(event.target, this.widgetName + ".preventClickEvent");
    }

    // these delegates are required to keep context
    this._mouseMoveDelegate = function(event) {
      return that._mouseMove(event);
    };
    this._mouseUpDelegate = function(event) {
      return that._mouseUp(event);
    };

    this.document
      .bind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
      .bind( "mouseup." + this.widgetName, this._mouseUpDelegate );

    event.preventDefault();

    mouseHandled = true;
    return true;
  },

  _mouseMove: function(event) {
    // IE mouseup check - mouseup happened when mouse was out of window
    if ($.ui.ie && ( !document.documentMode || document.documentMode < 9 ) && !event.button) {
      return this._mouseUp(event);

    // Iframe mouseup check - mouseup occurred in another document
    } else if ( !event.which ) {
      return this._mouseUp( event );
    }

    if (this._mouseStarted) {
      this._mouseDrag(event);
      return event.preventDefault();
    }

    if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
      this._mouseStarted =
        (this._mouseStart(this._mouseDownEvent, event) !== false);
      (this._mouseStarted ? this._mouseDrag(event) : this._mouseUp(event));
    }

    return !this._mouseStarted;
  },

  _mouseUp: function(event) {
    this.document
      .unbind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
      .unbind( "mouseup." + this.widgetName, this._mouseUpDelegate );

    if (this._mouseStarted) {
      this._mouseStarted = false;

      if (event.target === this._mouseDownEvent.target) {
        $.data(event.target, this.widgetName + ".preventClickEvent", true);
      }

      this._mouseStop(event);
    }

    mouseHandled = false;
    return false;
  },

  _mouseDistanceMet: function(event) {
    return (Math.max(
        Math.abs(this._mouseDownEvent.pageX - event.pageX),
        Math.abs(this._mouseDownEvent.pageY - event.pageY)
      ) >= this.options.distance
    );
  },

  _mouseDelayMet: function(/* event */) {
    return this.mouseDelayMet;
  },

  // These are placeholder methods, to be overriden by extending plugin
  _mouseStart: function(/* event */) {},
  _mouseDrag: function(/* event */) {},
  _mouseStop: function(/* event */) {},
  _mouseCapture: function(/* event */) { return true; }
});

/*!
 * jQuery UI Slider 1.11.0
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/slider/
 */


var slider = $.widget2( "ui.slider", $.ui.mouse, {
  version: "1.11.0",
  widgetEventPrefix: "slide",

  options: {
    animate: false,
    distance: 0,
    max: 100,
    min: 0,
    orientation: "horizontal",
    range: false,
    step: 1,
    value: 0,
    values: null,

    // callbacks
    change: null,
    slide: null,
    start: null,
    stop: null
  },

  // number of pages in a slider
  // (how many times can you page up/down to go through the whole range)
  numPages: 5,

  _create: function() {
    this._keySliding = false;
    this._mouseSliding = false;
    this._animateOff = true;
    this._handleIndex = null;
    this._detectOrientation();
    this._mouseInit();

    this.element
      .addClass( "ui-slider" +
        " ui-slider-" + this.orientation +
        " ui-widget" +
        " ui-widget-content" +
        " ui-corner-all");

    this._refresh();
    this._setOption( "disabled", this.options.disabled );

    this._animateOff = false;
  },

  _refresh: function() {
    this._createRange();
    this._createHandles();
    this._setupEvents();
    this._refreshValue();
  },

  _createHandles: function() {
    var i, handleCount,
      options = this.options,
      existingHandles = this.element.find( ".ui-slider-handle" ).addClass( "ui-state-default ui-corner-all-handle" ),
      handle = "<span class='ui-slider-handle ui-state-default ui-corner-all-handle' tabindex='0'></span>",
      handles = [];

    handleCount = ( options.values && options.values.length ) || 1;

    if ( existingHandles.length > handleCount ) {
      existingHandles.slice( handleCount ).remove();
      existingHandles = existingHandles.slice( 0, handleCount );
    }

    for ( i = existingHandles.length; i < handleCount; i++ ) {
      handles.push( handle );
    }

    this.handles = existingHandles.add( $( handles.join( "" ) ).appendTo( this.element ) );

    this.handle = this.handles.eq( 0 );

    this.handles.each(function( i ) {
      $( this ).data( "ui-slider-handle-index", i );
    });
  },

  _createRange: function() {
    var options = this.options,
      classes = "";

    if ( options.range ) {
      if ( options.range === true ) {
        if ( !options.values ) {
          options.values = [ this._valueMin(), this._valueMin() ];
        } else if ( options.values.length && options.values.length !== 2 ) {
          options.values = [ options.values[0], options.values[0] ];
        } else if ( $.isArray( options.values ) ) {
          options.values = options.values.slice(0);
        }
      }

      if ( !this.range || !this.range.length ) {
        this.range = $( "<div></div>" )
          .appendTo( this.element );

        classes = "ui-slider-range" +
        // note: this isn't the most fittingly semantic framework class for this element,
        // but worked best visually with a variety of themes
        " ui-widget-header ui-corner-all";
      } else {
        this.range.removeClass( "ui-slider-range-min ui-slider-range-max" )
          // Handle range switching from true to min/max
          .css({
            "left": "",
            "bottom": ""
          });
      }

      this.range.addClass( classes +
        ( ( options.range === "min" || options.range === "max" ) ? " ui-slider-range-" + options.range : "" ) );
    } else {
      if ( this.range ) {
        this.range.remove();
      }
      this.range = null;
    }
  },

  _setupEvents: function() {
    this._off( this.handles );
    this._on( this.handles, this._handleEvents );
    this._hoverable( this.handles );
    this._focusable( this.handles );
  },

  _destroy: function() {
    this.handles.remove();
    if ( this.range ) {
      this.range.remove();
    }

    this.element
      .removeClass( "ui-slider" +
        " ui-slider-horizontal" +
        " ui-slider-vertical" +
        " ui-widget" +
        " ui-widget-content" +
        " ui-corner-all" );

    this._mouseDestroy();
  },

  _mouseCapture: function( event ) {
    var position, normValue, distance, closestHandle, index, allowed, offset, mouseOverHandle,
      that = this,
      o = this.options;

    if ( o.disabled ) {
      return false;
    }

    this.elementSize = {
      width: this.element.outerWidth(),
      height: this.element.outerHeight()
    };
    this.elementOffset = this.element.offset();

    position = { x: event.pageX, y: event.pageY };
    normValue = this._normValueFromMouse( position );
    distance = this._valueMax() - this._valueMin() + 1;
    this.handles.each(function( i ) {
      var realDistance, absDistance;
      realDistance = normValue - that.values(i);
      absDistance = Math.abs(realDistance);
      if (!$(event.target).is(closestHandle) &&
        ( distance > absDistance ||
          ( distance === absDistance &&
            ( i === that._lastChangedValue || this === event.target || that.values(i) === o.min || realDistance >= 0 )))) {
        distance = absDistance;
        closestHandle = $( this );
        index = i;
      }
    });

    allowed = this._start( event, index );
    if ( allowed === false ) {
      return false;
    }
    this._mouseSliding = true;

    this._handleIndex = index;

    closestHandle
      .addClass( "ui-state-active" )
      .focus();

    offset = closestHandle.offset();
    mouseOverHandle = !$( event.target ).parents().addBack().is( ".ui-slider-handle" );
    this._clickOffset = mouseOverHandle ? { left: 0, top: 0 } : {
      left: event.pageX - offset.left - ( closestHandle.width() / 2 ),
      top: event.pageY - offset.top -
        ( closestHandle.height() / 2 ) -
        ( parseInt( closestHandle.css("borderTopWidth"), 10 ) || 0 ) -
        ( parseInt( closestHandle.css("borderBottomWidth"), 10 ) || 0) +
        ( parseInt( closestHandle.css("marginTop"), 10 ) || 0)
    };

    if ( !this.handles.hasClass( "ui-state-hover" ) ) {
      this._slide( event, index, normValue );
    }
    this._animateOff = true;
    return true;
  },

  _mouseStart: function() {
    return true;
  },

  _mouseDrag: function( event ) {
    var position = { x: event.pageX, y: event.pageY },
      normValue = this._normValueFromMouse( position );

    this._slide( event, this._handleIndex, normValue );

    return false;
  },

  _mouseStop: function( event ) {
    this.handles.removeClass( "ui-state-active" );
    this._mouseSliding = false;

    this._stop( event, this._handleIndex );
    this._change( event, this._handleIndex );

    this._handleIndex = null;
    this._clickOffset = null;
    this._animateOff = false;

    return false;
  },

  _detectOrientation: function() {
    this.orientation = ( this.options.orientation === "vertical" ) ? "vertical" : "horizontal";
  },

  _normValueFromMouse: function( position ) {
    var pixelTotal,
      pixelMouse,
      percentMouse,
      valueTotal,
      valueMouse;

    if ( this.orientation === "horizontal" ) {
      pixelTotal = this.elementSize.width;
      pixelMouse = position.x - this.elementOffset.left - ( this._clickOffset ? this._clickOffset.left : 0 );
    } else {
      pixelTotal = this.elementSize.height;
      pixelMouse = position.y - this.elementOffset.top - ( this._clickOffset ? this._clickOffset.top : 0 );
    }

    percentMouse = ( pixelMouse / pixelTotal );
    if ( percentMouse > 1 ) {
      percentMouse = 1;
    }
    if ( percentMouse < 0 ) {
      percentMouse = 0;
    }
    if ( this.orientation === "vertical" ) {
      percentMouse = 1 - percentMouse;
    }

    valueTotal = this._valueMax() - this._valueMin();
    valueMouse = this._valueMin() + percentMouse * valueTotal;

    return this._trimAlignValue( valueMouse );
  },

  _start: function( event, index ) {
    var uiHash = {
      handle: this.handles[ index ],
      value: this.value()
    };
    if ( this.options.values && this.options.values.length ) {
      uiHash.value = this.values( index );
      uiHash.values = this.values();
    }
    return this._trigger( "start", event, uiHash );
  },

  _slide: function( event, index, newVal ) {
    var otherVal,
      newValues,
      allowed;

    if ( this.options.values && this.options.values.length ) {
      otherVal = this.values( index ? 0 : 1 );

      if ( ( this.options.values.length === 2 && this.options.range === true ) &&
          ( ( index === 0 && newVal > otherVal) || ( index === 1 && newVal < otherVal ) )
        ) {
        newVal = otherVal;
      }

      if ( newVal !== this.values( index ) ) {
        newValues = this.values();
        newValues[ index ] = newVal;

          if (event.type == "mousedown") {
                this.values( index, newVal );
            }

        // A slide can be canceled by returning false from the slide callback
        allowed = this._trigger( "slide", event, {
          handle: this.handles[ index ],
          value: newVal,
          values: newValues
        } );
        otherVal = this.values( index ? 0 : 1 );
        if ( allowed !== false ) {
          this.values( index, newVal );
        }
      }
    } else {
      if ( newVal !== this.value() ) {
        // A slide can be canceled by returning false from the slide callback
        allowed = this._trigger( "slide", event, {
          handle: this.handles[ index ],
          value: newVal
        } );
        if ( allowed !== false ) {
              this.value( newVal );
        }
      }
    }
  },

  _stop: function( event, index ) {
    var uiHash = {
      handle: this.handles[ index ],
      value: this.value()
    };
    if ( this.options.values && this.options.values.length ) {
      uiHash.value = this.values( index );
      uiHash.values = this.values();
    }

    this._trigger( "stop", event, uiHash );
  },

  _change: function( event, index ) {
    if ( !this._keySliding && !this._mouseSliding ) {
      var uiHash = {
        handle: this.handles[ index ],
        value: this.value()
      };
      if ( this.options.values && this.options.values.length ) {
        uiHash.value = this.values( index );
        uiHash.values = this.values();
      }

      //store the last changed value index for reference when handles overlap
      this._lastChangedValue = index;

      this._trigger( "change", event, uiHash );
    }
  },

  value: function( newValue ) {
    if ( arguments.length ) {
      this.options.value = this._trimAlignValue( newValue );
      this._refreshValue();
      this._change( null, 0 );
      return;
    }

    return this._value();
  },

  values: function( index, newValue ) {
    var vals,
      newValues,
      i;

    if ( arguments.length > 1 ) {
      this.options.values[ index ] = this._trimAlignValue( newValue );
      this._refreshValue();
      this._change( null, index );
      return;
    }

    if ( arguments.length ) {
      if ( $.isArray( arguments[ 0 ] ) ) {
        vals = this.options.values;
        newValues = arguments[ 0 ];
        for ( i = 0; i < vals.length; i += 1 ) {
          vals[ i ] = this._trimAlignValue( newValues[ i ] );
          this._change( null, i );
        }
        this._refreshValue();
      } else {
        if ( this.options.values && this.options.values.length ) {
          return this._values( index );
        } else {
          return this.value();
        }
      }
    } else {
      return this._values();
    }
  },

  _setOption: function( key, value ) {
    var i,
      valsLength = 0;

    if ( key === "range" && this.options.range === true ) {
      if ( value === "min" ) {
        this.options.value = this._values( 0 );
        this.options.values = null;
      } else if ( value === "max" ) {
        this.options.value = this._values( this.options.values.length - 1 );
        this.options.values = null;
      }
    }

    if ( $.isArray( this.options.values ) ) {
      valsLength = this.options.values.length;
    }

    if ( key === "disabled" ) {
      this.element.toggleClass( "ui-state-disabled", !!value );
    }

    this._super( key, value );

    switch ( key ) {
      case "orientation":
        this._detectOrientation();
        this.element
          .removeClass( "ui-slider-horizontal ui-slider-vertical" )
          .addClass( "ui-slider-" + this.orientation );
        this._refreshValue();
        break;
      case "value":
        this._animateOff = true;
        this._refreshValue();
        this._change( null, 0 );
        this._animateOff = false;
        break;
      case "values":
        this._animateOff = true;
        this._refreshValue();
        for ( i = 0; i < valsLength; i += 1 ) {
          this._change( null, i );
        }
        this._animateOff = false;
        break;
      case "min":
      case "max":
        this._animateOff = true;
        this._refreshValue();
        this._animateOff = false;
        break;
      case "range":
        this._animateOff = true;
        this._refresh();
        this._animateOff = false;
        break;
    }
  },

  //internal value getter
  // _value() returns value trimmed by min and max, aligned by step
  _value: function() {
    var val = this.options.value;
    val = this._trimAlignValue( val );

    return val;
  },

  //internal values getter
  // _values() returns array of values trimmed by min and max, aligned by step
  // _values( index ) returns single value trimmed by min and max, aligned by step
  _values: function( index ) {
    var val,
      vals,
      i;

    if ( arguments.length ) {
      val = this.options.values[ index ];
      val = this._trimAlignValue( val );

      return val;
    } else if ( this.options.values && this.options.values.length ) {
      // .slice() creates a copy of the array
      // this copy gets trimmed by min and max and then returned
      vals = this.options.values.slice();
      for ( i = 0; i < vals.length; i+= 1) {
        vals[ i ] = this._trimAlignValue( vals[ i ] );
      }

      return vals;
    } else {
      return [];
    }
  },

  // returns the step-aligned value that val is closest to, between (inclusive) min and max
  _trimAlignValue: function( val ) {
    if ( val <= this._valueMin() ) {
      return this._valueMin();
    }
    if ( val >= this._valueMax() ) {
      return this._valueMax();
    }
    var step = ( this.options.step > 0 ) ? this.options.step : 1,
      valModStep = (val - this._valueMin()) % step,
      alignValue = val - valModStep;

    if ( Math.abs(valModStep) * 2 >= step ) {
      alignValue += ( valModStep > 0 ) ? step : ( -step );
    }

    // Since JavaScript has problems with large floats, round
    // the final value to 5 digits after the decimal point (see #4124)
    return parseFloat( alignValue.toFixed(5) );
  },

  _valueMin: function() {
    return this.options.min;
  },

  _valueMax: function() {
    return this.options.max;
  },

  _refreshValue: function() {
    var lastValPercent, valPercent, value, valueMin, valueMax,
      oRange = this.options.range,
      o = this.options,
      that = this,
      animate = ( !this._animateOff ) ? o.animate : false,
      _set = {};

    if ( this.options.values && this.options.values.length ) {
      this.handles.each(function( i ) {
        valPercent = ( that.values(i) - that._valueMin() ) / ( that._valueMax() - that._valueMin() ) * 100;
        _set[ that.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
        $( this ).stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
        if ( that.options.range === true ) {
          if ( that.orientation === "horizontal" ) {
            if ( i === 0 ) {
              that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { left: valPercent + "%" }, o.animate );
            }
            if ( i === 1 ) {
              that.range[ animate ? "animate" : "css" ]( { width: ( valPercent - lastValPercent ) + "%" }, { queue: false, duration: o.animate } );
            }
          } else {
            if ( i === 0 ) {
              that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { bottom: ( valPercent ) + "%" }, o.animate );
            }
            if ( i === 1 ) {
              that.range[ animate ? "animate" : "css" ]( { height: ( valPercent - lastValPercent ) + "%" }, { queue: false, duration: o.animate } );
            }
          }
        }
        lastValPercent = valPercent;
      });
    } else {
      value = this.value();
      valueMin = this._valueMin();
      valueMax = this._valueMax();
      valPercent = ( valueMax !== valueMin ) ?
          ( value - valueMin ) / ( valueMax - valueMin ) * 100 :
          0;
      _set[ this.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
      this.handle.stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );

      if ( oRange === "min" && this.orientation === "horizontal" ) {
        this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { width: valPercent + "%" }, o.animate );
      }
      if ( oRange === "max" && this.orientation === "horizontal" ) {
        this.range[ animate ? "animate" : "css" ]( { width: ( 100 - valPercent ) + "%" }, { queue: false, duration: o.animate } );
      }
      if ( oRange === "min" && this.orientation === "vertical" ) {
        this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { height: valPercent + "%" }, o.animate );
      }
      if ( oRange === "max" && this.orientation === "vertical" ) {
        this.range[ animate ? "animate" : "css" ]( { height: ( 100 - valPercent ) + "%" }, { queue: false, duration: o.animate } );
      }
    }
  },

  _handleEvents: {
    keydown: function( event ) {
      var allowed, curVal, newVal, step,
        index = $( event.target ).data( "ui-slider-handle-index" );

      switch ( event.keyCode ) {
        case $.ui.keyCode.HOME:
        case $.ui.keyCode.END:
        case $.ui.keyCode.PAGE_UP:
        case $.ui.keyCode.PAGE_DOWN:
        case $.ui.keyCode.UP:
        case $.ui.keyCode.RIGHT:
        case $.ui.keyCode.DOWN:
        case $.ui.keyCode.LEFT:
          event.preventDefault();
          if ( !this._keySliding ) {
            this._keySliding = true;
            $( event.target ).addClass( "ui-state-active" );
            allowed = this._start( event, index );
            if ( allowed === false ) {
              return;
            }
          }
          break;
      }

      step = this.options.step;
      if ( this.options.values && this.options.values.length ) {
        curVal = newVal = this.values( index );
      } else {
        curVal = newVal = this.value();
      }

      switch ( event.keyCode ) {
        case $.ui.keyCode.HOME:
          newVal = this._valueMin();
          break;
        case $.ui.keyCode.END:
          newVal = this._valueMax();
          break;
        case $.ui.keyCode.PAGE_UP:
          newVal = this._trimAlignValue(
            curVal + ( ( this._valueMax() - this._valueMin() ) / this.numPages )
          );
          break;
        case $.ui.keyCode.PAGE_DOWN:
          newVal = this._trimAlignValue(
            curVal - ( (this._valueMax() - this._valueMin()) / this.numPages ) );
          break;
        case $.ui.keyCode.UP:
        case $.ui.keyCode.RIGHT:
          if ( curVal === this._valueMax() ) {
            return;
          }
          newVal = this._trimAlignValue( curVal + step );
          break;
        case $.ui.keyCode.DOWN:
        case $.ui.keyCode.LEFT:
          if ( curVal === this._valueMin() ) {
            return;
          }
          newVal = this._trimAlignValue( curVal - step );
          break;
      }

      this._slide( event, index, newVal );
    },
    keyup: function( event ) {
      var index = $( event.target ).data( "ui-slider-handle-index" );

      if ( this._keySliding ) {
        this._keySliding = false;
        this._stop( event, index );
        this._change( event, index );
        $( event.target ).removeClass( "ui-state-active" );
      }
    }
  }
});

}));

}).call(global, module, undefined, undefined);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"/var/groupon/home/michchen/napistrano/build/1473902691243-29884/perf-2016.09.15_01.04/goods/core/frontend/vendor_modules/jquery.widget.js":6}],6:[function(require,module,exports){
/*!
 * jQuery UI Widget 1.8.13
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Widget
 */
(function( $, undefined ) {

// jQuery 1.4+
if ( $.cleanData ) {
	var _cleanData = $.cleanData;
	$.cleanData = function( elems ) {
                var tmp;
		for ( var i = 0, elem; (elem = elems[i]) != null; i++ ) {
			try {
				$( elem ).triggerHandler( "remove" );
			} catch (err) {
			}
		}
		_cleanData( elems );
	};
} else {
	var _remove = $.fn.remove;
	$.fn.remove = function( selector, keepData ) {
		return this.each(function() {
			if ( !keepData ) {
				if ( !selector || $.filter( selector, [ this ] ).length ) {
					$( "*", this ).add( [ this ] ).each(function() {
						$( this ).triggerHandler( "remove" );
					});
				}
			}
			return _remove.call( $(this), selector, keepData );
		});
	};
}

$.widget = function( name, base, prototype ) {
	var namespace = name.split( "." )[ 0 ],
		fullName;
	name = name.split( "." )[ 1 ];
	fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	// create selector for plugin
	$.expr[ ":" ][ fullName ] = function( elem ) {
		return !!$.data( elem, name );
	};

	$[ namespace ] = $[ namespace ] || {};
	$[ namespace ][ name ] = function( options, element ) {
		// allow instantiation without initializing for simple inheritance
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};

	var basePrototype = new base();
	// we need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
//	$.each( basePrototype, function( key, val ) {
//		if ( $.isPlainObject(val) ) {
//			basePrototype[ key ] = $.extend( {}, val );
//		}
//	});
	basePrototype.options = $.extend( true, {}, basePrototype.options );
	$[ namespace ][ name ].prototype = $.extend( true, basePrototype, {
		namespace: namespace,
		widgetName: name,
		widgetEventPrefix: $[ namespace ][ name ].prototype.widgetEventPrefix || name,
		widgetBaseClass: fullName
	}, prototype );

	$.widget.bridge( name, $[ namespace ][ name ] );
};

$.widget.bridge = function( name, object ) {
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string",
			args = Array.prototype.slice.call( arguments, 1 ),
			returnValue = this;

		// allow multiple hashes to be passed on init
		options = !isMethodCall && args.length ?
			$.extend.apply( null, [ true, options ].concat(args) ) :
			options;

		// prevent calls to internal methods
		if ( isMethodCall && options.charAt( 0 ) === "_" ) {
			return returnValue;
		}

		if ( isMethodCall ) {
			this.each(function() {
				var instance = $.data( this, name ),
					methodValue = instance && $.isFunction( instance[options] ) ?
						instance[ options ].apply( instance, args ) :
						instance;
				// TODO: add this back in 1.9 and use $.error() (see #5972)
//				if ( !instance ) {
//					throw "cannot call methods on " + name + " prior to initialization; " +
//						"attempted to call method '" + options + "'";
//				}
//				if ( !$.isFunction( instance[options] ) ) {
//					throw "no such method '" + options + "' for " + name + " widget instance";
//				}
//				var methodValue = instance[ options ].apply( instance, args );
				if ( methodValue !== instance && methodValue !== undefined ) {
					returnValue = methodValue;
					return false;
				}
			});
		} else {
			this.each(function() {
				var instance = $.data( this, name );
				if ( instance ) {
					instance.option( options || {} )._init();
				} else {
					$.data( this, name, new object( options, this ) );
				}
			});
		}

		return returnValue;
	};
};

$.Widget = function( options, element ) {
	// allow instantiation without initializing for simple inheritance
	if ( arguments.length ) {
		this._createWidget( options, element );
	}
};

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	options: {
		disabled: false
	},
	_createWidget: function( options, element ) {
		// $.widget.bridge stores the plugin instance, but we do it anyway
		// so that it's stored even before the _create function runs
		$.data( element, this.widgetName, this );
		this.element = $( element );
		this.options = $.extend( true, {},
			this.options,
			this._getCreateOptions(),
			options );

		var self = this;
		this.element.bind( "remove." + this.widgetName, function() {
			self.destroy();
		});

		this._create();
		this._trigger( "create" );
		this._init();
	},
	_getCreateOptions: function() {
		return $.metadata && $.metadata.get( this.element[0] )[ this.widgetName ];
	},
	_create: function() {},
	_init: function() {},

	destroy: function() {
		this.element
			.unbind( "." + this.widgetName )
			.removeData( this.widgetName );
		this.widget()
			.unbind( "." + this.widgetName )
			.removeAttr( "aria-disabled" )
			.removeClass(
				this.widgetBaseClass + "-disabled " +
				"ui-state-disabled" );
	},

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key;

		if ( arguments.length === 0 ) {
			// don't return a reference to the internal hash
			return $.extend( {}, this.options );
		}

		if  (typeof key === "string" ) {
			if ( value === undefined ) {
				return this.options[ key ];
			}
			options = {};
			options[ key ] = value;
		}

		this._setOptions( options );

		return this;
	},
	_setOptions: function( options ) {
		var self = this;
		$.each( options, function( key, value ) {
			self._setOption( key, value );
		});

		return this;
	},
	_setOption: function( key, value ) {
		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this.widget()
				[ value ? "addClass" : "removeClass"](
					this.widgetBaseClass + "-disabled" + " " +
					"ui-state-disabled" )
				.attr( "aria-disabled", value );
		}

		return this;
	},

	enable: function() {
		return this._setOption( "disabled", false );
	},
	disable: function() {
		return this._setOption( "disabled", true );
	},

	_trigger: function( type, event, data ) {
		var callback = this.options[ type ];

		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();
		data = data || {};

		// copy original event properties over to the new event
		// this would happen if we could call $.event.fix instead of $.Event
		// but we don't have a way to force an event to be fixed multiple times
		if ( event.originalEvent ) {
			for ( var i = $.event.props.length, prop; i; ) {
				prop = $.event.props[ --i ];
				event[ prop ] = event.originalEvent[ prop ];
			}
		}

		this.element.trigger( event, data );

		return !( $.isFunction(callback) &&
			callback.call( this.element[0], event, data ) === false ||
			event.isDefaultPrevented() );
	}
};

})( jQuery );

},{}],7:[function(require,module,exports){
var BreadCrumbModel;

module.exports = BreadCrumbModel = (function() {
  function BreadCrumbModel(_arg) {
    this.title = _arg.title, this.friendlyName = _arg.friendlyName, this.id = _arg.id, this.href = _arg.href, this.showSeparator = _arg.showSeparator, this.showHref = _arg.showHref;
    if (this.showHref == null) {
      this.showHref = true;
    }
    if (this.showSeparator == null) {
      this.showSeparator = true;
    }
  }

  BreadCrumbModel.prototype.getTitle = function() {
    var _ref;
    return (_ref = this.title) != null ? _ref : this.friendlyName;
  };

  return BreadCrumbModel;

})();



},{}],8:[function(require,module,exports){
(function (global){
var BreadcrumbModel, BreadcrumbPresenter, Crumb, TreeTraversalHelper, contains, extend, find, getDefaultCategoryCrumb, getFacetValues, getGoodsFriendlyName, getOrderedCommonNodes, getPageTitleLink, getParsedParams, getSelectedNodes, isArray, last, prettyUrls, _ref,
  __slice = [].slice;

BreadcrumbModel = require('../../common/models/crumb');

TreeTraversalHelper = require('../../../shared/common/helpers/tree_traversal');

_ref = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), isArray = _ref.isArray, contains = _ref.contains, extend = _ref.extend, find = _ref.find, last = _ref.last;

getOrderedCommonNodes = TreeTraversalHelper.getOrderedCommonNodes, getSelectedNodes = TreeTraversalHelper.getSelectedNodes;

prettyUrls = require('pretty-urls');

Crumb = BreadcrumbModel;

module.exports = BreadcrumbPresenter = (function() {
  var CATEGORY_FACET_KEY;

  CATEGORY_FACET_KEY = {
    raw: 'topcategory|category|category2|category3',
    structured: 'categories'
  };

  BreadcrumbPresenter.prototype.crumbs = [];

  function BreadcrumbPresenter(_arg) {
    var page, params;
    page = _arg.page, params = _arg.params;
    if (!page.facets) {
      return {};
    }
    if (Groupon.inRAPI) {
      CATEGORY_FACET_KEY.raw = 'topcategory|category|subcategory|subcategory2';
    }
    this.division = Groupon.division;
    this.isLocalPage = params.isLocalPage, this.isSeoEnabled = params.isSeoEnabled, this.collectionType = params.collectionType;
    this.facets = page.facets;
    this.categories = getFacetValues(this.facets, CATEGORY_FACET_KEY);
    this.baseURL = (function() {
      switch (false) {
        case !this.isLocalPage:
          return Groupon.urls.local;
        case !this.collectionType:
          return Groupon.urls.collections + "/" + Groupon.collection.id;
        default:
          return Groupon.urls.browse;
      }
    }).call(this);
    this.parsedParams = getParsedParams(params, this.categories);
  }

  BreadcrumbPresenter.prototype.toHash = function() {
    var breadcrumb, crumbsHash;
    crumbsHash = this._getCrumbsHash();
    breadcrumb = extend(crumbsHash, {
      pageTitleLink: getPageTitleLink(crumbsHash.lowestCategory, this.collectionType)
    });
    return {
      breadcrumb: breadcrumb
    };
  };

  BreadcrumbPresenter.prototype._getCrumbsHash = function() {
    var categories;
    categories = this._getCategoryCrumbs();
    if (this.collectionType) {
      categories.shift();
    }
    return {
      crumbs: this._getGoodsCrumbs(categories),
      lowestCategory: last(categories)
    };
  };

  BreadcrumbPresenter.prototype._getGoodsCrumbs = function(categories) {
    var goodsCrumbs;
    if (this.collectionType) {
      goodsCrumbs = [this._getGoodsCrumb(Groupon.urls.browse), this._getFeaturedCollectionsCrumb(Groupon.urls.collections), this._getCollectionCrumb(categories)];
    } else {
      goodsCrumbs = [this._getGoodsCrumb(this.baseURL)];
    }
    return goodsCrumbs.concat(categories);
  };

  BreadcrumbPresenter.prototype._getGoodsCrumb = function(baseUrl) {
    return new Crumb({
      title: this.division.name,
      friendlyName: I18n.translate('js.modules.breadcrumb.presenters.goods_friendly_name'),
      href: baseUrl,
      showSeparator: false
    });
  };

  BreadcrumbPresenter.prototype._getFeaturedCollectionsCrumb = function(collectionsUrl) {
    var featuredName;
    if (this.collectionType === 'brands') {
      featuredName = I18n.translate('js.modules.breadcrumb.presenters.featured_brands_friendly_name');
    } else {
      featuredName = I18n.translate('js.modules.breadcrumb.presenters.featured_collections_friendly_name');
    }
    return new Crumb({
      friendlyName: featuredName,
      href: collectionsUrl,
      showSeparator: true
    });
  };

  BreadcrumbPresenter.prototype._getCollectionCrumb = function(categories) {
    return new Crumb({
      friendlyName: Groupon.collection.name,
      href: this.baseURL,
      showHref: categories.length,
      showSeparator: true
    });
  };

  BreadcrumbPresenter.prototype._getCategoryCrumbs = function() {
    var category, categoryCrumbs, lowestCategory, matchingCategory, orderedCategories, _i, _len, _ref1, _ref2;
    if (!this.parsedParams.category) {
      return [getDefaultCategoryCrumb()];
    }
    categoryCrumbs = [];
    if (this.parsedParams.subCategories.length) {
      _ref2 = (_ref1 = getOrderedCommonNodes(this.categories, this.parsedParams.subCategories)) != null ? _ref1 : [], this.topCategory = _ref2[0], orderedCategories = 2 <= _ref2.length ? __slice.call(_ref2, 1) : [];
      if (!orderedCategories.length) {
        matchingCategory = find(this.categories[0].children, (function(_this) {
          return function(cat) {
            return cat.id === _this.parsedParams.category;
          };
        })(this));
        orderedCategories = matchingCategory != null ? [matchingCategory] : [];
      }
    } else {
      matchingCategory = find(this.categories[0].children, (function(_this) {
        return function(cat) {
          return cat.id === _this.parsedParams.category;
        };
      })(this));
      orderedCategories = matchingCategory != null ? [matchingCategory] : [];
    }
    if (!orderedCategories.length) {
      return [getDefaultCategoryCrumb()];
    }
    lowestCategory = (function() {
      switch (false) {
        case !this.parsedParams.selectedl6s.length:
          return this.parsedParams.selectedl6s;
        case !this.parsedParams.selectedl5s.length:
          return this.parsedParams.selectedl5s;
        case !this.parsedParams.selectedl4s.length:
          return this.parsedParams.selectedl4s;
        case !this.parsedParams.selectedl3s.length:
          return this.parsedParams.selectedl3s;
        case !this.parsedParams.selectedl2s.length:
          return this.parsedParams.selectedl2s;
      }
    }).call(this);
    for (_i = 0, _len = orderedCategories.length; _i < _len; _i++) {
      category = orderedCategories[_i];
      categoryCrumbs.push(new Crumb({
        id: category.id,
        friendlyName: getGoodsFriendlyName(category),
        href: this._getCategoryHref(category),
        showHref: contains(lowestCategory, category.id) ? false : void 0
      }));
    }
    return categoryCrumbs;
  };

  BreadcrumbPresenter.prototype._getCategoryHref = function(category) {
    var l2Categories, l3Categories, l4Categories, l5Categories, l6Categories;
    if (this.isSeoEnabled) {
      return this.baseURL + "/" + category.id;
    }
    l2Categories = [];
    l3Categories = [];
    l4Categories = [];
    l5Categories = [];
    l6Categories = [];
    if (contains(this.parsedParams.selectedl6s, category.id)) {
      l6Categories.push(category.id);
      l5Categories.push(category.parent.id);
      l4Categories.push(category.parent.parent.id);
      l3Categories.push(category.parent.parent.parent.id);
      l2Categories.push(category.parent.parent.parent.parent.id);
    } else if (contains(this.parsedParams.selectedl5s, category.id)) {
      l5Categories.push(category.id);
      l4Categories.push(category.parent.id);
      l3Categories.push(category.parent.parent.id);
      l2Categories.push(category.parent.parent.parent.id);
    } else if (contains(this.parsedParams.selectedl4s, category.id)) {
      l4Categories.push(category.id);
      l3Categories.push(category.parent.id);
      l2Categories.push(category.parent.parent.id);
    } else if (contains(this.parsedParams.selectedl3s, category.id)) {
      l3Categories.push(category.id);
      l2Categories.push(category.parent.id);
    } else if (contains(this.parsedParams.selectedl2s, category.id)) {
      l2Categories.push(category.id);
    }
    if (this.collectionType) {
      l2Categories = [];
    }
    return prettyUrls.V1.construct({
      baseURL: this.baseURL,
      l2Categories: l2Categories,
      l3Categories: l3Categories,
      l4Categories: l4Categories,
      l5Categories: l5Categories,
      l6Categories: l6Categories,
      interests: []
    });
  };

  return BreadcrumbPresenter;

})();

getGoodsFriendlyName = function(category) {
  return category.friendlyNameShort || category.friendlyName;
};

getPageTitleLink = function(categoryCrumb, collectionType) {
  var pageTitleText;
  if (collectionType) {
    if (!categoryCrumb) {
      return {
        text: Groupon.collection.name
      };
    }
    pageTitleText = Groupon.collection.name + " - " + (categoryCrumb.getTitle());
  } else {
    pageTitleText = I18n.t("js.modules.breadcrumb.presenters.page_title_format", {
      categoryText: categoryCrumb.getTitle()
    });
  }
  return {
    text: pageTitleText,
    href: categoryCrumb.href,
    id: categoryCrumb.id
  };
};

getDefaultCategoryCrumb = function() {
  var defaultCategory, friendlyNameToUse;
  defaultCategory = Groupon.Categories.defaultCategory;
  friendlyNameToUse = getGoodsFriendlyName(defaultCategory);
  return new Crumb({
    id: defaultCategory.id,
    friendlyName: friendlyNameToUse === "Goods" ? I18n.t("js.modules.breadcrumb.presenters.all_goods_friendly_name") : friendlyNameToUse,
    showHref: false
  });
};

getParsedParams = function(params, categories) {
  var category, category2, category3, category4, category5, division, l4Categories, l4Category, selectedl2s, selectedl3s, selectedl4, selectedl4s, selectedl5s, selectedl6s, subCategories, _i, _j, _len, _len1;
  category = params.category, category2 = params.category2, category3 = params.category3, category4 = params.category4, category5 = params.category5, division = params.division;
  selectedl2s = [category];
  selectedl3s = category2 ? category2.split(',') : [];
  selectedl4s = category3 ? category3.split(',') : [];
  selectedl5s = category4 ? category4.split(',') : [];
  selectedl6s = category5 ? category5.split(',') : [];
  subCategories = [].concat(selectedl3s, selectedl4s, selectedl5s, selectedl6s);
  for (_i = 0, _len = selectedl4s.length; _i < _len; _i++) {
    selectedl4 = selectedl4s[_i];
    l4Categories = getSelectedNodes(categories, 'children', function(cat) {
      return contains(selectedl4s, cat.id);
    });
    for (_j = 0, _len1 = l4Categories.length; _j < _len1; _j++) {
      l4Category = l4Categories[_j];
      if (!contains(selectedl3s, l4Category.parent.id)) {
        selectedl3s.push(l4Category.parent.id);
      }
    }
  }
  return {
    category: category,
    division: division,
    selectedl2s: selectedl2s,
    selectedl3s: selectedl3s,
    selectedl4s: selectedl4s,
    selectedl5s: selectedl5s,
    selectedl6s: selectedl6s,
    subCategories: subCategories
  };
};

getFacetValues = function(facets, facetKey) {
  var facet;
  if (isArray(facets)) {
    facet = find(facets, function(facet) {
      return facet.id === facetKey.raw;
    });
    return facet != null ? facet.values : void 0;
  } else {
    return facets[facetKey.structured];
  }
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../../../shared/common/helpers/tree_traversal":51,"../../common/models/crumb":7,"pretty-urls":107}],9:[function(require,module,exports){
var Backbone, BreadcrumbIndexTemplate, BreadcrumbView,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  __hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

BreadcrumbIndexTemplate = require('../../index.html.mustache');

module.exports = BreadcrumbView = (function(_super) {
  var BREADCRUMB_SELECTOR;

  __extends(BreadcrumbView, _super);

  BREADCRUMB_SELECTOR = '#breadcrumb-container';

  BreadcrumbView.prototype.template = BreadcrumbIndexTemplate;

  function BreadcrumbView(_at_presenter) {
    var $module, breadcrumb;
    this.presenter = _at_presenter;
    breadcrumb = this.presenter.breadcrumb;
    if (!$(BREADCRUMB_SELECTOR).length) {
      return;
    }
    $module = $(BREADCRUMB_SELECTOR);
    this.$el = $module;
  }

  BreadcrumbView.prototype.render = function() {
    return this.$el.replaceWith(this.toHtml());
  };

  BreadcrumbView.prototype.toHtml = function() {
    return this.template.render(this.presenter);
  };

  BreadcrumbView.prototype.getSelector = function() {
    var selector;
    selector = $(BREADCRUMB_SELECTOR);
    if (selector.length) {
      return selector;
    }
  };

  return BreadcrumbView;

})(Backbone.View);



},{"../../index.html.mustache":10,"backbone":56}],10:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("breadcrumb",c,p,1),c,p,0,17,727,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div id=\"breadcrumb-container\" class=\"module-container\">");t.b("\n" + i);t.b("    <div class=\"module breadcrumb\" data-bhw=\"GoodsBreadcrumb\">");t.b("\n" + i);t.b("      <nav class=\"breadcrumb-nav\">");t.b("\n" + i);t.b("        <ul>");t.b("\n" + i);if(t.s(t.f("crumbs",c,p,1),c,p,0,211,666,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <li>");t.b("\n" + i);if(t.s(t.f("showSeparator",c,p,1),c,p,0,263,334,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                <span class=\"separator\">&rsaquo;</span>");t.b("\n" + i);});c.pop();}if(t.s(t.f("showHref",c,p,1),c,p,0,384,500,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                <a class=\"crumb\" href=\"");t.b(t.v(t.f("href",c,p,0)));t.b("\" title=\"");t.b(t.v(t.f("friendlyName",c,p,0)));t.b("\">");t.b(t.v(t.f("friendlyName",c,p,0)));t.b("</a>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("showHref",c,p,1),c,p,1,0,0,"")){t.b("                <span class=\"crumb\">");t.b(t.v(t.f("friendlyName",c,p,0)));t.b("</span>");t.b("\n" + i);};t.b("            </li>");t.b("\n" + i);});c.pop();}t.b("        </ul>");t.b("\n" + i);t.b("      </nav>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{# breadcrumb }}\n  <div id=\"breadcrumb-container\" class=\"module-container\">\n    <div class=\"module breadcrumb\" data-bhw=\"GoodsBreadcrumb\">\n      <nav class=\"breadcrumb-nav\">\n        <ul>\n          {{# crumbs }}\n            <li>\n              {{# showSeparator }}\n                <span class=\"separator\">&rsaquo;</span>\n              {{/ showSeparator }}\n              {{# showHref }}\n                <a class=\"crumb\" href=\"{{ href }}\" title=\"{{ friendlyName }}\">{{ friendlyName }}</a>\n              {{/ showHref }}\n              {{^ showHref }}\n                <span class=\"crumb\">{{ friendlyName }}</span>\n              {{/ showHref }}\n            </li>\n          {{/ crumbs }}\n        </ul>\n      </nav>\n    </div>\n  </div>\n{{/ breadcrumb }}\n", Hogan);
},{"hogan.js":102}],11:[function(require,module,exports){
(function (global){
var CURRENT_PAGE_NUMBER_WITH_BOX, DEFAULT_MAX_PAGINATION_SLOTS_PER_PAGE, TERMINATOR_AND_DOTS, getDotsAndLastPage, getFirstPageAndDots, getPageHash, getPagesByRange, omitUndefined, toArray,
  __slice = [].slice;

omitUndefined = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null).omitUndefined;

DEFAULT_MAX_PAGINATION_SLOTS_PER_PAGE = 10;

TERMINATOR_AND_DOTS = 2;

CURRENT_PAGE_NUMBER_WITH_BOX = 1;

toArray = function(_arg) {
  var currentPageNumber, endDotsThreshold, endNumber, getPageUrl, maxPaginationSlotsPerPage, numbersRadius, startDotsThreshold, startNumber, totalPages;
  currentPageNumber = _arg.currentPageNumber, totalPages = _arg.totalPages, getPageUrl = _arg.getPageUrl, maxPaginationSlotsPerPage = _arg.maxPaginationSlotsPerPage;
  if (maxPaginationSlotsPerPage == null) {
    maxPaginationSlotsPerPage = DEFAULT_MAX_PAGINATION_SLOTS_PER_PAGE;
  }
  currentPageNumber = parseInt(currentPageNumber);
  endDotsThreshold = maxPaginationSlotsPerPage - TERMINATOR_AND_DOTS;
  startDotsThreshold = totalPages - maxPaginationSlotsPerPage + TERMINATOR_AND_DOTS + 1;
  if (totalPages <= maxPaginationSlotsPerPage) {
    return getPagesByRange(1, totalPages, currentPageNumber, getPageUrl);
  } else if (currentPageNumber < endDotsThreshold) {
    return __slice.call(getPagesByRange(1, endDotsThreshold, currentPageNumber, getPageUrl)).concat(__slice.call(getDotsAndLastPage(currentPageNumber, totalPages, getPageUrl)));
  } else if (currentPageNumber > startDotsThreshold) {
    return __slice.call(getFirstPageAndDots(currentPageNumber, getPageUrl)).concat(__slice.call(getPagesByRange(startDotsThreshold, totalPages, currentPageNumber, getPageUrl)));
  } else {
    numbersRadius = (maxPaginationSlotsPerPage - (TERMINATOR_AND_DOTS * 2) - CURRENT_PAGE_NUMBER_WITH_BOX) / 2;
    startNumber = currentPageNumber - Math.floor(numbersRadius);
    endNumber = currentPageNumber + Math.ceil(numbersRadius);
    return __slice.call(getFirstPageAndDots(currentPageNumber, getPageUrl)).concat(__slice.call(getPagesByRange(startNumber, endNumber, currentPageNumber, getPageUrl)), __slice.call(getDotsAndLastPage(currentPageNumber, totalPages, getPageUrl)));
  }
};

getFirstPageAndDots = function(currentPageNumber, getPageUrl) {
  return [
    getPageHash(1, currentPageNumber, getPageUrl), {
      text: '...',
      "box": false
    }
  ];
};

getDotsAndLastPage = function(currentPageNumber, totalPages, getPageUrl) {
  return [
    {
      text: '...',
      "box": false
    }, getPageHash(totalPages, currentPageNumber, getPageUrl)
  ];
};

getPagesByRange = function(from, to, currentPageNumber, getPageUrl) {
  var pageNumber, _i, _results;
  _results = [];
  for (pageNumber = _i = from; _i <= to; pageNumber = _i += 1) {
    _results.push(getPageHash(pageNumber, currentPageNumber, getPageUrl));
  }
  return _results;
};

getPageHash = function(pageNumber, currentPageNumber, getPageUrl) {
  var isCurrentPage;
  isCurrentPage = pageNumber === currentPageNumber;
  return omitUndefined({
    box: isCurrentPage,
    text: pageNumber,
    url: !isCurrentPage ? getPageUrl(pageNumber) : void 0
  });
};

module.exports = {
  toArray: toArray
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],12:[function(require,module,exports){
(function (global){
var BrowsePaginationFooterPresenter, PaginationSlots, getNextPageTranslation, getNextPageUrl, getPreviousPageTranslation, getPreviousPageUrl, getUrlForPageNumber, isEmpty, isSinglePageDeals, omit, partial, prefixI18n, qs, resultsHtml, toHash, _ref;

_ref = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), isEmpty = _ref.isEmpty, omit = _ref.omit, partial = _ref.partial;

prefixI18n = require('../../../shared/common/helpers/translations').prefixI18n;

PaginationSlots = require('../helpers/pagination_slots');

qs = require('qs');

toHash = function(attributes, config, modules, isClientSide) {
  var I18n, currentPageNumber, endingIndex, fetchedDealCount, getPageUrl, nextPageSize, query, queryParams, requestURL, startingIndex, totalDealCount, totalPages;
  if (config == null) {
    config = {};
  }
  I18n = modules.I18n;
  requestURL = attributes.requestURL, query = attributes.query, currentPageNumber = attributes.currentPageNumber, totalPages = attributes.totalPages, nextPageSize = attributes.nextPageSize, totalDealCount = attributes.totalDealCount, startingIndex = attributes.startingIndex, endingIndex = attributes.endingIndex, fetchedDealCount = attributes.fetchedDealCount;
  if (requestURL == null) {
    return;
  }
  queryParams = query;
  getPageUrl = partial(getUrlForPageNumber, requestURL, queryParams);
  if (isClientSide) {
    I18n = prefixI18n(I18n, 'js.');
  }
  return {
    number: currentPageNumber,
    resultsHtml: resultsHtml(startingIndex, endingIndex, totalDealCount, I18n),
    displayPagination: !isSinglePageDeals(currentPageNumber, nextPageSize),
    previousPage: getPreviousPageTranslation(I18n),
    nextPage: getNextPageTranslation(I18n),
    previousPageUrl: getPreviousPageUrl(requestURL, queryParams, currentPageNumber),
    nextPageUrl: getNextPageUrl(requestURL, queryParams, currentPageNumber, nextPageSize, totalPages),
    paginationSlots: PaginationSlots.toArray({
      currentPageNumber: currentPageNumber,
      totalPages: totalPages,
      getPageUrl: getPageUrl
    })
  };
};

getPreviousPageTranslation = function(I18n) {
  return I18n.t('modules.browse.presenters.pagination.previous');
};

getNextPageTranslation = function(I18n) {
  return I18n.t('modules.browse.presenters.pagination.next');
};

getPreviousPageUrl = function(requestURL, queryParams, currentPageNumber) {
  if (currentPageNumber === 1) {
    return;
  }
  return getUrlForPageNumber(requestURL, queryParams, parseInt(currentPageNumber) - 1);
};

getNextPageUrl = function(requestURL, queryParams, currentPageNumber, nextPageSize, totalPages) {
  if (currentPageNumber === totalPages || !(nextPageSize > 0)) {
    return;
  }
  return getUrlForPageNumber(requestURL, queryParams, parseInt(currentPageNumber) + 1);
};

resultsHtml = function(startingIndex, endingIndex, totalDealCount, I18n) {
  var translateOptions;
  translateOptions = {
    strongOpen: "<strong>",
    strongClose: "</strong>",
    totalDealCount: totalDealCount,
    startingIndex: startingIndex,
    endingIndex: endingIndex
  };
  return "<span>" + (I18n.t('modules.browse.presenters.pagination.results', translateOptions)) + "</span>";
};

getUrlForPageNumber = function(requestURL, queryParams, pageNumber) {
  var baseUri, paginationParams, stringify, _ref1;
  if (queryParams == null) {
    queryParams = {};
  }
  paginationParams = queryParams;
  if (paginationParams.page) {
    delete paginationParams.page;
  }
  if (pageNumber !== 1) {
    paginationParams.page = pageNumber;
  }
  baseUri = requestURL;
  if (baseUri.indexOf('?') > -1) {
    baseUri = baseUri.substring(0, baseUri.indexOf('?'));
  }
  if (isEmpty(paginationParams)) {
    return baseUri;
  }
  stringify = (_ref1 = qs != null ? qs.stringify : void 0) != null ? _ref1 : $.param;
  return baseUri + "?" + (stringify(paginationParams));
};

isSinglePageDeals = function(pageNumber, nextPageSize) {
  if (!((pageNumber != null) && (nextPageSize != null))) {
    return true;
  }
  if (pageNumber !== 1) {
    return false;
  }
  if (!(nextPageSize <= 0)) {
    return false;
  }
  return true;
};

module.exports = BrowsePaginationFooterPresenter = {
  toHash: toHash
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../../../shared/common/helpers/translations":50,"../helpers/pagination_slots":11,"qs":116}],13:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"error\">");t.b("\n" + i);t.b("  <h1>");t.b(t.v(t.f("error_message_header",c,p,0)));t.b("</h1>");t.b("\n");t.b("\n" + i);t.b("  <div class=\"error-content\">");t.b("\n" + i);t.b("    <p>");t.b(t.t(t.f("error_message_content_p1",c,p,0)));t.b("</p>");t.b("\n" + i);t.b("    <p>");t.b(t.t(t.f("error_message_content_p2",c,p,0)));t.b("</p>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"error\">\n  <h1>{{ error_message_header }}</h1>\n\n  <div class=\"error-content\">\n    <p>{{{ error_message_content_p1 }}}</p>\n    <p>{{{ error_message_content_p2 }}}</p>\n  </div>\n</div>\n", Hogan);
},{"hogan.js":102}],14:[function(require,module,exports){
var BROWSE_REFINEMENT_KEYS, BrowseApplication, BrowseContentView, BrowseHeaderTitleHelper, BrowseParsedParamsHelper, BrowseUpdateAppUrlHelper, BrowseUrlContructionHelper, DealsMmSearch, DealsPaginationEvents, PaginatedDealsBuilder, RefinementUI, SortToggleApplication, SpinnerGroup, ToolTipDelayView,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

BrowseContentView = require('./views/content');

BrowseHeaderTitleHelper = require('./helpers/header_title');

BrowseUpdateAppUrlHelper = require('./helpers/update_app_url');

BrowseUrlContructionHelper = require('./helpers/url_construction');

BrowseParsedParamsHelper = require('./helpers/parsed_params');

DealsMmSearch = require('../../deals/frontend/mm_search');

DealsPaginationEvents = require('../../deals/frontend/pagination_events');

PaginatedDealsBuilder = require('../../deals/frontend/helpers/paginated_deals_builder');

RefinementUI = require('grpn-refinement-ui/lib/frontend/application');

SortToggleApplication = require('../../grpn-sorts/frontend/application');

SpinnerGroup = require('./helpers/spinner_group');

ToolTipDelayView = require('./views/tool_tip_delay');

BROWSE_REFINEMENT_KEYS = ['category', 'category2', 'interest', 'minPrice', 'maxPrice', 'price', 'query'];

module.exports = BrowseApplication = (function() {
  var browseContentViewInstance, fetchAndRenderDeals, initAppWithoutRefinementUI, initRefinementUI, initSortsApp, refinementUIAppInstance, relocateInAppMessages, updatePageContent;

  refinementUIAppInstance = browseContentViewInstance = void 0;

  function BrowseApplication(_arg) {
    this.isLeftBarVisible = _arg.isLeftBarVisible, this.isOnNoDealsPage = _arg.isOnNoDealsPage, this.goodsBrowsePageLayoutValue = _arg.goodsBrowsePageLayoutValue, this.inNewHomepage = _arg.inNewHomepage, this.carouselConfig = _arg.carouselConfig, this.homeWidgetPreview = _arg.homeWidgetPreview, this.showFreeShippingModal = _arg.showFreeShippingModal, this.selectedCategory = _arg.selectedCategory, this.isSeoEnabled = _arg.isSeoEnabled, this.isVanityUrl = _arg.isVanityUrl, this.collection = _arg.collection, this.inGoodsHomepageSSR = _arg.inGoodsHomepageSSR, this.showClearanceWidget = _arg.showClearanceWidget, this.dealTileAds = _arg.dealTileAds, this.inRAPI = _arg.inRAPI, this.useNewGAPIConnector = _arg.useNewGAPIConnector;
    this.renderContent = __bind(this.renderContent, this);
    this.resetRefinementUi = __bind(this.resetRefinementUi, this);
    this.assignUrlBuilder();
  }

  BrowseApplication.prototype.assignUrlBuilder = function() {
    return this.constructUrl = (function() {
      switch (false) {
        case !this.collection:
          return BrowseUrlContructionHelper.getConstructCollectionById(this.collection.id, this.collection.type);
        case !this.isSeoEnabled:
          return BrowseUrlContructionHelper.constructV2;
        default:
          return BrowseUrlContructionHelper.constructV1;
      }
    }).call(this);
  };

  BrowseApplication.prototype.isMmHome = function() {
    var queryKeys;
    queryKeys = _.keys(Groupon.Utils.unparam());
    return this.goodsBrowsePageLayoutValue === "mmhome" && !_.intersection(queryKeys, BROWSE_REFINEMENT_KEYS).length && !this.collection && (!this.isVanityUrl || this.selectedCategory.id === 'all-deals');
  };

  BrowseApplication.prototype.startApp = function() {
    var adSenseBlock, pageOptions;
    if (this.isMmHome()) {
      this.renderMmHomeDeals(new DealsMmSearch({
        inNewHomepage: this.inNewHomepage,
        carouselConfig: this.carouselConfig,
        homeWidgetPreview: this.homeWidgetPreview,
        showFreeShippingModal: this.showFreeShippingModal,
        inGoodsHomepageSSR: this.inGoodsHomepageSSR
      }));
    } else {
      if (this.isLeftBarVisible) {
        initRefinementUI(this.constructUrl);
      } else {
        initAppWithoutRefinementUI();
      }
      relocateInAppMessages();
      initSortsApp(this.constructUrl);
    }
    if (Groupon.adSense) {
      pageOptions = {
        pubId: Groupon.adSense.pubId,
        query: Groupon.adSense.category,
        textColorPalette: ['#333']
      };
      adSenseBlock = {
        container: 'adsense-container',
        width: Groupon.adSense.width,
        height: Groupon.adSense.height,
        linkTarget: '_blank',
        adLoadedCallback: function(container, adsLoaded) {
          if (adsLoaded) {
            return $("#adsense-container").css({
              "min-height": 265
            });
          } else {
            return $("#adsense-container").css({
              "min-height": 0,
              "height": 0
            });
          }
        }
      };
      if (Groupon.adSense.showAds) {
        return _googCsa('plas', pageOptions, adSenseBlock);
      }
    }
  };

  BrowseApplication.prototype.resetRefinementUi = function() {
    if (refinementUIAppInstance != null) {
      refinementUIAppInstance.updateRefinements(Groupon.refinementUiPageData, {
        queue: true
      });
      return BrowseUpdateAppUrlHelper.updateFromRefinements(refinementUIAppInstance.selectedRefinements, this.constructUrl);
    }
  };

  BrowseApplication.prototype.renderContent = function(options) {
    return browseContentViewInstance != null ? browseContentViewInstance.render(options) : void 0;
  };

  initAppWithoutRefinementUI = function() {
    return browseContentViewInstance = new BrowseContentView({
      isContentRendered: true
    });
  };

  initRefinementUI = function(constructionLibrary) {
    var categoryAttributesEnabled, enabledFacets, facetFilters, getEnabledFacets, getParsedParams, refinementUiOptions, updateFromRefinements, _ref, _ref1, _ref2;
    updateFromRefinements = BrowseUpdateAppUrlHelper.updateFromRefinements, getEnabledFacets = BrowseUpdateAppUrlHelper.getEnabledFacets, getParsedParams = BrowseUpdateAppUrlHelper.getParsedParams;
    facetFilters = (_ref = Groupon.facetFilters) != null ? _ref : {};
    categoryAttributesEnabled = (_ref1 = Groupon.categoryAttributesEnabled) != null ? _ref1 : {};
    refinementUiOptions = (_ref2 = Groupon.refinementUiOptions) != null ? _ref2 : {};
    refinementUiOptions.container = '#refinement-ui';
    refinementUIAppInstance = new RefinementUI(Groupon.refinementUiPageData, refinementUiOptions);
    BrowseHeaderTitleHelper.updateHeaderTitle($('.page-header .title'), Groupon.refinementUiPageData, Groupon.seoMetaHash);
    refinementUIAppInstance.events.on('refinementsUpdated', function(selectedRefinements, selectedId) {
      var l1, l2, l3, l4, _filterSelectedRefinements, _ref3, _ref4, _ref5;
      Groupon.browseApp.lastUpdatedRefinementId = selectedId;
      _filterSelectedRefinements = function(Lm, categoryName) {
        var LmWhitelist, facetName, whitelist, _ref3, _results;
        if (!(LmWhitelist = categoryAttributesEnabled[Lm])) {
          return;
        }
        whitelist = (_ref3 = LmWhitelist[categoryName]) != null ? _ref3 : [];
        _results = [];
        for (facetName in facetFilters) {
          if (__indexOf.call(whitelist, facetName) < 0) {
            _results.push(delete selectedRefinements[facetName]);
          } else {
            _results.push(void 0);
          }
        }
        return _results;
      };
      if (!(l1 = selectedRefinements.category)) {

      } else if (!(l2 = (_ref3 = l1.selectedValues) != null ? _ref3[0] : void 0)) {
        _filterSelectedRefinements('L2', 'all');
      } else if (!(l3 = (_ref4 = l2.selectedValues) != null ? _ref4[0] : void 0)) {
        _filterSelectedRefinements('L2', l2.name);
      } else if (!(l4 = (_ref5 = l3.selectedValues) != null ? _ref5[0] : void 0)) {
        _filterSelectedRefinements('L3', l3.name);
      }
      updateFromRefinements(selectedRefinements, constructionLibrary);
      return updatePageContent();
    });
    browseContentViewInstance = new BrowseContentView({
      isContentRendered: true
    });
    if (refinementUIAppInstance.selectedRefinements) {
      enabledFacets = getEnabledFacets(refinementUIAppInstance.selectedRefinements);
      return BrowseParsedParamsHelper.setParsedParams(getParsedParams(enabledFacets));
    }
  };

  updatePageContent = function() {
    fetchAndRenderDeals();
    return OptimizeSuite.treatAsNewPage(window.location.href);
  };

  initSortsApp = function(constructionLibrary) {
    return $(function() {
      var sortsApp;
      sortsApp = SortToggleApplication;
      sortsApp.initialize();
      return sortsApp.on('change:sort', function(selectedRefinements) {
        BrowseUpdateAppUrlHelper.updateFromSorts(selectedRefinements, constructionLibrary);
        return fetchAndRenderDeals();
      });
    });
  };

  relocateInAppMessages = function() {
    return $(function() {
      var banner;
      banner = $("#in-app-messages").detach();
      banner.find(".hide-link").click(function() {
        return banner.slideUp();
      });
      return banner.appendTo("#inAppMessageBanner");
    });
  };

  fetchAndRenderDeals = function() {
    var paginatedBuilder;
    paginatedBuilder = new PaginatedDealsBuilder;
    if (browseContentViewInstance == null) {
      browseContentViewInstance = new BrowseContentView();
    }
    browseContentViewInstance.render({
      paginatedDealsBuilder: paginatedBuilder
    });
    return paginatedBuilder.on("fetchSuccess", function(search) {
      var refinementUiPageData, seoMetaHash, _ref;
      if (Groupon.refinementUiPageData) {
        _ref = search.page, refinementUiPageData = _ref.refinementUiPageData, seoMetaHash = _ref.seoMetaHash;
        Groupon.refinementUiPageData = refinementUiPageData;
        if (seoMetaHash) {
          Groupon.seoMetaHash = seoMetaHash;
        }
        refinementUIAppInstance.updateRefinements(refinementUiPageData);
        BrowseHeaderTitleHelper.updateHeaderTitle($('.page-header .title'), refinementUiPageData, seoMetaHash);
      }
      return DealsPaginationEvents.trigger("newPage", search.page);
    });
  };

  BrowseApplication.prototype.renderMmHomeDeals = function(mmSearch) {
    this._startSpinner();
    mmSearch.on('error', (function(_this) {
      return function() {
        return _this._onDoneFetchingDeals(function() {});
      };
    })(this));
    return mmSearch.on('success', (function(_this) {
      return function(deals, dealIdList) {
        return _this._onDoneFetchingDeals(function() {
          return $(function() {
            $("#browse_deals_container").replaceWith(deals);
            return GIG.Tooltip.reloadBindings(document.body);
          });
        });
      };
    })(this));
  };

  BrowseApplication.prototype._onDoneFetchingDeals = function(renderContentCallback) {
    renderContentCallback();
    return this._stopSpinner();
  };

  BrowseApplication.prototype._stopSpinner = function() {
    return SpinnerGroup.stop('deal-space', {
      remove: true
    });
  };

  BrowseApplication.prototype._startSpinner = function() {
    return SpinnerGroup.start('deal-space', {
      parentElem: $('#deal-space'),
      css: {
        marginTop: '100px'
      },
      useV2: true
    });
  };

  BrowseApplication.prototype.isCategoryPage = function() {
    var _ref;
    return _ref = this.getSelectedCategory(), __indexOf.call(Groupon.Categories.staticCategories.ids, _ref) < 0;
  };

  BrowseApplication.prototype.getSelectedCategory = function() {
    var _ref, _ref1;
    if (((_ref = Groupon.Categories) != null ? (_ref1 = _ref.selectedCategory) != null ? _ref1.id : void 0 : void 0) != null) {
      return Groupon.Categories.selectedCategory.id;
    }
    return 'all';
  };

  return BrowseApplication;

})();



},{"../../deals/frontend/helpers/paginated_deals_builder":35,"../../deals/frontend/mm_search":38,"../../deals/frontend/pagination_events":39,"../../grpn-sorts/frontend/application":45,"./helpers/header_title":16,"./helpers/parsed_params":17,"./helpers/spinner_group":18,"./helpers/update_app_url":20,"./helpers/url_construction":21,"./views/content":26,"./views/tool_tip_delay":29,"grpn-refinement-ui/lib/frontend/application":57}],15:[function(require,module,exports){
var BrowseContentHelper, DEAL_CONTENT_CONTAINER, DEAL_SPACE_MSG_CONTENT;

DEAL_CONTENT_CONTAINER = '#deal_content';

DEAL_SPACE_MSG_CONTENT = '#deal_space_message_content';

module.exports = BrowseContentHelper = {
  getDealsMessageSelector: function() {
    return $(DEAL_SPACE_MSG_CONTENT);
  },
  getDealsContentSelector: function() {
    return $(DEAL_CONTENT_CONTAINER);
  }
};



},{}],16:[function(require,module,exports){
(function (global){
var BrowseHeaderTitleHelper, PageHeaderTitlePresenter, PageHeaderTitleTemplate, findWhere, where, _changeHeaderTitle, _changeHeaderTitleAndBhc, _getSelectedMultiSelect, _getSelectedNestedRefinement, _ref, _resetHeaderTitle, _updateCollectionTitle,
  __slice = [].slice;

_ref = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), findWhere = _ref.findWhere, where = _ref.where;

PageHeaderTitlePresenter = require('../../../page_header/frontend/presenters/title');

PageHeaderTitleTemplate = require('../../../page_header/title.html.mustache');

_getSelectedNestedRefinement = function(nestedRefinements) {
  var selectedChild, selectedRefinement, _ref1;
  if (nestedRefinements == null) {
    return;
  }
  selectedRefinement = findWhere(nestedRefinements, {
    selected: true
  });
  if (!selectedRefinement || selectedRefinement.id === 'all') {
    return;
  }
  if (selectedRefinement != null ? (_ref1 = selectedRefinement.children) != null ? _ref1.length : void 0 : void 0) {
    selectedChild = _getSelectedNestedRefinement(selectedRefinement.children);
  }
  if (selectedChild) {
    return selectedChild;
  }
  return selectedRefinement;
};

_getSelectedMultiSelect = function() {
  var refinementArgs, refinements, selectedRefinement, selectedRefinements, _i, _len;
  refinementArgs = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
  for (_i = 0, _len = refinementArgs.length; _i < _len; _i++) {
    refinements = refinementArgs[_i];
    selectedRefinements = where(refinements, {
      selected: true
    });
    if (!(selectedRefinements.length < 2)) {
      break;
    }
    if (selectedRefinements.length === 1) {
      selectedRefinement = selectedRefinements[0];
      break;
    }
  }
  return selectedRefinement;
};

_changeHeaderTitle = function(elem, refinement) {
  return elem.html(refinement.friendlyName);
};

_changeHeaderTitleAndBhc = function(elem, refinement, pageMeta) {
  return elem.html($('<a>').text((pageMeta != null ? pageMeta.h1 : void 0) || refinement.friendlyName).attr({
    'data-bhc': refinement.dataBhc
  }));
};

_resetHeaderTitle = function(elem) {
  var refinementAll;
  refinementAll = {
    dataBhc: 'category:all',
    friendlyName: I18n.translate('js.modules.browse.presenters.all_goods')
  };
  return _changeHeaderTitleAndBhc(elem, refinementAll, void 0);
};

_updateCollectionTitle = function(elem, collection, refinementInterests) {
  var headingPresenter, queryParams, topCategory;
  topCategory = Groupon.Categories.selectedCategory;
  if (topCategory.id == null) {
    topCategory = Groupon.Categories.defaultCategory;
  }
  queryParams = Groupon.Utils.unparam();
  headingPresenter = (new PageHeaderTitlePresenter({
    selectedCategory: topCategory,
    params: queryParams,
    basePath: window.location.pathname,
    refinementInterests: refinementInterests,
    collection: collection
  })).toHash();
  if (headingPresenter != null) {
    return elem.html(PageHeaderTitleTemplate.render(headingPresenter));
  }
};

module.exports = BrowseHeaderTitleHelper = {
  updateHeaderTitle: function(elem, refinementUiPageData, seoMetaHash) {
    var collection, refinementCategories, refinementDiscounts, refinementInterests, selectedCategory, selectedInterestOrDiscount, _ref1, _ref2, _ref3;
    if ((collection = Groupon.collection)) {
      return _updateCollectionTitle(elem, collection);
    }
    refinementCategories = (_ref1 = findWhere(refinementUiPageData, {
      id: 'category'
    })) != null ? _ref1.refinementData : void 0;
    selectedCategory = _getSelectedNestedRefinement(refinementCategories);
    if (selectedCategory) {
      return _changeHeaderTitleAndBhc(elem, selectedCategory, seoMetaHash != null ? seoMetaHash.pageMeta : void 0);
    }
    refinementDiscounts = ((_ref2 = findWhere(refinementUiPageData, {
      id: 'discount'
    })) != null ? _ref2.refinementData : void 0) || [];
    refinementInterests = ((_ref3 = findWhere(refinementUiPageData, {
      id: 'interest'
    })) != null ? _ref3.refinementData : void 0) || [];
    selectedInterestOrDiscount = _getSelectedMultiSelect(refinementInterests, refinementDiscounts);
    if (selectedInterestOrDiscount) {
      return _changeHeaderTitle(elem, selectedInterestOrDiscount);
    }
    return _resetHeaderTitle(elem);
  }
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../../../page_header/frontend/presenters/title":47,"../../../page_header/title.html.mustache":48}],17:[function(require,module,exports){
var Backbone, BrowseParsedParamsHelper, handlers, parsedParams;

Backbone = require('backbone');

parsedParams = new Backbone.Model();

handlers = {};

module.exports = BrowseParsedParamsHelper = {
  setParsedParams: function(params, options) {
    parsedParams.clear({
      silent: true
    });
    parsedParams.set(params, {
      silent: true
    });
    return parsedParams.trigger('change', parsedParams, options);
  },
  getParsedParams: function() {
    return parsedParams.toJSON();
  },
  onUpdate: function(cb, key) {
    var changeHandler;
    changeHandler = function(model, options) {
      return cb(model.toJSON(), options);
    };
    if (key != null) {
      handlers[key] = changeHandler;
    }
    return parsedParams.on('change', changeHandler);
  },
  offUpdate: function(key) {
    if (handlers[key]) {
      parsedParams.off('change', handlers[key]);
      return delete handlers[key];
    }
  }
};



},{"backbone":56}],18:[function(require,module,exports){
var SpinnerGroup, SpinnerView;

SpinnerView = require('../../../spinner/frontend/views/spinner');

module.exports = SpinnerGroup = {
  spinners: {},
  addSpinner: function(name, options) {
    return this.spinners[name] = (new SpinnerView(options)).render();
  },
  removeSpinner: function(name) {
    var _ref;
    if ((_ref = this.spinners[name]) != null) {
      _ref.remove();
    }
    return delete this.spinners[name];
  },
  start: function(name, options) {
    var spinner, _ref;
    spinner = (_ref = this.spinners[name]) != null ? _ref : this.addSpinner(name, options).render();
    return spinner != null ? spinner.start() : void 0;
  },
  stop: function(name, options) {
    var spinner, _ref;
    if (options != null ? options.remove : void 0) {
      return this.removeSpinner(name);
    }
    if (!((_ref = (spinner = this.spinners[name])) != null ? _ref.isRunning() : void 0)) {
      return;
    }
    return spinner.stop();
  }
};



},{"../../../spinner/frontend/views/spinner":53}],19:[function(require,module,exports){
var TrackingHelper;

TrackingHelper = (function() {
  function TrackingHelper() {
    this.recordedFirstPage = false;
  }

  TrackingHelper.prototype.pageReady = function() {
    if (this.recordedFirstPage) {
      return;
    }
    if (!Groupon.Performance) {
      return;
    }
    Groupon.Performance.pageReady();
    return this.recordedFirstPage = true;
  };

  return TrackingHelper;

})();

module.exports = TrackingHelper;



},{}],20:[function(require,module,exports){
(function (global){
var ALL_FACET_NAMES, BrowseParsedParamsHelper, BrowseUpdateAppUrlHelper, FACET_FILTERS, FACET_NAMES, PARAM_WHITELIST, UpdateAppURLHelper, extend, keys, pluck, where, _addSort, _getCategoryHash, _getEnabledFacets, _getExtraQS, _getNestedRefinements, _getParsedParams, _getSelectedFlatRefinements, _getSelectedRange, _ref, _ref1, _ref2, _ref3;

BrowseParsedParamsHelper = require('./parsed_params');

UpdateAppURLHelper = require('../../../shared/frontend/helpers/app_url');

_ref = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), extend = _ref.extend, keys = _ref.keys, pluck = _ref.pluck, where = _ref.where;

FACET_NAMES = {
  CATEGORY_QUERY: 'category2',
  SUBCATEGORY_QUERY: 'category3',
  SUBCATEGORY2_QUERY: 'category4',
  SUBCATEGORY3_QUERY: 'category5',
  INTEREST_QUERY: 'interest',
  DISCOUNT_QUERY: 'discount',
  BRAND_QUERY: 'brand'
};

PARAM_WHITELIST = ['interest', 'discount', 'query', 'minPrice', 'maxPrice', 'price', 'brand', 'sort'];

FACET_FILTERS = (_ref1 = Groupon.facetFilters) != null ? _ref1 : (_ref2 = Groupon.PageAppData) != null ? (_ref3 = _ref2.config) != null ? _ref3.facetFilters : void 0 : void 0;

ALL_FACET_NAMES = PARAM_WHITELIST.concat(keys(FACET_FILTERS));

_getCategoryHash = function(categoryHash) {
  var selectedCategory, _ref4, _ref5;
  if ((_ref4 = Groupon.PageAppData) != null ? (_ref5 = _ref4.experiments) != null ? _ref5.inTouchFilters : void 0 : void 0) {
    selectedCategory = _getNestedRefinements(categoryHash, 'category2');
    if (!selectedCategory.length) {
      selectedCategory = _getNestedRefinements(categoryHash, 'category');
    }
    return {
      category: selectedCategory,
      category2: _getNestedRefinements(categoryHash, 'category3'),
      category3: _getNestedRefinements(categoryHash, 'category4')
    };
  } else {
    return {
      category2: _getNestedRefinements(categoryHash, 'category2'),
      category3: _getNestedRefinements(categoryHash, 'category3'),
      category4: _getNestedRefinements(categoryHash, 'category4'),
      category5: _getNestedRefinements(categoryHash, 'category5')
    };
  }
};

_getParsedParams = function(enabledFacets) {
  var attr, param, parsedParams;
  parsedParams = {};
  for (attr in enabledFacets) {
    param = enabledFacets[attr];
    if ((param != null ? param.constructor : void 0) === Array) {
      if (param.length) {
        parsedParams[attr] = param.join(',');
      }
    } else {
      parsedParams[attr] = param;
    }
  }
  return parsedParams;
};

_getEnabledFacets = function(selectedRefinements) {
  var enabledFacets, facet;
  enabledFacets = extend({}, _getCategoryHash(selectedRefinements.category), {
    interest: _getSelectedFlatRefinements(selectedRefinements.interest),
    discount: _getSelectedFlatRefinements(selectedRefinements.discount),
    minPrice: _getSelectedRange(selectedRefinements, 'price', 'min'),
    maxPrice: _getSelectedRange(selectedRefinements, 'price', 'max'),
    price: _getSelectedFlatRefinements(selectedRefinements.price),
    brand: _getSelectedFlatRefinements(selectedRefinements.brand),
    query: _getSelectedFlatRefinements(selectedRefinements.search)
  });
  if (selectedRefinements.sort != null) {
    enabledFacets.sort = _getSelectedFlatRefinements(selectedRefinements.sort);
  }
  for (facet in FACET_FILTERS) {
    enabledFacets[facet] = _getSelectedFlatRefinements(selectedRefinements[facet]);
  }
  return enabledFacets;
};

_getExtraQS = function(enabledFacets, whitelist) {
  var currentParam, extraQS, param, _i, _len, _ref4;
  extraQS = {};
  for (_i = 0, _len = whitelist.length; _i < _len; _i++) {
    param = whitelist[_i];
    if (currentParam = (_ref4 = enabledFacets[param]) != null ? _ref4.join(',') : void 0) {
      extraQS[param] = currentParam;
    }
  }
  return extraQS;
};

_getSelectedRange = function(selectedRefinements, rangeType, value) {
  var range, _ref4;
  if ((selectedRefinements != null ? (_ref4 = selectedRefinements.range) != null ? _ref4.selectedValues.length : void 0 : void 0) > 0) {
    range = where(selectedRefinements.range.selectedValues, {
      id: rangeType
    });
    if (range.length > 0) {
      if (value === 'min') {
        return [range[0].selectedMin];
      } else {
        return [range[0].selectedMax];
      }
    }
  }
};

_getSelectedFlatRefinements = function(selectedRefinement) {
  var _ref4;
  if (!(selectedRefinement != null ? (_ref4 = selectedRefinement.selectedValues) != null ? _ref4.length : void 0 : void 0)) {
    return;
  }
  return pluck(selectedRefinement.selectedValues, 'name');
};

_getNestedRefinements = function(selectedRefinement, key, refinementNames) {
  var refinement, selectedRefinements, _i, _len, _ref4;
  if (refinementNames == null) {
    refinementNames = [];
  }
  if (!(selectedRefinement != null ? (_ref4 = selectedRefinement.selectedValues) != null ? _ref4.length : void 0 : void 0)) {
    return [];
  }
  selectedRefinements = selectedRefinement.selectedValues;
  for (_i = 0, _len = selectedRefinements.length; _i < _len; _i++) {
    refinement = selectedRefinements[_i];
    if (refinement.id === key) {
      refinementNames.push(refinement.name);
    } else {
      _getNestedRefinements(refinement, key, refinementNames);
    }
  }
  return refinementNames;
};

_addSort = function(extraQS) {
  var queryParams;
  if (!extraQS.sort) {
    queryParams = Groupon.Utils.unparam();
    if (queryParams.sort) {
      extraQS.sort = queryParams.sort;
    }
  }
  if (extraQS.sort === 'relevance') {
    return delete extraQS.sort;
  }
};

module.exports = BrowseUpdateAppUrlHelper = {
  getEnabledFacets: _getEnabledFacets,
  getParsedParams: _getParsedParams,
  updateFromRefinements: function(selectedRefinements, constructionLibrary, options) {
    var adjustedURL, enabledFacets, extraQS, parsedParams;
    if (options == null) {
      options = {};
    }
    enabledFacets = _getEnabledFacets(selectedRefinements);
    extraQS = _getExtraQS(enabledFacets, ALL_FACET_NAMES);
    _addSort(extraQS);
    adjustedURL = constructionLibrary(enabledFacets, FACET_NAMES, extraQS);
    parsedParams = _getParsedParams(enabledFacets);
    BrowseParsedParamsHelper.setParsedParams(parsedParams, options);
    return UpdateAppURLHelper(adjustedURL);
  },
  updateFromSorts: function(sortRefinement) {
    var adjustedURL, queryParams;
    queryParams = Groupon.Utils.unparam();
    if (sortRefinement.sort) {
      queryParams.sort = sortRefinement.sort;
    }
    adjustedURL = window.location.pathname + "?" + ($.param(queryParams));
    return UpdateAppURLHelper(adjustedURL, {
      pushState: true
    });
  }
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../../../shared/frontend/helpers/app_url":52,"./parsed_params":17}],21:[function(require,module,exports){
var BrowseUrlConstructionHelper, constructedCategoryTaxonomy, prettyUrls, _constructCategoryTaxonomy, _constructCollection, _constructTaxonomyNode, _decideSelectedCategories, _getAppRoot, _getSelectedCategory, _getSelectedCategoryObject, _isCategoryPage, _recursivelyConstructCategoryTaxonomy;

constructedCategoryTaxonomy = void 0;

prettyUrls = require('pretty-urls');

_isCategoryPage = function() {
  var _ref;
  return (_ref = _getSelectedCategory()) !== 'all-deals' && _ref !== 'new-deals';
};

_getSelectedCategoryObject = function() {
  var _ref, _ref1, _ref2;
  return (_ref = (_ref1 = Groupon.Categories) != null ? _ref1.selectedCategory : void 0) != null ? _ref : (_ref2 = Groupon.PageAppData) != null ? _ref2.selectedCategory : void 0;
};

_getSelectedCategory = function() {
  var selectedCategoryObject;
  selectedCategoryObject = _getSelectedCategoryObject();
  if ((selectedCategoryObject != null ? selectedCategoryObject.id : void 0) != null) {
    return selectedCategoryObject.id;
  }
  return 'all';
};

_recursivelyConstructCategoryTaxonomy = function(category, categoryTaxonomy, startingLevel, rootPath) {
  var children, id;
  if (rootPath == null) {
    rootPath = [];
  }
  children = category.children, id = category.id;
  rootPath.push(id);
  categoryTaxonomy[id] = _constructTaxonomyNode(id, startingLevel, rootPath.slice(0));
  if (children != null ? children.length : void 0) {
    _.each(children, function(childCategory) {
      return _recursivelyConstructCategoryTaxonomy(childCategory, categoryTaxonomy, startingLevel + 1, rootPath);
    });
  }
  rootPath.pop();
  return categoryTaxonomy;
};

_constructCategoryTaxonomy = function() {
  var categoryTaxonomy;
  categoryTaxonomy = {};
  if (!_isCategoryPage()) {
    return categoryTaxonomy;
  }
  return _recursivelyConstructCategoryTaxonomy(_getSelectedCategoryObject(), categoryTaxonomy, 2);
};

_constructTaxonomyNode = function(id, level, rootPath) {
  return {
    id: id,
    level: level,
    rootPath: rootPath
  };
};

_decideSelectedCategories = function(enabledFacets, facetNames) {
  var CATEGORY_QUERY, SUBCATEGORY2_QUERY, SUBCATEGORY3_QUERY, SUBCATEGORY_QUERY, selectedCategoryObject, _ref;
  if (!_isCategoryPage()) {
    return [];
  } else {
    CATEGORY_QUERY = facetNames.CATEGORY_QUERY, SUBCATEGORY_QUERY = facetNames.SUBCATEGORY_QUERY, SUBCATEGORY2_QUERY = facetNames.SUBCATEGORY2_QUERY, SUBCATEGORY3_QUERY = facetNames.SUBCATEGORY3_QUERY;
    if (!_.isEmpty(enabledFacets[CATEGORY_QUERY]) || !_.isEmpty(enabledFacets[SUBCATEGORY_QUERY]) || !_.isEmpty(enabledFacets[SUBCATEGORY2_QUERY]) || !_.isEmpty(enabledFacets[SUBCATEGORY3_QUERY])) {
      return _.compact(_.union(enabledFacets[CATEGORY_QUERY], enabledFacets[SUBCATEGORY_QUERY], enabledFacets[SUBCATEGORY2_QUERY], enabledFacets[SUBCATEGORY3_QUERY]));
    } else if (((_ref = (selectedCategoryObject = _getSelectedCategoryObject())) != null ? _ref.id : void 0) != null) {
      return [selectedCategoryObject.id];
    } else {
      return ["all"];
    }
  }
};

_constructCollection = function(collectionId, collectionType, enabledFacets, facetNames, extraQS) {
  var collectionsRoot;
  if (collectionType) {
    collectionsRoot = Groupon.urls.collections;
  }
  delete extraQS.query;
  return prettyUrls.V1.construct({
    baseURL: collectionsRoot + "/" + collectionId,
    l2Categories: _isCategoryPage() ? [_getSelectedCategory()] : void 0,
    l3Categories: enabledFacets[facetNames.CATEGORY_QUERY],
    l4Categories: enabledFacets[facetNames.SUBCATEGORY_QUERY],
    l5Categories: enabledFacets[facetNames.SUBCATEGORY2_QUERY],
    l6Categories: enabledFacets[facetNames.SUBCATEGORY3_QUERY],
    interests: enabledFacets[facetNames.INTEREST_QUERY],
    brands: enabledFacets[facetNames.BRAND_QUERY],
    discounts: enabledFacets[facetNames.DISCOUNT_QUERY],
    extraQS: extraQS
  });
};

_getAppRoot = function() {
  var _ref, _ref1, _ref2;
  return (_ref = (_ref1 = Groupon.urls) != null ? _ref1.browse : void 0) != null ? _ref : (_ref2 = Groupon.PageAppData) != null ? _ref2.baseUrl : void 0;
};

module.exports = BrowseUrlConstructionHelper = {
  constructCollection: _constructCollection,
  constructV1: function(enabledFacets, facetNames, extraQS) {
    var appRoot;
    appRoot = _getAppRoot();
    return prettyUrls.V1.construct({
      baseURL: appRoot,
      l2Categories: _isCategoryPage() ? [_getSelectedCategory()] : void 0,
      l3Categories: enabledFacets[facetNames.CATEGORY_QUERY],
      l4Categories: enabledFacets[facetNames.SUBCATEGORY_QUERY],
      l5Categories: enabledFacets[facetNames.SUBCATEGORY2_QUERY],
      l6Categories: enabledFacets[facetNames.SUBCATEGORY3_QUERY],
      interests: enabledFacets[facetNames.INTEREST_QUERY],
      brands: enabledFacets[facetNames.BRAND_QUERY],
      discounts: enabledFacets[facetNames.DISCOUNT_QUERY],
      extraQS: extraQS
    });
  },
  constructV2: function(enabledFacets, facetNames, extraQS) {
    var appRoot, selectedCategories;
    appRoot = _getAppRoot();
    if (constructedCategoryTaxonomy == null) {
      constructedCategoryTaxonomy = _constructCategoryTaxonomy();
    }
    selectedCategories = _.uniq(_decideSelectedCategories(enabledFacets, facetNames));
    return prettyUrls.V2.construct(constructedCategoryTaxonomy, {
      selectedCategories: selectedCategories,
      selectedInterests: enabledFacets[facetNames.INTEREST_QUERY],
      selectedBrands: enabledFacets[facetNames.BRAND_QUERY],
      baseURL: appRoot,
      extraQS: extraQS
    });
  },
  getConstructCollectionById: function(collectionId, collectionType) {
    return function(enabledFacets, facetNames, extraQS) {
      return _constructCollection(collectionId, collectionType, enabledFacets, facetNames, extraQS);
    };
  }
};



},{"pretty-urls":107}],22:[function(require,module,exports){
var Backbone, BrowsePageEvents;

Backbone = require('backbone');

module.exports = BrowsePageEvents = _.extend({}, Backbone.Events);



},{"backbone":56}],23:[function(require,module,exports){
var BrowseErrorPresenter;

module.exports = BrowseErrorPresenter = (function() {
  function BrowseErrorPresenter() {}

  BrowseErrorPresenter.prototype.toHash = function() {
    var aClose, aOpen, breakline, category, href, isClearanceSelected, isPriceFilterSelected, queryParams;
    href = window.location.href;
    aOpen = "<a href='" + href + "'>";
    aClose = "</a>";
    breakline = "<br>";
    queryParams = Groupon.Utils.unparam();
    isPriceFilterSelected = ((queryParams != null ? queryParams.minPrice : void 0) != null) || ((queryParams != null ? queryParams.maxPrice : void 0) != null);
    isClearanceSelected = (queryParams != null ? queryParams.discount : void 0) === "gg-clearance";
    if (isPriceFilterSelected) {
      category = (queryParams != null ? queryParams.category : void 0) || 'all';
      href = "/goods?category=" + category;
      aOpen = "<a href='" + href + "'>";
      return {
        error_message_header: I18n.translate('js.modules.browse.presenters.error_message.message_header'),
        error_message_content_p1: I18n.translate('js.modules.browse.presenters.error_message.price_range_message_content_p1', {
          aOpen: aOpen,
          aClose: aClose
        }),
        error_message_content_p2: I18n.translate('js.modules.browse.presenters.error_message.message_content_p2', {
          breakline: breakline
        })
      };
    } else if (isClearanceSelected) {
      href = "/goods?category=all&discount=gg-clearance";
      aOpen = "<a href='" + href + "'>";
      return {
        error_message_header: I18n.translate('js.modules.browse.presenters.error_message.message_header'),
        error_message_content_p1: I18n.translate('js.modules.browse.presenters.error_message.clearance_message_content_p1', {
          aOpen: aOpen,
          aClose: aClose
        })
      };
    } else {
      return {
        error_message_header: I18n.translate('js.modules.browse.presenters.error_message.message_header'),
        error_message_content_p1: I18n.translate('js.modules.browse.presenters.error_message.message_content_p1', {
          aOpen: aOpen,
          aClose: aClose
        }),
        error_message_content_p2: I18n.translate('js.modules.browse.presenters.error_message.message_content_p2', {
          breakline: breakline
        })
      };
    }
  };

  return BrowseErrorPresenter;

})();



},{}],24:[function(require,module,exports){
var BrowseNoDealsErrorPresenter;

module.exports = BrowseNoDealsErrorPresenter = {
  toHash: function(lastUpdatedRefinementId) {
    switch (lastUpdatedRefinementId) {
      case 'range':
        return {
          noDealsMessage: I18n.translate('js.modules.browse.presenters.no_deals_discoverability.range.message'),
          noDealsSuggestion: I18n.translate('js.modules.browse.presenters.no_deals_discoverability.range.suggestion')
        };
      case 'discount':
        return {
          noDealsMessage: I18n.translate('js.modules.browse.presenters.no_deals_discoverability.discount.message'),
          noDealsSuggestion: I18n.translate('js.modules.browse.presenters.no_deals_discoverability.discount.suggestion')
        };
    }
  }
};



},{}],25:[function(require,module,exports){
var BackToTop, findScrollTop, showBackToTop;

BackToTop = {
  render: function() {
    if (!showBackToTop()) {
      return;
    }
    $(window).on('scroll', function() {
      var scrollTop;
      scrollTop = findScrollTop();
      if (scrollTop > 100) {
        return $('#back-to-top').fadeIn();
      } else {
        return $('#back-to-top').fadeOut();
      }
    });
    return $('#back-to-top').on('click', function() {
      return $('body,html').animate({
        scrollTop: 0
      }, 500);
    });
  }
};

findScrollTop = function() {
  if ($(window).scrollTop() > 0) {
    return $(window).scrollTop();
  }
  if (document.documentElement.scrollTop > 0) {
    return document.documentElement.scrollTop;
  }
  return 0;
};

showBackToTop = function() {
  return $('#back-to-top').length > 0;
};

module.exports = BackToTop;



},{}],26:[function(require,module,exports){
(function (global){
var BreadcrumbPresenter, BreadcrumbView, BrowseContentHelper, BrowseContentView, BrowseErrorHtml, BrowseNoDealsErrorView, DealsApplication, DealsFeaturedImageCarousel, DealsPageHeaderView, PaginatedDealsListView, SpinnerGroup, isEmpty,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

isEmpty = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null).isEmpty;

BrowseContentHelper = require('../helpers/content');

SpinnerGroup = require('../helpers/spinner_group');

BrowseErrorHtml = require('./error');

DealsFeaturedImageCarousel = require('../../../deals/frontend/featured_image_carousel');

DealsPageHeaderView = require('../../../deals/frontend/views/page_header');

BreadcrumbPresenter = require('../../../breadcrumb/frontend/presenters/breadcrumb');

BreadcrumbView = require('../../../breadcrumb/frontend/views/breadcrumb');

BrowseNoDealsErrorView = require('./no_deals_error');

PaginatedDealsListView = require('../../../deals/frontend/views/paginated_deals_list');

DealsApplication = require('../../../deals/frontend/application');

module.exports = BrowseContentView = (function() {
  BrowseContentView.prototype.SELECTORS = {
    DEAL_CONTENT: '#content #deal_content .content',
    DEAL_SPACE: '#deal-space',
    REFINEMENT_DICOUNTS: '.refinement-box.flat-refinements.discounts'
  };

  function BrowseContentView(options) {
    this._fetchSuccess = __bind(this._fetchSuccess, this);
    this._fetchError = __bind(this._fetchError, this);
    this.render(options);
  }

  BrowseContentView.prototype.render = function(_arg) {
    var isContentRendered, paginatedDealsBuilder, _ref;
    _ref = _arg != null ? _arg : {}, paginatedDealsBuilder = _ref.paginatedDealsBuilder, isContentRendered = _ref.isContentRendered;
    this._renderedContent = isContentRendered;
    this._renderedSpinner = false;
    $((function(_this) {
      return function() {
        if (!isContentRendered) {
          return _this._startSpinner();
        } else {
          return _this._renderedOnServer();
        }
      };
    })(this));
    if (paginatedDealsBuilder != null) {
      paginatedDealsBuilder.on('fetchError', this._fetchError).on('fetchSuccess', this._fetchSuccess);
    }
    return void 0;
  };

  BrowseContentView.prototype._renderedOnServer = function() {
    return $((function(_this) {
      return function() {
        var completedDealSearch, overwriteExisting, pageData;
        pageData = {
          metadata: {
            pagination: Groupon.pagination
          }
        };
        completedDealSearch = new DealsApplication({
          pageData: pageData
        });
        overwriteExisting = false;
        return _this._updateContent(completedDealSearch, overwriteExisting);
      };
    })(this));
  };

  BrowseContentView.prototype._updateContent = function(search, overwriteExisting) {
    var $breadcrumbSelector, $dealsContent, $dealsMessage, breadcrumb, breadcrumbPresenter, breadcrumbPresenterHash, clearanceDealsCount, dealsList, _ref;
    if (overwriteExisting == null) {
      overwriteExisting = true;
    }
    $dealsMessage = BrowseContentHelper.getDealsMessageSelector();
    $dealsContent = BrowseContentHelper.getDealsContentSelector();
    $breadcrumbSelector = BreadcrumbView.prototype.getSelector();
    breadcrumb = void 0;
    if ($breadcrumbSelector) {
      breadcrumbPresenter = new BreadcrumbPresenter(search);
      if (!isEmpty(breadcrumbPresenter)) {
        breadcrumb = (breadcrumbPresenterHash = breadcrumbPresenter.toHash()).breadcrumb;
        new BreadcrumbView(breadcrumbPresenterHash).render();
      }
    }
    new DealsPageHeaderView($dealsMessage, breadcrumb).render();
    clearanceDealsCount = (_ref = search.page.clearanceDealsCount) != null ? _ref.values : void 0;
    if (clearanceDealsCount != null) {
      if (clearanceDealsCount) {
        $(this.SELECTORS.REFINEMENT_DICOUNTS).show();
      } else {
        $(this.SELECTORS.REFINEMENT_DICOUNTS).hide();
      }
    }
    dealsList = new PaginatedDealsListView($dealsContent, search);
    if (overwriteExisting) {
      dealsList.render();
    } else {
      dealsList.postRender(overwriteExisting);
    }
    Groupon.Utils.lazyLoadImages();
    if (Groupon.showGoodsFeaturedImageCarousel) {
      return this._initGoodsFeaturedImageCarousel();
    }
  };

  BrowseContentView.prototype._fetchError = function() {
    $((function(_this) {
      return function() {
        var $dealContentContainer, $noDealsContainer, lastUpdatedRefinementId, noDealsHtml, resetRefinementUi, _ref;
        _ref = Groupon.browseApp, lastUpdatedRefinementId = _ref.lastUpdatedRefinementId, resetRefinementUi = _ref.resetRefinementUi;
        $dealContentContainer = $(_this.SELECTORS.DEAL_CONTENT);
        if (Groupon.showNoDealsMessage) {
          noDealsHtml = BrowseNoDealsErrorView.render(lastUpdatedRefinementId);
        }
        if (noDealsHtml) {
          if (($noDealsContainer = $dealContentContainer.find('.notification.info')).length) {
            $noDealsContainer.replaceWith(noDealsHtml);
          } else {
            $dealContentContainer.prepend(noDealsHtml);
          }
          return resetRefinementUi();
        } else {
          $dealContentContainer.html(BrowseErrorHtml());
          return Groupon.BrowseTracking.pageReady();
        }
      };
    })(this));
    return this._stopSpinner();
  };

  BrowseContentView.prototype._fetchSuccess = function(search) {
    $((function(_this) {
      return function() {
        return _this._updateContent(search);
      };
    })(this));
    return this._stopSpinner();
  };

  BrowseContentView.prototype._initGoodsFeaturedImageCarousel = function() {
    return $(function() {
      return new DealsFeaturedImageCarousel({
        el: $('#featured-image-carousel')
      });
    });
  };

  BrowseContentView.prototype._startSpinner = function() {
    if (!this._renderedContent) {
      SpinnerGroup.start('deal-content', {
        parentElem: $(this.SELECTORS.DEAL_SPACE),
        css: {
          marginTop: '100px'
        },
        useV2: true
      });
      return this._renderedSpinner = true;
    }
  };

  BrowseContentView.prototype._stopSpinner = function() {
    this._renderedContent = true;
    if (this._renderedSpinner) {
      return SpinnerGroup.stop('deal-content');
    }
  };

  return BrowseContentView;

})();


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../../../breadcrumb/frontend/presenters/breadcrumb":8,"../../../breadcrumb/frontend/views/breadcrumb":9,"../../../deals/frontend/application":32,"../../../deals/frontend/featured_image_carousel":33,"../../../deals/frontend/views/page_header":40,"../../../deals/frontend/views/paginated_deals_list":41,"../helpers/content":15,"../helpers/spinner_group":18,"./error":27,"./no_deals_error":28}],27:[function(require,module,exports){
var BrowseErrorHtml, BrowseErrorMessageTemplate, BrowseErrorPresenter;

BrowseErrorPresenter = require('../presenters/error');

BrowseErrorMessageTemplate = require('../../error_message.html.mustache');

module.exports = BrowseErrorHtml = function() {
  var hash, presenter;
  presenter = new BrowseErrorPresenter;
  hash = presenter.toHash();
  return BrowseErrorMessageTemplate.render(hash);
};



},{"../../error_message.html.mustache":13,"../presenters/error":23}],28:[function(require,module,exports){
var BrowseNoDealsErrorPresenter, BrowseNoDealsErrorView, BrowseNoDealsMessageTemplate;

BrowseNoDealsErrorPresenter = require('../presenters/no_deals_error');

BrowseNoDealsMessageTemplate = require('../../no_deals_message.html.mustache');

module.exports = BrowseNoDealsErrorView = {
  template: BrowseNoDealsMessageTemplate,
  render: function(lastUpdatedRefinementId) {
    var noDealsHash;
    if (!(lastUpdatedRefinementId != null ? lastUpdatedRefinementId.length : void 0)) {
      return;
    }
    noDealsHash = BrowseNoDealsErrorPresenter.toHash(lastUpdatedRefinementId);
    if (noDealsHash) {
      return this.template.render(noDealsHash);
    }
  }
};



},{"../../no_deals_message.html.mustache":30,"../presenters/no_deals_error":24}],29:[function(require,module,exports){
var DEFAULT_HIDE_DELAY, DEFAULT_SHOW_DELAY, ToolTipDelayView,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  __hasProp = {}.hasOwnProperty;

DEFAULT_SHOW_DELAY = 1000;

DEFAULT_HIDE_DELAY = 100;

module.exports = ToolTipDelayView = (function(_super) {
  __extends(ToolTipDelayView, _super);

  function ToolTipDelayView() {
    this.hideToolTip = __bind(this.hideToolTip, this);
    this.showToolTip = __bind(this.showToolTip, this);
    return ToolTipDelayView.__super__.constructor.apply(this, arguments);
  }

  ToolTipDelayView.prototype.showDebounce = null;

  ToolTipDelayView.prototype.hideDebounce = null;

  ToolTipDelayView.prototype.events = {
    'mouseenter': 'showToolTip',
    'mouseleave': 'hideToolTip'
  };

  ToolTipDelayView.prototype.initialize = function(_arg) {
    this.eventName = _arg.eventName, this.showDelay = _arg.showDelay, this.hideDelay = _arg.hideDelay;
    if (this.eventName == null) {
      this.eventName = 'showdelayed';
    }
    if (this.showDelay == null) {
      this.showDelay = DEFAULT_SHOW_DELAY;
    }
    if (this.hideDelay == null) {
      this.hideDelay = DEFAULT_HIDE_DELAY;
    }
    this.cacheElem();
    return this.initToolTipElemHandlers();
  };

  ToolTipDelayView.prototype.cacheElem = function() {
    return this.$toolTipElem = $("#" + (this.$el.data('tooltip-id')));
  };

  ToolTipDelayView.prototype.initToolTipElemHandlers = function() {
    this.$toolTipElem.on('mouseenter', this.showToolTip);
    return this.$toolTipElem.on('mouseleave', this.hideToolTip);
  };

  ToolTipDelayView.prototype.showToolTip = function() {
    if (this.hideDebounce) {
      this.hideDebounce = clearTimeout(this.hideDebounce);
    }
    if (this.showDebounce) {
      return;
    }
    return this.showDebounce = setTimeout(((function(_this) {
      return function() {
        return _this.$el.trigger(_this.eventName);
      };
    })(this)), this.showDelay);
  };

  ToolTipDelayView.prototype.hideToolTip = function() {
    if (this.showDebounce) {
      this.showDebounce = clearTimeout(this.showDebounce);
    }
    if (this.hideDebounce) {
      return;
    }
    return this.hideDebounce = setTimeout(((function(_this) {
      return function() {
        return GIG.Tooltip.close(_this.$toolTipElem);
      };
    })(this)), this.hideDelay);
  };

  return ToolTipDelayView;

})(Backbone.View);



},{}],30:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("noDealsMessage",c,p,1),c,p,0,21,251,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("	<div class=\"notification info\">");t.b("\n" + i);t.b("	  <div class=\"no-deals-message\">");t.b(t.t(t.f("noDealsMessage",c,p,0)));t.b("</div>");t.b("\n" + i);if(t.s(t.f("noDealsSuggestion",c,p,1),c,p,0,144,218,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("	    <div class=\"no-deals-suggestion\">");t.b(t.t(t.f("noDealsSuggestion",c,p,0)));t.b("</div>");t.b("\n" + i);});c.pop();}t.b("	</div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{# noDealsMessage }}\n\t<div class=\"notification info\">\n\t  <div class=\"no-deals-message\">{{{ noDealsMessage }}}</div>\n\t  {{# noDealsSuggestion }}\n\t    <div class=\"no-deals-suggestion\">{{{ noDealsSuggestion }}}</div>\n\t  {{/ noDealsSuggestion }}\n\t</div>\n{{/ noDealsMessage }}\n", Hogan);
},{"hogan.js":102}],31:[function(require,module,exports){
var HomepageCarousel, carouselIntervalInstance,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

carouselIntervalInstance = null;

module.exports = HomepageCarousel = (function() {
  function HomepageCarousel(_arg) {
    var showSubnavWidget, _ref, _ref1;
    _ref = _arg != null ? _arg : {}, this.carouselConfig = _ref.carouselConfig, this.showFreeShippingModal = _ref.showFreeShippingModal, this.inGoodsHomepageSSR = _ref.inGoodsHomepageSSR;
    this._startCarousel = __bind(this._startCarousel, this);
    this.widget = $("#carousel-widget");
    this.wrapper = this.widget.find("#carousel-wrapper");
    this.length = this.wrapper.children().length - 1;
    this.index = 0;
    this.advance = true;
    if (this.carouselConfig != null) {
      _ref1 = this.carouselConfig, this.carouselInterval = _ref1.carouselInterval, this.numOfSlots = _ref1.numOfSlots, showSubnavWidget = _ref1.showSubnavWidget, this.overlayControls = _ref1.overlayControls, this.maxNumOfMenuItems = _ref1.maxNumOfMenuItems, this.maxNumOfMenuCols = _ref1.maxNumOfMenuCols, this.moreCategoriesId = _ref1.moreCategoriesId;
      this.maxNumOfSubnavItems = this.numOfSlots;
      if (showSubnavWidget) {
        this.maxNumOfSubnavItems = this.numOfSlots - 1;
      }
    }
    this.menuItemHeight = 28;
    this.menuTopPadding = 3;
    this.moreCategoriesLabel = I18n.translate('js.modules.home.more_categories');
    if (this.showFreeShippingModal) {
      this._loadFreeShippingModal();
    }
    if (!this.inGoodsHomepageSSR) {
      if ($("#homepage-header").length && $("#homepage-header-temp").length) {
        $("#homepage-header-temp").children().appendTo("#homepage-header");
      }
    }
    if (this.widget.length) {
      if (this._hasNoControls()) {
        $("#homepage-header").addClass('carousel-height-no-controls');
      } else {
        $("#homepage-header").addClass('carousel-height');
      }
    }
    if (this.widget.length) {
      this._initializeCarousel();
      if (!$('html').hasClass('lt-ie9' && this.wrapper.children().length > 1)) {
        carouselIntervalInstance = setTimeout(this._startCarousel, this.carouselInterval);
      }
      this._loadControls();
      this._loadSubnav();
    }
  }

  HomepageCarousel.prototype._hasNoControls = function() {
    return this.wrapper.children().length === 1 || this.overlayControls;
  };

  HomepageCarousel.prototype._initializeCarousel = function() {
    var child, circles;
    child = this.wrapper.children().get(0);
    if (child) {
      $(child).css("opacity", 1).css("display", "block");
    }
    circles = this.widget.find(".icon-circle");
    if (circles.length) {
      return $(circles[0]).addClass("selected");
    }
  };

  HomepageCarousel.prototype._startCarousel = function() {
    this._advanceCarousel("right");
    return carouselIntervalInstance = setTimeout(this._startCarousel, this.carouselInterval);
  };

  HomepageCarousel.prototype._advanceCarousel = function(direction) {
    var prevIndex;
    prevIndex = this.index;
    this._incrementIndex(direction);
    if (prevIndex !== this.index) {
      this._showSlide(prevIndex, this.index);
      return this._showCircle(prevIndex, this.index);
    }
  };

  HomepageCarousel.prototype._jumpCarousel = function(from, to) {
    if (from !== to) {
      this._showSlide(from, to);
      this._showCircle(from, to);
      return this.index = to;
    }
  };

  HomepageCarousel.prototype._stopCarousel = function() {
    return carouselIntervalInstance = window.clearInterval(carouselIntervalInstance);
  };

  HomepageCarousel.prototype._incrementIndex = function(direction) {
    if (direction === 'right') {
      this.index += 1;
      if (this.index > this.length) {
        return this.index = 0;
      }
    } else {
      this.index -= 1;
      if (this.index < 0) {
        return this.index = this.length;
      }
    }
  };

  HomepageCarousel.prototype._showSlide = function(from, to) {
    var children;
    if (from !== to) {
      children = this.wrapper.children();
      from = $(children.get(from));
      to = $(children.get(to));
      from.fadeTo('fast', 0);
      to.fadeTo('fast', 1);
      return from.hide();
    }
  };

  HomepageCarousel.prototype._showCircle = function(from, to) {
    var circles;
    if (from !== to) {
      circles = this.widget.find(".icon-circle");
      if (circles.length) {
        $(circles[from]).removeClass("selected");
        return $(circles[to]).addClass("selected");
      }
    }
  };

  HomepageCarousel.prototype._loadFreeShippingModal = function() {
    if (window.GIG) {
      return window.GIG.init();
    }
  };

  HomepageCarousel.prototype._loadControls = function() {
    $('.homepage-carousel-left').on('click', (function(_this) {
      return function(e) {
        _this.advance = false;
        _this._stopCarousel();
        return _this._advanceCarousel('left');
      };
    })(this));
    $('.homepage-carousel-right').on('click', (function(_this) {
      return function(e) {
        _this.advance = false;
        _this._stopCarousel();
        return _this._advanceCarousel('right');
      };
    })(this));
    $('.carousel-item, .nav-bar-item, .menu').on('mouseenter', (function(_this) {
      return function(e) {
        return _this._stopCarousel();
      };
    })(this));
    $('.carousel-item, .nav-bar-item, .menu').on('mouseleave', (function(_this) {
      return function(e) {
        _this._stopCarousel();
        if (_this.advance) {
          return carouselIntervalInstance = setTimeout(_this._startCarousel, _this.carouselInterval);
        }
      };
    })(this));
    return $('.icon-circle').on('click', (function(_this) {
      return function(e) {
        var from, to, _ref, _ref1, _ref2;
        to = parseInt((_ref = e.target) != null ? (_ref1 = _ref.attributes) != null ? (_ref2 = _ref1.getNamedItem("index")) != null ? _ref2.value : void 0 : void 0 : void 0, 10);
        from = _this.index;
        if (from !== to) {
          _this._stopCarousel();
          return _this._jumpCarousel(from, to);
        }
      };
    })(this));
  };

  HomepageCarousel.prototype._numOfCols = function(numOfItems) {
    return Math.ceil(numOfItems / this.maxNumOfMenuItems);
  };

  HomepageCarousel.prototype._numOfItemsPerCol = function(numOfItems, numOfCols) {
    return Math.ceil(numOfItems / numOfCols);
  };

  HomepageCarousel.prototype._flyoutPosition = function(navBarItemPos, numOfItemsPerCol) {
    var pos;
    pos = numOfItemsPerCol <= 1 ? 0 : Math.floor(numOfItemsPerCol / 2) - 1;
    if (pos > navBarItemPos) {
      return navBarItemPos;
    } else {
      return pos;
    }
  };

  HomepageCarousel.prototype._indexStartingFromEnd = function(navBarItemPos) {
    return (this.numOfSlots - 1) - navBarItemPos;
  };

  HomepageCarousel.prototype._calculateMenuTop = function(flyoutPosition) {
    return (this.menuItemHeight * flyoutPosition) + this.menuTopPadding;
  };

  HomepageCarousel.prototype._setMenuTop = function(menu, menuHoverContainer, menuTop) {
    menu.css('top', -menuTop + 'px');
    return menuHoverContainer.css('top', -menuTop + 'px');
  };

  HomepageCarousel.prototype._repositionMenu = function(menu, menuHoverContainer, navBarItemPos, numOfItemsPerCol) {
    var flyoutPosition, menuTop, newFlyoutPos, newNavBarItemPos;
    flyoutPosition = this._flyoutPosition(navBarItemPos, numOfItemsPerCol);
    menuTop = this._calculateMenuTop(flyoutPosition);
    if (navBarItemPos < (this.numOfSlots / 2)) {
      if (flyoutPosition <= navBarItemPos) {
        this._setMenuTop(menu, menuHoverContainer, menuTop);
      }
    } else {
      newFlyoutPos = (numOfItemsPerCol - 1) - flyoutPosition;
      newNavBarItemPos = this._indexStartingFromEnd(navBarItemPos);
      if (newFlyoutPos > newNavBarItemPos) {
        flyoutPosition = (numOfItemsPerCol - 1) - newNavBarItemPos;
        menuTop = this._calculateMenuTop(flyoutPosition);
      }
      this._setMenuTop(menu, menuHoverContainer, menuTop);
    }
    return menu.addClass('flyout-pos' + flyoutPosition);
  };

  HomepageCarousel.prototype._updateMenuWidth = function(menu, numOfCols) {
    if (numOfCols > this.maxNumOfMenuCols) {
      numOfCols = this.maxNumOfMenuCols;
    }
    return menu.addClass('columns-' + numOfCols);
  };

  HomepageCarousel.prototype._createCol = function(colNum, menu, numOfItemsPerCol, menuItems) {
    var colEnd, colStart, column, menuItem, _i, _len, _ref, _results;
    menu.append("<div class='menu-column'><ul></ul></div>");
    column = menu.find("ul")[colNum];
    colStart = colNum * numOfItemsPerCol;
    colEnd = colStart + numOfItemsPerCol;
    _ref = menuItems.slice(colStart, colEnd);
    _results = [];
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      menuItem = _ref[_i];
      _results.push($(column).append(menuItem));
    }
    return _results;
  };

  HomepageCarousel.prototype._createCols = function(numOfCols, menu, numOfItemsPerCol, menuItems) {
    var i, _i, _ref, _results;
    _results = [];
    for (i = _i = 0, _ref = numOfCols - 1; _i <= _ref; i = _i += 1) {
      if (i === this.maxNumOfMenuCols) {
        break;
      }
      _results.push(this._createCol(i, menu, numOfItemsPerCol, menuItems));
    }
    return _results;
  };

  HomepageCarousel.prototype._formatMenu = function(navBarItemPos, el) {
    var menu, menuHoverContainer, menuItems, numOfCols, numOfItems, numOfItemsPerCol;
    menu = $(el).find('.menu');
    menuHoverContainer = $(el).find('.menu-hover-container');
    menuItems = menu.find('.menu-item');
    numOfItems = menuItems.length;
    numOfCols = this._numOfCols(numOfItems);
    numOfItemsPerCol = this._numOfItemsPerCol(numOfItems, numOfCols);
    this._repositionMenu(menu, menuHoverContainer, navBarItemPos, numOfItemsPerCol);
    if (numOfItems > this.maxNumOfMenuItems) {
      menu.empty();
      this._updateMenuWidth(menu, numOfCols);
      this._createCols(numOfCols, menu, numOfItemsPerCol, menuItems);
    }
    return menuHoverContainer.height(menu.outerHeight());
  };

  HomepageCarousel.prototype._appendL2Category = function(menu, itemPos, el, menuItems) {
    var bhc, li, navBarLabel, title, url;
    navBarLabel = $(el).find('.nav-bar-label');
    bhc = navBarLabel.attr('data-bhc');
    title = navBarLabel.text().trim();
    url = $(el).find('a').attr('href');
    menu.append("<li class='menu-item' data-bhc='" + bhc + "'><a href='" + url + "'>" + title + "</a></li>");
    li = $(menu.find('li')[itemPos]);
    return menuItems.push(li);
  };

  HomepageCarousel.prototype._moreCategoriesNavBarItem = function(el) {
    var moreCategoriesLabel, moreCategoriesLink;
    $(el).attr('id', this.moreCategoriesId);
    moreCategoriesLink = $(el).find('a')[0];
    $(moreCategoriesLink).removeAttr('href');
    moreCategoriesLabel = $(el).find('.nav-bar-label');
    $(moreCategoriesLabel).attr('data-bhc', 'category:' + this.moreCategoriesId);
    $(moreCategoriesLabel).attr('data-bhc-path', 'LeftNavCategories|category:' + this.moreCategoriesId);
    return $(moreCategoriesLabel).html(this.moreCategoriesLabel);
  };

  HomepageCarousel.prototype._moreCategoriesMenu = function(moreCategories) {
    var i, menu, menuHoverContainer, menuItems, numOfCols, numOfItems, numOfItemsPerCol, _i, _ref;
    numOfItems = moreCategories.length;
    numOfCols = this._numOfCols(numOfItems);
    numOfItemsPerCol = this._numOfItemsPerCol(numOfItems, numOfCols);
    menu = $('#' + this.moreCategoriesId).find('.menu');
    menuHoverContainer = $('#' + this.moreCategoriesId).find('.menu-hover-container');
    menu.attr('class', 'menu arrow').empty();
    menuItems = [];
    for (i = _i = 0, _ref = numOfItems - 1; 0 <= _ref ? _i <= _ref : _i >= _ref; i = 0 <= _ref ? ++_i : --_i) {
      this._appendL2Category(menu, i, moreCategories[i], menuItems);
    }
    this._createCols(numOfCols, menu, numOfItemsPerCol, menuItems);
    return this._repositionMenu(menu, menuHoverContainer, this.maxNumOfSubnavItems - 1, numOfItemsPerCol);
  };

  HomepageCarousel.prototype._loadSubnav = function() {
    var el, hasMoreCategories, i, lastl2CategorySlot, moreCategories, navBarItems, _i, _len;
    moreCategories = [];
    navBarItems = $('.nav-bar-item');
    lastl2CategorySlot = this.maxNumOfSubnavItems - 1;
    hasMoreCategories = navBarItems.length > this.maxNumOfSubnavItems;
    for (i = _i = 0, _len = navBarItems.length; _i < _len; i = ++_i) {
      el = navBarItems[i];
      if (hasMoreCategories && i >= lastl2CategorySlot) {
        moreCategories.push($(el).clone());
        if (i === lastl2CategorySlot) {
          this._moreCategoriesNavBarItem(el);
        } else {
          $(el).remove();
        }
      }
      this._formatMenu(i, el);
    }
    if (moreCategories.length > 0) {
      return this._moreCategoriesMenu(moreCategories);
    }
  };

  return HomepageCarousel;

})();



},{}],32:[function(require,module,exports){
var BrowseContentHelper, DealsApplication, DealsGTMHelper, DealsSearchParamsHelper, Page, performSearch, updateSeoPageMetaHash,
  __slice = [].slice,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

DealsSearchParamsHelper = require('./helpers/search_params');

DealsGTMHelper = require('./helpers/gtm-update');

BrowseContentHelper = require('../../browse/frontend/helpers/content');

updateSeoPageMetaHash = require('../../seo/frontend/page_meta_updater').updateSeoPageMetaHash;

Page = (function() {
  function Page(pageNumber, data) {
    var paginationData, _ref, _ref1;
    paginationData = data.metadata.pagination;
    _.extend(this, {
      clearanceDealsCount: data.clearanceDealsCount,
      countHtml: paginationData.countHtml,
      totalDealCount: paginationData.availableCount,
      bloodhoundHtml: paginationData.bloodhoundHtml,
      dealCount: paginationData.dealsCount,
      dealIdList: ((_ref = data.metadata) != null ? (_ref1 = _ref.pagination) != null ? _ref1.dealIdList : void 0 : void 0) || [],
      dealsHtml: data.dealsHtml,
      featuredHtml: data.featuredHtml,
      carouselHtml: data.carouselHtml,
      topDealsHtml: data.topDealsHtml,
      nextPageSize: paginationData.nextPageSize,
      number: pageNumber,
      totalPages: paginationData.totalPages,
      facets: data.metadata.facets,
      firstDeal: data.metadata.firstDeal,
      startingIndex: paginationData.startingIndex,
      endingIndex: paginationData.endingIndex,
      refinementUiPageData: data.refinementUiPageData,
      cardsHtml: data.cardsHtml,
      seoMetaHash: data.seoMetaHash
    });
  }

  return Page;

})();

performSearch = function(params) {
  var search, _ref;
  if (params == null) {
    params = {};
  }
  if ((_ref = this.xhr) != null) {
    _ref.abort();
  }
  this.xhr = $.ajax({
    url: '/goods/deals/partial',
    data: params
  });
  search = _.clone(Backbone.Events);
  this.xhr.done(_(search.trigger).bind(search, 'success'));
  this.xhr.fail((function(_this) {
    return function(xhr, textStatus) {
      if (textStatus !== "abort") {
        return search.trigger('error');
      }
    };
  })(this));
  this.xhr.always(function() {
    search.trigger.apply(search, ['complete'].concat(__slice.call(arguments)));
    return search.off();
  });
  return {
    on: _(search.once).bind(search)
  };
};

module.exports = DealsApplication = (function() {
  function DealsApplication(options) {
    var dealsSearch;
    if (options == null) {
      options = {};
    }
    this._triggerSuccessHandler = __bind(this._triggerSuccessHandler, this);
    this._triggerErrorHandler = __bind(this._triggerErrorHandler, this);
    this._events = _.extend({}, Backbone.Events);
    this.params = DealsSearchParamsHelper.getBaseParams(options);
    this._searchedServerSide = false;
    this._pageNumber = isNaN(Number(this.params.page)) ? 1 : Number(this.params.page);
    if (!/^\d+$/.test(this.params.minPrice)) {
      delete this.params.minPrice;
    }
    if (!/^\d+$/.test(this.params.maxPrice)) {
      delete this.params.maxPrice;
    }
    if ((this.params.minPrice != null) && (this.params.maxPrice != null) && parseInt(this.params.minPrice, 10) > parseInt(this.params.maxPrice, 10)) {
      delete this.params.minPrice;
      delete this.params.maxPrice;
    }
    if (!options.pageData) {
      if (options.pageNumber != null) {
        _.extend(this.params, {
          page: options.pageNumber
        });
        this._pageNumber = options.pageNumber;
      }
      dealsSearch = performSearch(this.params);
      dealsSearch.on('error', this._triggerErrorHandler);
      dealsSearch.on('success', this._triggerSuccessHandler);
    } else {
      this.page = new Page(this._pageNumber, options.pageData);
      this._searchedServerSide = true;
      null;
    }
  }

  DealsApplication.prototype.on = function(event, callback) {
    return this._events.on(event, callback);
  };

  DealsApplication.prototype.unfilteredParams = function() {
    return unfilteredParams(this.params);
  };

  DealsApplication.prototype.nextPage = function() {
    return new this.constructor({
      params: this.params,
      pageNumber: this._pageNumber + 1
    });
  };

  DealsApplication.prototype._triggerErrorHandler = function() {
    this._events.trigger('error');
    return this._events.stopListening();
  };

  DealsApplication.prototype._triggerSuccessHandler = function(_arg, textStatus) {
    var adSenseBlock, deals, pageOptions, seoMetaHash, _ref, _ref1;
    deals = (_arg != null ? _arg : {}).deals;
    if (textStatus !== 'success') {
      return this._triggerErrorHandler();
    } else {
      this.page = new Page(this._pageNumber, deals);
      Groupon.pagination = (_ref = deals.metadata) != null ? _ref.pagination : void 0;
      this._events.trigger('success', deals);
      this._events.stopListening();
      if (this.params) {
        DealsGTMHelper.update(this.params);
      }
      if (deals.adSenseAd) {
        pageOptions = {
          pubId: deals.adSenseAd.pubId,
          query: deals.adSenseAd.category,
          textColorPalette: ['#333']
        };
        adSenseBlock = {
          container: 'adsense-container',
          width: deals.adSenseAd.width,
          height: deals.adSenseAd.height,
          linkTarget: '_blank',
          adLoadedCallback: function(container, adsLoaded) {
            if (adsLoaded) {
              return $("#adsense-container").css({
                "min-height": 265
              });
            } else {
              return $("#adsense-container").css({
                "min-height": 0,
                "height": 0
              });
            }
          }
        };
        if (deals.adSenseAd.showAds) {
          _googCsa('plas', pageOptions, adSenseBlock);
        }
      }
      if (((_ref1 = Groupon.enabledFeatures) != null ? _ref1.isSEOMetadataEnabled : void 0) && (seoMetaHash = this.page.seoMetaHash)) {
        return updateSeoPageMetaHash(seoMetaHash);
      }
    }
  };

  DealsApplication.prototype.isEmptySearch = function() {
    var _ref;
    return ((_ref = this.page) != null ? _ref.totalDealCount : void 0) === 0;
  };

  DealsApplication.prototype.isSearchedServerSide = function() {
    return this._searchedServerSide;
  };

  return DealsApplication;

})();



},{"../../browse/frontend/helpers/content":15,"../../seo/frontend/page_meta_updater":49,"./helpers/gtm-update":34,"./helpers/search_params":37}],33:[function(require,module,exports){
var DealsFeaturedImageCarousel;

module.exports = DealsFeaturedImageCarousel = (function() {
  function DealsFeaturedImageCarousel(_arg) {
    var el, _ref, _ref1;
    el = _arg.el;
    if (el != null ? el.length : void 0) {
      this.carouselWidget = el;
    }
    this.images = (_ref = this.carouselWidget) != null ? _ref.find('img') : void 0;
    if (!((_ref1 = this.images) != null ? _ref1.length : void 0)) {
      return {};
    }
    this.size = this.images.length - 1;
    this.position = 0;
    this.initializeCarousel();
  }

  DealsFeaturedImageCarousel.prototype.initializeCarousel = function() {
    var firstImage;
    firstImage = this.images[0];
    $(firstImage).show();
    this.carouselWidget.find('.icon-arrow-left-large').on('click', (function(_this) {
      return function(e) {
        return _this.slide('left');
      };
    })(this));
    return this.carouselWidget.find('.icon-arrow-right-large').on('click', (function(_this) {
      return function(e) {
        return _this.slide('right');
      };
    })(this));
  };

  DealsFeaturedImageCarousel.prototype.slide = function(direction) {
    return this.updateCarousel(this.nextPosition(direction));
  };

  DealsFeaturedImageCarousel.prototype.nextPosition = function(direction) {
    if (direction === 'left') {
      if (this.position > 0) {
        return this.position - 1;
      } else {
        return this.size;
      }
    } else {
      if (this.position < this.size) {
        return this.position + 1;
      } else {
        return 0;
      }
    }
  };

  DealsFeaturedImageCarousel.prototype.updateCarousel = function(nextPosition) {
    if (this.position === nextPosition) {
      return;
    }
    this.updateSlide(this.position, nextPosition);
    return this.position = nextPosition;
  };

  DealsFeaturedImageCarousel.prototype.updateSlide = function(currentPosition, nextPosition) {
    var currentImage, nextImage;
    currentImage = this.images[currentPosition];
    nextImage = this.images[nextPosition];
    $(currentImage).hide();
    return $(nextImage).show();
  };

  return DealsFeaturedImageCarousel;

})();



},{}],34:[function(require,module,exports){
var DealsGTMHelper;

module.exports = DealsGTMHelper = {
  update: function(params) {
    var category2, category3, dlUpdate;
    category2 = params.category2, category3 = params.category3;
    if (window.dataLayer != null) {
      dlUpdate = {
        event: 'cat-nav'
      };
      window.dataLayer.push(['dl_categories.splice', 1, 2]);
      dlUpdate.dl_category_sub = category2 || '';
      if (category2 != null) {
        window.dataLayer.push(['dl_categories.push', category2]);
      }
      if (category3 != null) {
        window.dataLayer.push(['dl_categories.push', category3]);
      }
      return window.dataLayer.push(dlUpdate);
    }
  }
};



},{}],35:[function(require,module,exports){
var DealsApplication, PaginatedDealsBuilder,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

DealsApplication = require('../application');

module.exports = PaginatedDealsBuilder = (function() {
  function PaginatedDealsBuilder(_arg) {
    this.omitSearch = (_arg != null ? _arg : {}).omitSearch;
    this.triggerFetchSuccess = __bind(this.triggerFetchSuccess, this);
    this.triggerFetchError = __bind(this.triggerFetchError, this);
    this.events = _.clone(Backbone.Events);
    this.search = new DealsApplication(this._searchOptions());
    this.search.on('error', this.triggerFetchError);
    this.search.on('success', this.triggerFetchSuccess);
  }

  PaginatedDealsBuilder.prototype._searchOptions = function() {
    if (Groupon.onNoDealsPage) {
      return {
        unfiltered: true
      };
    } else {
      return _.omitUndefined({
        omitSearch: this.omitSearch
      });
    }
  };

  PaginatedDealsBuilder.prototype.triggerFetchError = function() {
    this.events.trigger('fetchError');
    return this.events.stopListening();
  };

  PaginatedDealsBuilder.prototype.triggerFetchSuccess = function() {
    return $((function(_this) {
      return function() {
        _this.events.trigger('fetchSuccess', _this.search);
        return _this.events.stopListening();
      };
    })(this));
  };

  PaginatedDealsBuilder.prototype.on = function() {
    var _ref;
    return (_ref = this.events).on.apply(_ref, arguments);
  };

  return PaginatedDealsBuilder;

})();



},{"../application":32}],36:[function(require,module,exports){
var DealsPaginationEvents, DealsPaginationEventsHelper, PaginatedDealsBuilder, UpdateAppURLHelper, fetchAndRenderDeals, sendPaginationEvent, updateURLAndFetch;

UpdateAppURLHelper = require('../../../shared/frontend/helpers/app_url');

PaginatedDealsBuilder = require('./paginated_deals_builder');

DealsPaginationEvents = require('../pagination_events');

module.exports = DealsPaginationEventsHelper = {
  updatePageByHref: function(url, shouldScroll) {
    if (shouldScroll == null) {
      shouldScroll = true;
    }
    return updateURLAndFetch(url, shouldScroll);
  },
  updateToPreviousPage: function(shouldScroll) {
    var qs, queryString, url;
    if (shouldScroll == null) {
      shouldScroll = true;
    }
    qs = Groupon.Utils.unparam();
    if (!(qs.page > 1)) {
      return;
    }
    qs.page--;
    if (qs.page <= 1) {
      delete qs.page;
    }
    queryString = !_.isEmpty(qs) ? "?" + ($.param(qs)) : "";
    url = "" + window.location.pathname + queryString;
    return updateURLAndFetch(url, shouldScroll);
  },
  updateToNextPage: function(shouldScroll) {
    var qs, url;
    if (shouldScroll == null) {
      shouldScroll = true;
    }
    qs = Groupon.Utils.unparam();
    if (qs.page != null) {
      qs.page++;
    } else {
      qs.page = 2;
    }
    if (qs.page > Groupon.pagination.totalPages) {
      return;
    }
    url = window.location.pathname + "?" + ($.param(qs));
    return updateURLAndFetch(url, shouldScroll);
  },
  popStateHandler: function(currentSearchPage) {
    var popStatePage, _ref;
    popStatePage = (_ref = Groupon.Utils.unparam().page) != null ? _ref : 1;
    if (currentSearchPage !== popStatePage) {
      return fetchAndRenderDeals();
    }
  }
};

updateURLAndFetch = function(url, shouldScroll) {
  UpdateAppURLHelper(url, {
    pushState: true
  });
  if (shouldScroll) {
    $(document).scrollTop(0);
  }
  return fetchAndRenderDeals();
};

fetchAndRenderDeals = function() {
  var paginatedBuilder;
  paginatedBuilder = new PaginatedDealsBuilder;
  Groupon.browseApp.renderContent({
    paginatedDealsBuilder: paginatedBuilder
  });
  return paginatedBuilder.on("fetchSuccess", function(search) {
    return sendPaginationEvent(search);
  });
};

sendPaginationEvent = function(dealSearch) {
  return DealsPaginationEvents.trigger("newPage", dealSearch.page);
};



},{"../../../shared/frontend/helpers/app_url":52,"../pagination_events":39,"./paginated_deals_builder":35}],37:[function(require,module,exports){
var BrowseParsedParamsHelper, DealsSearchParamsHelper, addCategoryParam, getFacetGroupFiltersParam, initializeParams, unfilteredParams;

BrowseParsedParamsHelper = require('../../../browse/frontend/helpers/parsed_params');

module.exports = DealsSearchParamsHelper = {
  getBaseParams: function(options) {
    var params, _ref, _ref1;
    if (options == null) {
      options = {};
    }
    params = initializeParams(options);
    params.division = Cookie.get('division');
    if (addCategoryParam(params)) {
      params.category = Groupon.browseApp.getSelectedCategory();
    }
    params.facet_group_filters = getFacetGroupFiltersParam(options);
    if ((_ref = Groupon.RefinementBar) != null ? _ref.isLeftBarVisible : void 0) {
      params.isRefinementBarDisplayed = true;
    }
    params.isLocalPage = Groupon.isLocalPage;
    params.isSeoEnabled = Groupon.isSeoEnabled;
    params.collectionType = (_ref1 = Groupon.collection) != null ? _ref1.type : void 0;
    if (Groupon.isSeoEnabled) {
      _.extend(params, BrowseParsedParamsHelper.getParsedParams());
    }
    if (options.omitSearch) {
      delete params.query;
    }
    if (params.collectionType) {
      params.query = Groupon.collection.id;
    }
    return params;
  }
};

initializeParams = function(options) {
  var parsedParams;
  if (options.params != null) {
    return _.clone(options.params);
  }
  parsedParams = Groupon.Utils.unparam();
  if (options.unfiltered) {
    return unfilteredParams(parsedParams);
  }
  return parsedParams;
};

unfilteredParams = function(params) {
  return _.pick(params, 'address', 'lat', 'lng', 'page', 'sort');
};

addCategoryParam = function(params) {
  return (params.category == null) && Groupon.browseApp.isCategoryPage();
};

getFacetGroupFiltersParam = function(options) {
  if (options.facet_group_filters != null) {
    return options.facet_group_filters;
  } else if (!Groupon.refinementUiPageData) {
    if (Groupon.inRAPI) {
      return 'topcategory|category|subcategory|subcategory2,deal_type';
    } else {
      return 'topcategory|category|category2|category3;deal_type;city|neighborhood';
    }
  }
};



},{"../../../browse/frontend/helpers/parsed_params":17}],38:[function(require,module,exports){
var DealsMmSearch, HomepageCarousel, performSearch,
  __slice = [].slice,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

HomepageCarousel = require('../../carousel/frontend/carousel');

performSearch = function(params) {
  var search, _ref;
  if (params == null) {
    params = {};
  }
  if ((_ref = this.xhr) != null) {
    _ref.abort();
  }
  this.xhr = $.ajax({
    url: '/goods/deals/megamindhome',
    data: params
  });
  search = _.clone(Backbone.Events);
  this.xhr.done(_(search.trigger).bind(search, 'success'));
  this.xhr.fail((function(_this) {
    return function(xhr, textStatus) {
      if (!textStatus === "abort") {
        return _(search.trigger).bind(search, 'error');
      }
    };
  })(this));
  this.xhr.always(function() {
    search.trigger.apply(search, ['complete'].concat(__slice.call(arguments)));
    return search.off();
  });
  return {
    on: _(search.once).bind(search)
  };
};

module.exports = DealsMmSearch = (function() {
  function DealsMmSearch(options) {
    var datetime, dealsSearch, megamindPreview, _ref;
    if (options == null) {
      options = {};
    }
    this._triggerSuccessHandler = __bind(this._triggerSuccessHandler, this);
    this._triggerErrorHandler = __bind(this._triggerErrorHandler, this);
    this._events = _.extend({}, Backbone.Events);
    this.inNewHomepage = options.inNewHomepage, this.carouselConfig = options.carouselConfig, this.homeWidgetPreview = options.homeWidgetPreview, this.showFreeShippingModal = options.showFreeShippingModal;
    if (this.homeWidgetPreview) {
      _ref = this.homeWidgetPreview, datetime = _ref.datetime, megamindPreview = _ref.megamindPreview;
    }
    if (datetime && megamindPreview) {
      this.params = {
        datetime: datetime,
        megamindPreview: megamindPreview
      };
    }
    dealsSearch = performSearch(this.params);
    dealsSearch.on('error', this._triggerErrorHandler);
    dealsSearch.on('success', this._triggerSuccessHandler);
    null;
  }

  DealsMmSearch.prototype.on = function(event, callback) {
    return this._events.on(event, callback);
  };

  DealsMmSearch.prototype._triggerErrorHandler = function() {
    this._events.trigger('error');
    return this._events.stopListening();
  };

  DealsMmSearch.prototype._triggerSuccessHandler = function(_arg, textStatus) {
    var dealIdList, deals, _ref;
    _ref = _arg != null ? _arg : {}, deals = _ref.deals, dealIdList = _ref.dealIdList;
    if (textStatus !== 'success') {
      return this._triggerErrorHandler();
    } else {
      this._events.trigger('success', deals, dealIdList);
      Groupon.Utils.lazyLoadImages();
      if (this.inNewHomepage) {
        new HomepageCarousel({
          carouselConfig: this.carouselConfig,
          showFreeShippingModal: this.showFreeShippingModal,
          inGoodsHomepageSSR: this.inGoodsHomepageSSR
        });
      }
      return this._events.stopListening();
    }
  };

  return DealsMmSearch;

})();



},{"../../carousel/frontend/carousel":31}],39:[function(require,module,exports){
var Backbone, DealsPaginationEvents;

Backbone = require('backbone');

module.exports = DealsPaginationEvents = _.extend({}, Backbone.Events);



},{"backbone":56}],40:[function(require,module,exports){
var DealsPageHeaderView;

module.exports = DealsPageHeaderView = (function() {
  function DealsPageHeaderView(_at_$dealsMessage, _at_breadcrumb) {
    this.$dealsMessage = _at_$dealsMessage;
    this.breadcrumb = _at_breadcrumb;
  }

  DealsPageHeaderView.prototype.render = function() {
    var href, text, _ref, _ref1, _ref2;
    if ((((_ref = Groupon.collection) != null ? _ref.id : void 0) != null) && ((_ref1 = this.breadcrumb) != null ? _ref1.pageTitleLink : void 0)) {
      this.$el = $('.page-header .title span');
      _ref2 = this.breadcrumb.pageTitleLink, text = _ref2.text, href = _ref2.href;
      this.$el.attr('href', href);
      this.$el.text(text);
    }
    if (Groupon.onNoDealsPage) {
      return this.$dealsMessage.show();
    }
  };

  return DealsPageHeaderView;

})();



},{}],41:[function(require,module,exports){
var DealsPaginationEventsHelper, DealsPaginationFooterView, PaginatedDealsListTemplate, PaginatedDealsListView,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

DealsPaginationFooterView = require('./pagination_footer');

DealsPaginationEventsHelper = require('../helpers/pagination_events');

PaginatedDealsListTemplate = require('../../paginated_deals_list.html.mustache');

module.exports = PaginatedDealsListView = (function() {
  PaginatedDealsListView.prototype.template = PaginatedDealsListTemplate;

  PaginatedDealsListView.prototype.dealsListId = 'browse-deals';

  function PaginatedDealsListView(_at_$el, _at_dealSearch) {
    var currentSearchPage, _ref;
    this.$el = _at_$el;
    this.dealSearch = _at_dealSearch;
    this.searchError = __bind(this.searchError, this);
    this.searchSuccess = __bind(this.searchSuccess, this);
    this.$content = this.$el.find('.content');
    this.prevSearch = null;
    this.footer = new DealsPaginationFooterView();
    this.footer.on('click:paginationLink', this.paginationClickHandler);
    currentSearchPage = (_ref = this.dealSearch.params.page) != null ? _ref : 1;
    window.onpopstate = _.partial(DealsPaginationEventsHelper.popStateHandler, currentSearchPage);
  }

  PaginatedDealsListView.prototype.render = function() {
    if (this.dealSearch.isEmptySearch()) {
      return;
    }
    this.$content.html(this.toHtml());
    this.postRender();
    return Groupon.BrowseTracking.pageReady();
  };

  PaginatedDealsListView.prototype.postRender = function(overwriteExisting) {
    var element, options;
    if (overwriteExisting == null) {
      overwriteExisting = true;
    }
    this.footer.updatePresenter(this.dealSearch).setElement(this.$el.find('.pagination_footer'));
    if (overwriteExisting) {
      this.footer.render();
    }
    GIG.Utils.truncateElements(element = this.$content, options = {
      watch: false
    });
    return GIG.Tooltip.reloadBindings(element = this.$content, false);
  };

  PaginatedDealsListView.prototype.toHtml = function() {
    return this.template.render(this.present());
  };

  PaginatedDealsListView.prototype.present = function() {
    var hash, _ref;
    hash = _.extend({}, this.dealSearch.page, {
      dealsListId: this.dealsListId,
      columnLayoutClass: Groupon.columnLayoutClass,
      cardUIClass: Groupon.cardUIClass,
      clearanceWidget: ((_ref = this.dealSearch.params) != null ? _ref.discount : void 0) === "gg-clearance" && Groupon.showClearanceWidget
    });
    return hash;
  };

  PaginatedDealsListView.prototype.searchSuccess = function() {
    this.$content.find("#" + this.dealsListId).append(this.dealSearch.page.dealsHtml);
    return this.postRender();
  };

  PaginatedDealsListView.prototype.searchError = function() {
    this.dealSearch = this.prevSearch;
    this.footer.removeLoadingState();
    return this.$el.find('.pagination_footer').remove();
  };

  PaginatedDealsListView.prototype.paginationClickHandler = function(event) {
    return DealsPaginationEventsHelper.updatePageByHref(event.target.href);
  };

  return PaginatedDealsListView;

})();



},{"../../paginated_deals_list.html.mustache":43,"../helpers/pagination_events":36,"./pagination_footer":42}],42:[function(require,module,exports){
var BrowsePaginationFooterPresenter, DealsPaginationFooterTemplate, DealsPaginationFooterView,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  __hasProp = {}.hasOwnProperty;

BrowsePaginationFooterPresenter = require('../../../browse/common/presenters/pagination_footer');

DealsPaginationFooterTemplate = require('../../pagination_footer.html.mustache');

module.exports = DealsPaginationFooterView = (function(_super) {
  __extends(DealsPaginationFooterView, _super);

  function DealsPaginationFooterView() {
    this.paginationClickHandler = __bind(this.paginationClickHandler, this);
    return DealsPaginationFooterView.__super__.constructor.apply(this, arguments);
  }

  DealsPaginationFooterView.prototype.template = DealsPaginationFooterTemplate;

  DealsPaginationFooterView.prototype.events = {
    'click .pagination a': 'paginationClickHandler'
  };

  DealsPaginationFooterView.prototype.initialize = function() {
    if (this.fetchedDealCount == null) {
      this.fetchedDealCount = 0;
    }
    return this.presenter = null;
  };

  DealsPaginationFooterView.prototype.updatePresenter = function(dealSearch) {
    var dealCount, endingIndex, nextPageSize, number, page, paginationFooter, startingIndex, totalDealCount, totalPages;
    page = dealSearch.page;
    number = page.number, totalPages = page.totalPages, dealCount = page.dealCount, nextPageSize = page.nextPageSize, totalDealCount = page.totalDealCount, startingIndex = page.startingIndex, endingIndex = page.endingIndex;
    this.fetchedDealCount += dealCount;
    paginationFooter = _.extend({}, BrowsePaginationFooterPresenter.toHash({
      requestURL: window.location.pathname,
      query: Groupon.Utils.unparam(),
      currentPageNumber: number,
      totalPages: totalPages,
      nextPageSize: nextPageSize,
      fetchedDealCount: this.fetchedDealCount,
      totalDealCount: totalDealCount,
      startingIndex: startingIndex,
      endingIndex: endingIndex
    }, void 0, {
      I18n: I18n
    }, true));
    this.presenter = {
      paginationFooter: paginationFooter
    };
    return this;
  };

  DealsPaginationFooterView.prototype.render = function() {
    return this.$el.html(this.toHtml());
  };

  DealsPaginationFooterView.prototype.toHtml = function() {
    return this.template.render(this.presenter);
  };

  DealsPaginationFooterView.prototype.removeLoadingState = function() {
    return $('.pagination button').removeClass('loading');
  };

  DealsPaginationFooterView.prototype.paginationClickHandler = function(event) {
    event.preventDefault();
    return this.trigger('click:paginationLink', event);
  };

  return DealsPaginationFooterView;

})(Backbone.View);



},{"../../../browse/common/presenters/pagination_footer":12,"../../pagination_footer.html.mustache":44}],43:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("cardsHtml",c,p,1),c,p,0,16,139,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div id=\"");t.b(t.v(t.f("dealsListId",c,p,0)));t.b("\" data-bhw=\"BrowseDeals\" class=\"block-grid ");t.b(t.v(t.f("cardUIClass",c,p,0)));t.b("\">");t.b("\n" + i);t.b("    ");t.b(t.t(t.f("cardsHtml",c,p,0)));t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(!t.s(t.f("cardsHtml",c,p,1),c,p,1,0,0,"")){t.b("  ");t.b(t.t(t.f("carouselHtml",c,p,0)));t.b("\n" + i);t.b("  ");t.b(t.t(t.f("topDealsHtml",c,p,0)));t.b("\n" + i);t.b("  ");t.b(t.t(t.f("featuredHtml",c,p,0)));t.b("\n");t.b("\n" + i);t.b("  <div id=\"");t.b(t.v(t.f("dealsListId",c,p,0)));t.b("\" data-bhw=\"BrowseDeals\" class=\"block-grid browse-deals ");t.b(t.v(t.f("columnLayoutClass",c,p,0)));t.b("\">");t.b("\n" + i);if(t.s(t.f("clearanceWidget",c,p,1),c,p,0,380,589,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div id=\"clearance-widget\" style=\"padding-left: 9px\">");t.b("\n" + i);t.b("        <a href=\"/goods/all\">");t.b("\n" + i);t.b("          <img src=\"https://img.grouponcdn.com/deal/eTnqcGU7XHwnms1s56UGkN/DE-705x254\">");t.b("\n" + i);t.b("        </a>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);});c.pop();}t.b("    ");t.b(t.t(t.f("dealsHtml",c,p,0)));t.b("\n" + i);t.b("  </div>");t.b("\n" + i);};t.b("\n" + i);t.b("<div class=\"pagination_footer\"></div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "{{# cardsHtml }}\n  <div id=\"{{ dealsListId }}\" data-bhw=\"BrowseDeals\" class=\"block-grid {{ cardUIClass }}\">\n    {{{ cardsHtml }}}\n  </div>\n{{/ cardsHtml }}\n\n{{^ cardsHtml }}\n  {{{ carouselHtml }}}\n  {{{ topDealsHtml }}}\n  {{{ featuredHtml }}}\n\n  <div id=\"{{ dealsListId }}\" data-bhw=\"BrowseDeals\" class=\"block-grid browse-deals {{ columnLayoutClass }}\">\n    {{# clearanceWidget }}\n      <div id=\"clearance-widget\" style=\"padding-left: 9px\">\n        <a href=\"/goods/all\">\n          <img src=\"https://img.grouponcdn.com/deal/eTnqcGU7XHwnms1s56UGkN/DE-705x254\">\n        </a>\n      </div>\n    {{/ clearanceWidget }}\n    {{{ dealsHtml }}}\n  </div>\n{{/ cardsHtml }}\n\n<div class=\"pagination_footer\"></div>\n", Hogan);
},{"hogan.js":102}],44:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("paginationFooter",c,p,1),c,p,0,23,1145,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("displayPagination",c,p,1),c,p,0,50,1120,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"pagination\" data-bhw=\"BrowsePaginationLinks\">");t.b("\n" + i);t.b("      <ul class=\"pagination_links\">");t.b("\n" + i);t.b("        <li>");t.b("\n" + i);if(t.s(t.f("previousPageUrl",c,p,1),c,p,0,194,314,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <a href=\"");t.b(t.v(t.f("previousPageUrl",c,p,0)));t.b("\" class=\"previous\" data-bhc=\"page:previous\">");t.b(t.v(t.f("previousPage",c,p,0)));t.b("</a>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("previousPageUrl",c,p,1),c,p,1,0,0,"")){t.b("            <span class=\"previous\">");t.b(t.v(t.f("previousPage",c,p,0)));t.b("</span>");t.b("\n" + i);};t.b("        </li>");t.b("\n" + i);if(t.s(t.f("paginationSlots",c,p,1),c,p,0,508,717,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <li ");if(t.s(t.f("box",c,p,1),c,p,0,533,544,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("class=\"box\"");});c.pop();}t.b(">");t.b("\n" + i);t.b("            ");if(t.s(t.f("url",c,p,1),c,p,0,578,639,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<a href=\"");t.b(t.v(t.f("url",c,p,0)));t.b("\" data-bhc=\"page:");t.b(t.v(t.f("text",c,p,0)));t.b("\">");t.b(t.v(t.f("text",c,p,0)));t.b("</a>");});c.pop();}t.b("\n" + i);t.b("            ");if(!t.s(t.f("url",c,p,1),c,p,1,0,0,"")){t.b(t.v(t.f("text",c,p,0)));};t.b("\n" + i);t.b("          </li>");t.b("\n" + i);});c.pop();}t.b("\n" + i);t.b("        <li>");t.b("\n" + i);if(t.s(t.f("nextPageUrl",c,p,1),c,p,0,782,886,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <a href=\"");t.b(t.v(t.f("nextPageUrl",c,p,0)));t.b("\" class=\"next\" data-bhc=\"page:next\">");t.b(t.v(t.f("nextPage",c,p,0)));t.b("</a>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("nextPageUrl",c,p,1),c,p,1,0,0,"")){t.b("            <span class=\"next\">");t.b(t.v(t.f("nextPage",c,p,0)));t.b("</span>");t.b("\n" + i);};t.b("        </li>");t.b("\n" + i);t.b("      </ul>");t.b("\n" + i);t.b("      <p class='results'>");t.b("\n" + i);t.b("        ");t.b(t.t(t.f("resultsHtml",c,p,0)));t.b("\n" + i);t.b("      </p>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{# paginationFooter }}\n  {{# displayPagination }}\n    <div class=\"pagination\" data-bhw=\"BrowsePaginationLinks\">\n      <ul class=\"pagination_links\">\n        <li>\n          {{# previousPageUrl }}\n            <a href=\"{{ previousPageUrl }}\" class=\"previous\" data-bhc=\"page:previous\">{{ previousPage }}</a>\n          {{/ previousPageUrl }}\n          {{^ previousPageUrl }}\n            <span class=\"previous\">{{ previousPage }}</span>\n          {{/ previousPageUrl }}\n        </li>\n        {{# paginationSlots }}\n          <li {{# box }}class=\"box\"{{/ box }}>\n            {{# url }}<a href=\"{{ url }}\" data-bhc=\"page:{{ text }}\">{{ text }}</a>{{/ url }}\n            {{^ url }}{{ text }}{{/ url }}\n          </li>\n        {{/ paginationSlots }}\n\n        <li>\n          {{# nextPageUrl }}\n            <a href=\"{{ nextPageUrl }}\" class=\"next\" data-bhc=\"page:next\">{{ nextPage }}</a>\n          {{/ nextPageUrl }}\n          {{^ nextPageUrl }}\n            <span class=\"next\">{{ nextPage }}</span>\n          {{/ nextPageUrl }}\n        </li>\n      </ul>\n      <p class='results'>\n        {{{ resultsHtml }}}\n      </p>\n    </div>\n  {{/ displayPagination }}\n{{/ paginationFooter }}\n", Hogan);
},{"hogan.js":102}],45:[function(require,module,exports){
(function (global){
var Application, Backbone, SORT_TOGGLE_SELECTOR, SortToggleView, _, _ref, _ref1;

Backbone = (_ref = typeof window !== "undefined" && window !== null ? window.Backbone : void 0) != null ? _ref : require('backbone');

_ = (_ref1 = typeof window !== "undefined" && window !== null ? window._ : void 0) != null ? _ref1 : (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);

SORT_TOGGLE_SELECTOR = '.page-header .sort-toggle';

SortToggleView = void 0;

Application = _.extend({}, Backbone.Events, {
  initialize: function() {
    this._createModelsAndViews();
    return this._addListeners();
  },
  _createModelsAndViews: function() {
    var _ref2, _ref3, _ref4;
    if (SortToggleView == null) {
      SortToggleView = (_ref2 = typeof Modules !== "undefined" && Modules !== null ? (_ref3 = Modules.SortToggle) != null ? (_ref4 = _ref3.Views) != null ? _ref4.SortToggle : void 0 : void 0 : void 0) != null ? _ref2 : require('./views/sort_toggle');
    }
    return this.sortToggleView = new SortToggleView({
      el: SORT_TOGGLE_SELECTOR
    });
  },
  _addListeners: function() {
    return this.listenTo(this.sortToggleView, 'change:value', function(event) {
      return this.trigger('change:sort', event);
    });
  }
});

if (typeof module !== "undefined" && module !== null ? module.exports : void 0) {
  module.exports = Application;
} else {
  Modules.SortToggle.Application = Application;
}


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./views/sort_toggle":46,"backbone":56}],46:[function(require,module,exports){
var Backbone, SortToggleView, _ref,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  __hasProp = {}.hasOwnProperty;

Backbone = (_ref = typeof window !== "undefined" && window !== null ? window.Backbone : void 0) != null ? _ref : require('backbone');

SortToggleView = (function(_super) {
  __extends(SortToggleView, _super);

  function SortToggleView() {
    return SortToggleView.__super__.constructor.apply(this, arguments);
  }

  SortToggleView.prototype.events = {
    'change': '_onChange'
  };

  SortToggleView.prototype._onChange = function() {
    return this.trigger('change:value', {
      sort: this.$el.val()
    });
  };

  return SortToggleView;

})(Backbone.View);

if (typeof module !== "undefined" && module !== null ? module.exports : void 0) {
  module.exports = SortToggleView;
} else {
  Modules.SortToggle.Views.SortToggle = SortToggleView;
}



},{"backbone":56}],47:[function(require,module,exports){
(function (global){
var PageHeaderTitlePresenter, isEmpty;

isEmpty = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null).isEmpty;

module.exports = PageHeaderTitlePresenter = (function() {
  var categoryLink, getCategoryName, getDataBhc, getFriendlyName, getSelectedInterests, showCategoryLink;

  function PageHeaderTitlePresenter(_arg) {
    this.selectedCategory = _arg.selectedCategory, this.params = _arg.params, this.basePath = _arg.basePath, this.refinementInterests = _arg.refinementInterests, this.collection = _arg.collection;
  }

  PageHeaderTitlePresenter.prototype.toHash = function() {
    var ctx, message, query, selectedInterests, _ref;
    ctx = {};
    selectedInterests = getSelectedInterests(this.refinementInterests);
    if ((_ref = this.collection) != null ? _ref.id : void 0) {

    } else if (showCategoryLink(this.selectedCategory, this.params, selectedInterests)) {
      ctx["link"] = categoryLink(this.params, this.basePath, this.selectedCategory);
    } else if (this.params.query != null) {
      query = this.params.query;
      message = I18n.translate('js.modules.browse.presenters.page_header.query_message', {
        query: query
      });
      ctx["searchQuery"] = {
        query: query,
        message: message
      };
    } else if (selectedInterests.length === 1) {
      ctx["interestName"] = selectedInterests[0].get("friendlyName");
    } else {
      ctx["link"] = categoryLink(this.params, this.basePath, this.selectedCategory);
    }
    if (!isEmpty(ctx)) {
      return {
        titleHeading: ctx
      };
    }
  };

  categoryLink = function(queryParams, basePath, selectedCategory) {
    var serializedParams;
    queryParams = _.omit(queryParams, "category2", "category3", "interest");
    serializedParams = $.param(queryParams);
    if (serializedParams !== '') {
      serializedParams = '?' + serializedParams;
    }
    return {
      "href": basePath + serializedParams,
      "text": getCategoryName(selectedCategory, queryParams),
      "id": selectedCategory.id,
      "dataBhc": getDataBhc()
    };
  };

  getDataBhc = function() {
    var _ref;
    if (this.collection) {
      return "collection:" + this.collection.id;
    }
    return "category:" + ((_ref = this.selectedCategory) != null ? _ref.id : void 0);
  };

  getCategoryName = function(selectedCategory, queryParams) {
    if (selectedCategory.id === "all-deals" && queryParams.context === "local") {
      return I18n.translate('js.modules.browse.presenters.local_deals_friendly_name');
    } else {
      return getFriendlyName(selectedCategory);
    }
  };

  getSelectedInterests = function(refinementInterests) {
    return refinementInterests != null ? refinementInterests.where({
      selected: true
    }) : void 0;
  };

  showCategoryLink = function(selectedCategory, params, selectedInterests) {
    return ((selectedCategory != null ? selectedCategory.id : void 0) !== 'all-deals') || ((params.query == null) && selectedInterests.length !== 1);
  };

  getFriendlyName = function(category) {
    return category.friendlyNameShort || category.friendlyName;
  };

  return PageHeaderTitlePresenter;

})();


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],48:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("titleHeading",c,p,1),c,p,0,19,859,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("searchQuery",c,p,1),c,p,0,40,117,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <span data-bhc=\"query:");t.b(t.v(t.f("query",c,p,0)));t.b("\">");t.b("\n" + i);t.b("      ");t.b(t.t(t.f("message",c,p,0)));t.b("\n" + i);t.b("    </span>");t.b("\n" + i);});c.pop();}if(t.s(t.f("interestName",c,p,1),c,p,0,157,247,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <span data-bhc=\"interest:");t.b(t.v(t.f("interestName",c,p,0)));t.b("\">");t.b("\n" + i);t.b("      ");t.b(t.v(t.f("interestName",c,p,0)));t.b("\n" + i);t.b("    </span>");t.b("\n" + i);});c.pop();}if(t.s(t.f("brand",c,p,1),c,p,0,281,351,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <span data-bhc=\"brand:");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("      ");t.b(t.v(t.f("title",c,p,0)));t.b("\n" + i);t.b("    </span>");t.b("\n" + i);});c.pop();}if(t.s(t.f("link",c,p,1),c,p,0,377,432,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <a href=\"");t.b(t.v(t.f("href",c,p,0)));t.b("\">");t.b("\n" + i);t.b("      ");t.b(t.v(t.f("text",c,p,0)));t.b("\n" + i);t.b("    </a>");t.b("\n" + i);});c.pop();}if(t.s(t.f("subcategory",c,p,1),c,p,0,464,613,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <span class=\"subcategory-bread\">");t.b("\n" + i);t.b("      <a href=\"");t.b(t.v(t.f("url",c,p,0)));t.b("\" data-bhc=\"subcategory:");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("        ");t.b(t.v(t.f("friendlyName",c,p,0)));t.b("\n" + i);t.b("      </a>");t.b("\n" + i);t.b("    </span>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("searchQuery",c,p,1),c,p,1,0,0,"")){if(!t.s(t.f("brand",c,p,1),c,p,1,0,0,"")){if(!t.s(t.f("interestName",c,p,1),c,p,1,0,0,"")){if(!t.s(t.f("link",c,p,1),c,p,1,0,0,"")){t.b("          <span>");t.b("\n" + i);t.b("            ");t.b(t.v(t.f("title",c,p,0)));t.b("\n" + i);t.b("          </span>");t.b("\n" + i);};};};};});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{# titleHeading }}\n  {{# searchQuery }}\n    <span data-bhc=\"query:{{ query }}\">\n      {{{ message }}}\n    </span>\n  {{/ searchQuery }}\n  {{# interestName }}\n    <span data-bhc=\"interest:{{ interestName }}\">\n      {{ interestName }}\n    </span>\n  {{/ interestName }}\n  {{# brand }}\n    <span data-bhc=\"brand:{{ id }}\">\n      {{ title }}\n    </span>\n  {{/ brand }}\n  {{# link }}\n    <a href=\"{{ href }}\">\n      {{ text }}\n    </a>\n  {{/ link }}\n  {{# subcategory }}\n    <span class=\"subcategory-bread\">\n      <a href=\"{{ url }}\" data-bhc=\"subcategory:{{ id }}\">\n        {{ friendlyName }}\n      </a>\n    </span>\n  {{/ subcategory }}\n  {{^ searchQuery }}\n    {{^ brand }}\n      {{^ interestName }}\n        {{^ link }}\n          <span>\n            {{ title }}\n          </span>\n        {{/ link }}\n      {{/ interestName }}\n    {{/ brand }}\n  {{/ searchQuery }}\n{{/ titleHeading }}\n", Hogan);
},{"hogan.js":102}],49:[function(require,module,exports){
module.exports = {
  updateSeoPageMetaHash: function(seoMetaHash) {
    var $head, $next, $prev, $robots, alternate, alternates, canonical, description, keywords, next, noindexed, pageMeta, prev, title, _i, _len;
    title = seoMetaHash.title, pageMeta = seoMetaHash.pageMeta;
    if (!pageMeta) {
      return;
    }
    canonical = pageMeta.canonical, keywords = pageMeta.keywords, description = pageMeta.description, noindexed = pageMeta.noindexed, prev = pageMeta.prev, next = pageMeta.next, alternates = pageMeta.alternates;
    $head = $('head');
    $head.find('title').text(title);
    $head.find('link[rel="canonical"]').attr('href', canonical);
    $head.find('meta[name="keywords"]').attr('content', keywords);
    $head.find('meta[name="description"]').attr('content', description);
    for (_i = 0, _len = alternates.length; _i < _len; _i++) {
      alternate = alternates[_i];
      $head.find("link[hreflang='" + alternate.hreflang + "']").attr('href', alternate.href);
    }
    $robots = $head.find('meta[name="robots"]');
    if (!noindexed) {
      $robots.remove();
    } else if ($robots.length < 1) {
      $head.append('<meta name="robots" content="noindex,nofollow">');
    }
    $prev = $head.find('link[rel="prev"]');
    if (!prev) {
      $prev.remove();
    } else if ($prev.length) {
      $prev.attr('href', prev);
    } else {
      $head.append("<link rel='prev' href='" + prev + "'>");
    }
    $next = $head.find('link[rel="next"]');
    if (!next) {
      return $next.remove();
    } else if ($next.length) {
      return $next.attr('href', next);
    } else {
      return $head.append("<link rel='next' href='" + next + "'>");
    }
  }
};



},{}],50:[function(require,module,exports){
(function (global){
var extend;

extend = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null).extend;

module.exports = {
  prefixI18n: function(I18n, prefix) {
    return extend({}, I18n, {
      t: function(key, options) {
        key = "" + prefix + key;
        return I18n.t(key, options);
      }
    });
  }
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],51:[function(require,module,exports){
(function (global){
var TreeTraversalHelper, contains, getAncestors, getCommonAncestor, getOrderedCommonNodes, getSelectedNodes, min, uniq, _ref;

_ref = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), contains = _ref.contains, min = _ref.min, uniq = _ref.uniq;

getOrderedCommonNodes = function(nodes, selectedIds, idKey, childrenKey) {
  var commonAncestor, selectedNodes;
  if (idKey == null) {
    idKey = 'id';
  }
  if (childrenKey == null) {
    childrenKey = 'children';
  }
  selectedNodes = getSelectedNodes(nodes, childrenKey, (function(_this) {
    return function(node) {
      return contains(selectedIds, node[idKey]);
    };
  })(this));
  if (!selectedNodes.length) {
    return;
  }
  commonAncestor = getCommonAncestor(selectedNodes);
  return getAncestors(commonAncestor);
};

getSelectedNodes = (function(_this) {
  return function(nodes, childrenKey, isSelectedFunction, parent) {
    var node, selectedChildNodes, selectedNodes, _i, _len;
    selectedNodes = [];
    for (_i = 0, _len = nodes.length; _i < _len; _i++) {
      node = nodes[_i];
      if (node.parent == null) {
        node.parent = parent;
      }
      if (isSelectedFunction(node)) {
        selectedNodes.push(node);
      }
      if (node[childrenKey]) {
        selectedChildNodes = getSelectedNodes(node[childrenKey], childrenKey, isSelectedFunction, node);
      }
      if (selectedChildNodes != null ? selectedChildNodes.length : void 0) {
        selectedNodes = selectedNodes.concat(selectedChildNodes);
      }
    }
    return selectedNodes;
  };
})(this);

getCommonAncestor = function(nodes, parentKey) {
  var ancestor, ancestors, ancestorsAtCurrentLevel, commonAncestor, i, lengths, matrixOfAncestors, node, shortestLength, _i, _j, _len, _ref1;
  if (parentKey == null) {
    parentKey = 'parent';
  }
  if (!(nodes != null ? nodes.length : void 0)) {
    return;
  }
  if (nodes.length === 1) {
    return nodes[0];
  }
  if (nodes.length === 2 && nodes[0][parentKey] === nodes[1]) {
    return nodes[0];
  }
  if (nodes.length === 2 && nodes[1][parentKey] === nodes[0]) {
    return nodes[1];
  }
  if (nodes.length === 3 && nodes[2][parentKey] === nodes[1] && nodes[1][parentKey] === nodes[0]) {
    return nodes[2];
  }
  if (nodes.length === 4 && nodes[3][parentKey] === nodes[2] && nodes[2][parentKey] === nodes[1] && nodes[1][parentKey] === nodes[0]) {
    return nodes[3];
  }
  matrixOfAncestors = [];
  lengths = [];
  for (_i = 0, _len = nodes.length; _i < _len; _i++) {
    node = nodes[_i];
    ancestors = getAncestors(node);
    matrixOfAncestors.push(ancestors);
    lengths.push(ancestors.length);
  }
  shortestLength = min(lengths);
  commonAncestor = void 0;
  for (i = _j = 0, _ref1 = shortestLength - 1; 0 <= _ref1 ? _j <= _ref1 : _j >= _ref1; i = 0 <= _ref1 ? ++_j : --_j) {
    ancestorsAtCurrentLevel = (function() {
      var _k, _len1, _results;
      _results = [];
      for (_k = 0, _len1 = matrixOfAncestors.length; _k < _len1; _k++) {
        ancestor = matrixOfAncestors[_k];
        _results.push(ancestor[i]);
      }
      return _results;
    })();
    if (uniq(ancestorsAtCurrentLevel).length === 1) {
      commonAncestor = ancestorsAtCurrentLevel[0];
    }
  }
  return commonAncestor;
};

getAncestors = function(node, parentKey) {
  var ancestor, ancestors;
  if (parentKey == null) {
    parentKey = 'parent';
  }
  if (!node) {
    return;
  }
  ancestors = [node];
  ancestor = node;
  while (ancestor[parentKey]) {
    ancestor = ancestor[parentKey];
    ancestors.push(ancestor);
  }
  return ancestors.reverse();
};

module.exports = TreeTraversalHelper = {
  getOrderedCommonNodes: getOrderedCommonNodes,
  getSelectedNodes: getSelectedNodes
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],52:[function(require,module,exports){
var UpdateAppURLHelper, usePushState;

module.exports = UpdateAppURLHelper = function(adjustedURL, opts) {
  var _ref;
  if (opts == null) {
    opts = {};
  }
  if (usePushState(opts)) {
    return window.history.pushState(null, null, adjustedURL);
  } else if (((_ref = window.history) != null ? _ref.replaceState : void 0) != null) {
    return window.history.replaceState(null, null, adjustedURL);
  } else {
    return window.location = adjustedURL;
  }
};

usePushState = function(opts) {
  var _ref;
  if (!opts.pushState) {
    return false;
  }
  return ((_ref = window.history) != null ? _ref.pushState : void 0) != null;
};



},{}],53:[function(require,module,exports){
var Backbone, SpinnerTemplate, SpinnerView;

Backbone = require('backbone');

SpinnerTemplate = require('../../spinner.html.mustache');

module.exports = SpinnerView = Backbone.View.extend({
  template: SpinnerTemplate,
  initialize: function(_arg) {
    var _ref;
    this.parentElem = _arg.parentElem, this.css = _arg.css, this.useV2 = _arg.useV2;
    return (_ref = this.parentElem) != null ? typeof _ref.append === "function" ? _ref.append(this.$el) : void 0 : void 0;
  },
  render: function() {
    this.stop();
    this.$el.html(this.template.render({
      useV2: this.useV2
    }));
    if (this.useV2) {
      if (this.css != null) {
        this.$el.find('.g-spinner').css(this.css);
      }
    } else {
      if (this.css != null) {
        this.$el.find('.t-spinner-small').css(this.css);
      }
    }
    return this;
  },
  isRunning: function() {
    return this.$el.is(':visible');
  },
  isInDom: function() {
    return $.contains(document.documentElement, this.$el[0]);
  },
  start: function() {
    var _ref;
    if (!this.isInDom()) {
      if ((_ref = this.parentElem) != null) {
        if (typeof _ref.append === "function") {
          _ref.append(this.$el);
        }
      }
    }
    return this.$el.show();
  },
  stop: function() {
    return this.$el.hide();
  }
});



},{"../../spinner.html.mustache":54,"backbone":56}],54:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"spinner-overlay\">");t.b("\n" + i);if(t.s(t.f("useV2",c,p,1),c,p,0,44,122,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div id=\"spinner-back\">");t.b("\n" + i);t.b("      <div class=\"g-spinner\"></div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("useV2",c,p,1),c,p,1,0,0,"")){t.b("    <div class=\"t-spinner-small\"></div>");t.b("\n" + i);};t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"spinner-overlay\">\n  {{# useV2 }}\n    <div id=\"spinner-back\">\n      <div class=\"g-spinner\"></div>\n    </div>\n  {{/ useV2 }}\n  {{^ useV2 }}\n    <div class=\"t-spinner-small\"></div>\n  {{/ useV2 }}\n</div>\n", Hogan);
},{"hogan.js":102}],55:[function(require,module,exports){
var ThirdPartyAdsView;

ThirdPartyAdsView = {
  hideDealTileIfAdBlocked: function() {
    var $adBlockBait, ad, _i, _len, _ref, _results;
    $adBlockBait = $(".ad_container");
    if ($adBlockBait.is(":visible") === false) {
      _ref = $('.deal-ad-card');
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        ad = _ref[_i];
        _results.push($(ad).closest(".deal-card").hide());
      }
      return _results;
    }
  }
};

module.exports = ThirdPartyAdsView;



},{}],56:[function(require,module,exports){
(function (global){
//     Backbone.js 1.0.0

//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(){

  // Initial Setup
  // -------------

  // Save a reference to the global object (`window` in the browser, `exports`
  // on the server).
  var root = this;

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create local references to array methods we'll want to use later.
  var array = [];
  var push = array.push;
  var slice = array.slice;
  var splice = array.splice;

  // The top-level namespace. All public Backbone classes and modules will
  // be attached to this. Exported for both the browser and the server.
  var Backbone;
  if (typeof exports !== 'undefined') {
    Backbone = exports;
  } else {
    Backbone = root.Backbone = {};
  }

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.0.0';

  // Require Underscore, if we're on the server, and it's not already present.
  var _ = root._;
  if (!_ && (typeof require !== 'undefined')) _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = root.jQuery || root.Zepto || root.ender || root.$;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = {};
        return this;
      }

      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeners = this._listeners;
      if (!listeners) return this;
      var deleteListener = !name && !callback;
      if (typeof name === 'object') callback = this;
      if (obj) (listeners = {})[obj._listenerId] = obj;
      for (var id in listeners) {
        listeners[id].off(name, callback, this);
        if (deleteListener) delete this._listeners[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeners = this._listeners || (this._listeners = {});
      var id = obj._listenerId || (obj._listenerId = _.uniqueId('l'));
      listeners[id] = obj;
      if (typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var defaults;
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId('c');
    this.attributes = {};
    _.extend(this, _.pick(options, modelOptions));
    if (options.parse) attrs = this.parse(attrs, options) || {};
    if (defaults = _.result(this, 'defaults')) {
      attrs = _.defaults({}, attrs, defaults);
    }
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // A list of options to be attached directly to the model, if provided.
  var modelOptions = ['url', 'urlRoot', 'collection'];

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      unset           = options.unset;
      silent          = options.silent;
      changes         = [];
      changing        = this._changing;
      this._changing  = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }
      current = this.attributes, prev = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          this.changed[attr] = val;
        } else {
          delete this.changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = true;
        for (var i = 0, l = changes.length; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var val, changed = false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      for (var attr in diff) {
        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
        (changed || (changed = {}))[attr] = val;
      }
      return changed;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        if (!model.set(model.parse(resp, options), options)) return false;
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      var attrs, method, xhr, attributes = this.attributes;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      // If we're not waiting and attributes exist, save acts as `set(attr).save(null, opts)`.
      if (attrs && (!options || !options.wait) && !this.set(attrs, options)) return false;

      options = _.extend({validate: true}, options);

      // Do not persist invalid models.
      if (!this._validate(attrs, options)) return false;

      // Set temporary attributes if `{wait: true}`.
      if (attrs && options.wait) {
        this.attributes = _.extend({}, attributes, attrs);
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = model.parse(resp, options);
        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
          return false;
        }
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch') options.attrs = attrs;
      xhr = this.sync(method, this, options);

      // Restore attributes.
      if (attrs && options.wait) this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;

      var destroy = function() {
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (options.wait || model.isNew()) destroy();
        if (success) success(model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      if (this.isNew()) {
        options.success();
        return false;
      }
      wrapError(this, options);

      var xhr = this.sync('delete', this, options);
      if (!options.wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base = _.result(this, 'urlRoot') || _.result(this.collection, 'url') || urlError();
      if (this.isNew()) return base;
      return base + (base.charAt(base.length - 1) === '/' ? '' : '/') + encodeURIComponent(this.id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return this.id == null;
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend(options || {}, { validate: true }));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options || {}, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  _.each(modelMethods, function(method) {
    Model.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.attributes);
      return _[method].apply(_, args);
    };
  });

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analagous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.url) this.url = options.url;
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, merge: false, remove: false};

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model){ return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set.
    add: function(models, options) {
      return this.set(models, _.defaults(options || {}, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      models = _.isArray(models) ? models.slice() : [models];
      options || (options = {});
      var i, l, index, model;
      for (i = 0, l = models.length; i < l; i++) {
        model = this.get(models[i]);
        if (!model) continue;
        delete this._byId[model.id];
        delete this._byId[model.cid];
        index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;
        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }
        this._removeReference(model);
      }
      return this;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      options = _.defaults(options || {}, setOptions);
      if (options.parse) models = this.parse(models, options);
      if (!_.isArray(models)) models = models ? [models] : [];
      var i, l, model, attrs, existing, sort;
      var at = options.at;
      var sortable = this.comparator && (at == null) && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
      var toAdd = [], toRemove = [], modelMap = {};

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      for (i = 0, l = models.length; i < l; i++) {
        if (!(model = this._prepareModel(models[i], options))) continue;

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        if (existing = this.get(model)) {
          if (options.remove) modelMap[existing.cid] = true;
          if (options.merge) {
            existing.set(model.attributes, options);
            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
          }

        // This is a new model, push it to the `toAdd` list.
        } else if (options.add) {
          toAdd.push(model);

          // Listen to added models' events, and index models for lookup by
          // `id` and by `cid`.
          model.on('all', this._onModelEvent, this);
          this._byId[model.cid] = model;
          if (model.id != null) this._byId[model.id] = model;
        }
      }

      // Remove nonexistent models if appropriate.
      if (options.remove) {
        for (i = 0, l = this.length; i < l; ++i) {
          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
        }
        if (toRemove.length) this.remove(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      if (toAdd.length) {
        if (sortable) sort = true;
        this.length += toAdd.length;
        if (at != null) {
          splice.apply(this.models, [at, 0].concat(toAdd));
        } else {
          push.apply(this.models, toAdd);
        }
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      if (options.silent) return this;

      // Trigger `add` events.
      for (i = 0, l = toAdd.length; i < l; i++) {
        (model = toAdd[i]).trigger('add', model, this, options);
      }

      // Trigger `sort` if the collection was sorted.
      if (sort) this.trigger('sort', this, options);
      return this;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options || (options = {});
      for (var i = 0, l = this.models.length; i < l; i++) {
        this._removeReference(this.models[i]);
      }
      options.previousModels = this.models;
      this._reset();
      this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return this;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      model = this._prepareModel(model, options);
      this.add(model, _.extend({at: this.length}, options));
      return model;
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      this.remove(model, options);
      return model;
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      model = this._prepareModel(model, options);
      this.add(model, _.extend({at: 0}, options));
      return model;
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      this.remove(model, options);
      return model;
    },

    // Slice out a sub-array of models from the collection.
    slice: function(begin, end) {
      return this.models.slice(begin, end);
    },

    // Get a model from the set by id.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj.id != null ? obj.id : obj.cid || obj];
    },

    // Get the model at the given index.
    at: function(index) {
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      if (_.isEmpty(attrs)) return first ? void 0 : [];
      return this[first ? 'find' : 'filter'](function(model) {
        for (var key in attrs) {
          if (attrs[key] !== model.get(key)) return false;
        }
        return true;
      });
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      // Run sort based on type of `comparator`.
      if (_.isString(this.comparator) || this.comparator.length === 1) {
        this.models = this.sortBy(this.comparator, this);
      } else {
        this.models.sort(_.bind(this.comparator, this));
      }

      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Figure out the smallest index at which a model should be inserted so as
    // to maintain order.
    sortedIndex: function(model, value, context) {
      value || (value = this.comparator);
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _.sortedIndex(this.models, model, iterator, context);
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return _.invoke(this.models, 'get', attr);
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success(collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      if (!(model = this._prepareModel(model, options))) return false;
      if (!options.wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(resp) {
        if (options.wait) collection.add(model, options);
        if (success) success(model, resp, options);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models);
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (attrs instanceof Model) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options || (options = {});
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model._validate(attrs, options)) {
        this.trigger('invalid', this, attrs, options);
        return false;
      }
      return model;
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model) {
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if ((event === 'add' || event === 'remove') && collection !== this) return;
      if (event === 'destroy') this.remove(model, options);
      if (model && event === 'change:' + model.idAttribute) {
        delete this._byId[model.previous(model.idAttribute)];
        if (model.id != null) this._byId[model.id] = model;
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
    'tail', 'drop', 'last', 'without', 'indexOf', 'shuffle', 'lastIndexOf',
    'isEmpty', 'chain'];

  // Mix in each Underscore method as a proxy to `Collection#models`.
  _.each(methods, function(method) {
    Collection.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.models);
      return _[method].apply(_, args);
    };
  });

  // Underscore methods that take a property name as an argument.
  var attributeMethods = ['groupBy', 'countBy', 'sortBy'];

  // Use attributes instead of properties.
  _.each(attributeMethods, function(method) {
    Collection.prototype[method] = function(value, context) {
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _[method](this.models, iterator, context);
    };
  });

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    this._configure(options || {});
    this._ensureElement();
    this.initialize.apply(this, arguments);
    this.delegateEvents();
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be merged as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be prefered to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this.$el.remove();
      this.stopListening();
      return this;
    },

    // Change the view's element (`this.el` property), including event
    // re-delegation.
    setElement: function(element, delegate) {
      if (this.$el) this.undelegateEvents();
      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
      this.el = this.$el[0];
      if (delegate !== false) this.delegateEvents();
      return this;
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save'
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    // This only works for delegate-able events: not `focus`, `blur`, and
    // not `change`, `submit`, and `reset` in Internet Explorer.
    delegateEvents: function(events) {
      if (!(events || (events = _.result(this, 'events')))) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[events[key]];
        if (!method) continue;

        var match = key.match(delegateEventSplitter);
        var eventName = match[1], selector = match[2];
        method = _.bind(method, this);
        eventName += '.delegateEvents' + this.cid;
        if (selector === '') {
          this.$el.on(eventName, method);
        } else {
          this.$el.on(eventName, selector, method);
        }
      }
      return this;
    },

    // Clears all callbacks previously bound to the view with `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // Performs the initial configuration of a View with a set of options.
    // Keys with special meaning *(e.g. model, collection, id, className)* are
    // attached directly to the view.  See `viewOptions` for an exhaustive
    // list.
    _configure: function(options) {
      if (this.options) options = _.extend({}, _.result(this, 'options'), options);
      _.extend(this, _.pick(options, viewOptions));
      this.options = options;
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
        this.setElement($el, false);
      } else {
        this.setElement(_.result(this, 'el'), false);
      }
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
    // that still has ActiveX enabled by default, override jQuery to use that
    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
    if (params.type === 'PATCH' && window.ActiveXObject &&
          !(window.external && window.external.msActiveXFilteringEnabled)) {
      params.xhr = function() {
        return new ActiveXObject("Microsoft.XMLHTTP");
      };
    }

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch':  'PATCH',
    'delete': 'DELETE',
    'read':   'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        callback && callback.apply(router, args);
        router.trigger.apply(router, ['route:' + name].concat(args));
        router.trigger('route', name, args);
        Backbone.history.trigger('route', router, name, args);
      });
      return this;
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional){
                     return optional ? match : '([^\/]+)';
                   })
                   .replace(splatParam, '(.*?)');
      return new RegExp('^' + route + '$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param) {
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    _.bindAll(this, 'checkUrl');

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for detecting MSIE.
  var isExplorer = /msie [\w.]+/;

  // Cached regex for removing a trailing slash.
  var trailingSlash = /\/$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the cross-browser normalized URL fragment, either from the URL,
    // the hash, or the override.
    getFragment: function(fragment, forcePushState) {
      if (fragment == null) {
        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
          fragment = this.location.pathname;
          var root = this.root.replace(trailingSlash, '');
          if (!fragment.indexOf(root)) fragment = fragment.substr(root.length);
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error("Backbone.history has already been started");
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({}, {root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
      var fragment          = this.getFragment();
      var docMode           = document.documentMode;
      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      if (oldIE && this._wantsHashChange) {
        this.iframe = Backbone.$('<iframe src="javascript:0" tabindex="-1" />').hide().appendTo('body')[0].contentWindow;
        this.navigate(fragment);
      }

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._hasPushState) {
        Backbone.$(window).on('popstate', this.checkUrl);
      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
        Backbone.$(window).on('hashchange', this.checkUrl);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      // Determine if we need to change the base url, for a pushState link
      // opened by a non-pushState browser.
      this.fragment = fragment;
      var loc = this.location;
      var atRoot = loc.pathname.replace(/[^\/]$/, '$&/') === this.root;

      // If we've started off with a route from a `pushState`-enabled browser,
      // but we're currently in a browser that doesn't support it...
      if (this._wantsHashChange && this._wantsPushState && !this._hasPushState && !atRoot) {
        this.fragment = this.getFragment(null, true);
        this.location.replace(this.root + this.location.search + '#' + this.fragment);
        // Return immediately as browser will do redirect to new url
        return true;

      // Or if we've started out with a hash-based route, but we're currently
      // in a browser where it could be `pushState`-based instead...
      } else if (this._wantsPushState && this._hasPushState && atRoot && loc.hash) {
        this.fragment = this.getHash().replace(routeStripper, '');
        this.history.replaceState({}, document.title, this.root + this.fragment + loc.search);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
      clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();
      if (current === this.fragment && this.iframe) {
        current = this.getFragment(this.getHash(this.iframe));
      }
      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl() || this.loadUrl(this.getHash());
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragmentOverride) {
      var fragment = this.fragment = this.getFragment(fragmentOverride);
      var matched = _.any(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
      return matched;
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: options};
      fragment = this.getFragment(fragment || '');
      if (this.fragment === fragment) return;
      this.fragment = fragment;
      var url = this.root + fragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._hasPushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if(!options.replace) this.iframe.document.open().close();
          this._updateHash(this.iframe.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain, for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function (model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error(model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

}).call(this);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],57:[function(require,module,exports){
var Availabilities, Bookable, BreadcrumbQuery, BreadcrumbsView, LinksList, ParentNestedLinks, Range, RangeFilters, Ranges, Refinement, RefinementUI, Refinements, ResetAll, ResetFilters, getCollectionForRefinement, getRefinementData, getView, rangeRefinementCollectionOptions, refinementCollectionOptions, renderBreadcrumb, renderResetAll, templates,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

Refinements = require('./collections/refinements');

Ranges = require('./collections/ranges');

Bookable = require('./models/bookable');

Refinement = require('./models/refinement');

Range = require('./models/range');

refinementCollectionOptions = require('./presenters/refinement_collection_options');

rangeRefinementCollectionOptions = require('./presenters/range_refinement_collection_options');

LinksList = require('./views/links_list');

ParentNestedLinks = require('./views/parent_nested_links');

ResetAll = require('./views/reset_all');

ResetFilters = require('./views/reset_filters');

RangeFilters = require('./views/range_filters');

Availabilities = require('./views/availabilities');

BreadcrumbsView = require('./views/breadcrumbs');

BreadcrumbQuery = require('./views/breadcrumb_query');

templates = require('../templates');

RefinementUI = (function() {
  RefinementUI.prototype.template = templates['widget'];

  function RefinementUI(refinements, options) {
    var container;
    if (refinements == null) {
      refinements = [];
    }
    if (options == null) {
      options = {};
    }
    this._updateSelectedRefinements = bind(this._updateSelectedRefinements, this);
    container = options.container, this.shouldResetViews = options.shouldResetViews, this.showBreadcrumbFilter = options.showBreadcrumbFilter;
    if (!container) {
      return;
    }
    this.$container = $(container);
    this.events = _.clone(Backbone.Events);
    this.refinementCollections = {};
    this.selectedRefinements = {};
    this.refinementViews = {};
    this.refinementIds = [];
    _.each(refinements, (function(_this) {
      return function(refinement) {
        var collection, view;
        collection = _this._createRefinementCollection(refinement);
        _this.refinementCollections[refinement.id] = collection;
        view = _this._createRefinementView(refinement, collection, _this.$container);
        if (collection.isQueryFilter) {
          _this.queryFilterView = view;
        }
        if (_this.shouldResetViews) {
          _this.refinementViews[refinement.id] = view;
          _this.refinementIds.push(refinement.id);
        }
        return view.render();
      };
    })(this));
    if (this.showBreadcrumbFilter) {
      this.breadcrumbView = renderBreadcrumb(this.$container, this.refinementCollections);
      this.resetAllView = this.breadcrumbView.resetAllView;
    } else {
      this.resetAllView = renderResetAll(this.$container, this.refinementCollections, this.bookableModel);
    }
  }

  RefinementUI.prototype.updateRefinements = function(updatedRefinements, updateOptions) {
    if (this.shouldResetViews && this._hasMismatch(updatedRefinements)) {
      return this._rerenderViews(updatedRefinements, updateOptions);
    } else {
      return _.each(updatedRefinements, (function(_this) {
        return function(refinement) {
          var ref, ref1;
          if (refinement.dates) {
            if ((ref = _this.bookableModel) != null) {
              ref.set('dates', refinement.dates, updateOptions);
            }
          }
          return (ref1 = _this.refinementCollections[refinement.id]) != null ? ref1.setOrdered(refinement, updateOptions) : void 0;
        };
      })(this));
    }
  };

  RefinementUI.prototype.resetAll = function() {
    return this.resetAllView.resetAll();
  };

  RefinementUI.prototype._hasMismatch = function(refinements) {
    if (refinements.length !== this.refinementIds.length) {
      return true;
    }
    return _.some(refinements, (function(_this) {
      return function(v, i) {
        return v.id !== _this.refinementIds[i];
      };
    })(this));
  };

  RefinementUI.prototype._rerenderViews = function(updatedRefinements, updateOptions) {
    var collections, elems, id, idsToRemove, j, len, oldRefinementIds, ref, ref1, views;
    oldRefinementIds = this.refinementIds;
    this.refinementIds = [];
    collections = [];
    elems = [];
    views = [];
    if (this.queryFilterView) {
      elems.push(this.queryFilterView.el);
      views.push(this.queryFilterView);
    }
    if (this.showBreadcrumbFilter) {
      elems.push(this.breadcrumbView.el);
      views.push(this.breadcrumbView);
    } else {
      elems.push(this.resetAllView.el);
      views.push(this.resetAllView);
    }
    _.each(updatedRefinements, (function(_this) {
      return function(refinement) {
        var collection, view;
        _this.refinementIds.push(refinement.id);
        if ((collection = _this.refinementCollections[refinement.id])) {
          if (collection.isQueryFilter) {
            return;
          }
          collection.collapseFilter = refinement.collapseFilter;
          collection.setOrdered(refinement, updateOptions);
          view = _this.refinementViews[refinement.id];
        } else {
          collection = _this._createRefinementCollection(refinement);
          _this.refinementCollections[refinement.id] = collection;
          view = _this._createRefinementView(refinement, collection);
          _this.refinementViews[refinement.id] = view;
        }
        collections.push(collection);
        elems.push(view.el);
        return views.push(view);
      };
    })(this));
    this.resetAllView.resetRefinements(collections);
    if (this.breadcrumbView != null) {
      idsToRemove = _.difference(oldRefinementIds, this.refinementIds);
      ref = idsToRemove || [];
      for (j = 0, len = ref.length; j < len; j++) {
        id = ref[j];
        this._removeUnusedId(id);
      }
      if ((ref1 = this.breadcrumbView) != null) {
        ref1.resetRefinements(this.refinementCollections, idsToRemove);
      }
    }
    this.$container.html(elems);
    return _.each(views, function(view) {
      return view.render().delegateEvents();
    });
  };

  RefinementUI.prototype._removeUnusedId = function(id) {
    var ref, ref1, ref2, ref3;
    if ((ref = this.refinementViews) != null) {
      if ((ref1 = ref[id]) != null) {
        ref1.remove();
      }
    }
    if ((ref2 = this.refinementViews) != null) {
      delete ref2[id];
    }
    return (ref3 = this.refinementCollections) != null ? delete ref3[id] : void 0;
  };

  RefinementUI.prototype._createRefinementCollection = function(refinement) {
    var collection;
    collection = getCollectionForRefinement(refinement);
    this.events.listenTo(collection, 'selectedModels:updated', this._updateSelectedRefinements);
    this._setSelectedRefinement(refinement.id, collection.getSelectedValues());
    return collection;
  };

  RefinementUI.prototype._setSelectedRefinement = function(id, selectedValues) {
    return this.selectedRefinements[id] = {
      selectedValues: selectedValues
    };
  };

  RefinementUI.prototype._updateSelectedRefinements = function(selected) {
    this._setSelectedRefinement(selected.id, selected.selectedValues);
    if (selected.queue) {
      return;
    }
    return this.events.trigger('refinementsUpdated', this.selectedRefinements, selected.id);
  };

  RefinementUI.prototype._createRefinementView = function(refinement, collection, container) {
    var $containerEl, RefinementViewClass;
    $containerEl = (container != null ? container.find("[data-id='" + refinement.id + "']") : void 0) || $(this.template.render(refinement));
    RefinementViewClass = getView(refinement);
    if (refinement.availabilities) {
      this.bookableModel = this._getBookableModel(refinement);
    }
    return new RefinementViewClass({
      model: this.bookableModel,
      collection: collection,
      el: $containerEl
    });
  };

  RefinementUI.prototype._getBookableModel = function(refinement) {
    var bookableModel, date, dates, partySize, partySizes;
    date = refinement.date, partySizes = refinement.partySizes, dates = refinement.dates;
    partySize = this._getSelectedPartySize(partySizes);
    bookableModel = new Bookable({
      dates: dates,
      date: date,
      partySize: partySize
    });
    this._setSelectedRefinement('dates', [bookableModel.get('date')]);
    this._setSelectedRefinement('partySizes', [bookableModel.get('partySize')]);
    this.events.listenTo(bookableModel, 'selectedModels:updated', this._updateSelectedRefinements);
    return bookableModel;
  };

  RefinementUI.prototype._getSelectedPartySize = function(partySizes) {
    var ref;
    return (ref = _.find(partySizes, function(partySizeData) {
      return partySizeData.selected;
    })) != null ? ref.value : void 0;
  };

  return RefinementUI;

})();

getCollectionForRefinement = function(refinement) {
  var refinementData, refinementOptions;
  if (refinement.rangeFilters) {
    refinementOptions = rangeRefinementCollectionOptions.toHash(refinement);
    return new Ranges(refinement.refinementData, refinementOptions);
  } else {
    refinementData = getRefinementData(refinement);
    refinementOptions = refinementCollectionOptions.toHash(refinement);
    return new Refinements(refinementData, refinementOptions);
  }
};

getRefinementData = function(refinement) {
  var ref;
  return (ref = refinement.expandedRefinementData) != null ? ref : refinement.refinementData;
};

getView = function(refinement) {
  if (refinement.flatRefinementLinks) {
    return LinksList;
  }
  if (refinement.isQueryFilter) {
    return BreadcrumbQuery;
  }
  if (refinement.resetFilters) {
    return ResetFilters;
  }
  if (refinement.rangeFilters) {
    return RangeFilters;
  }
  if (refinement.availabilities) {
    return Availabilities;
  }
  return ParentNestedLinks;
};

renderResetAll = function(container, refinements, bookableModel) {
  var el;
  el = container.find('#reset-all-container');
  return new ResetAll({
    refinements: refinements,
    el: el,
    bookableModel: bookableModel
  }).render();
};

renderBreadcrumb = function(container, refinementCollections) {
  var el;
  el = container.find('#grui-breadcrumb-container');
  return new BreadcrumbsView({
    refinementCollections: refinementCollections,
    el: el
  }).render();
};

module.exports = window.RefinementUI = RefinementUI;

},{"../templates":94,"./collections/ranges":59,"./collections/refinements":60,"./models/bookable":64,"./models/range":66,"./models/refinement":67,"./presenters/range_refinement_collection_options":68,"./presenters/refinement_collection_options":69,"./views/availabilities":70,"./views/breadcrumb_query":75,"./views/breadcrumbs":77,"./views/links_list":80,"./views/parent_nested_links":84,"./views/range_filters":86,"./views/reset_all":87,"./views/reset_filters":88}],58:[function(require,module,exports){
var BreadcrumbModel, BreadcrumbsCollection,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

BreadcrumbModel = require('../models/breadcrumb');

module.exports = BreadcrumbsCollection = (function(superClass) {
  extend(BreadcrumbsCollection, superClass);

  function BreadcrumbsCollection() {
    return BreadcrumbsCollection.__super__.constructor.apply(this, arguments);
  }

  BreadcrumbsCollection.prototype.model = BreadcrumbModel;

  BreadcrumbsCollection.prototype.setNewRefinementCollections = function(refinementCollections, idsToRemove) {
    this._removeListeners(this.refinementCollections);
    this.refinementCollections = refinementCollections;
    this._applyListeners(refinementCollections);
    this._initSelectedValues(refinementCollections);
    return this._removeUnusedPills(idsToRemove);
  };

  BreadcrumbsCollection.prototype._initSelectedValues = function(refinementCollections) {
    var collection, key, results;
    results = [];
    for (key in refinementCollections) {
      collection = refinementCollections[key];
      if (this._supportsBreadcrumb(collection)) {
        results.push(this._updateSelections({
          id: collection.id,
          selectedValues: collection.getSelectedValues()
        }));
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  BreadcrumbsCollection.prototype._parseSelectedValues = function(selectedValues, id) {
    return _.map(selectedValues, function(arg) {
      var friendlyNameShort, name, refinementId;
      name = arg.name, refinementId = arg.refinementId, friendlyNameShort = arg.friendlyNameShort;
      return {
        name: name,
        refinementId: refinementId,
        friendlyNameShort: friendlyNameShort,
        selected: true,
        collectionId: id,
        id: id + "-" + refinementId
      };
    });
  };

  BreadcrumbsCollection.prototype._updateSelections = function(selectedModels) {
    var currentSelectedIds, id, newSelectedIds, newSelectedValues, selectedValues;
    selectedValues = selectedModels.selectedValues, id = selectedModels.id;
    newSelectedValues = this._parseSelectedValues(selectedValues, id);
    currentSelectedIds = _.pluck(this.where({
      collectionId: id
    }), 'id');
    newSelectedIds = _.pluck(newSelectedValues, 'id');
    if (currentSelectedIds.length) {
      this.remove(_.difference(currentSelectedIds, newSelectedIds));
    }
    return this.add(newSelectedValues);
  };

  BreadcrumbsCollection.prototype._applyListeners = function(refinementCollections) {
    var collection, key;
    for (key in refinementCollections) {
      collection = refinementCollections[key];
      if (this._supportsBreadcrumb(collection)) {
        this.listenTo(collection, 'selectedModels:updated', this._updateSelections);
      }
    }
    return this.on('change:selected', this._removeModel);
  };

  BreadcrumbsCollection.prototype._removeListeners = function(refinementCollections) {
    var collection, key;
    for (key in refinementCollections) {
      collection = refinementCollections[key];
      if (this._supportsBreadcrumb(collection)) {
        this.stopListening(collection, 'selectedModels:updated');
      }
    }
    return this.off('change:selected', this._removeModel);
  };

  BreadcrumbsCollection.prototype._removeModel = function(model, value, options) {
    var ref, ref1, ref2;
    if (!value) {
      this.remove(model);
      return (ref = this.refinementCollections) != null ? (ref1 = ref[model.get('collectionId')]) != null ? (ref2 = ref1.get(model.get('name'))) != null ? ref2.deselect() : void 0 : void 0 : void 0;
    }
  };

  BreadcrumbsCollection.prototype._removeUnusedPills = function(idsToRemove) {
    var i, id, len, pillsToRemove, ref, results;
    if (!(idsToRemove != null ? idsToRemove.length : void 0)) {
      return;
    }
    results = [];
    for (i = 0, len = idsToRemove.length; i < len; i++) {
      id = idsToRemove[i];
      if ((ref = (pillsToRemove = this.where({
        collectionId: id
      }))) != null ? ref.length : void 0) {
        results.push(this.remove(pillsToRemove));
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  BreadcrumbsCollection.prototype._supportsBreadcrumb = function(collection) {
    return (collection != null) && collection.multiselect;
  };

  return BreadcrumbsCollection;

})(Backbone.Collection);

},{"../models/breadcrumb":65}],59:[function(require,module,exports){
var Ranges, Refinements,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Refinements = require('./refinements');

module.exports = Ranges = (function(superClass) {
  extend(Ranges, superClass);

  function Ranges() {
    this._updateModel = bind(this._updateModel, this);
    return Ranges.__super__.constructor.apply(this, arguments);
  }

  Ranges.prototype.initialize = function(models, options) {
    if (options == null) {
      options = {};
    }
    this.id = options.id, this.multiselect = options.multiselect;
    return this.on('change:updated', this._updateModel);
  };

  Ranges.prototype.anySelected = function() {
    return !!this.filter(function(model) {
      return model.isNotDefault();
    }).length;
  };

  Ranges.prototype.getSelectedValues = function() {
    return this.reduce(((function(_this) {
      return function(memo, refinement) {
        if (!refinement.isNotDefault()) {
          return memo;
        }
        memo.push(_this._selectedHash(refinement));
        return memo;
      };
    })(this)), []);
  };

  Ranges.prototype.setOrdered = function() {
    Refinements.prototype.setOrdered.apply(this, arguments);
    return this.triggerModelsUpdated({
      queue: true
    });
  };

  Ranges.prototype._selectedHash = function(refinement) {
    var friendlyNameShort, id, name, ref, refinementId, selectedMax, selectedMin, showPriceRangeButton, unit;
    selectedMin = refinement.get('selectedMin');
    selectedMax = refinement.get('selectedMax');
    showPriceRangeButton = refinement.get('showPriceRangeButton');
    id = name = refinement.get('id');
    unit = (ref = refinement.get('unit')) != null ? ref : '';
    refinementId = id + ":" + selectedMin + "-" + selectedMax;
    friendlyNameShort = "" + unit + selectedMin + " - " + unit + selectedMax;
    return {
      id: id,
      name: name,
      refinementId: refinementId,
      friendlyNameShort: friendlyNameShort,
      selectedMin: selectedMin,
      selectedMax: selectedMax,
      showPriceRangeButton: showPriceRangeButton
    };
  };

  Ranges.prototype._updateModel = function(model, value, options) {
    if (value) {
      if (!options.preventTrigger) {
        this.triggerModelsUpdated(options);
      }
      return model.set('updated', false, {
        silent: true
      });
    }
  };

  return Ranges;

})(Refinements);

},{"./refinements":60}],60:[function(require,module,exports){
var Refinements,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

module.exports = Refinements = (function(superClass) {
  extend(Refinements, superClass);

  function Refinements() {
    this._updateSelectedModels = bind(this._updateSelectedModels, this);
    this.triggerModelsUpdated = bind(this.triggerModelsUpdated, this);
    return Refinements.__super__.constructor.apply(this, arguments);
  }

  Refinements.prototype.initialize = function(models, options) {
    if (options == null) {
      options = {};
    }
    this.dataBhw = options.dataBhw, this.flatRefinements = options.flatRefinements, this.hasCheckbox = options.hasCheckbox, this.id = options.id, this.level = options.level, this.max = options.max, this.multiselect = options.multiselect, this.prefix = options.prefix, this.refinementData = options.refinementData, this.title = options.title, this.useSimplifiedCategory = options.useSimplifiedCategory, this.l1Category = options.l1Category, this.useExpandedRefinementData = options.useExpandedRefinementData, this.updateSelectedOnReset = options.updateSelectedOnReset, this.isQueryFilter = options.isQueryFilter, this.showCollapseControl = options.showCollapseControl, this.collapseFilter = options.collapseFilter, this.showMoreSearch = options.showMoreSearch, this.showMoreSearchMax = options.showMoreSearchMax, this.showMoreSearchPlaceholder = options.showMoreSearchPlaceholder;
    return this.on('change:selected', this._updateSelectedModels);
  };

  Refinements.prototype.deselectAll = function(options) {
    if (options == null) {
      options = {};
    }
    this.invoke('deselect', {
      preventTrigger: true
    });
    return this.triggerModelsUpdated(options);
  };

  Refinements.prototype.setOrdered = function(arg, updateOptions) {
    var expandedRefinementData, refinementData;
    refinementData = arg.refinementData, expandedRefinementData = arg.expandedRefinementData;
    if (expandedRefinementData != null) {
      this.refinementData = refinementData;
      return this._resetRefinementData(expandedRefinementData, updateOptions);
    } else if (this._orderMatches(refinementData)) {
      return this.set(refinementData, updateOptions);
    } else {
      return this._resetRefinementData(refinementData, updateOptions);
    }
  };

  Refinements.prototype.anySelected = function() {
    return !!this.where({
      selected: true
    }).length;
  };

  Refinements.prototype.getSelectedValues = function() {
    var selectedIDs;
    selectedIDs = [];
    this.each((function(_this) {
      return function(refinement) {
        if (refinement.get('selected')) {
          return selectedIDs.push(_this._selectedHash(refinement));
        }
      };
    })(this));
    return selectedIDs;
  };

  Refinements.prototype.triggerModelsUpdated = function(options) {
    if (options == null) {
      options = {};
    }
    return this.trigger('selectedModels:updated', {
      id: this.id,
      selectedValues: this.getSelectedValues(),
      queue: !!options.queue
    });
  };

  Refinements.prototype._resetRefinementData = function(refinementData, updateOptions) {
    this.reset(refinementData, updateOptions);
    if (this.updateSelectedOnReset) {
      return this.triggerModelsUpdated({
        queue: true
      });
    }
  };

  Refinements.prototype._updateSelectedModels = function(model, value, options) {
    if (!this.multiselect && model.get('selected')) {
      _.each(this.without(model), function(refinement) {
        return refinement.deselect({
          preventTrigger: true
        });
      });
    }
    if (!options.preventTrigger) {
      return this.triggerModelsUpdated(options);
    }
  };

  Refinements.prototype._selectedHash = function(refinement) {
    var name;
    name = refinement.get('id');
    return {
      id: this.id,
      name: name,
      refinementId: name,
      friendlyNameShort: refinement.get('friendlyNameShort'),
      selectedValues: refinement.nestedRefinements.getSelectedValues()
    };
  };

  Refinements.prototype._orderMatches = function(newModels) {
    var mismatch;
    if (newModels.length !== this.models.length) {
      return false;
    }
    mismatch = _.find(newModels, (function(_this) {
      return function(newModel, index) {
        return _this.get(newModel.id) && _this.models[index].id !== newModel.id;
      };
    })(this));
    return !mismatch;
  };

  return Refinements;

})(Backbone.Collection);

},{}],61:[function(require,module,exports){
var dispatch;

dispatch = void 0;

module.exports = function() {
  if (dispatch) {
    return dispatch;
  }
  return dispatch = _.extend({}, Backbone.Events);
};

},{}],62:[function(require,module,exports){
var allTranslations, myI18n;

allTranslations = require('../../translations.json');

myI18n = void 0;

module.exports = function() {
  if (myI18n) {
    return myI18n;
  }
  myI18n = I18n.scoped();
  myI18n.translations = {
    refinements: allTranslations[I18n.locale].modules.refinements,
    number: I18n.translations.number
  };
  return myI18n;
};

},{"../../translations.json":95}],63:[function(require,module,exports){
module.exports = _.mixin({
  preventDefaultAndDefer: function(eventName) {
    return function(e) {
      e.preventDefault();
      return _.defer((function(_this) {
        return function() {
          return typeof _this[eventName] === "function" ? _this[eventName](e) : void 0;
        };
      })(this));
    };
  }
});

},{}],64:[function(require,module,exports){
var Bookable, Refinement,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Refinement = require('./refinement');

module.exports = Bookable = (function(superClass) {
  extend(Bookable, superClass);

  function Bookable() {
    return Bookable.__super__.constructor.apply(this, arguments);
  }

  Bookable.prototype.initialize = function(arg) {
    var date, dates, partySize, ref;
    ref = arg != null ? arg : {}, date = ref.date, dates = ref.dates, partySize = ref.partySize;
    this.set({
      date: date,
      partySize: partySize,
      dates: dates
    });
    return this.on('change', (function(_this) {
      return function(e, arg1) {
        var queue, ref1;
        queue = arg1.queue;
        ref1 = e.changed, date = ref1.date, partySize = ref1.partySize;
        if ('date' in e.changed) {
          _this._onChange('dates', date, queue);
        }
        if ('partySize' in e.changed) {
          return _this._onChange('partySizes', partySize, queue);
        }
      };
    })(this));
  };

  Bookable.prototype._onChange = function(id, value, queue) {
    return this.trigger('selectedModels:updated', {
      id: id,
      selectedValues: [value],
      queue: !!queue
    });
  };

  return Bookable;

})(Refinement);

},{"./refinement":67}],65:[function(require,module,exports){
var Breadcrumb,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Breadcrumb = (function(superClass) {
  extend(Breadcrumb, superClass);

  function Breadcrumb() {
    return Breadcrumb.__super__.constructor.apply(this, arguments);
  }

  Breadcrumb.prototype.deselect = function() {
    return this.set('selected', false);
  };

  return Breadcrumb;

})(Backbone.Model);

module.exports = Breadcrumb;

},{}],66:[function(require,module,exports){
var Range, i18n,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

i18n = require('../i18n')();

module.exports = Range = (function(superClass) {
  extend(Range, superClass);

  function Range() {
    return Range.__super__.constructor.apply(this, arguments);
  }

  Range.prototype.deselect = function(options) {
    var displayedMax, displayedMin, selectedMax, selectedMin;
    displayedMin = selectedMin = this.get('rangeMin');
    displayedMax = selectedMax = this.get('rangeMax');
    return this.set({
      displayedMin: displayedMin,
      displayedMax: displayedMax,
      selectedMin: selectedMin,
      selectedMax: selectedMax,
      updated: true
    }, options);
  };

  Range.prototype.isNotDefault = function() {
    return (this.get('selectedMin') !== this.get('rangeMin')) || (this.get('selectedMax') !== this.get('rangeMax'));
  };

  Range.prototype.validateMin = function(newMin) {
    var err, rangeMin;
    if (isNaN(newMin)) {
      err = i18n.translate('refinements.error_nan_input', {
        input: this.get('unitName')
      });
    } else if (newMin < (rangeMin = this.get('rangeMin'))) {
      err = i18n.translate('refinements.error_oob_input', {
        bound: 'Min',
        unit: this.get('unit'),
        value: rangeMin
      });
    } else if (newMin > this.get('displayedMax')) {
      err = i18n.translate('refinements.error_invalid_input', {
        selectedBound: 'Min',
        comparison: 'less',
        otherBound: 'max'
      });
    }
    return err;
  };

  Range.prototype.validateMax = function(newMax) {
    var err, rangeMax;
    if (isNaN(newMax)) {
      err = i18n.translate('refinements.error_nan_input', {
        input: this.get('unitName')
      });
    } else if (newMax > (rangeMax = this.get('rangeMax'))) {
      err = i18n.translate('refinements.error_oob_input', {
        bound: 'Max',
        unit: this.get('unit'),
        value: rangeMax
      });
    } else if (newMax < this.get('displayedMin')) {
      err = i18n.translate('refinements.error_invalid_input', {
        selectedBound: 'Max',
        comparison: 'greater',
        otherBound: 'min'
      });
    }
    return err;
  };

  return Range;

})(Backbone.Model);

},{"../i18n":62}],67:[function(require,module,exports){
(function (global){
var Refinement, find,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

find = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null).find;

Refinement = (function(superClass) {
  extend(Refinement, superClass);

  function Refinement() {
    this._updateNestedRefinements = bind(this._updateNestedRefinements, this);
    return Refinement.__super__.constructor.apply(this, arguments);
  }

  Refinement.prototype.defaults = function() {
    var ref;
    return {
      children: [],
      hasCheckbox: (ref = this.collection) != null ? ref.hasCheckbox : void 0
    };
  };

  Refinement.prototype.initialize = function() {
    this.refinementCollectionOptions = require('../presenters/refinement_collection_options');
    this.Refinements = require('../collections/refinements');
    this.nestedRefinements = this._createNestedCollections();
    this.set('lowestSelected', this._isLowestSelected());
    this.set('isLastLevel', this._isLastLevel());
    this.set('isLastButOneLevel', this._isLastButOneLevel());
    this.set('showCollapseControl', this.collection.showCollapseControl);
    this._setCategoryVisibility();
    this._listenToChildren();
    this.on('change:selected', (function(_this) {
      return function() {
        _this.set('lowestSelected', _this._isLowestSelected());
        return _this._setCategoryVisibility();
      };
    })(this));
    return this.on('change:children', this._updateNestedRefinements);
  };

  Refinement.prototype.select = function(options) {
    var ref;
    if (options == null) {
      options = {};
    }
    if (!this.get('selected')) {
      this.set('selected', true, options);
    }
    return (ref = this.nestedRefinements) != null ? ref.invoke('deselect') : void 0;
  };

  Refinement.prototype.deselect = function(options) {
    var ref;
    if (options == null) {
      options = {};
    }
    this.set('selected', false, options);
    return (ref = this.nestedRefinements) != null ? ref.invoke('deselect', {
      preventTrigger: true
    }) : void 0;
  };

  Refinement.prototype.toggleSelected = function(options) {
    var ref;
    if (options == null) {
      options = {};
    }
    if ((ref = this.collection) != null ? ref.multiselect : void 0) {
      if (this.get('selected')) {
        return this.deselect(options);
      } else {
        return this.select(options);
      }
    } else {
      return this.select(options);
    }
  };

  Refinement.prototype.toJSON = function() {
    var superMethod;
    superMethod = Backbone.Model.prototype.toJSON.apply(this, arguments);
    return _.extend({}, superMethod, {
      children: this.nestedRefinements.toJSON()
    });
  };

  Refinement.prototype._isLowestSelected = function() {
    if (!this.get('selected')) {
      return false;
    }
    return !this.nestedRefinements.anySelected();
  };

  Refinement.prototype._isLastLevel = function() {
    return !this.get('children').length;
  };

  Refinement.prototype._isLastButOneLevel = function() {
    if (!this.get('children').length) {
      return false;
    }
    return find(this.get('children'), function(child) {
      var ref;
      return (child != null ? (ref = child.children) != null ? ref.length : void 0 : void 0) > 0;
    }) == null;
  };

  Refinement.prototype._setCategoryVisibility = function() {
    if (this.collection.useSimplifiedCategory) {
      return this.set({
        simplifiedShow: this.get('selected') || this.nestedRefinements.anySelected(),
        useSimplifiedCategory: true
      });
    }
  };

  Refinement.prototype._createNestedCollections = function() {
    var refinementOptions;
    refinementOptions = this.refinementCollectionOptions.toHash(this.collection);
    return new this.Refinements(this.get('children'), refinementOptions);
  };

  Refinement.prototype._listenToChildren = function() {
    return this.listenTo(this.nestedRefinements, 'selectedModels:updated', (function(_this) {
      return function() {
        var ref;
        _this.set('lowestSelected', _this._isLowestSelected());
        return (ref = _this.collection) != null ? ref.triggerModelsUpdated.apply(ref, arguments) : void 0;
      };
    })(this));
  };

  Refinement.prototype._updateNestedRefinements = function(model, newValue, options) {
    return this.nestedRefinements.set(newValue);
  };

  return Refinement;

})(Backbone.Model);

module.exports = Refinement;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../collections/refinements":60,"../presenters/refinement_collection_options":69}],68:[function(require,module,exports){
var Range;

Range = require('../models/range');

module.exports = {
  toHash: function(refinementCollection) {
    if (!refinementCollection) {
      return {};
    }
    return _.extend(_.pick(refinementCollection, 'id', 'multiselect'), {
      model: Range
    });
  }
};

},{"../models/range":66}],69:[function(require,module,exports){
var Refinement, findLevel, findRefinementId, findRefinementPrefix;

Refinement = require('../models/refinement');

module.exports = {
  toHash: function(refinementCollection) {
    var level;
    if (!refinementCollection) {
      return {};
    }
    level = findLevel(refinementCollection);
    return {
      dataBhw: refinementCollection.dataBhw,
      flatRefinements: !!refinementCollection.flatRefinementLinks,
      hasCheckbox: refinementCollection.hasCheckbox,
      id: findRefinementId(refinementCollection, level),
      level: level,
      max: refinementCollection.max,
      model: Refinement,
      multiselect: refinementCollection.multiselect,
      prefix: findRefinementPrefix(refinementCollection, level),
      refinementData: refinementCollection.useExpandedRefinementData ? refinementCollection.refinementData : void 0,
      title: refinementCollection.title,
      useExpandedRefinementData: refinementCollection.useExpandedRefinementData,
      updateSelectedOnReset: refinementCollection.updateSelectedOnReset,
      useSimplifiedCategory: refinementCollection.useSimplifiedCategory,
      l1Category: refinementCollection.l1Category,
      isQueryFilter: refinementCollection.isQueryFilter,
      showCollapseControl: refinementCollection.showCollapseControl,
      collapseFilter: refinementCollection.collapseFilter,
      showMoreSearch: refinementCollection.showMoreSearch,
      showMoreSearchMax: refinementCollection.showMoreSearchMax,
      showMoreSearchPlaceholder: refinementCollection.showMoreSearchPlaceholder
    };
  }
};

findRefinementId = function(refinements, level) {
  if (level === 1) {
    return refinements.id;
  }
  return "" + refinements.prefix + level;
};

findLevel = function(refinements) {
  if (refinements.level) {
    return refinements.level + 1;
  } else {
    return 1;
  }
};

findRefinementPrefix = function(refinements, level) {
  if (level === 1) {
    return refinements.id;
  }
  return refinements.prefix;
};

},{"../models/refinement":67}],70:[function(require,module,exports){
var Availabilities, AvailableDates, AvailablePartySizes, AvailableTimes, dtfDispatch,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

AvailableTimes = require('./available_times');

AvailableDates = require('./available_dates');

AvailablePartySizes = require('./available_party_sizes');

dtfDispatch = require('../events/dtfDispatch')();

module.exports = Availabilities = (function(superClass) {
  extend(Availabilities, superClass);

  function Availabilities() {
    return Availabilities.__super__.constructor.apply(this, arguments);
  }

  Availabilities.prototype.initialize = function() {
    this.availableTimes = new AvailableTimes({
      collection: this.collection,
      el: '[data-id=availableTimes]'
    });
    this.availableDates = new AvailableDates({
      model: this.model,
      el: '[data-id=availableDates]'
    });
    this.availablePartySizes = new AvailablePartySizes({
      model: this.model,
      el: '[data-id=availablePartySizes]'
    });
    return this.listenTo(dtfDispatch, 'flyout:shown', this._handleFlyouts);
  };

  Availabilities.prototype._handleFlyouts = function(eventElement) {
    switch (eventElement.name) {
      case 'availableTimes':
        this.availableDates.hideFlyout();
        return this.availablePartySizes.hideFlyout();
      case 'availableDates':
        this.availableTimes.hideFlyout();
        return this.availablePartySizes.hideFlyout();
      case 'availablePartySizes':
        this.availableTimes.hideFlyout();
        return this.availableDates.hideFlyout();
    }
  };

  return Availabilities;

})(Backbone.View);

},{"../events/dtfDispatch":61,"./available_dates":71,"./available_party_sizes":72,"./available_times":73}],71:[function(require,module,exports){
var AvailableDates, Flyout, grpnUI, i18n, moment, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

moment = require('moment');

Flyout = require('./flyout');

templates = require('../../templates');

i18n = require('../i18n')();

grpnUI = require('grpn-ui');

module.exports = AvailableDates = (function(superClass) {
  extend(AvailableDates, superClass);

  function AvailableDates() {
    return AvailableDates.__super__.constructor.apply(this, arguments);
  }

  AvailableDates.ADDITIONAL_DATES = 29;

  AvailableDates.prototype.template = templates['available_dates'];

  AvailableDates.prototype.partials = {
    available_dates_flyout: templates['available_dates_flyout'],
    'grpn-ui/date-picker': templates['grpn-ui/date-picker']
  };

  AvailableDates.prototype.events = {
    'click .flyout-trigger': 'toggleFlyout',
    'click .icon-close': '_reset'
  };

  AvailableDates.prototype.initialize = function() {
    this.model.on('change:date', (function(_this) {
      return function() {
        return _this._onChangeDate();
      };
    })(this));
    this.flyout = new Flyout({
      id: 'date-flyout'
    });
    return this.render();
  };

  AvailableDates.prototype.render = function() {
    this.$el.html(this.template.render(this.toHash(), this.partials));
    this.setFlyout();
    this.datePicker = grpnUI.initDatePicker(this.el, {
      model: {
        earliestDate: moment(),
        latestDate: moment().add(AvailableDates.ADDITIONAL_DATES, 'day'),
        defaultValue: this.model.get('date') != null ? moment(this.model.get('date'), 'YYYY-MM-DD') : void 0,
        activeDates: this.model.get('dates').map(function(date) {
          return moment(date, 'YYYY-MM-DD');
        })
      }
    });
    this.listenTo(this.datePicker, 'change', (function(_this) {
      return function(date) {
        _this.hideFlyout();
        return _this.model.set('date', date.format('YYYY-MM-DD'));
      };
    })(this));
    return this;
  };

  AvailableDates.prototype.toHash = function() {
    var label, selectedDate;
    selectedDate = this.model.get('date');
    if (selectedDate) {
      label = moment(selectedDate, 'YYYY-MM-DD').format('ddd MMM D');
    } else {
      label = i18n.translate('refinements.all_dates');
    }
    return {
      label: label,
      hasSelection: !!selectedDate
    };
  };

  AvailableDates.prototype.setFlyout = function() {
    return this.flyout.setElement(this.$el.find('.flyout'));
  };

  AvailableDates.prototype.hideFlyout = function() {
    return this.flyout.hide();
  };

  AvailableDates.prototype.toggleFlyout = function() {
    this.flyout.showHide();
    return this._resetDatePickerState();
  };

  AvailableDates.prototype._onChangeDate = function() {
    return this.render();
  };

  AvailableDates.prototype._reset = function(e) {
    e.stopPropagation();
    this.hideFlyout();
    return this.model.set('date', null);
  };

  AvailableDates.prototype._resetDatePickerState = function() {
    if (!!this.model.get('date')) {
      return this.datePicker.resetToSelected();
    } else {
      return this.datePicker.reset();
    }
  };

  return AvailableDates;

})(Backbone.View);

},{"../../templates":94,"../i18n":62,"./flyout":79,"grpn-ui":98,"moment":106}],72:[function(require,module,exports){
var AvailablePartySizes, Flyout, i18n, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Flyout = require('./flyout');

templates = require('../../templates');

i18n = require('../i18n')();

module.exports = AvailablePartySizes = (function(superClass) {
  extend(AvailablePartySizes, superClass);

  function AvailablePartySizes() {
    return AvailablePartySizes.__super__.constructor.apply(this, arguments);
  }

  AvailablePartySizes.prototype.template = templates['available_party_sizes'];

  AvailablePartySizes.prototype.events = {
    'click .flyout-trigger': 'toggleFlyout',
    'click .party-size-option': '_selectPartySize',
    'click .icon-close': '_reset'
  };

  AvailablePartySizes.prototype.initialize = function() {
    this.flyout = new Flyout;
    this.model.on('change:partySize', (function(_this) {
      return function(e, partySize) {
        return _this._onChangePartySize(partySize);
      };
    })(this));
    this.setFlyout();
    return this.render();
  };

  AvailablePartySizes.prototype.render = function() {
    this._renderLabel(this.model.get('partySize'));
    return this;
  };

  AvailablePartySizes.prototype.setFlyout = function() {
    return this.flyout.setElement(this.$el.find('.flyout'));
  };

  AvailablePartySizes.prototype.hideFlyout = function() {
    return this.flyout.hide();
  };

  AvailablePartySizes.prototype.toggleFlyout = function() {
    if (!this._flyoutIsSet()) {
      this.setFlyout();
    }
    return this.flyout.showHide();
  };

  AvailablePartySizes.prototype._reset = function(e) {
    e.stopPropagation();
    this.hideFlyout();
    return this.model.set('partySize', null);
  };

  AvailablePartySizes.prototype._onChangePartySize = function(partySize) {
    this._renderLabel(partySize);
    return this._updateSelection(partySize);
  };

  AvailablePartySizes.prototype._updateSelection = function(partySize) {
    this.$el.find('.selected').removeClass('selected');
    if (partySize) {
      return this.$el.find("[data-value='" + partySize + "']").addClass('selected');
    }
  };

  AvailablePartySizes.prototype._renderLabel = function(partySize) {
    var label, selectionField;
    if (partySize) {
      label = i18n.translate('refinements.party_size_count', {
        count: partySize
      });
      this.$el.find('.flyout-trigger').addClass('has-selection');
    } else {
      label = i18n.translate('refinements.all_party_sizes');
      this.$el.find('.flyout-trigger').removeClass('has-selection');
    }
    selectionField = this.$el.find('.selection');
    return selectionField.html(label);
  };

  AvailablePartySizes.prototype._flyoutIsSet = function() {
    var ref;
    return ((ref = this.flyout.$el) != null ? ref.length : void 0) > 0;
  };

  AvailablePartySizes.prototype._selectPartySize = function(event) {
    var partySize;
    this.hideFlyout();
    partySize = parseInt(event.target.getAttribute('data-value'));
    return this.model.set('partySize', partySize);
  };

  return AvailablePartySizes;

})(Backbone.View);

},{"../../templates":94,"../i18n":62,"./flyout":79}],73:[function(require,module,exports){
var AvailableTimes, Flyout, i18n, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Flyout = require('./flyout');

templates = require('../../templates');

i18n = require('../i18n')();

module.exports = AvailableTimes = (function(superClass) {
  extend(AvailableTimes, superClass);

  function AvailableTimes() {
    return AvailableTimes.__super__.constructor.apply(this, arguments);
  }

  AvailableTimes.prototype.template = templates['available_times'];

  AvailableTimes.prototype.partials = {
    available_times_flyout: templates['available_times_flyout'],
    availability: templates['availability']
  };

  AvailableTimes.prototype.events = {
    'click .flyout-trigger': 'toggleFlyout',
    'click .time-spot': _.preventDefaultAndDefer('_handleClick'),
    'click .icon-close': '_reset'
  };

  AvailableTimes.prototype.initialize = function() {
    this.listenTo(this.collection, 'add change reset', (function(_this) {
      return function() {
        return _this.render();
      };
    })(this));
    this.flyout = new Flyout({
      id: 'time-flyout'
    });
    return this.render();
  };

  AvailableTimes.prototype.render = function() {
    this.$el.html(this.template.render(this.toHash(), this.partials));
    this.setFlyout();
    return this;
  };

  AvailableTimes.prototype.setFlyout = function() {
    this.flyout.hide();
    return this.flyout.setElement(this.$el.find('.flyout'));
  };

  AvailableTimes.prototype.hideFlyout = function() {
    return this.flyout.hide();
  };

  AvailableTimes.prototype.toHash = function() {
    var ref, ref1;
    return {
      id: this.collection.id,
      dataBhw: this.collection.dataBhw,
      title: this.collection.title,
      refinementData: this.collection.toJSON(),
      showRefinementBox: this.collection.length > 0,
      hasSelection: !!this._getSelectedItem(),
      selectedTime: this._getSelectedTime(),
      hasAm: (ref = _.first(this.collection.models)) != null ? ref.get('isAm') : void 0,
      hasPm: (ref1 = _.last(this.collection.models)) != null ? ref1.get('isPm') : void 0,
      afternoonEvening: i18n.translate('refinements.afternoon_evening'),
      morning: i18n.translate('refinements.morning')
    };
  };

  AvailableTimes.prototype.toggleFlyout = function() {
    return this.flyout.showHide();
  };

  AvailableTimes.prototype._handleClick = function(e) {
    var model, timevalue;
    timevalue = e.target.parentNode.getAttribute('data-id');
    model = this.collection.get(timevalue);
    return model != null ? model.toggleSelected() : void 0;
  };

  AvailableTimes.prototype._reset = function(e) {
    var ref;
    e.stopPropagation();
    return (ref = this._getSelectedItem()) != null ? ref.deselect() : void 0;
  };

  AvailableTimes.prototype._getSelectedTime = function() {
    var selectedItem;
    if (selectedItem = this._getSelectedItem()) {
      return selectedItem.get('friendlyName');
    } else {
      return i18n.translate('refinements.all_times');
    }
  };

  AvailableTimes.prototype._getSelectedItem = function() {
    return _.find(this.collection.models, function(item) {
      return item.get('selected');
    });
  };

  return AvailableTimes;

})(Backbone.View);

},{"../../templates":94,"../i18n":62,"./flyout":79}],74:[function(require,module,exports){
var BreadcrumbView, templates;

templates = require('../../templates');

BreadcrumbView = Backbone.View.extend({
  template: templates['breadcrumb'],
  events: {
    'click': 'deselect'
  },
  className: 'grui-breadcrumb-pill',
  tagName: 'div',
  initialize: function() {
    return this.listenTo(this.model, 'change:selected remove', this.remove);
  },
  render: function() {
    this.$el.html(this.template.render(this.model.toJSON()));
    return this;
  },
  deselect: function(e) {
    e.preventDefault();
    return this.model.deselect();
  }
});

module.exports = BreadcrumbView;

},{"../../templates":94}],75:[function(require,module,exports){
var BreadcrumbQuery, ResetFilters, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../mixins/underscore');

ResetFilters = require('./reset_filters');

templates = require('../../templates');

module.exports = BreadcrumbQuery = (function(superClass) {
  extend(BreadcrumbQuery, superClass);

  function BreadcrumbQuery() {
    return BreadcrumbQuery.__super__.constructor.apply(this, arguments);
  }

  BreadcrumbQuery.prototype.template = templates['breadcrumb_query'];

  BreadcrumbQuery.prototype.partials = {
    breadcrumb: templates['breadcrumb']
  };

  BreadcrumbQuery.prototype.events = {
    'click .grui-breadcrumb-pill': _.preventDefaultAndDefer('_clearFilter')
  };

  BreadcrumbQuery.prototype._getHtml = function() {
    return this.template.render(this._getViewModel(), this.partials);
  };

  BreadcrumbQuery.prototype._getViewModel = function() {
    var ref, viewModel;
    viewModel = (ref = this.collection.findWhere({
      selected: true
    })) != null ? ref.toJSON() : void 0;
    if (viewModel != null) {
      viewModel.friendlyNameShort = "\"" + viewModel.friendlyName + "\"";
    }
    return {
      query: viewModel
    };
  };

  return BreadcrumbQuery;

})(ResetFilters);

},{"../../templates":94,"../mixins/underscore":63,"./reset_filters":88}],76:[function(require,module,exports){
var BreadcrumbReset, ResetAll, i18n, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

ResetAll = require('./reset_all');

templates = require('../../templates');

i18n = require('../i18n')();

module.exports = BreadcrumbReset = (function(superClass) {
  extend(BreadcrumbReset, superClass);

  function BreadcrumbReset() {
    return BreadcrumbReset.__super__.constructor.apply(this, arguments);
  }

  BreadcrumbReset.prototype.template = templates['breadcrumb'];

  BreadcrumbReset.prototype.className = 'grui-breadcrumb-reset-pill';

  BreadcrumbReset.prototype.tagName = 'div';

  BreadcrumbReset.prototype._toHash = function() {
    return {
      friendlyNameShort: i18n.translate('refinements.reset'),
      id: 'grui-breadcrumb-reset'
    };
  };

  return BreadcrumbReset;

})(ResetAll);

},{"../../templates":94,"../i18n":62,"./reset_all":87}],77:[function(require,module,exports){
var BreadcrumbResetView, BreadcrumbView, BreadcrumbsCollection, BreadcrumbsView, RESET_FILTER_MIN_COUNT, i18n, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

BreadcrumbView = require('./breadcrumb');

BreadcrumbsCollection = require('../collections/breadcrumbs');

BreadcrumbResetView = require('./breadcrumb_reset');

templates = require('../../templates');

i18n = require('../i18n')();

RESET_FILTER_MIN_COUNT = 2;

BreadcrumbsView = (function(superClass) {
  extend(BreadcrumbsView, superClass);

  function BreadcrumbsView() {
    return BreadcrumbsView.__super__.constructor.apply(this, arguments);
  }

  BreadcrumbsView.prototype.template = templates['breadcrumb_filters'];

  BreadcrumbsView.prototype.initialize = function(options) {
    var refinementCollections;
    if (options == null) {
      options = {};
    }
    refinementCollections = options.refinementCollections, this.resetFilterMin = options.resetFilterMin;
    this.breadcrumbViews = {};
    if (this.resetFilterMin == null) {
      this.resetFilterMin = RESET_FILTER_MIN_COUNT;
    }
    this.collection = new BreadcrumbsCollection();
    this.resetAllView = new BreadcrumbResetView({
      refinements: refinementCollections
    });
    this.resetRefinements(refinementCollections);
    return this._applyListeners();
  };

  BreadcrumbsView.prototype.render = function() {
    this.$el.html(this.template.render(this._toHash()));
    this._cacheElem();
    this._toggleVisibility();
    this._addAllBreadcrumbHtml();
    return this;
  };

  BreadcrumbsView.prototype.resetRefinements = function(refinementCollections, idsToRemove) {
    if (refinementCollections == null) {
      refinementCollections = {};
    }
    return this.collection.setNewRefinementCollections(refinementCollections, idsToRemove);
  };

  BreadcrumbsView.prototype._toHash = function() {
    return {
      breadcrumbTitle: i18n.translate('refinements.selected_filters')
    };
  };

  BreadcrumbsView.prototype._applyListeners = function() {
    this.listenTo(this.collection, 'add', this._appendBreadcrumbView);
    this.listenTo(this.collection, 'remove', this._handleRemove);
    return this.listenTo(this.collection, 'add remove reset', this._toggleVisibility);
  };

  BreadcrumbsView.prototype._cacheElem = function() {
    this.$breadcrumbContainer = this.$el.find('.grui-breadcrumb-container');
    return this.$resetAllContainer = this.$el.find('.grui-breadcrumb-reset-container');
  };

  BreadcrumbsView.prototype._shouldShowResetView = function() {
    return this.collection.length > this.resetFilterMin;
  };

  BreadcrumbsView.prototype._toggleResetShow = function() {
    if (this._shouldShowResetView()) {
      return this.$resetAllContainer.show();
    } else {
      return this.$resetAllContainer.hide();
    }
  };

  BreadcrumbsView.prototype._toggleBreadcrumbs = function() {
    if (this.collection.length) {
      return this.$el.show();
    } else {
      return this.$el.hide();
    }
  };

  BreadcrumbsView.prototype._toggleVisibility = function() {
    this._toggleBreadcrumbs();
    return this._toggleResetShow();
  };

  BreadcrumbsView.prototype._removeBreadcrumbView = function(id) {
    var ref;
    if ((ref = this.breadcrumbViews[id]) != null) {
      ref.remove();
    }
    return delete this.breadcrumbViews[id];
  };

  BreadcrumbsView.prototype._removeAllBreadcrumbViews = function() {
    var id;
    for (id in this.breadcrumbViews) {
      this._removeBreadcrumbView(id);
    }
    return this.breadcrumbViews = {};
  };

  BreadcrumbsView.prototype._handleRemove = function(model) {
    return this._removeBreadcrumbView(model.get('id'));
  };

  BreadcrumbsView.prototype._getBreadcrumbView = function(model) {
    return (new BreadcrumbView({
      model: model
    })).render();
  };

  BreadcrumbsView.prototype._addBreadcrumbView = function(model) {
    return this.breadcrumbViews[model.get('id')] = this._getBreadcrumbView(model);
  };

  BreadcrumbsView.prototype._appendBreadcrumbView = function(model) {
    return this.$breadcrumbContainer.append(this._addBreadcrumbView(model).el);
  };

  BreadcrumbsView.prototype._getBreadcrumbHtml = function(model) {
    return this._addBreadcrumbView(model).el;
  };

  BreadcrumbsView.prototype._getAllBreadcrumbHtml = function(collection) {
    if (collection == null) {
      collection = [];
    }
    this._removeAllBreadcrumbViews();
    return collection.map((function(_this) {
      return function(model) {
        return _this._getBreadcrumbHtml(model);
      };
    })(this));
  };

  BreadcrumbsView.prototype._addAllBreadcrumbHtml = function() {
    this.$breadcrumbContainer.html(this._getAllBreadcrumbHtml(this.collection));
    return this.$resetAllContainer.html(this.resetAllView.render().delegateEvents().el);
  };

  return BreadcrumbsView;

})(Backbone.View);

module.exports = BreadcrumbsView;

},{"../../templates":94,"../collections/breadcrumbs":58,"../i18n":62,"./breadcrumb":74,"./breadcrumb_reset":76}],78:[function(require,module,exports){
var CheckboxReset, i18n, templates,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../mixins/underscore');

templates = require('../../templates');

i18n = require('../i18n')();

module.exports = CheckboxReset = (function(superClass) {
  extend(CheckboxReset, superClass);

  function CheckboxReset() {
    this.render = bind(this.render, this);
    return CheckboxReset.__super__.constructor.apply(this, arguments);
  }

  CheckboxReset.prototype.template = templates['checkbox_reset'];

  CheckboxReset.prototype.events = {
    'click': _.preventDefaultAndDefer('_handleReset')
  };

  CheckboxReset.prototype.initialize = function() {
    return this.listenTo(this.collection, 'change', this.render);
  };

  CheckboxReset.prototype.render = function() {
    this.$el.html(this.template.render(this._toHash()));
    return this;
  };

  CheckboxReset.prototype._toHash = function() {
    return {
      anySelected: this.collection.anySelected(),
      id: this.collection.id,
      all: i18n.translate('refinements.all')
    };
  };

  CheckboxReset.prototype._handleReset = function(e) {
    return this.collection.deselectAll();
  };

  return CheckboxReset;

})(Backbone.View);

},{"../../templates":94,"../i18n":62,"../mixins/underscore":63}],79:[function(require,module,exports){
var Flyout, dtfDispatch,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../mixins/underscore');

dtfDispatch = require('../events/dtfDispatch')();

module.exports = Flyout = (function(superClass) {
  extend(Flyout, superClass);

  function Flyout() {
    return Flyout.__super__.constructor.apply(this, arguments);
  }

  Flyout.prototype.initialize = function() {
    return this._shown = false;
  };

  Flyout.prototype.showHide = function() {
    if (this._shown) {
      return this.hide();
    } else {
      return this.show();
    }
  };

  Flyout.prototype.isVisible = function() {
    return this._shown;
  };

  Flyout.prototype.show = function() {
    if (!this.$el) {
      return;
    }
    this.$el.show();
    this._createOverlay();
    this.showHighlight();
    this._shown = true;
    return dtfDispatch.trigger('flyout:shown', {
      name: this.$el.parents('[data-id]').data('id')
    });
  };

  Flyout.prototype.hide = function() {
    if (!this.$el) {
      return;
    }
    this.removeHighlight();
    this._destroyOverlay();
    this.$el.hide();
    this._shown = false;
    return dtfDispatch.trigger('hidden');
  };

  Flyout.prototype.showHighlight = function() {
    var flyoutTrigger, flyoutTriggerArrow;
    flyoutTrigger = this.$el.parent().find('.flyout-trigger');
    flyoutTriggerArrow = flyoutTrigger.find('span:last-of-type');
    if (!flyoutTrigger.hasClass('active-flyout')) {
      flyoutTrigger.addClass('active-flyout');
    }
    if (!flyoutTriggerArrow.hasClass('icon-arrow-up-large')) {
      flyoutTriggerArrow.addClass('icon-arrow-up-large');
    }
    if (flyoutTriggerArrow.hasClass('icon-arrow-down-large')) {
      return flyoutTriggerArrow.removeClass('icon-arrow-down-large');
    }
  };

  Flyout.prototype.removeHighlight = function() {
    var flyoutTrigger, flyoutTriggerArrow;
    flyoutTrigger = this.$el.parent().find('.flyout-trigger');
    flyoutTriggerArrow = flyoutTrigger.find('span:last-of-type');
    if (flyoutTrigger.hasClass('active-flyout')) {
      flyoutTrigger.removeClass('active-flyout');
    }
    if (flyoutTriggerArrow.hasClass('icon-arrow-up-large')) {
      flyoutTriggerArrow.removeClass('icon-arrow-up-large');
    }
    if (!flyoutTriggerArrow.hasClass('icon-arrow-down-large')) {
      return flyoutTriggerArrow.addClass('icon-arrow-down-large');
    }
  };

  Flyout.prototype._hasOverlay = function() {
    return this.$el.siblings('.flyout-overlay').length > 0;
  };

  Flyout.prototype._overlay = function() {
    return this.$el.siblings('.flyout-overlay');
  };

  Flyout.prototype._destroyOverlay = function() {
    return this._overlay().off('click').remove();
  };

  Flyout.prototype._createOverlay = function() {
    this.$el.after('<div class="flyout-overlay"></div>');
    return this._overlay().on('click', (function(_this) {
      return function() {
        return _this.showHide();
      };
    })(this));
  };

  return Flyout;

})(Backbone.View);

},{"../events/dtfDispatch":61,"../mixins/underscore":63}],80:[function(require,module,exports){
var LinksList, templates,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

templates = require('../../templates');

module.exports = LinksList = (function(superClass) {
  extend(LinksList, superClass);

  function LinksList() {
    this.render = bind(this.render, this);
    return LinksList.__super__.constructor.apply(this, arguments);
  }

  LinksList.prototype.template = templates['links_list'];

  LinksList.prototype.partials = {
    link: templates['link']
  };

  LinksList.prototype.events = {
    'click .toggle-refinements': '_toggleRefinementList'
  };

  LinksList.prototype.initialize = function() {
    return this.listenTo(this.collection, 'add change reset', this.render);
  };

  LinksList.prototype.render = function() {
    this.$el.html(this.template.render(this.toHash(), this.partials));
    this.$refinementList = this.$el.find('.refinement-list');
    return this;
  };

  LinksList.prototype.toHash = function() {
    return {
      refinementData: this.collection.toJSON()
    };
  };

  LinksList.prototype._toggleRefinementList = function(ev) {
    var listId;
    $(ev.currentTarget).toggleClass("icon-arrow-down-large icon-arrow-up-large");
    listId = $(ev.currentTarget).data('id');
    return $("#" + listId + ".refinement-list").slideToggle();
  };

  return LinksList;

})(Backbone.View);

},{"../../templates":94}],81:[function(require,module,exports){
var ModalItem, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

templates = require('../../templates');

module.exports = ModalItem = (function(superClass) {
  extend(ModalItem, superClass);

  function ModalItem() {
    return ModalItem.__super__.constructor.apply(this, arguments);
  }

  ModalItem.prototype.template = templates['modal_item'];

  ModalItem.prototype.partials = {
    checkbox: templates['checkbox']
  };

  ModalItem.prototype.events = {
    "click .refinement": "toggleSelected"
  };

  ModalItem.prototype.tagName = "li";

  ModalItem.prototype.initialize = function() {
    this.id = this.model.id;
    return this.selected = this.model.get('selected');
  };

  ModalItem.prototype.attributes = function() {
    return {
      "data-bhc": "brand:" + this.model.id,
      "data-id": this.model.id
    };
  };

  ModalItem.prototype.resetSelectedState = function(refinement) {
    this.selected = refinement.get('selected');
    return this._toggleCheckbox();
  };

  ModalItem.prototype.render = function() {
    this.$el.html(this.template.render(this.model.toJSON(), this.partials));
    return this;
  };

  ModalItem.prototype._toggleCheckbox = function() {
    return this.$el.find('input').prop('checked', this.selected);
  };

  ModalItem.prototype.toggleSelected = function() {
    this.selected = !this.selected;
    return this._toggleCheckbox();
  };

  return ModalItem;

})(Backbone.View);

},{"../../templates":94}],82:[function(require,module,exports){
var NestedLink, templates,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../mixins/underscore');

templates = require('../../templates');

module.exports = NestedLink = (function(superClass) {
  extend(NestedLink, superClass);

  function NestedLink() {
    this._handleClick = bind(this._handleClick, this);
    this.remove = bind(this.remove, this);
    return NestedLink.__super__.constructor.apply(this, arguments);
  }

  NestedLink.prototype.template = templates['nested_link'];

  NestedLink.prototype.partials = {
    checkbox: templates['checkbox']
  };

  NestedLink.prototype.events = {
    'click .dynamic': _.preventDefaultAndDefer('_handleClick')
  };

  NestedLink.prototype.initialize = function() {
    var ref, ref1, ref2;
    this.$childrenEl = (ref = $(this.options.childrenEl)) != null ? ref : $('div');
    this.$childView = (ref1 = this.options.childView) != null ? ref1 : Backbone.View;
    if ((ref2 = this.model.nestedRefinements) != null ? ref2.length : void 0) {
      this.childView = this._createChildView();
    }
    this.listenTo(this.model, 'change', this._renderMain);
    return this.listenTo(this.model, 'remove', this.remove);
  };

  NestedLink.prototype.render = function() {
    this._renderMain();
    this._renderChildren();
    return this;
  };

  NestedLink.prototype.remove = function() {
    var ref;
    if ((ref = this.childView) != null) {
      ref.remove();
    }
    return Backbone.View.prototype.remove.apply(this);
  };

  NestedLink.prototype._renderMain = function(model, options) {
    if (options == null) {
      options = {};
    }
    if (options.preventTrigger) {
      return;
    }
    this.$el.html(this.template.render(this.model.toJSON(), this.partials));
    this.$childrenEl.toggleClass('expanded', this.model.get('selected'));
    return this.$childrenEl.toggleClass('lowest-selected', this.model.get('lowestSelected'));
  };

  NestedLink.prototype._createChildView = function() {
    return new this.$childView({
      collection: this.model.nestedRefinements,
      el: this.$childrenEl
    });
  };

  NestedLink.prototype._renderChildren = function() {
    var ref;
    return (ref = this.childView) != null ? ref.render() : void 0;
  };

  NestedLink.prototype._handleClick = function(e) {
    return this.model.toggleSelected();
  };

  return NestedLink;

})(Backbone.View);

},{"../../templates":94,"../mixins/underscore":63}],83:[function(require,module,exports){
var NestedLink, NestedLinks, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

NestedLink = require('./nested_link');

templates = require('../../templates');

module.exports = NestedLinks = (function(superClass) {
  extend(NestedLinks, superClass);

  function NestedLinks() {
    return NestedLinks.__super__.constructor.apply(this, arguments);
  }

  NestedLinks.prototype.template = templates['child_list'];

  NestedLinks.prototype.partials = {
    nested_item: templates['nested_item']
  };

  NestedLinks.prototype.initialize = function() {
    this.listenTo(this.collection, 'add change:simplifiedShow reset', this.render);
    return this.childViews = [];
  };

  NestedLinks.prototype.render = function() {
    this._removeChildren();
    this.$el.html(this.template.render(this._toHash(), this.partials));
    this._renderChildren();
    return this;
  };

  NestedLinks.prototype.remove = function() {
    this._removeChildren();
    return Backbone.View.prototype.remove.apply(this);
  };

  NestedLinks.prototype._toHash = function() {
    return {
      children: this.collection.toJSON()
    };
  };

  NestedLinks.prototype._renderChildren = function() {
    return this.collection.each((function(_this) {
      return function(refinement) {
        var $childrenEl, $refinementEl, childView;
        $refinementEl = _this.$el.find("[data-id='" + (refinement.get('id')) + "']");
        $childrenEl = $refinementEl.next('.children-list');
        childView = new NestedLink({
          model: refinement,
          el: $refinementEl,
          childrenEl: $childrenEl,
          childView: NestedLinks
        });
        _this.childViews.push(childView);
        return childView.render();
      };
    })(this));
  };

  NestedLinks.prototype._removeChildren = function() {
    _.invoke(this.childViews, 'remove');
    return this.childViews = [];
  };

  return NestedLinks;

})(Backbone.View);

},{"../../templates":94,"./nested_link":82}],84:[function(require,module,exports){
var CheckboxReset, NestedLinks, ParentNestedLinks, ShowMoreModal, TypeaheadSearch, i18n, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

CheckboxReset = require('./checkbox_reset');

NestedLinks = require('./nested_links');

ShowMoreModal = require('./show_more_modal');

TypeaheadSearch = require('./typeahead_search');

templates = require('../../templates');

i18n = require('../i18n')();

module.exports = ParentNestedLinks = (function(superClass) {
  extend(ParentNestedLinks, superClass);

  function ParentNestedLinks() {
    return ParentNestedLinks.__super__.constructor.apply(this, arguments);
  }

  ParentNestedLinks.prototype.template = templates['nested_links'];

  ParentNestedLinks.prototype.partials = {
    child_list: templates['child_list'],
    nested_item: templates['nested_item'],
    see_more: templates['see_more']
  };

  ParentNestedLinks.prototype.events = {
    "click .see-more": "_renderShowMoreModal",
    'click .toggle-refinements': '_toggleRefinementList'
  };

  ParentNestedLinks.prototype.render = function() {
    NestedLinks.prototype.render.apply(this, arguments);
    if (this.collection.multiselect) {
      this._renderReset();
    }
    this._renderShowMoreSearch();
    if (this.showMoreModal) {
      this.showMoreModal.render();
    }
    this._cacheElements();
    return this;
  };

  ParentNestedLinks.prototype.remove = function() {
    var ref, ref1, ref2;
    if ((ref = this.checkboxResetView) != null) {
      ref.remove();
    }
    if ((ref1 = this.showMoreModal) != null) {
      ref1.remove();
    }
    if ((ref2 = this.showMoreSearch) != null) {
      ref2.remove();
    }
    return ParentNestedLinks.__super__.remove.apply(this, arguments);
  };

  ParentNestedLinks.prototype._cacheElements = function() {
    this.$refinementList = this.$el.find('.refinement-list');
    return this.$seeMore = this.$el.find('.see-more');
  };

  ParentNestedLinks.prototype._toHash = function() {
    return {
      id: this.collection.id,
      multiselect: !!this.collection.multiselect,
      refinementData: this._getRefinementData(),
      showRefinementBox: this.collection.length > 0,
      useSimplifiedCategory: this.collection.useSimplifiedCategory,
      l1Category: this.collection.l1Category,
      showSeeMoreLink: this.collection.length > this.collection.max,
      title: this.collection.title,
      seeMore: i18n.translate('refinements.see_more'),
      showCollapseControl: this.collection.showCollapseControl,
      collapseFilter: this._collapseFilter(),
      showMoreSearch: this.collection.showMoreSearch,
      showMoreSearchPlaceholder: this.collection.showMoreSearchPlaceholder
    };
  };

  ParentNestedLinks.prototype._collapseFilter = function() {
    if (this.collection.anySelected()) {
      return false;
    } else {
      return this.collection.collapseFilter;
    }
  };

  ParentNestedLinks.prototype._getRefinementData = function() {
    if (this.collection.useExpandedRefinementData) {
      return this.collection.refinementData;
    }
    return this.collection.toJSON();
  };

  ParentNestedLinks.prototype._renderReset = function() {
    var $containerEl, ref;
    $containerEl = this.$el.find('.reset');
    if ((ref = this.checkboxResetView) != null) {
      ref.remove();
    }
    return this.checkboxResetView = new CheckboxReset({
      el: $containerEl,
      collection: this.collection
    }).render();
  };

  ParentNestedLinks.prototype._renderShowMoreModal = function() {
    if (!this.collection.useExpandedRefinementData) {
      return;
    }
    if (!this.showMoreModal) {
      this.showMoreModal = new ShowMoreModal({
        collection: this.collection
      });
    }
    return this.showMoreModal.show();
  };

  ParentNestedLinks.prototype._toggleRefinementList = function(ev) {
    $(ev.currentTarget).toggleClass("icon-arrow-down-large icon-arrow-up-large");
    this.$refinementList.stop().slideToggle();
    return this.$seeMore.stop().slideToggle();
  };

  ParentNestedLinks.prototype._renderShowMoreSearch = function() {
    var $containerEl, ref;
    if (!this.collection.showMoreSearch) {
      return;
    }
    $containerEl = this.$el.find('.grui-show-more-search');
    if ((ref = this.showMoreSearch) != null) {
      ref.remove();
    }
    return this.showMoreSearch = new TypeaheadSearch({
      collection: this.collection,
      el: $containerEl
    }).render();
  };

  return ParentNestedLinks;

})(NestedLinks);

},{"../../templates":94,"../i18n":62,"./checkbox_reset":78,"./nested_links":83,"./show_more_modal":89,"./typeahead_search":92}],85:[function(require,module,exports){
var ENTER_KEYCODE, RangeFilter, i18n, pick, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

pick = _.pick;

templates = require('../../templates');

i18n = require('../i18n')();

ENTER_KEYCODE = 13;

module.exports = RangeFilter = (function(superClass) {
  extend(RangeFilter, superClass);

  function RangeFilter() {
    return RangeFilter.__super__.constructor.apply(this, arguments);
  }

  RangeFilter.prototype.template = templates['range_filter'];

  RangeFilter.prototype.className = 'refinement-box';

  RangeFilter.prototype.events = {
    'blur input.refinement-range-bottom-input': '_setMin',
    'blur input.refinement-range-top-input': '_setMax',
    'keyup input.refinement-range-bottom-input': '_enterMin',
    'keyup input.refinement-range-top-input': '_enterMax',
    'click .toggle-refinements': '_toggleRefinementRange',
    'mousedown a.btn-range-submit': '_setRange'
  };

  RangeFilter.prototype.initialize = function() {
    return this.listenTo(this.model, 'remove', this.remove);
  };

  RangeFilter.prototype.render = function() {
    this.$el.html(this.template.render(this._getViewHash()));
    this._cacheElem();
    this._applySlider();
    return this;
  };

  RangeFilter.prototype._getViewHash = function() {
    var viewHash;
    viewHash = this.model.toJSON();
    viewHash.applyText = i18n.translate('refinements.apply');
    return viewHash;
  };

  RangeFilter.prototype._cacheElem = function() {
    var rangeInputs;
    this.$rangeInputs = rangeInputs = this.$el.find('.refinement-range-input');
    this.$minRangeInput = $(rangeInputs[0]);
    this.$maxRangeInput = $(rangeInputs[1]);
    this.$minInput = this.$minRangeInput.find('input');
    this.$maxInput = this.$maxRangeInput.find('input');
    return this.$refinementRange = this.$el.find('.refinement-range');
  };

  RangeFilter.prototype._clearError = function() {
    return this.$rangeInputs.removeClass('refinement-range-error');
  };

  RangeFilter.prototype._setError = function(err, el) {
    el.find('.refinement-range-error-message').text(err);
    return el.addClass('refinement-range-error');
  };

  RangeFilter.prototype._setMin = function() {
    var newMin;
    newMin = parseInt(this.$minInput.val());
    if (!this._isValidNewMin(newMin)) {
      return this.$minInput.val(this.model.get('displayedMin'));
    }
    this.$sliderContainer.slider('values', 0, newMin);
    return this._updateState(newMin, this.model.get('displayedMax'), !this.model.get('showPriceRangeButton'));
  };

  RangeFilter.prototype._setMax = function() {
    var newMax;
    newMax = parseInt(this.$maxInput.val());
    if (!this._isValidNewMax(newMax)) {
      return this.$maxInput.val(this.model.get('displayedMax'));
    }
    this.$sliderContainer.slider('values', 1, newMax);
    return this._updateState(this.model.get('displayedMin'), newMax, !this.model.get('showPriceRangeButton'));
  };

  RangeFilter.prototype._setRange = function() {
    return this._updateState(this.$minInput.val(), this.$maxInput.val(), this.model.get('showPriceRangeButton'));
  };

  RangeFilter.prototype._enterMin = function(e) {
    if (e.keyCode === ENTER_KEYCODE) {
      return this._setMin();
    }
  };

  RangeFilter.prototype._enterMax = function(e) {
    if (e.keyCode === ENTER_KEYCODE) {
      return this._setMax();
    }
  };

  RangeFilter.prototype._isValidNewMin = function(newMin) {
    var err;
    err = this.model.validateMin(newMin);
    if (err) {
      this._setError(err, this.$minRangeInput);
      return false;
    } else {
      this._clearError();
      return true;
    }
  };

  RangeFilter.prototype._isValidNewMax = function(newMax) {
    var err;
    err = this.model.validateMax(newMax);
    if (err) {
      this._setError(err, this.$maxRangeInput);
      return false;
    } else {
      this._clearError();
      return true;
    }
  };

  RangeFilter.prototype._updateState = function(newMin, newMax, experiment) {
    if (this.model.get('selectedMin') !== newMin || this.model.get('selectedMax') !== newMax) {
      return this.model.set({
        displayedMin: newMin,
        displayedMax: newMax,
        selectedMin: newMin,
        selectedMax: newMax,
        updated: experiment
      });
    }
  };

  RangeFilter.prototype._applySlider = function() {
    var displayedMax, displayedMin, rangeMax, rangeMin, ref, sliderContainerElem;
    ref = pick(this.model.toJSON(), 'rangeMin', 'rangeMax', 'displayedMin', 'displayedMax'), rangeMin = ref.rangeMin, rangeMax = ref.rangeMax, displayedMin = ref.displayedMin, displayedMax = ref.displayedMax;
    sliderContainerElem = $(this.$el.find('.refinement-range-slider'));
    this.$sliderContainer = sliderContainerElem.slider({
      range: true,
      min: rangeMin,
      max: rangeMax,
      values: [displayedMin, displayedMax],
      slide: (function(_this) {
        return function(e, ui) {
          _this.$minInput.val(ui.values[0]);
          return _this.$maxInput.val(ui.values[1]);
        };
      })(this),
      stop: (function(_this) {
        return function(e, ui) {
          _this._clearError();
          return _this._updateState(ui.values[0], ui.values[1], !_this.model.get('showPriceRangeButton'));
        };
      })(this)
    });
    this.$minInput.val(displayedMin);
    return this.$maxInput.val(displayedMax);
  };

  RangeFilter.prototype._toggleRefinementRange = function(ev) {
    $(ev.currentTarget).toggleClass("icon-arrow-down-large icon-arrow-up-large");
    return this.$refinementRange.slideToggle();
  };

  return RangeFilter;

})(Backbone.View);

},{"../../templates":94,"../i18n":62}],86:[function(require,module,exports){
var RangeFilter, RangeFilters,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

RangeFilter = require('./range_filter');

module.exports = RangeFilters = (function(superClass) {
  extend(RangeFilters, superClass);

  function RangeFilters() {
    return RangeFilters.__super__.constructor.apply(this, arguments);
  }

  RangeFilters.prototype.initialize = function() {
    return this.listenTo(this.collection, 'add change reset', this.render);
  };

  RangeFilters.prototype.render = function() {
    this._resetChildViews(this.collection);
    this.$el.html(this._getAllRangeFiltersHtml(this.childViews));
    return this;
  };

  RangeFilters.prototype._getRangeFilterView = function(model) {
    return (new RangeFilter({
      model: model
    })).render();
  };

  RangeFilters.prototype._getAllRangeFilterViews = function(collection) {
    if (collection == null) {
      collection = [];
    }
    return collection.map(this._getRangeFilterView);
  };

  RangeFilters.prototype._getAllRangeFiltersHtml = function(views) {
    return _.pluck(views, 'el');
  };

  RangeFilters.prototype._resetChildViews = function(collection) {
    _.invoke(this.childViews, 'remove');
    return this.childViews = this._getAllRangeFilterViews(collection);
  };

  return RangeFilters;

})(Backbone.View);

},{"./range_filter":85}],87:[function(require,module,exports){
var ResetAll, i18n, templates,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../mixins/underscore');

templates = require('../../templates');

i18n = require('../i18n')();

module.exports = ResetAll = (function(superClass) {
  extend(ResetAll, superClass);

  function ResetAll() {
    this.resetAll = bind(this.resetAll, this);
    return ResetAll.__super__.constructor.apply(this, arguments);
  }

  ResetAll.prototype.template = templates['reset_all'];

  ResetAll.prototype.events = {
    'click': _.preventDefaultAndDefer('resetAll')
  };

  ResetAll.prototype.initialize = function() {
    return this.resetRefinements(this.options.refinements);
  };

  ResetAll.prototype.render = function() {
    this.$el.html(this.template.render(this._toHash()));
    return this;
  };

  ResetAll.prototype.resetRefinements = function(refinementCollections) {
    _.each(this.collections, (function(_this) {
      return function(collection) {
        return _this.stopListening(collection, 'selectedModels:updated');
      };
    })(this));
    this.collections = this._getResetableCollections(refinementCollections);
    return this._setupListeners();
  };

  ResetAll.prototype._toHash = function() {
    return {
      resetAllText: i18n.translate('refinements.reset_all'),
      refinementsSelected: this._anyRefinementsSelected()
    };
  };

  ResetAll.prototype.resetAll = function(e) {
    var date, model, partySize, queue;
    model = this.options.bookableModel;
    date = model != null ? model.get('date') : void 0;
    partySize = model != null ? model.get('partySize') : void 0;
    queue = this.collections.length - 1;
    if (date) {
      queue++;
    }
    if (partySize) {
      queue++;
    }
    if (date) {
      model.unset('date', {
        queue: !!queue
      });
      queue--;
    }
    if (partySize) {
      model.unset('partySize', {
        queue: !!queue
      });
      queue--;
    }
    return _.each(this.collections, function(collection) {
      collection.deselectAll({
        queue: !!queue
      });
      return queue--;
    });
  };

  ResetAll.prototype._getResetableCollections = function(refinementCollections) {
    var collection, collections, key;
    collections = [];
    for (key in refinementCollections) {
      collection = refinementCollections[key];
      if (collection.multiselect) {
        collections.push(collection);
      } else if (collection.id === 'availabilities') {
        collections.push(collection);
      }
    }
    return collections;
  };

  ResetAll.prototype._setupListeners = function() {
    var model;
    model = this.options.bookableModel;
    if (model) {
      this.listenTo(model, 'selectedModels:updated', this.render);
    }
    return _.each(this.collections, (function(_this) {
      return function(collection) {
        _this.stopListening(collection, 'selectedModels:updated');
        return _this.listenTo(collection, 'selectedModels:updated', _this.render);
      };
    })(this));
  };

  ResetAll.prototype._anyRefinementsSelected = function() {
    var model;
    model = this.options.bookableModel;
    if ((model != null ? model.get('partySize') : void 0) || (model != null ? model.get('date') : void 0)) {
      return true;
    }
    return _.any(this.collections, function(collection) {
      return collection.anySelected();
    });
  };

  return ResetAll;

})(Backbone.View);

},{"../../templates":94,"../i18n":62,"../mixins/underscore":63}],88:[function(require,module,exports){
var ResetFilters, templates,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../mixins/underscore');

templates = require('../../templates');

module.exports = ResetFilters = (function(superClass) {
  extend(ResetFilters, superClass);

  function ResetFilters() {
    this._clearFilter = bind(this._clearFilter, this);
    return ResetFilters.__super__.constructor.apply(this, arguments);
  }

  ResetFilters.prototype.template = templates['reset_filters'];

  ResetFilters.prototype.events = {
    'click .dynamic': _.preventDefaultAndDefer('_clearFilter')
  };

  ResetFilters.prototype.initialize = function() {
    return this.listenTo(this.collection, 'change', this.render);
  };

  ResetFilters.prototype.render = function() {
    this.$el.html(this._getHtml());
    return this;
  };

  ResetFilters.prototype._getHtml = function() {
    return this.template.render({
      refinementData: this.collection.toJSON()
    });
  };

  ResetFilters.prototype._clearFilter = function(e) {
    var targetId, targetModel;
    targetId = $(e.currentTarget).data('id');
    targetModel = this.collection.get(targetId);
    if (targetModel != null) {
      return targetModel.deselect();
    }
  };

  return ResetFilters;

})(Backbone.View);

},{"../../templates":94,"../mixins/underscore":63}],89:[function(require,module,exports){
var DEFAULT_ANIMATE_TIME, ModalItem, ShowMoreModal, TypeaheadSearch, i18n, templates,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

ModalItem = require('./modal_item');

TypeaheadSearch = require('./typeahead_search');

templates = require('../../templates');

i18n = require('../i18n')();

DEFAULT_ANIMATE_TIME = 200;

module.exports = ShowMoreModal = (function(superClass) {
  extend(ShowMoreModal, superClass);

  function ShowMoreModal() {
    this._renderModalViews = bind(this._renderModalViews, this);
    return ShowMoreModal.__super__.constructor.apply(this, arguments);
  }

  ShowMoreModal.prototype.template = templates['show_more_modal'];

  ShowMoreModal.prototype.partials = {
    checkbox: templates['checkbox'],
    modal_item: templates['modal_item']
  };

  ShowMoreModal.prototype.events = {
    "click .apply": "_applyRefinements"
  };

  ShowMoreModal.prototype.initialize = function() {
    _.bindAll(this, '_handleShowMoreSearchSelection');
    return this._createModal();
  };

  ShowMoreModal.prototype.render = function() {
    this._startPageScroll();
    this.$el.replaceWith(this.template.render(this._toHash(), this.partials));
    this._setElement();
    this._cacheElem();
    this._renderModalItems();
    this._renderShowMoreSearch();
    return this;
  };

  ShowMoreModal.prototype.show = function() {
    this._resetModalItems();
    GIG.Modal.open({
      el: this.el
    });
    return this._stopPageScroll();
  };

  ShowMoreModal.prototype._cacheElem = function() {
    this.$modalItemsContainer = this.$el.find('.checkbox-holder');
    return this.$viewsContainer = this.$el.find('.checkbox-container');
  };

  ShowMoreModal.prototype._applyRefinements = function() {
    this._updateCollection();
    return GIG.Modal.close();
  };

  ShowMoreModal.prototype._createModal = function() {
    this.modalId = GIG.Modal.create(this.template.render(this._toHash(), this.partials), {
      destroyOnClose: false
    });
    this._setElement();
    this._cacheElem();
    this._renderModalItems();
    this._renderShowMoreSearch();
    return GIG.Modal.onClose(this._startPageScroll);
  };

  ShowMoreModal.prototype._removeModalViews = function() {
    return _.invoke(this.modalItems, 'remove');
  };

  ShowMoreModal.prototype._createModalViews = function() {
    this._removeModalViews();
    return this.modalItems = this.collection.map(function(refinement) {
      return new ModalItem({
        model: refinement
      });
    });
  };

  ShowMoreModal.prototype._renderModalItems = function() {
    this._createModalViews();
    return _.defer(this._renderModalViews);
  };

  ShowMoreModal.prototype._renderModalViews = function() {
    var modalItemElems;
    modalItemElems = this.modalItems.map(function(modalItem) {
      return modalItem.render().$el;
    });
    this.$viewsContainer.html(modalItemElems);
    return this.$el.find('.spinner-overlay').hide();
  };

  ShowMoreModal.prototype._resetModalItems = function() {
    var i, len, modalItem, ref, refinement, results;
    ref = this.modalItems;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      modalItem = ref[i];
      if (refinement = this.collection.get(modalItem.id)) {
        results.push(modalItem.resetSelectedState(refinement));
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  ShowMoreModal.prototype._setElement = function() {
    this.el = $("#" + this.modalId);
    return this.setElement(this.el);
  };

  ShowMoreModal.prototype._startPageScroll = function() {
    return $('body').css('overflow', 'auto');
  };

  ShowMoreModal.prototype._stopPageScroll = function() {
    return $('body').css('overflow', 'hidden');
  };

  ShowMoreModal.prototype._toHash = function() {
    return {
      dataBhw: this.collection.dataBhw,
      id: this.collection.id,
      modalId: this.modalId,
      title: this.collection.title,
      apply: i18n.translate('refinements.apply'),
      showMoreSearch: this.collection.showMoreSearch,
      showMoreSearchPlaceholder: this.collection.showMoreSearchPlaceholder
    };
  };

  ShowMoreModal.prototype._updateCollection = function() {
    var i, id, len, modalItem, model, ref, selected;
    ref = this.modalItems;
    for (i = 0, len = ref.length; i < len; i++) {
      modalItem = ref[i];
      id = modalItem.id, selected = modalItem.selected;
      if ((model = this.collection.get(id)) && model.get('selected') !== selected) {
        model.toggleSelected({
          preventTrigger: true
        });
      }
    }
    return this.collection.triggerModelsUpdated();
  };

  ShowMoreModal.prototype._handleShowMoreSearchSelection = function(model) {
    var id, modalItemView;
    id = model.get('id');
    modalItemView = _.find(this.modalItems, function(view) {
      return (view != null ? view.id : void 0) === id;
    });
    if (!(modalItemView != null ? modalItemView.selected : void 0)) {
      if (modalItemView != null) {
        modalItemView.toggleSelected();
      }
    }
    return this._scrollToSelected(modalItemView);
  };

  ShowMoreModal.prototype._scrollToSelected = function(modalItemView) {
    var $modalItem, scrollTop;
    if (!modalItemView) {
      return;
    }
    $modalItem = modalItemView.$el;
    scrollTop = this.$modalItemsContainer.scrollTop() + $modalItem.offset().top - this.$modalItemsContainer.offset().top;
    if (!isNaN(scrollTop)) {
      return this.$modalItemsContainer.animate({
        scrollTop: scrollTop
      }, DEFAULT_ANIMATE_TIME);
    }
  };

  ShowMoreModal.prototype._renderShowMoreSearch = function() {
    var $containerEl, ref;
    if (!this.collection.showMoreSearch) {
      return;
    }
    $containerEl = this.$el.find('.grui-show-more-search');
    if ((ref = this.showMoreSearch) != null) {
      ref.remove();
    }
    return this.showMoreSearch = new TypeaheadSearch({
      collection: this.collection,
      el: $containerEl,
      onSelection: this._handleShowMoreSearchSelection
    }).render();
  };

  return ShowMoreModal;

})(Backbone.View);

},{"../../templates":94,"../i18n":62,"./modal_item":81,"./typeahead_search":92}],90:[function(require,module,exports){
var TypeaheadInput;

TypeaheadInput = Backbone.View.extend({
  events: {
    'blur .grui-show-more-search-input': '_handleBlur',
    'focus .grui-show-more-search-input': '_handleFocus',
    'input .grui-show-more-search-input': '_handleType'
  },
  render: function() {
    this._cacheElem();
    return this;
  },
  blur: function() {
    return this.$input.blur();
  },
  focus: function() {
    return this.$input.focus();
  },
  setValue: function(value) {
    this.$input.val(value);
    return this.trigger('typeEvent', value);
  },
  getValue: function() {
    return this.$input.val();
  },
  clearValue: function() {
    return this.setValue('');
  },
  _cacheElem: function() {
    return this.$input = this.$el.find('.grui-show-more-search-input');
  },
  _handleBlur: function() {
    return this.trigger('blurEvent');
  },
  _handleFocus: function() {
    return this.trigger('focusEvent');
  },
  _handleType: _.debounce((function() {
    return this.trigger('typeEvent', this.getValue());
  }), 100)
});

module.exports = TypeaheadInput;

},{}],91:[function(require,module,exports){
var DEFAULT_MAX_RESULTS, DEFAULT_SORT_COMPARATOR, TypeaheadResultsList, templates;

templates = require('../../templates');

DEFAULT_SORT_COMPARATOR = function(a, b) {
  return b.get('count') - a.get('count');
};

DEFAULT_MAX_RESULTS = 5;

TypeaheadResultsList = Backbone.View.extend({
  _currentQuery: '',
  _currentResultModels: [],
  template: templates['typeahead_search_results_item'],
  events: {
    'click .grui-show-more-search-result-item': '_handleClickSelection'
  },
  initialize: function() {
    return this.sortedCollection = this.collection.slice(0).sort(DEFAULT_SORT_COMPARATOR);
  },
  hideAllResults: function() {
    return this.$el.hide();
  },
  showAllResults: function() {
    var ref;
    if (!((ref = this._currentResultModels) != null ? ref.length : void 0)) {
      return this.hideAllResults();
    }
    return this.$el.show();
  },
  resetState: function() {
    this.hideAllResults();
    this._resetResultsState();
    return this._currentQuery = '';
  },
  filterResults: function(query) {
    var maxResultsCount, queryToMatch, ref, resultElems, resultModels;
    if (!((query = query.trim()) && this._currentQuery !== query)) {
      if (!query.length) {
        this.resetState();
      }
      return;
    }
    maxResultsCount = (ref = this.sortedCollection.showMoreSearchMax) != null ? ref : DEFAULT_MAX_RESULTS;
    queryToMatch = new RegExp("(" + query + ")", 'i');
    resultModels = [];
    resultElems = [];
    _.find(this.sortedCollection, (function(_this) {
      return function(model) {
        var html, name;
        name = model.get('friendlyNameShort');
        if (name != null ? name.match(queryToMatch) : void 0) {
          html = _this.template.render({
            count: model.get('count'),
            displayText: name.replace(queryToMatch, '<b>$1</b>'),
            id: model.get('id')
          });
          resultModels.push(model);
          resultElems.push(html);
        }
        return resultElems.length >= maxResultsCount;
      };
    })(this));
    this._currentQuery = query;
    this._currentResultModels = resultModels;
    this.$el.html(resultElems);
    return this.showAllResults();
  },
  _triggerSelectionMade: function(highlightedModel) {
    if (!highlightedModel) {
      return;
    }
    return this.trigger('selectionMade', highlightedModel);
  },
  _handleClickSelection: function(e) {
    var id;
    id = $(e.target).data('id');
    return this._triggerSelectionMade(this.collection.get(id));
  },
  _resetResultsState: function() {
    this._currentResultModels = [];
    return this.$el.html('');
  }
});

module.exports = TypeaheadResultsList;

},{"../../templates":94}],92:[function(require,module,exports){
var KEYCODE_TAB, TypeaheadInput, TypeaheadResultsList, TypeaheadSearch, templates;

TypeaheadInput = require('./typeahead_input');

TypeaheadResultsList = require('./typeahead_results_list');

templates = require('../../templates');

KEYCODE_TAB = 9;

TypeaheadSearch = Backbone.View.extend({
  template: templates['typeahead_search'],
  partials: {
    typeahead_search_input: templates['typeahead_search_input']
  },
  initialize: function(options) {
    var onSelection;
    _.bindAll(this, '_handleBlur', '_handleFocus', '_handleKeypress');
    if ((onSelection = options != null ? options.onSelection : void 0) != null) {
      this.onSelection = onSelection;
    }
    return this._applyInitializeListeners();
  },
  render: function() {
    this.$el.html(this.template.render(this._toHash(), this.partials));
    this._cacheElem();
    this._initInput();
    this._initResults();
    this._applyListeners();
    return this;
  },
  remove: function() {
    var ref, ref1;
    this.closeSearch();
    if ((ref = this.inputView) != null) {
      ref.remove();
    }
    if ((ref1 = this.resultsView) != null) {
      ref1.remove();
    }
    return Backbone.View.prototype.remove.call(this);
  },
  closeSearch: function() {
    this.$el.removeClass('grui-show-more-search-focused');
    $(document).off('click', this._handleBlur);
    $(document).off('keydown', this._handleKeypress);
    this.resultsView.hideAllResults();
    return this.inputView.blur();
  },
  resetSearch: function() {
    this.closeSearch();
    this.inputView.clearValue();
    return this.resultsView.resetState();
  },
  onSelection: function(model) {
    return model.select();
  },
  _toHash: function() {
    return {
      showMoreSearchPlaceholder: this.collection.showMoreSearchPlaceholder
    };
  },
  _cacheElem: function() {
    this.$input = this.$el.find('.grui-show-more-search-input-container');
    return this.$results = this.$el.find('.grui-show-more-search-results');
  },
  _initInput: function() {
    var ref;
    if ((ref = this.inputView) != null) {
      ref.remove();
    }
    return this.inputView = (new TypeaheadInput({
      el: this.$input
    })).render();
  },
  _initResults: function() {
    var ref;
    this.stopListening(this.resultsView);
    if ((ref = this.resultsView) != null) {
      ref.remove();
    }
    return this.resultsView = (new TypeaheadResultsList({
      collection: this.collection,
      el: this.$results
    })).render();
  },
  _handleBlur: function(arg) {
    var ref, ref1, target;
    target = arg.target;
    if (this.$input.is(target) || this.$results.is(target) || ((ref = this.$input.has(target)) != null ? ref.length : void 0) || ((ref1 = this.$results.has(target)) != null ? ref1.length : void 0)) {
      return;
    }
    return this.closeSearch();
  },
  _handleFocus: function() {
    this.$el.addClass('grui-show-more-search-focused');
    this.resultsView.showAllResults();
    $(document).off('click', this._handleBlur).on('click', this._handleBlur);
    return $(document).off('keydown', this._handleKeypress).on('keydown', this._handleKeypress);
  },
  _handleKeypress: function(e) {
    var altKey, ctrlKey, keyCode, keyValue, which;
    altKey = e.altKey, ctrlKey = e.ctrlKey, keyCode = e.keyCode, which = e.which;
    if (altKey || ctrlKey) {
      return;
    }
    keyValue = keyCode != null ? keyCode : which;
    if (keyValue === KEYCODE_TAB) {
      return this.closeSearch();
    }
  },
  _handleReset: function(model, value, options) {
    if (!(options != null ? options.preventTrigger : void 0)) {
      return this.resetSearch();
    }
  },
  _handleSelection: function(model) {
    this.resetSearch();
    return this.onSelection(model);
  },
  _applyInitializeListeners: function() {
    return this.listenTo(this.collection, 'reset', this._handleReset);
  },
  _applyListeners: function() {
    var inputView, resultsView;
    inputView = this.inputView, resultsView = this.resultsView;
    this.listenTo(this.resultsView, 'selectionMade', this._handleSelection);
    resultsView.listenTo(inputView, 'typeEvent', resultsView.filterResults);
    resultsView.listenTo(inputView, 'keypressEvent', this._handleKeypress);
    return resultsView.listenTo(inputView, 'focusEvent', this._handleFocus);
  }
});

module.exports = TypeaheadSearch;

},{"../../templates":94,"./typeahead_input":90,"./typeahead_results_list":91}],93:[function(require,module,exports){
module.exports = (function() {
    var Hogan = require('hogan.js');
    var templates = {};
    templates['availability'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<li class=\"time-spot\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-value=\"");t.b(t.v(t.f("friendlyName",c,p,0)));t.b("\">");t.b("\n" + i);t.b("  <a class=\"");if(t.s(t.f("selected",c,p,1),c,p,0,95,103,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("selected");});c.pop();}t.b("\" href=\"");t.b(t.v(t.f("url",c,p,0)));t.b("\">");t.b(t.v(t.f("friendlyName",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("</li>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['available_dates'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"availabilities\">");t.b("\n" + i);t.b("  <div class=\"refinement-box\">");t.b("\n" + i);t.b("    <div class=\"flyout-trigger ");if(t.s(t.f("hasSelection",c,p,1),c,p,0,108,121,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("has-selection");});c.pop();}t.b("\">");t.b("\n" + i);t.b("      <span class=\"icon-calendar\"></span>");t.b("\n" + i);t.b("      <span>");t.b(t.v(t.f("label",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("      ");if(t.s(t.f("hasSelection",c,p,1),c,p,0,235,267,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"icon-close\"></span>");});c.pop();}t.b("\n" + i);t.b("      <span class=\"arrow icon-arrow-down-large\"></span>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b(t.rp("<available_dates_flyout0",c,p,"      "));t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {"<available_dates_flyout0":{name:"available_dates_flyout", partials: {}, subs: {  }}}, subs: {  }});
    templates['available_dates_flyout'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"flyout\">");t.b("\n" + i);t.b("  <div class='content'>");t.b("\n" + i);t.b(t.rp("<grpn-ui/date-picker0",c,p,"    "));t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n");t.b("\n");return t.fl(); },partials: {"<grpn-ui/date-picker0":{name:"grpn-ui/date-picker", partials: {}, subs: {  }}}, subs: {  }});
    templates['available_party_sizes'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("isFoodAndDrink",c,p,1),c,p,0,19,404,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"availabilities party-size\">");t.b("\n" + i);t.b("    <div class=\"refinement-box\">");t.b("\n" + i);t.b("      <div class=\"flyout-trigger\">");t.b("\n" + i);t.b("        <span class=\"icon-group\"></span>");t.b("\n" + i);t.b("        <span class=\"selection\">");t.b(t.v(t.f("all_party_sizes",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("        <span class=\"arrow icon-arrow-down-large\"></span>");t.b("\n" + i);t.b("        <span class=\"icon-close\"></span>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b(t.rp("<available_party_sizes_flyout0",c,p,"      "));t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {"<available_party_sizes_flyout0":{name:"available_party_sizes_flyout", partials: {}, subs: {  }}}, subs: {  }});
    templates['available_party_sizes_flyout'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("\n" + i);t.b("  <div class=\"flyout\">");t.b("\n" + i);t.b("    <h4 class=\"heading\">");t.b(t.v(t.f("party_size_prompt",c,p,0)));t.b("</h4>");t.b("\n" + i);t.b("    <div class=\"horizontal-content\">");t.b("\n" + i);t.b("      <ul>");t.b("\n" + i);if(t.s(t.f("partySizes",c,p,1),c,p,0,146,289,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <li class=\"party-size-option");if(t.s(t.f("selected",c,p,1),c,p,0,198,207,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" selected");});c.pop();}t.b("\" data-value=\"");t.b(t.v(t.f("value",c,p,0)));t.b("\" data-name=\"");t.b(t.v(t.f("name",c,p,0)));t.b("\">");t.b(t.v(t.f("value",c,p,0)));t.b("</li>");t.b("\n" + i);});c.pop();}t.b("      </ul>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['available_times'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"availabilities\">");t.b("\n" + i);if(t.s(t.f("showRefinementBox",c,p,1),c,p,0,55,444,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"refinement-box\">");t.b("\n" + i);t.b("      <div class=\"flyout-trigger ");if(t.s(t.f("hasSelection",c,p,1),c,p,0,139,152,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("has-selection");});c.pop();}t.b("\">");t.b("\n" + i);t.b("        <span class=\"icon-now\"></span>");t.b("\n" + i);t.b("        <span>");t.b(t.v(t.f("selectedTime",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("        ");if(t.s(t.f("hasSelection",c,p,1),c,p,0,274,306,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"icon-close\"></span>");});c.pop();}t.b("\n" + i);t.b("        <span class=\"arrow icon-arrow-down-large\"></span>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b(t.rp("<available_times_flyout0",c,p,"      "));t.b("    </div>");t.b("\n" + i);});c.pop();}t.b("</div>");t.b("\n");return t.fl(); },partials: {"<available_times_flyout0":{name:"available_times_flyout", partials: {}, subs: {  }}}, subs: {  }});
    templates['available_times_flyout'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"flyout\">");t.b("\n" + i);if(t.s(t.f("hasAm",c,p,1),c,p,0,33,202,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <ul class=\"pills\">");t.b("\n" + i);t.b("      <li><h4>");t.b(t.v(t.f("morning",c,p,0)));t.b("</h4><li>");t.b("\n" + i);if(t.s(t.f("refinementData",c,p,1),c,p,0,117,170,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("isAm",c,p,1),c,p,0,133,154,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.rp("<availability0",c,p," "));});c.pop();}});c.pop();}t.b("    </ul>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("hasPm",c,p,1),c,p,0,226,405,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <ul class=\"pills\">");t.b("\n" + i);t.b("      <li><h4>");t.b(t.v(t.f("afternoonEvening",c,p,0)));t.b("</h4></li>");t.b("\n" + i);if(t.s(t.f("refinementData",c,p,1),c,p,0,320,373,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("isPm",c,p,1),c,p,0,336,357,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.rp("<availability1",c,p," "));});c.pop();}});c.pop();}t.b("    </ul>");t.b("\n" + i);});c.pop();}t.b("</div>");t.b("\n");return t.fl(); },partials: {"<availability0":{name:"availability", partials: {}, subs: {  }},"<availability1":{name:"availability", partials: {}, subs: {  }}}, subs: {  }});
    templates['breadcrumb'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<a class=\"grui-breadcrumb-friendly-name\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-bhc=\"breadcrumbPill:");t.b(t.v(t.f("id",c,p,0)));t.b("\" href=\"");if(t.s(t.f("url",c,p,1),c,p,0,107,114,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.v(t.f("url",c,p,0)));});c.pop();}if(!t.s(t.f("url",c,p,1),c,p,1,0,0,"")){t.b("#");};t.b("\">");t.b(t.v(t.f("friendlyNameShort",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("<span class=\"grui-breadcrumb-close-btn icon-x\"></span>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['breadcrumb_filters'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"refinement-box\" data-bhw=\"refinementBreadcrumbFilters\">");t.b("\n" + i);t.b("  <h4>");t.b(t.v(t.f("breadcrumbTitle",c,p,0)));t.b("</h4>");t.b("\n" + i);t.b("  <div class=\"grui-breadcrumb-pills-container\">");t.b("\n" + i);t.b("    <span class=\"grui-breadcrumb-container\"></span><span class=\"grui-breadcrumb-reset-container\"></span>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['breadcrumb_query'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("query",c,p,1),c,p,0,12,174,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"grui-breadcrumb-pill\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("    <span class=\"grui-breadcrumb-search-icon icon-magnifying-glass\"></span>");t.b("\n" + i);t.b(t.rp("<breadcrumb0",c,p,"    "));t.b("  </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {"<breadcrumb0":{name:"breadcrumb", partials: {}, subs: {  }}}, subs: {  }});
    templates['checkbox'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<input type=\"checkbox\" ");if(t.s(t.f("selected",c,p,1),c,p,0,36,43,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("checked");});c.pop();}t.b(" id=\"ref-ui-checkbox-");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['checkbox_reset'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<input type=\"checkbox\" ");if(!t.s(t.f("anySelected",c,p,1),c,p,1,0,0,"")){t.b("checked");};t.b(" id=\"ref-ui-checkbox-reset-");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("<label for=\"ref-ui-checkbox-reset-");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("  <a href=\"\">");t.b(t.v(t.f("all",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("</label>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['child_list'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("children",c,p,1),c,p,0,13,310,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <li class=\"refinement");if(t.s(t.f("isLastLevel",c,p,1),c,p,0,53,64,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" last-level");});c.pop();}if(t.s(t.f("simplifiedShow",c,p,1),c,p,0,99,115,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" simplified-show");});c.pop();}t.b("\" data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("\">");t.b("\n" + i);t.b(t.rp("<nested_item0",c,p,"    "));t.b("    <ul class=\"children-list");if(t.s(t.f("lowestSelected",c,p,1),c,p,0,230,246,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" lowest-selected");});c.pop();}t.b("\">");t.b("\n" + i);t.b(t.rp("<child_list1",c,p,"      "));t.b("    </ul>");t.b("\n" + i);t.b("  </li>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {"<nested_item0":{name:"nested_item", partials: {}, subs: {  }},"<child_list1":{name:"child_list", partials: {}, subs: {  }}}, subs: {  }});
    templates['link'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<li data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" class=\"sub-category-links child-refinement");if(t.s(t.f("selected",c,p,1),c,p,0,76,85,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" selected");});c.pop();}t.b("\" data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("\">");t.b("\n" + i);t.b("  <a href=\"");t.b(t.v(t.f("url",c,p,0)));t.b("\">");t.b("\n" + i);t.b("    ");t.b(t.v(t.f("friendlyName",c,p,0)));t.b("\n" + i);t.b("    ");if(t.s(t.f("count",c,p,1),c,p,0,180,224,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"deal-counts\">(");t.b(t.v(t.f("count",c,p,0)));t.b(")</span>");});c.pop();}t.b("\n" + i);t.b("    ");if(t.s(t.f("badges",c,p,1),c,p,0,250,292,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"badge-");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b(t.v(t.f("text",c,p,0)));t.b("</span>");});c.pop();}t.b("\n" + i);t.b("  </a>");t.b("\n" + i);t.b("</li>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['links_list'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"refinement-links\">");t.b("\n" + i);if(t.s(t.f("refinementData",c,p,1),c,p,0,54,577,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"refinement-box\">");t.b("\n" + i);t.b("    <h4>");t.b(t.v(t.f("friendlyName",c,p,0)));if(t.s(t.f("showCollapseControl",c,p,1),c,p,0,138,360,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" <span data-bhw=\"collapse_filter_");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("-list\" class=\"toggle-refinements ");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,248,269,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("icon-arrow-down-large");});c.pop();}if(!t.s(t.f("collapseFilter",c,p,1),c,p,1,0,0,"")){t.b("icon-arrow-up-large");};t.b("\"></span>");});c.pop();}t.b("</h4>");t.b("\n" + i);t.b("    <ul id='");t.b(t.v(t.f("id",c,p,0)));t.b("-list' class=\"refinement-list");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,460,470,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" collapsed");});c.pop();}t.b("\">");t.b("\n" + i);if(t.s(t.f("children",c,p,1),c,p,0,513,540,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.rp("<link0",c,p,"        "));});c.pop();}t.b("    </ul>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}t.b("</div>");t.b("\n");return t.fl(); },partials: {"<link0":{name:"link", partials: {}, subs: {  }}}, subs: {  }});
    templates['main'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("queryFilterId",c,p,1),c,p,0,20,99,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div data-id=\"");t.b(t.v(t.f("queryFilterId",c,p,0)));t.b("\" data-bhw=\"queryFilterRefinement\">");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}if(t.s(t.f("showBreadcrumbFilter",c,p,1),c,p,0,147,193,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div id=\"grui-breadcrumb-container\"></div>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("showBreadcrumbFilter",c,p,1),c,p,1,0,0,"")){t.b("  <div id='reset-all-container'>");t.b("\n" + i);t.b(t.rp("<reset_all0",c,p,"    "));t.b("  </div>");t.b("\n" + i);};t.b("\n" + i);if(t.s(t.f("widgets",c,p,1),c,p,0,353,370,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.rp("<widget1",c,p,"  "));});c.pop();}return t.fl(); },partials: {"<reset_all0":{name:"reset_all", partials: {}, subs: {  }},"<widget1":{name:"widget", partials: {}, subs: {  }}}, subs: {  }});
    templates['modal_item'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<span class=\"refinement\">");t.b("\n" + i);if(t.s(t.f("hasCheckbox",c,p,1),c,p,0,46,69,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.rp("<checkbox0",c,p,"    "));});c.pop();}t.b("  <label title=\"");t.b(t.v(t.f("friendlyNameShort",c,p,0)));t.b("\">");t.b(t.v(t.f("friendlyNameShort",c,p,0)));t.b("\n" + i);t.b("    ");if(!t.s(t.f("hideCounts",c,p,1),c,p,1,0,0,"")){if(t.s(t.f("count",c,p,1),c,p,0,178,222,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"deal-counts\">(");t.b(t.v(t.f("count",c,p,0)));t.b(")</span>");});c.pop();}};t.b("\n" + i);t.b("    ");if(t.s(t.f("badges",c,p,1),c,p,0,263,305,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"badge-");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b(t.v(t.f("text",c,p,0)));t.b("</span>");});c.pop();}t.b("\n" + i);t.b("  </label>");t.b("\n" + i);t.b("</span>");t.b("\n");return t.fl(); },partials: {"<checkbox0":{name:"checkbox", partials: {}, subs: {  }}}, subs: {  }});
    templates['nested_item'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<span data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b(t.rp("<nested_link0",c,p,"  "));t.b("</span>");t.b("\n");return t.fl(); },partials: {"<nested_link0":{name:"nested_link", partials: {}, subs: {  }}}, subs: {  }});
    templates['nested_link'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<span class=\"refinement-name");if(t.s(t.f("lowestSelected",c,p,1),c,p,0,47,56,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" selected");});c.pop();}if(!t.s(t.f("static",c,p,1),c,p,1,0,0,"")){t.b(" dynamic");};t.b("\">");t.b("\n" + i);if(t.s(t.f("hasCheckbox",c,p,1),c,p,0,128,151,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.rp("<checkbox0",c,p,"    "));});c.pop();}t.b("  <label class=\"name truncated");if(!t.s(t.f("lowestSelected",c,p,1),c,p,1,0,0,"")){if(!t.s(t.f("isLastButOneLevel",c,p,1),c,p,1,0,0,"")){if(t.s(t.f("simplifiedShow",c,p,1),c,p,0,260,271,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" show-arrow");});c.pop();}};};t.b("\" for=\"ref-ui-checkbox-");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);if(t.s(t.f("useSimplifiedCategory",c,p,1),c,p,0,395,486,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      ");if(!t.s(t.f("hasCheckbox",c,p,1),c,p,1,0,0,"")){t.b("<span class=\"icon-arrow-left-large\"></span>");};t.b("\n" + i);});c.pop();}t.b("    <a href=\"");t.b(t.v(t.f("url",c,p,0)));t.b("\" ");if(t.s(t.f("noFollow",c,p,1),c,p,0,552,566,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("rel=\"nofollow\"");});c.pop();}t.b(">");t.b(t.v(t.f("friendlyNameShort",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("    ");if(!t.s(t.f("hideCounts",c,p,1),c,p,1,0,0,"")){if(t.s(t.f("count",c,p,1),c,p,0,637,681,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"deal-counts\">(");t.b(t.v(t.f("count",c,p,0)));t.b(")</span>");});c.pop();}};t.b("\n" + i);t.b("    ");if(t.s(t.f("badges",c,p,1),c,p,0,722,764,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"badge-");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b(t.v(t.f("text",c,p,0)));t.b("</span>");});c.pop();}t.b("\n" + i);t.b("  </label>");t.b("\n" + i);t.b("</span>");t.b("\n");return t.fl(); },partials: {"<checkbox0":{name:"checkbox", partials: {}, subs: {  }}}, subs: {  }});
    templates['nested_links'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("showRefinementBox",c,p,1),c,p,0,24,1466,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<div class=\"refinement-box");if(t.s(t.f("useSimplifiedCategory",c,p,1),c,p,0,77,97,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" simplified-category");});c.pop();}t.b("\">");t.b("\n" + i);t.b("  <h4>");t.b(t.v(t.f("title",c,p,0)));if(t.s(t.f("showCollapseControl",c,p,1),c,p,0,167,367,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" <span data-bhw=\"collapse_filter_");t.b(t.v(t.f("id",c,p,0)));t.b("\" class=\"toggle-refinements ");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,255,276,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("icon-arrow-down-large");});c.pop();}if(!t.s(t.f("collapseFilter",c,p,1),c,p,1,0,0,"")){t.b("icon-arrow-up-large");};t.b("\"></span>");});c.pop();}t.b("</h4>");t.b("\n");t.b("\n" + i);t.b("  <ul class=\"refinement-list");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,449,459,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" collapsed");});c.pop();}t.b("\">");t.b("\n" + i);if(t.s(t.f("showMoreSearch",c,p,1),c,p,0,508,590,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div data-bhw=\"lhnShowMoreSearch\" class=\"grui-show-more-search\"></div>");t.b("\n" + i);});c.pop();}if(t.s(t.f("multiselect",c,p,1),c,p,0,634,733,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <li class='refinement reset' data-bhc=\"");t.b(t.v(t.f("id",c,p,0)));t.b(":all\">");t.b("\n" + i);t.b(t.rp("<checkbox_reset0",c,p,"      "));t.b("    </li>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("refinementData",c,p,1),c,p,0,778,1411,"{{ }}")){t.rs(c,p,function(c,p,t){if(!t.s(t.f("multiselect",c,p,1),c,p,1,0,0,"")){if(t.s(t.f("useSimplifiedCategory",c,p,1),c,p,0,838,1025,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <li class=\"refinement show-arrow\">");t.b("\n" + i);t.b("            <a href=\"");t.b(t.v(t.d("l1Category.url",c,p,0)));t.b("\"><span class=\"icon-arrow-left-large\"></span> ");t.b(t.v(t.d("l1Category.friendlyName",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("          </li>");t.b("\n" + i);});c.pop();}};t.b("\n" + i);t.b("      <li class=\"refinement");if(t.s(t.f("useSimplifiedCategory",c,p,1),c,p,0,1131,1185,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("lowestSelected",c,p,1),c,p,0,1150,1166,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" has-l1-category");});c.pop();}});c.pop();}t.b("\" data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("\">");t.b("\n" + i);t.b(t.rp("<nested_item1",c,p,"        "));t.b("        <ul class=\"children-list");if(t.s(t.f("lowestSelected",c,p,1),c,p,0,1315,1331,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" lowest-selected");});c.pop();}t.b("\">");t.b("\n" + i);t.b(t.rp("<child_list2",c,p,"          "));t.b("        </ul>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}t.b("  </ul>");t.b("\n" + i);t.b(t.rp("<see_more3",c,p,"  "));t.b("</div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {"<checkbox_reset0":{name:"checkbox_reset", partials: {}, subs: {  }},"<nested_item1":{name:"nested_item", partials: {}, subs: {  }},"<child_list2":{name:"child_list", partials: {}, subs: {  }},"<see_more3":{name:"see_more", partials: {}, subs: {  }}}, subs: {  }});
    templates['range_filter'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<h4 data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("_title\">");t.b(t.v(t.f("friendlyNameShort",c,p,0)));if(t.s(t.f("showCollapseControl",c,p,1),c,p,0,80,280,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" <span data-bhw=\"collapse_filter_");t.b(t.v(t.f("id",c,p,0)));t.b("\" class=\"toggle-refinements ");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,168,189,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("icon-arrow-down-large");});c.pop();}if(!t.s(t.f("collapseFilter",c,p,1),c,p,1,0,0,"")){t.b("icon-arrow-up-large");};t.b("\"></span>");});c.pop();}t.b("</h4>");t.b("\n" + i);t.b("<div class=\"refinement-range");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,361,371,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" collapsed");});c.pop();}t.b("\">");t.b("\n" + i);t.b("  <div data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("_slider\" class=\"refinement-range-slider\"></div>");t.b("\n");t.b("\n" + i);t.b("  <div class=\"refinement-range-input-container\">");t.b("\n" + i);t.b("    <div class=\"refinement-range-input\">");t.b("\n" + i);t.b("      <div class=\"refinement-range-input-unit\">");t.b(t.v(t.f("unit",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("      <input data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("_minInput\" type=\"text\" class=\"refinement-range-bottom-input\" value=");t.b(t.v(t.f("displayedMin",c,p,0)));t.b(">");t.b("\n" + i);t.b("      <div data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("_minError\" class=\"refinement-range-error-message\"></div>");t.b("\n" + i);t.b("    </div>");t.b("\n");t.b("\n" + i);t.b("    <div class=\"refinement-range-input\">");t.b("\n" + i);t.b("      <div class=\"refinement-range-input-unit\">");t.b(t.v(t.f("unit",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("      <input data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("_maxInput\" type=\"text\" class=\"refinement-range-top-input\" value=");t.b(t.v(t.f("displayedMax",c,p,0)));t.b(">");t.b("\n" + i);t.b("      <div data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("_maxError\" class=\"refinement-range-error-message\"></div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);if(t.s(t.f("showPriceRangeButton",c,p,1),c,p,0,1201,1342,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"refinement-range-submit\">");t.b("\n" + i);t.b("    <a class='btn-secondary btn-range-submit btn-invert'>");t.b("\n" + i);t.b("      ");t.b(t.v(t.f("applyText",c,p,0)));t.b("\n" + i);t.b("    </a>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['reset_all'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div id=\"clear-module\" data-bhw=\"refinementResetButton\" ");if(t.s(t.f("refinementsSelected",c,p,1),c,p,0,80,92,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("class=\"show\"");});c.pop();}t.b(">");t.b("\n" + i);t.b("  <div class=\"pill-reset\">");t.b("\n" + i);t.b("    <a href=\"#\">");t.b(t.v(t.f("resetAllText",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("    <span class=\"icon-x\"></span>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }});
    templates['reset_filters'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<ul class=\"pills\">");t.b("\n" + i);if(t.s(t.f("refinementData",c,p,1),c,p,0,40,264,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("selected",c,p,1),c,p,0,58,248,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <li class=\"dismiss\">");t.b("\n" + i);t.b("        <a href=\"");t.b(t.v(t.f("url",c,p,0)));t.b("\" class=\"bubble-filter-term");if(!t.s(t.f("static",c,p,1),c,p,1,0,0,"")){t.b(" dynamic");};t.b("\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("\">\"");t.b(t.v(t.f("friendlyName",c,p,0)));t.b("\"</a>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}});c.pop();}t.b("</ul>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['see_more'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("showSeeMoreLink",c,p,1),c,p,0,22,141,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <a class=\"see-more ");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,65,75,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" collapsed");});c.pop();}t.b("\" data-bhc=\"");t.b(t.v(t.f("id",c,p,0)));t.b(":showMore\">");t.b(t.v(t.f("seeMore",c,p,0)));t.b("</a>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }});
    templates['show_more_modal'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"modal refinement-modal");if(t.s(t.f("showMoreSearch",c,p,1),c,p,0,55,85,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" grui-show-more-search-visible");});c.pop();}t.b("\" ");if(t.s(t.f("modalId",c,p,1),c,p,0,122,138,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("id=\"");t.b(t.v(t.f("modalId",c,p,0)));t.b("\"");});c.pop();}t.b(">");t.b("\n" + i);t.b("  <div class=\"modal-body\">");t.b("\n" + i);t.b("    <div class=\"close-modal icon-x\"></div>");t.b("\n");t.b("\n" + i);t.b("    <div class=\"tabs-container\">");t.b("\n" + i);t.b("      <ul class=\"tabs\">");t.b("\n" + i);t.b("        <li class=\"");t.b(t.v(t.f("id",c,p,0)));t.b("-tab active\"><a>");t.b(t.v(t.f("title",c,p,0)));t.b("</a></li>");t.b("\n" + i);t.b("      </ul>");t.b("\n" + i);t.b("    </div>");t.b("\n");t.b("\n" + i);if(t.s(t.f("showMoreSearch",c,p,1),c,p,0,391,475,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div data-bhw=\"modalShowMoreSearch\" class=\"grui-show-more-search\"></div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);t.b("    <div class=\"checkbox-holder\" data-bhw=\"");t.b(t.v(t.f("dataBhw",c,p,0)));t.b("Modal\" data-bh-viewport=\"respect\">");t.b("\n" + i);t.b("      <div class=\"spinner-overlay\">");t.b("\n" + i);t.b("        <div class=\"icon-g-loader\"></div>");t.b("\n" + i);t.b("      </div>");t.b("\n");t.b("\n" + i);t.b("      <ul class=\"checkbox-container\">");t.b("\n" + i);t.b("      </ul>");t.b("\n" + i);t.b("    </div>");t.b("\n");t.b("\n" + i);t.b("    <div class=\"modal-footer\">");t.b("\n" + i);t.b("      <button class=\"apply btn-small btn-cta\" data-bhc=\"show-more-modal:apply\">");t.b(t.v(t.f("apply",c,p,0)));t.b("</button>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['typeahead_search'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b(t.rp("<typeahead_search_input0",c,p,""));t.b("<div class=\"grui-show-more-search-results-container\">");t.b("\n" + i);t.b("  <div class=\"grui-show-more-search-results\" data-bhw=\"showMoreSearchResults\"></div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {"<typeahead_search_input0":{name:"typeahead_search_input", partials: {}, subs: {  }}}, subs: {  }});
    templates['typeahead_search_input'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"gig-field grui-show-more-search-input-container\">");t.b("\n" + i);t.b("  <input data-bhw=\"showMoreSearchInput\" class=\"grui-show-more-search-input\" type=\"text\" placeholder=\"");t.b(t.v(t.f("showMoreSearchPlaceholder",c,p,0)));t.b("\">");t.b("\n" + i);t.b("  <span class=\"icon icon-magnifying-glass\">");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['typeahead_search_results_item'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div data-id='");t.b(t.v(t.f("id",c,p,0)));t.b("' data-bhc=\"resultItem:");t.b(t.v(t.f("id",c,p,0)));t.b("\" class='grui-show-more-search-result-item");if(t.s(t.f("isActive",c,p,1),c,p,0,106,113,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" active");});c.pop();}t.b("'>");t.b("\n" + i);t.b("  ");t.b(t.t(t.f("displayText",c,p,0)));if(t.s(t.f("count",c,p,1),c,p,0,162,174,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" (");t.b(t.v(t.f("count",c,p,0)));t.b(")");});c.pop();}t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['widget'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("resetFilters",c,p,1),c,p,0,19,173,"{{ }}")){t.rs(c,p,function(c,p,t){if(!t.s(t.f("isQueryFilter",c,p,1),c,p,1,0,0,"")){t.b("    <div id=\"reset-filters\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-bhw=\"");t.b(t.v(t.f("dataBhw",c,p,0)));t.b("\">");t.b("\n" + i);t.b(t.rp("<reset_filters0",c,p,"      "));t.b("    </div>");t.b("\n" + i);};});c.pop();}t.b("\n" + i);if(t.s(t.f("rangeFilters",c,p,1),c,p,0,213,422,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-bhw=\"");t.b(t.v(t.f("dataBhw",c,p,0)));t.b("\" data-bh-viewport=\"respect\">");t.b("\n" + i);if(t.s(t.f("refinementData",c,p,1),c,p,0,312,393,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div class=\"refinement-box\">");t.b("\n" + i);t.b(t.rp("<range_filter1",c,p,"        "));t.b("      </div>");t.b("\n" + i);});c.pop();}t.b("  </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("flatRefinementLinks",c,p,1),c,p,0,469,576,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-bhw=\"");t.b(t.v(t.f("dataBhw",c,p,0)));t.b("\" data-bh-viewport=\"respect\">");t.b("\n" + i);t.b(t.rp("<links_list2",c,p,"    "));t.b("  </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("availabilities",c,p,1),c,p,0,625,1246,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div id=\"availabilities-container\" class=\"refinement-box\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-bhw=\"");t.b(t.v(t.f("dataBhw",c,p,0)));t.b("\" data-bh-viewport=\"respect\">");t.b("\n" + i);t.b("    <h4>");t.b(t.v(t.f("title",c,p,0)));t.b("<span class=\"badge-new\">NEW!</span></h4>");t.b("\n");t.b("\n" + i);t.b("    <div name=\"available-party-sizes\" data-id=\"availablePartySizes\" data-bhc='dtf_option:party_size'>");t.b("\n" + i);t.b(t.rp("<available_party_sizes3",c,p,"      "));t.b("    </div>");t.b("\n");t.b("\n" + i);t.b("    <div name=\"available-dates\" data-id='availableDates' data-bhc='dtf_option:reservation_date'>");t.b("\n" + i);t.b(t.rp("<available_dates4",c,p,"      "));t.b("    </div>");t.b("\n");t.b("\n" + i);t.b("    <div name=\"available-times\" data-id='availableTimes' data-bhc=\"dtf_option:reservation_time\">");t.b("\n" + i);t.b(t.rp("<available_times5",c,p,"      "));t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("nestedRefinementLinks",c,p,1),c,p,0,1297,1429,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"refinement-box\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-bhw=\"");t.b(t.v(t.f("dataBhw",c,p,0)));t.b("\" data-bh-viewport=\"respect\">");t.b("\n" + i);t.b(t.rp("<nested_links6",c,p,"    "));t.b("  </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {"<reset_filters0":{name:"reset_filters", partials: {}, subs: {  }},"<range_filter1":{name:"range_filter", partials: {}, subs: {  }},"<links_list2":{name:"links_list", partials: {}, subs: {  }},"<available_party_sizes3":{name:"available_party_sizes", partials: {}, subs: {  }},"<available_dates4":{name:"available_dates", partials: {}, subs: {  }},"<available_times5":{name:"available_times", partials: {}, subs: {  }},"<nested_links6":{name:"nested_links", partials: {}, subs: {  }}}, subs: {  }});
    return templates;
})();
},{"hogan.js":102}],94:[function(require,module,exports){
var grpnUiTemplates, localTemplates, name, template;

grpnUiTemplates = require('grpn-ui/templates');

localTemplates = require('../lib/localTemplates');

for (name in grpnUiTemplates) {
  template = grpnUiTemplates[name];
  localTemplates["grpn-ui/" + name] = template;
}

module.exports = localTemplates;

},{"../lib/localTemplates":93,"grpn-ui/templates":100}],95:[function(require,module,exports){
module.exports={"en":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"}}},"de_DE":{"modules":{"refinements":{"afternoon_evening":"Nachmittag und Abend","all":"Alle","all_dates":"Alle Termine","all_party_sizes":"Alle Gruppengrößen","all_times":"Alle Zeiten","apply":"Anwenden","error_invalid_input":"{{selectedBound}} muss {{comparison}} sein als {{otherBound}}","error_nan_input":"Bitte gültige/-s/-n {{input}} eingeben","error_oob_input":"{{bound}} ist {{unit}}{{value}}","morning":"Morgen","party_size_count":{"one":"{{count}} Person","other":"{{count}} Personen"},"party_size_prompt":"Wie viele Personen?","reset":"Reset","reset_all":"Alle zurücksetzen","see_more":"Weitere anzeigen","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"·","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"EUR"}},"es_ES":{"modules":{"refinements":{"afternoon_evening":"Mediodía y Tarde","all":"Todo","all_dates":"Todas las fechas","all_party_sizes":"Todos los tamaños de fiesta","all_times":"Todos los tiempos","apply":"Solicitar","error_invalid_input":"{{selectedBound}} debe ser {{comparison}} que {{otherBoun}}","error_nan_input":"Por favor, introduce un {input}} valor","error_oob_input":"{{bound}} es {{unit}}{{value}}","morning":"Mañana","party_size_count":{"one":"{{count}} Persona","other":"{{count}} Personas"},"party_size_prompt":"¿Cuántas personas?","reset":"Reset","reset_all":"Reiniciar","see_more":"Ver más","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0%"},"defaultCurrency":"EUR"}},"fr_FR":{"modules":{"refinements":{"afternoon_evening":"Après-midi & Soirée","all":"Tout","all_dates":"Toutes les dates","all_party_sizes":"Tout sélectionner","all_times":"Toutes les heures","apply":"Appliquer","error_invalid_input":"{{selectedBound}} doit être {{comparison}} au {{otherBound}}","error_nan_input":"Merci de renseigner un {{input}} valide","error_oob_input":"{{bound}} est de {{unit}}{{value}}","morning":"Matin","party_size_count":{"one":"{{count}} Personne","other":"{{count}} Personnes"},"party_size_prompt":"Combien de personne(s) ?","reset":"Reset","reset_all":"Supprimer les filtres","see_more":"Afficher plus","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"EUR"}},"it_IT":{"modules":{"refinements":{"afternoon_evening":"Pomeriggio e sera","all":"Tutti","all_dates":"Tutte le date","all_party_sizes":"Tutti i gruppi","all_times":"Qualsiasi orario","apply":"Applica","error_invalid_input":"{{selectedBound}} deve essere {{comparison}} di {{otherBound}}","error_nan_input":"Per favore inserisci un {{input}} valido","error_oob_input":"{{bound}} è {{unit}}{{value}}","morning":"Mattino","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"Quante persone?","reset":"Reset","reset_all":"Cancella tutti","see_more":"Vedi più","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.00","percent":"#,##0%"},"defaultCurrency":"EUR"}},"iw_IL":{"modules":{"refinements":{"afternoon_evening":"אחה\"צ & ערב","all":"הכל ","all_dates":"All Dates","all_party_sizes":"כל המידות","all_times":"All Times","apply":"הרשם","error_invalid_input":"{{selectedBound}}  חייב להיות בין {{comparison}} ל  {{otherBound}}","error_nan_input":"אנא הזן  {{input}} תקין","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"בוקר","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"כמה אנשים?","reset":"Reset","reset_all":"התחל ","see_more":"ראה עוד ","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"‎+","minusSign":"‎-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0%"},"defaultCurrency":"ILS"}},"nl_NL":{"modules":{"refinements":{"afternoon_evening":"Middag & avond","all":"Alle","all_dates":"Alle data","all_party_sizes":"Alle groepsgroottes ","all_times":"Alle tijden","apply":"Toepassen","error_invalid_input":"{{selectedBound}} moet {{comparison}} zijn dan {{otherBound}}","error_nan_input":"Voer een geldige {{input}} in","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Ochtend","party_size_count":{"one":"{{count}} persoon","other":"{{count}} personen"},"party_size_prompt":"Hoeveel mensen?","reset":"Reset","reset_all":"Herstel","see_more":"Meer zien","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.00;¤ #,##0.00-","percent":"#,##0%"},"defaultCurrency":"EUR"}},"pl_PL":{"modules":{"refinements":{"afternoon_evening":"Popołudnie i wieczór","all":"Wszystko","all_dates":"Wszystkie daty","all_party_sizes":"Wszystkie rodzaje","all_times":"Cały czas","apply":"Zgłoś się","error_invalid_input":"{{selectedBound}} musi być {{comparison}} niż {{otherBound}}","error_nan_input":"Wprowadź prawidłowy {{input}}","error_oob_input":"{{bound}} jest {{unit}}{{value}}","morning":"Rano","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"Ile osób?","reset":"Reset","reset_all":"Resetuj wszystko","see_more":"Zobacz więcej","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.## ¤;(#,##0.## ¤)","percent":"#,##0%"},"defaultCurrency":"PLN"}},"pt_PT":{"modules":{"refinements":{"afternoon_evening":"Tarde e noite","all":"Tudo","all_dates":"Todas as datas","all_party_sizes":"Grupos de todos os tamanhos","all_times":"Todos os momentos","apply":"Aplicar","error_invalid_input":"{{selectedBound}} deve ser {{comparison}} que {{otherBound}}","error_nan_input":"Por favor insira um {{input}} válido","error_oob_input":"{{bound}} é {{unit}}{{value}}","morning":"Manhã","party_size_count":{"one":"{{count}} pessoa","other":"{{count}} pessoas"},"party_size_prompt":"Quantas pessoas?","reset":"Reset","reset_all":"Redefinir tudo","see_more":"Ver mais","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0%"},"defaultCurrency":"EUR"}},"ar_AE":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"‎+","minusSign":"‎-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.##;¤ #,##0.##-","percent":"#,##0%"},"defaultCurrency":"AED"}},"da_DK":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","DKK":"kr"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"DKK"}},"el_GR":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"Μια θεωρία","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"ισχύουν","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"e","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0%"},"defaultCurrency":"EUR"}},"en_HK":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"HKD"}},"en_ID":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","IDR":"Rs."}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"IDR"}},"en_US":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"USD"}},"en_ZA":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","ZAR":"R"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.00","percent":"#,##0%"},"defaultCurrency":"ZAR"}},"fi_FI":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"−","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"epäluku","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"EUR"}},"id_ID":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"Sebuah teori","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Sepotong daun","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","IDR":"Rs."}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"IDR"}},"ja_JP":{"modules":{"refinements":{"afternoon_evening":"午後および夕方","all":"すべて","all_dates":"全期日","all_party_sizes":"全パーティー規模","all_times":"常時","apply":"適用する","error_invalid_input":"（選択バウンド）は、（他のバウンド）よりも（比較内容）でなければならない。","error_nan_input":"有効な（インプット）を入力して下さい。","error_oob_input":"（バウンド）は（数値）（まで）","morning":"午前","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"人数は？","reset":"Reset","reset_all":"すべてをリセット","see_more":"4日前githubをインポート","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"￥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.##","percent":"#,##0%"},"defaultCurrency":"JPY"}},"no_NO":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"−","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","NOK":"kr"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"NOK"}},"ru_RU":{"modules":{"refinements":{"afternoon_evening":"День и вечер","all":"Все","all_dates":"Все даты","all_party_sizes":"Любое количество","all_times":"Любое время суток","apply":"Применить","error_invalid_input":"{{selectedBound}} должно быть {{comparison}} чем {{otherBound}}","error_nan_input":"Введите корректный {{input}}","error_oob_input":"{{bound}} {{unit}}{{value}}","morning":"Утро","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"Сколько человек?","reset":"Reset","reset_all":"Сбросить","see_more":"Подробнее","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"не число","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","RUB":"р."}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"RUB"}},"sv_SE":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"−","exponential":"×10^","superscriptingExponent":"·","perMille":"‰","infinity":"∞","nan":"¤¤¤","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","SEK":"kr"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"SEK"}},"th_TH":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"ทฤษฎี","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"ชิ้นส่วนของใบ","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"THB"}},"tr_TR":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"bir teori","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Yapraklar bir parça","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"TL","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"%#,##0"},"defaultCurrency":"TRY"}},"zh_HK":{"modules":{"refinements":{"afternoon_evening":"下午及晚上","all":"全部","all_dates":"所有日子","all_party_sizes":"所有派對人數","all_times":"所有時間","apply":"應用","error_invalid_input":"{{selectedBound}} 須 {{comparison}} 過 {{otherBound}}","error_nan_input":"請輸入有效 {{input}}","error_oob_input":"{{bound}} 是 {{unit}}{{value}}","morning":"早上","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"多少人？","reset":"Reset","reset_all":"全部重置","see_more":"查看更多","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"HKD"}},"en_GB":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"GBP"}},"es_MX":{"modules":{"refinements":{"afternoon_evening":"Mediodía y Tarde","all":"Todo","all_dates":"Todas las fechas","all_party_sizes":"Todos los tamaños de fiesta","all_times":"Todos los tiempos","apply":"Solicitar","error_invalid_input":"{{selectedBound}} debe ser {{comparison}} que {{otherBoun}}","error_nan_input":"Por favor, introduce un {input}} valor","error_oob_input":"{{bound}} es {{unit}}{{value}}","morning":"Mañana","party_size_count":{"one":"{{count}} Persona","other":"{{count}} Personas"},"party_size_prompt":"¿Cuántas personas?","reset":"Reset","reset_all":"Reiniciar","see_more":"Ver más","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"MXN"}},"pt_BR":{"modules":{"refinements":{"afternoon_evening":"Tarde e noite","all":"Tudo","all_dates":"Todas as datas","all_party_sizes":"Grupos de todos os tamanhos","all_times":"Todos os momentos","apply":"Aplicar","error_invalid_input":"{{selectedBound}} deve ser {{comparison}} que {{otherBound}}","error_nan_input":"Por favor insira um {{input}} válido","error_oob_input":"{{bound}} é {{unit}}{{value}}","morning":"Manhã","party_size_count":{"one":"{{count}} pessoa","other":"{{count}} pessoas"},"party_size_prompt":"Quantas pessoas?","reset":"Reset","reset_all":"Redefinir tudo","see_more":"Ver mais","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"BRL"}},"de_AT":{"modules":{"refinements":{"afternoon_evening":"Nachmittag und Abend","all":"Alle","all_dates":"Alle Termine","all_party_sizes":"Alle Gruppengrößen","all_times":"Alle Zeiten","apply":"Anwenden","error_invalid_input":"{{selectedBound}} muss {{comparison}} sein als {{otherBound}}","error_nan_input":"Bitte gültige/-s/-n {{input}} eingeben","error_oob_input":"{{bound}} ist {{unit}}{{value}}","morning":"Morgen","party_size_count":{"one":"{{count}} Person","other":"{{count}} Personen"},"party_size_prompt":"Wie viele Personen?","reset":"Reset","reset_all":"Alle zurücksetzen","see_more":"Weitere anzeigen","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"·","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.00","percent":"#,##0 %"},"defaultCurrency":"EUR"}},"de_CH":{"modules":{"refinements":{"afternoon_evening":"Nachmittag und Abend","all":"Alle","all_dates":"Alle Termine","all_party_sizes":"Alle Gruppengrößen","all_times":"Alle Zeiten","apply":"Anwenden","error_invalid_input":"{{selectedBound}} muss {{comparison}} sein als {{otherBound}}","error_nan_input":"Bitte gültige/-s/-n {{input}} eingeben","error_oob_input":"{{bound}} ist {{unit}}{{value}}","morning":"Morgen","party_size_count":{"one":"{{count}} Person","other":"{{count}} Personen"},"party_size_prompt":"Wie viele Personen?","reset":"Reset","reset_all":"Alle zurücksetzen","see_more":"Weitere anzeigen","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":"'","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"·","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.00;¤-#,##0.00","percent":"#,##0 %"},"defaultCurrency":"CHF"}},"en_CA":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"CAD"}},"en_PH":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"PHP"}},"fr_BE":{"modules":{"refinements":{"afternoon_evening":"Après-midi & Soirée","all":"Tout","all_dates":"Toutes les dates","all_party_sizes":"Tout sélectionner","all_times":"Toutes les heures","apply":"Appliquer","error_invalid_input":"{{selectedBound}} doit être {{comparison}} au {{otherBound}}","error_nan_input":"Merci de renseigner un {{input}} valide","error_oob_input":"{{bound}} est de {{unit}}{{value}}","morning":"Matin","party_size_count":{"one":"{{count}} Personne","other":"{{count}} Personnes"},"party_size_prompt":"Combien de personne(s) ?","reset":"Reset","reset_all":"Supprimer les filtres","see_more":"Afficher plus","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"EUR"}},"fr_CA":{"modules":{"refinements":{"afternoon_evening":"Après-midi & Soirée","all":"Tout","all_dates":"Toutes les dates","all_party_sizes":"Tout sélectionner","all_times":"Toutes les heures","apply":"Appliquer","error_invalid_input":"{{selectedBound}} doit être {{comparison}} au {{otherBound}}","error_nan_input":"Merci de renseigner un {{input}} valide","error_oob_input":"{{bound}} est de {{unit}}{{value}}","morning":"Matin","party_size_count":{"one":"{{count}} Personne","other":"{{count}} Personnes"},"party_size_prompt":"Combien de personne(s) ?","reset":"Reset","reset_all":"Supprimer les filtres","see_more":"Afficher plus","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"CAD"}},"fr_CH":{"modules":{"refinements":{"afternoon_evening":"Après-midi & Soirée","all":"Tout","all_dates":"Toutes les dates","all_party_sizes":"Tout sélectionner","all_times":"Toutes les heures","apply":"Appliquer","error_invalid_input":"{{selectedBound}} doit être {{comparison}} au {{otherBound}}","error_nan_input":"Merci de renseigner un {{input}} valide","error_oob_input":"{{bound}} est de {{unit}}{{value}}","morning":"Matin","party_size_count":{"one":"{{count}} Personne","other":"{{count}} Personnes"},"party_size_prompt":"Combien de personne(s) ?","reset":"Reset","reset_all":"Supprimer les filtres","see_more":"Afficher plus","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":"'","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.00;¤-#,##0.00","percent":"#,##0 %"},"defaultCurrency":"CHF"}},"fr_MA":{"modules":{"refinements":{"afternoon_evening":"Après-midi & Soirée","all":"Tout","all_dates":"Toutes les dates","all_party_sizes":"Tout sélectionner","all_times":"Toutes les heures","apply":"Appliquer","error_invalid_input":"{{selectedBound}} doit être {{comparison}} au {{otherBound}}","error_nan_input":"Merci de renseigner un {{input}} valide","error_oob_input":"{{bound}} est de {{unit}}{{value}}","morning":"Matin","party_size_count":{"one":"{{count}} Personne","other":"{{count}} Personnes"},"party_size_prompt":"Combien de personne(s) ?","reset":"Reset","reset_all":"Supprimer les filtres","see_more":"Afficher plus","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","MAD":"Dhs"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.## ¤;(#,##0.## ¤)","percent":"#,##0 %"},"defaultCurrency":"MAD"}},"nl_BE":{"modules":{"refinements":{"afternoon_evening":"Middag & avond","all":"Alle","all_dates":"Alle data","all_party_sizes":"Alle groepsgroottes ","all_times":"Alle tijden","apply":"Toepassen","error_invalid_input":"{{selectedBound}} moet {{comparison}} zijn dan {{otherBound}}","error_nan_input":"Voer een geldige {{input}} in","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Ochtend","party_size_count":{"one":"{{count}} persoon","other":"{{count}} personen"},"party_size_prompt":"Hoeveel mensen?","reset":"Reset","reset_all":"Herstel","see_more":"Meer zien","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0%"},"defaultCurrency":"EUR"}},"ru_UA":{"modules":{"refinements":{"afternoon_evening":"День и вечер","all":"Все","all_dates":"Все даты","all_party_sizes":"Любое количество","all_times":"Любое время суток","apply":"Применить","error_invalid_input":"{{selectedBound}} должно быть {{comparison}} чем {{otherBound}}","error_nan_input":"Введите корректный {{input}}","error_oob_input":"{{bound}} {{unit}}{{value}}","morning":"Утро","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"Сколько человек?","reset":"Reset","reset_all":"Сбросить","see_more":"Подробнее","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"не число","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","RUB":"р."}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"UAH"}},"zh_TW":{"modules":{"refinements":{"afternoon_evening":"下午及晚上","all":"全部","all_dates":"所有日子","all_party_sizes":"所有派對人數","all_times":"所有時間","apply":"應用","error_invalid_input":"{{selectedBound}} 須 {{comparison}} 過 {{otherBound}}","error_nan_input":"請輸入有效 {{input}}","error_oob_input":"{{bound}} 是 {{unit}}{{value}}","morning":"早上","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"多少人？","reset":"Reset","reset_all":"全部重置","see_more":"查看更多","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00;(¤#,##0.00)","percent":"#,##0%"},"defaultCurrency":"TWD"}},"en_AE":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"‎+","minusSign":"‎-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.##;¤ #,##0.##-","percent":"#,##0%"},"defaultCurrency":"AED"}},"en_AU":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"AUD"}},"en_CH":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":"'","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"CHF"}},"en_IE":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"EUR"}},"en_IN":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##,##0.###","currency":"¤ #,##,##0.00","percent":"#,##,##0%"},"defaultCurrency":"INR"}},"en_MY":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","MYR":"RM"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"MYR"}},"en_NZ":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"NZD"}},"en_SG":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"S$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"SGD"}},"en_TH":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"THB"}},"es_AR":{"modules":{"refinements":{"afternoon_evening":"Mediodía y Tarde","all":"Todo","all_dates":"Todas las fechas","all_party_sizes":"Todos los tamaños de fiesta","all_times":"Todos los tiempos","apply":"Solicitar","error_invalid_input":"{{selectedBound}} debe ser {{comparison}} que {{otherBoun}}","error_nan_input":"Por favor, introduce un {input}} valor","error_oob_input":"{{bound}} es {{unit}}{{value}}","morning":"Mañana","party_size_count":{"one":"{{count}} Persona","other":"{{count}} Personas"},"party_size_prompt":"¿Cuántas personas?","reset":"Reset","reset_all":"Reiniciar","see_more":"Ver más","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"ARS"}},"es_CO":{"modules":{"refinements":{"afternoon_evening":"Mediodía y Tarde","all":"Todo","all_dates":"Todas las fechas","all_party_sizes":"Todos los tamaños de fiesta","all_times":"Todos los tiempos","apply":"Solicitar","error_invalid_input":"{{selectedBound}} debe ser {{comparison}} que {{otherBoun}}","error_nan_input":"Por favor, introduce un {input}} valor","error_oob_input":"{{bound}} es {{unit}}{{value}}","morning":"Mañana","party_size_count":{"one":"{{count}} Persona","other":"{{count}} Personas"},"party_size_prompt":"¿Cuántas personas?","reset":"Reset","reset_all":"Reiniciar","see_more":"Ver más","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.##","percent":"#,##0%"},"defaultCurrency":"COP"}},"es_PE":{"modules":{"refinements":{"afternoon_evening":"Mediodía y Tarde","all":"Todo","all_dates":"Todas las fechas","all_party_sizes":"Todos los tamaños de fiesta","all_times":"Todos los tiempos","apply":"Solicitar","error_invalid_input":"{{selectedBound}} debe ser {{comparison}} que {{otherBoun}}","error_nan_input":"Por favor, introduce un {input}} valor","error_oob_input":"{{bound}} es {{unit}}{{value}}","morning":"Mañana","party_size_count":{"one":"{{count}} Persona","other":"{{count}} Personas"},"party_size_prompt":"¿Cuántas personas?","reset":"Reset","reset_all":"Reiniciar","see_more":"Ver más","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","PEN":"S/."}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"PEN"}},"es_CL":{"modules":{"refinements":{"afternoon_evening":"Mediodía y Tarde","all":"Todo","all_dates":"Todas las fechas","all_party_sizes":"Todos los tamaños de fiesta","all_times":"Todos los tiempos","apply":"Solicitar","error_invalid_input":"{{selectedBound}} debe ser {{comparison}} que {{otherBoun}}","error_nan_input":"Por favor, introduce un {input}} valor","error_oob_input":"{{bound}} es {{unit}}{{value}}","morning":"Mañana","party_size_count":{"one":"{{count}} Persona","other":"{{count}} Personas"},"party_size_prompt":"¿Cuántas personas?","reset":"Reset","reset_all":"Reiniciar","see_more":"Ver más","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.##;¤-#,##0.##","percent":"#,##0%"},"defaultCurrency":"CLP"}},"es_PR":{"modules":{"refinements":{"afternoon_evening":"Mediodía y Tarde","all":"Todo","all_dates":"Todas las fechas","all_party_sizes":"Todos los tamaños de fiesta","all_times":"Todos los tiempos","apply":"Solicitar","error_invalid_input":"{{selectedBound}} debe ser {{comparison}} que {{otherBoun}}","error_nan_input":"Por favor, introduce un {input}} valor","error_oob_input":"{{bound}} es {{unit}}{{value}}","morning":"Mañana","party_size_count":{"one":"{{count}} Persona","other":"{{count}} Personas"},"party_size_prompt":"¿Cuántas personas?","reset":"Reset","reset_all":"Reiniciar","see_more":"Ver más","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"USD"}},"es_PA":{"modules":{"refinements":{"afternoon_evening":"Mediodía y Tarde","all":"Todo","all_dates":"Todas las fechas","all_party_sizes":"Todos los tamaños de fiesta","all_times":"Todos los tiempos","apply":"Solicitar","error_invalid_input":"{{selectedBound}} debe ser {{comparison}} que {{otherBoun}}","error_nan_input":"Por favor, introduce un {input}} valor","error_oob_input":"{{bound}} es {{unit}}{{value}}","morning":"Mañana","party_size_count":{"one":"{{count}} Persona","other":"{{count}} Personas"},"party_size_prompt":"¿Cuántas personas?","reset":"Reset","reset_all":"Reiniciar","see_more":"Ver más","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","PAB":"B/."}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0%"},"defaultCurrency":"USD"}},"es_UY":{"modules":{"refinements":{"afternoon_evening":"Mediodía y Tarde","all":"Todo","all_dates":"Todas las fechas","all_party_sizes":"Todos los tamaños de fiesta","all_times":"Todos los tiempos","apply":"Solicitar","error_invalid_input":"{{selectedBound}} debe ser {{comparison}} que {{otherBoun}}","error_nan_input":"Por favor, introduce un {input}} valor","error_oob_input":"{{bound}} es {{unit}}{{value}}","morning":"Mañana","party_size_count":{"one":"{{count}} Persona","other":"{{count}} Personas"},"party_size_prompt":"¿Cuántas personas?","reset":"Reset","reset_all":"Reiniciar","see_more":"Ver más","selected_filters":"Selected Filters"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.00","percent":"#,##0%"},"defaultCurrency":"UYU"}}}
},{}],96:[function(require,module,exports){
'use strict';
var ARROW_BUFFER_HEIGHT, CoachMark, _,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

_ = require('lodash');

ARROW_BUFFER_HEIGHT = 10;

module.exports = CoachMark = (function(superClass) {
  extend(CoachMark, superClass);

  function CoachMark() {
    return CoachMark.__super__.constructor.apply(this, arguments);
  }

  CoachMark.SELECTOR = '.grpn-ui.coach-mark';

  CoachMark.prototype.events = {
    'click .dismiss': '_dismiss'
  };

  CoachMark.prototype.initialize = function() {
    return $('body').on('click', (function(_this) {
      return function(event) {
        return _this._dismissOnClickOut(event);
      };
    })(this));
  };

  CoachMark.prototype._dismiss = function(event) {
    if (event != null) {
      event.stopPropagation();
    }
    return this.$el.hide();
  };

  CoachMark.prototype._dismissOnClickOut = function(event) {
    if ($.contains(this.el, event.target)) {
      return;
    }
    return this._dismiss(event);
  };

  return CoachMark;

})(Backbone.View);

},{"lodash":105}],97:[function(require,module,exports){
'use strict';
var DAYS, DatePicker, MONTH_NAMES, _, i, moment, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

moment = require('moment');

_ = require('lodash');

MONTH_NAMES = (function() {
  var j, results;
  results = [];
  for (i = j = 0; j <= 11; i = ++j) {
    results.push(moment().month(i).format('MMMM'));
  }
  return results;
})();

DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

templates = require('../../lib/templates');

module.exports = DatePicker = (function(superClass) {
  extend(DatePicker, superClass);

  function DatePicker() {
    return DatePicker.__super__.constructor.apply(this, arguments);
  }

  DatePicker.SELECTOR = '.grpn-ui.date-picker';

  DatePicker.prototype.events = {
    'click [data-control="next"]': '_navigateNextMonth',
    'click [data-control="prev"]': '_navigatePrevMonth',
    'click .date': '_dateSelected',
    'click': '_keepOpen'
  };

  DatePicker.prototype.initialize = function() {
    var x;
    this.monthDays = (function() {
      var j, k, ref, results, results1;
      results = [];
      for (x = j = 0; j <= 11; x = ++j) {
        results.push((function() {
          results1 = [];
          for (var k = 1, ref = this._lastDate(x); 1 <= ref ? k <= ref : k >= ref; 1 <= ref ? k++ : k--){ results1.push(k); }
          return results1;
        }).apply(this));
      }
      return results;
    }).call(this);
    this.currentMonth = [this.model.earliestDate.year(), this.model.earliestDate.month()];
    this.currentValue = this.defaultValue = this.model.defaultValue;
    this._initView();
    this._updateCalendar.apply(this, this.currentMonth);
    return this._updateControls();
  };

  DatePicker.prototype.value = function() {
    return this.currentValue;
  };

  DatePicker.prototype.reset = function() {
    this.currentMonth = [this.model.earliestDate.year(), this.model.earliestDate.month()];
    this._updateCalendar.apply(this, this.currentMonth);
    this.currentValue = this.model.defaultValue;
    return this._updateControls();
  };

  DatePicker.prototype.resetToSelected = function() {
    this.currentMonth = [this.currentValue.year(), this.currentValue.month()];
    this._updateCalendar.apply(this, this.currentMonth);
    return this._updateControls();
  };

  DatePicker.prototype._isNonEmptyArray = function(obj) {
    return _.isArray(obj) && obj.length > 0;
  };

  DatePicker.prototype._initView = function() {
    this.$header = this.$('.calendar-header');
    this.$daysContainer = this.$('.days');
    return this.$controls = this.$('.controls');
  };

  DatePicker.prototype._updateCalendar = function(year, month) {
    var j, len, ref, results, x;
    this.$header.find('.month-name').text(MONTH_NAMES[month] + " " + year);
    this.$daysContainer.text('');
    ref = this.monthDays[month];
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      x = ref[j];
      results.push(this._createDate(year, month, x));
    }
    return results;
  };

  DatePicker.prototype._lastDate = function(month) {
    return moment().month(month).endOf('month').date();
  };

  DatePicker.prototype._createDate = function(year, month, day) {
    var date, dayHash;
    if (year == null) {
      year = moment().year();
    }
    date = moment([year, month, day]);
    dayHash = {
      day: day,
      dayName: DAYS[date.day()],
      date: date.format('YYYY-MM-DD'),
      selectable: this._isSelectableDate(date),
      selected: date.isSame(this.currentValue)
    };
    return this.$daysContainer.append(templates['date-picker/day'].render(dayHash));
  };

  DatePicker.prototype._isSelectableDate = function(date) {
    var activeDates;
    if (!this._inDateRange(date)) {
      return false;
    }
    activeDates = this.model.activeDates;
    if (this._isNonEmptyArray(activeDates)) {
      return _.some(activeDates, function(d) {
        return d.isSame(date, 'day');
      });
    }
    return true;
  };

  DatePicker.prototype._inDateRange = function(date) {
    if (date.isSame(this.model.earliestDate, 'day')) {
      return true;
    }
    return date.isBetween(this.model.earliestDate, this.model.latestDate);
  };

  DatePicker.prototype._navigateNextMonth = function(e) {
    if (!this.$('[data-control="next"]').hasClass('icon-arrow-right-large')) {
      return;
    }
    if (e != null) {
      e.stopPropagation();
    }
    return this._navigateMonth(1);
  };

  DatePicker.prototype._navigatePrevMonth = function(e) {
    if (!this.$('[data-control="prev"]').hasClass('icon-arrow-left-large')) {
      return;
    }
    if (e != null) {
      e.stopPropagation();
    }
    return this._navigateMonth(-1);
  };

  DatePicker.prototype._navigateMonth = function(offset) {
    var month;
    month = moment(this.currentMonth);
    month.add(offset, 'month');
    this.currentMonth = [month.year(), month.month()];
    this._updateCalendar.apply(this, this.currentMonth);
    return this._updateControls();
  };

  DatePicker.prototype._updateControls = function() {
    var hideNext, hidePrev, month;
    month = moment(this.currentMonth);
    hideNext = !month.add(1, 'month').isAfter(this.model.latestDate);
    hidePrev = !month.subtract(1, 'month').isBefore(this.model.earliestDate);
    this.$('[data-control="next"]').toggleClass('icon-arrow-right-large', hideNext);
    return this.$('[data-control="prev"]').toggleClass('icon-arrow-left-large', hidePrev);
  };

  DatePicker.prototype._keepOpen = function(ev) {
    return ev.stopPropagation();
  };

  DatePicker.prototype._dateSelected = function(ev) {
    var date;
    ev.stopPropagation();
    date = this.$(ev.currentTarget).data('date');
    date = moment(date, 'YYYY-MM-DD');
    if (!this._isSelectableDate(date)) {
      return;
    }
    this.$(ev.currentTarget).parent().find('.selected').removeClass('selected');
    this.$(ev.currentTarget).addClass('selected');
    this.currentValue = date;
    return this.trigger('change', date);
  };

  return DatePicker;

})(Backbone.View);

},{"../../lib/templates":99,"lodash":105,"moment":106}],98:[function(require,module,exports){
'use strict';
var CoachMark, DatePicker;

DatePicker = require('./date-picker');

CoachMark = require('./coach-mark');

module.exports = window.GrpnUI = {
  initCoachMarks: function(element) {
    var el, i, len, ref, results;
    if (element == null) {
      element = 'body';
    }
    ref = $(element).find(CoachMark.SELECTOR);
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      el = ref[i];
      results.push(new CoachMark({
        el: el
      }));
    }
    return results;
  },
  initDatePicker: function(element, options) {
    if (options == null) {
      options = {};
    }
    options.el = $(element).find(DatePicker.SELECTOR).get(0);
    return new DatePicker(options);
  }
};

},{"./coach-mark":96,"./date-picker":97}],99:[function(require,module,exports){
module.exports = (function() {
    var Hogan = require('hogan.js');
    var templates = {};
    templates['coach-mark'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"grpn-ui coach-mark\" data-selector=\"");t.b(t.v(t.f("selector",c,p,0)));t.b("\" data-position=\"");t.b(t.v(t.f("position",c,p,0)));t.b("\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("  <div class=\"description\">");t.b(t.t(t.f("description",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("  <div class=\"dismiss\">");t.b(t.t(t.f("dismiss",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['date-picker/day'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"date ");t.b(t.v(t.f("dayName",c,p,0)));t.b(" ");if(t.s(t.f("selectable",c,p,1),c,p,0,44,54,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("selectable");});c.pop();}t.b(" ");if(t.s(t.f("selected",c,p,1),c,p,0,83,91,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("selected");});c.pop();}t.b("\" data-date=\"");t.b(t.v(t.f("date",c,p,0)));t.b("\">");t.b("\n" + i);t.b("  ");t.b(t.v(t.f("day",c,p,0)));t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }});
    templates['date-picker'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"grpn-ui date-picker ");t.b(t.v(t.f("datePickerClasses",c,p,0)));t.b("\">");t.b("\n" + i);t.b("  <div class=\"calendar-header\">");t.b("\n" + i);t.b("    <div class=\"control icon-arrow-left-large\" data-control=\"prev\">&nbsp;</div>");t.b("\n" + i);t.b("    <div class=\"month-name\"></div>");t.b("\n" + i);t.b("    <div class=\"control icon-arrow-right-large\" data-control=\"next\">&nbsp;</div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("  <div class=\"day-labels\">");t.b("\n" + i);t.b("    <div class=\"day\">S</div>");t.b("\n" + i);t.b("    <div class=\"day\">M</div>");t.b("\n" + i);t.b("    <div class=\"day\">T</div>");t.b("\n" + i);t.b("    <div class=\"day\">W</div>");t.b("\n" + i);t.b("    <div class=\"day\">T</div>");t.b("\n" + i);t.b("    <div class=\"day\">F</div>");t.b("\n" + i);t.b("    <div class=\"day\">S</div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("  <div class=\"days\"></div>");t.b("\n" + i);t.b("  <div class=\"controls\"></div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    return templates;
})();
},{"hogan.js":102}],100:[function(require,module,exports){
// This file exists so that compiled templates can be required
// separately from the front end code
module.exports = require('./lib/templates');

},{"./lib/templates":99}],101:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline =  /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      rLineSep = /\u2028/,
      rParagraphSep = /\u2029/;

  Hogan.tags = {
    '#': 1, '^': 2, '<': 3, '$': 4,
    '/': 5, '!': 6, '>': 7, '=': 8, '_v': 9,
    '{': 10, '&': 11, '_t': 12
  };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push({tag: '_t', text: new String(buf)});
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;
      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace =
          (Hogan.tags[tokens[j].tag] < Hogan.tags['_v']) ||
          (tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null);
        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (tokens[j].text) {
            if ((next = tokens[j+1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].text.toString()
            }
            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({tag:'\n'});
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(
            text.substring(text.indexOf('=', index) + 1, closeIndex)
          ).split(' ');

      otag = delimiters[0];
      ctag = delimiters[delimiters.length - 1];

      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = Hogan.tags[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';
        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }
          state = IN_TAG;
        }
        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
                       i: (tagType == '/') ? seenTag - otag.length : i + ctag.length});
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;
          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);

    return tokens;
  }

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  }

  // the tags allowed inside super templates
  var allowedInSuper = {'_t': true, '\n': true, '$': true, '/': true};

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        tail = null,
        token = null;

    tail = stack[stack.length - 1];

    while (tokens.length > 0) {
      token = tokens.shift();

      if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) {
        throw new Error('Illegal content in < super tag.');
      }

      if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }
        opener = stack.pop();
        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }
        opener.end = token.i;
        return instructions;
      } else if (token.tag == '\n') {
        token.last = (tokens.length == 0) || (tokens[0].tag == '\n');
      }

      instructions.push(token);
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  function stringifySubstitutions(obj) {
    var items = [];
    for (var key in obj) {
      items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
    }
    return "{ " + items.join(",") + " }";
  }

  function stringifyPartials(codeObj) {
    var partials = [];
    for (var key in codeObj.partials) {
      partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
    }
    return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
  }

  Hogan.stringify = function(codeObj, text, options) {
    return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) +  "}";
  }

  var serialNo = 0;
  Hogan.generate = function(tree, text, options) {
    serialNo = 0;
    var context = { code: '', subs: {}, partials: {} };
    Hogan.walk(tree, context);

    if (options.asString) {
      return this.stringify(context, text, options);
    }

    return this.makeTemplate(context, text, options);
  }

  Hogan.wrapMain = function(code) {
    return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
  }

  Hogan.template = Hogan.Template;

  Hogan.makeTemplate = function(codeObj, text, options) {
    var template = this.makePartials(codeObj);
    template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
    return new this.template(template, text, this, options);
  }

  Hogan.makePartials = function(codeObj) {
    var key, template = {subs: {}, partials: codeObj.partials, name: codeObj.name};
    for (key in template.partials) {
      template.partials[key] = this.makePartials(template.partials[key]);
    }
    for (key in codeObj.subs) {
      template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
    }
    return template;
  }

  function esc(s) {
    return s.replace(rSlash, '\\\\')
            .replace(rQuot, '\\\"')
            .replace(rNewline, '\\n')
            .replace(rCr, '\\r')
            .replace(rLineSep, '\\u2028')
            .replace(rParagraphSep, '\\u2029');
  }

  function chooseMethod(s) {
    return (~s.indexOf('.')) ? 'd' : 'f';
  }

  function createPartial(node, context) {
    var prefix = "<" + (context.prefix || "");
    var sym = prefix + node.n + serialNo++;
    context.partials[sym] = {name: node.n, partials: {}};
    context.code += 't.b(t.rp("' +  esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
    return sym;
  }

  Hogan.codegen = {
    '#': function(node, context) {
      context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' +
                      'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' +
                      't.rs(c,p,' + 'function(c,p,t){';
      Hogan.walk(node.nodes, context);
      context.code += '});c.pop();}';
    },

    '^': function(node, context) {
      context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
      Hogan.walk(node.nodes, context);
      context.code += '};';
    },

    '>': createPartial,
    '<': function(node, context) {
      var ctx = {partials: {}, code: '', subs: {}, inPartial: true};
      Hogan.walk(node.nodes, ctx);
      var template = context.partials[createPartial(node, context)];
      template.subs = ctx.subs;
      template.partials = ctx.partials;
    },

    '$': function(node, context) {
      var ctx = {subs: {}, code: '', partials: context.partials, prefix: node.n};
      Hogan.walk(node.nodes, ctx);
      context.subs[node.n] = ctx.code;
      if (!context.inPartial) {
        context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
      }
    },

    '\n': function(node, context) {
      context.code += write('"\\n"' + (node.last ? '' : ' + i'));
    },

    '_v': function(node, context) {
      context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    },

    '_t': function(node, context) {
      context.code += write('"' + esc(node.text) + '"');
    },

    '{': tripleStache,

    '&': tripleStache
  }

  function tripleStache(node, context) {
    context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
  }

  function write(s) {
    return 't.b(' + s + ');';
  }

  Hogan.walk = function(nodelist, context) {
    var func;
    for (var i = 0, l = nodelist.length; i < l; i++) {
      func = Hogan.codegen[nodelist[i].tag];
      func && func(nodelist[i], context);
    }
    return context;
  }

  Hogan.parse = function(tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  }

  Hogan.cache = {};

  Hogan.cacheKey = function(text, options) {
    return [text, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join('||');
  }

  Hogan.compile = function(text, options) {
    options = options || {};
    var key = Hogan.cacheKey(text, options);
    var template = this.cache[key];

    if (template) {
      var partials = template.partials;
      for (var name in partials) {
        delete partials[name].instance;
      }
      return template;
    }

    template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = template;
  }
})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],102:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

// This file is for use with Node.js. See dist/ for browser files.

var Hogan = require('./compiler');
Hogan.Template = require('./template').Template;
Hogan.template = Hogan.Template;
module.exports = Hogan;

},{"./compiler":101,"./template":103}],103:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

var Hogan = {};

(function (Hogan) {
  Hogan.Template = function (codeObj, text, compiler, options) {
    codeObj = codeObj || {};
    this.r = codeObj.code || this.r;
    this.c = compiler;
    this.options = options || {};
    this.text = text || '';
    this.partials = codeObj.partials || {};
    this.subs = codeObj.subs || {};
    this.buf = '';
  }

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function (context, partials, indent) { return ''; },

    // variable escaping
    v: hoganEscape,

    // triple stache
    t: coerceToString,

    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },

    // render internal -- a hook for overrides that catches partials too
    ri: function (context, partials, indent) {
      return this.r(context, partials, indent);
    },

    // ensurePartial
    ep: function(symbol, partials) {
      var partial = this.partials[symbol];

      // check to see that if we've instantiated this partial before
      var template = partials[partial.name];
      if (partial.instance && partial.base == template) {
        return partial.instance;
      }

      if (typeof template == 'string') {
        if (!this.c) {
          throw new Error("No compiler available.");
        }
        template = this.c.compile(template, this.options);
      }

      if (!template) {
        return null;
      }

      // We use this to check whether the partials dictionary has changed
      this.partials[symbol].base = template;

      if (partial.subs) {
        // Make sure we consider parent template now
        if (!partials.stackText) partials.stackText = {};
        for (key in partial.subs) {
          if (!partials.stackText[key]) {
            partials.stackText[key] = (this.activeSub !== undefined && partials.stackText[this.activeSub]) ? partials.stackText[this.activeSub] : this.text;
          }
        }
        template = createSpecializedPartial(template, partial.subs, partial.partials,
          this.stackSubs, this.stackPartials, partials.stackText);
      }
      this.partials[symbol].instance = template;

      return template;
    },

    // tries to find a partial in the current scope and render it
    rp: function(symbol, context, partials, indent) {
      var partial = this.ep(symbol, partials);
      if (!partial) {
        return '';
      }

      return partial.ri(context, partials, indent);
    },

    // render a section
    rs: function(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },

    // maybe start a section
    s: function(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ms(val, ctx, partials, inverted, start, end, tags);
      }

      pass = !!val;

      if (!inverted && pass && ctx) {
        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },

    // find values with dotted names
    d: function(key, ctx, partials, returnFound) {
      var found,
          names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          doModelGet = this.options.modelGet,
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        val = ctx[ctx.length - 1];
      } else {
        for (var i = 1; i < names.length; i++) {
          found = findInScope(names[i], val, doModelGet);
          if (found !== undefined) {
            cx = val;
            val = found;
          } else {
            val = '';
          }
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.mv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },

    // find values with normal names
    f: function(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false,
          doModelGet = this.options.modelGet;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        val = findInScope(key, v, doModelGet);
        if (val !== undefined) {
          found = true;
          break;
        }
      }

      if (!found) {
        return (returnFound) ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.mv(val, ctx, partials);
      }

      return val;
    },

    // higher order templates
    ls: function(func, cx, partials, text, tags) {
      var oldTags = this.options.delimiters;

      this.options.delimiters = tags;
      this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
      this.options.delimiters = oldTags;

      return false;
    },

    // compile text
    ct: function(text, cx, partials) {
      if (this.options.disableLambda) {
        throw new Error('Lambda features disabled.');
      }
      return this.c.compile(text, this.options).render(cx, partials);
    },

    // template result buffering
    b: function(s) { this.buf += s; },

    fl: function() { var r = this.buf; this.buf = ''; return r; },

    // method replace section
    ms: function(func, ctx, partials, inverted, start, end, tags) {
      var textSource,
          cx = ctx[ctx.length - 1],
          result = func.call(cx);

      if (typeof result == 'function') {
        if (inverted) {
          return true;
        } else {
          textSource = (this.activeSub && this.subsText && this.subsText[this.activeSub]) ? this.subsText[this.activeSub] : this.text;
          return this.ls(result, cx, partials, textSource.substring(start, end), tags);
        }
      }

      return result;
    },

    // method replace variable
    mv: function(func, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = func.call(cx);

      if (typeof result == 'function') {
        return this.ct(coerceToString(result.call(cx)), cx, partials);
      }

      return result;
    },

    sub: function(name, context, partials, indent) {
      var f = this.subs[name];
      if (f) {
        this.activeSub = name;
        f(context, partials, this, indent);
        this.activeSub = false;
      }
    }

  };

  //Find a key in an object
  function findInScope(key, scope, doModelGet) {
    var val;

    if (scope && typeof scope == 'object') {

      if (scope[key] !== undefined) {
        val = scope[key];

      // try lookup with get for backbone or similar model data
      } else if (doModelGet && scope.get && typeof scope.get == 'function') {
        val = scope.get(key);
      }
    }

    return val;
  }

  function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
    function PartialTemplate() {};
    PartialTemplate.prototype = instance;
    function Substitutions() {};
    Substitutions.prototype = instance.subs;
    var key;
    var partial = new PartialTemplate();
    partial.subs = new Substitutions();
    partial.subsText = {};  //hehe. substext.
    partial.buf = '';

    stackSubs = stackSubs || {};
    partial.stackSubs = stackSubs;
    partial.subsText = stackText;
    for (key in subs) {
      if (!stackSubs[key]) stackSubs[key] = subs[key];
    }
    for (key in stackSubs) {
      partial.subs[key] = stackSubs[key];
    }

    stackPartials = stackPartials || {};
    partial.stackPartials = stackPartials;
    for (key in partials) {
      if (!stackPartials[key]) stackPartials[key] = partials[key];
    }
    for (key in stackPartials) {
      partial.partials[key] = stackPartials[key];
    }

    return partial;
  }

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos = /\'/g,
      rQuot = /\"/g,
      hChars = /[&<>\"\']/;

  function coerceToString(val) {
    return String((val === null || val === undefined) ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ?
      str
        .replace(rAmp, '&amp;')
        .replace(rLt, '&lt;')
        .replace(rGt, '&gt;')
        .replace(rApos, '&#39;')
        .replace(rQuot, '&quot;') :
      str;
  }

  var isArray = Array.isArray || function(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };

})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],104:[function(require,module,exports){
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}

},{}],105:[function(require,module,exports){
(function (global){
/**
 * @license
 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern -d -o ./index.js`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '3.10.1';

  /** Used to compose bitmasks for wrapper metadata. */
  var BIND_FLAG = 1,
      BIND_KEY_FLAG = 2,
      CURRY_BOUND_FLAG = 4,
      CURRY_FLAG = 8,
      CURRY_RIGHT_FLAG = 16,
      PARTIAL_FLAG = 32,
      PARTIAL_RIGHT_FLAG = 64,
      ARY_FLAG = 128,
      REARG_FLAG = 256;

  /** Used as default options for `_.trunc`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect when a function becomes hot. */
  var HOT_COUNT = 150,
      HOT_SPAN = 16;

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2;

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
      reUnescapedHtml = /[&<>"'`]/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

  /**
   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
   */
  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
      reHasRegExpChars = RegExp(reRegExpChars.source);

  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect hexadecimal string values. */
  var reHasHexPrefix = /^0[xX]/;

  /** Used to detect host constructors (Safari > 5). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^\d+$/;

  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to match words to create compound words. */
  var reWords = (function() {
    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
  }());

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
  cloneableTags[dateTag] = cloneableTags[float32Tag] =
  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[stringTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[mapTag] = cloneableTags[setTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map latin-1 supplementary letters to basic latin letters. */
  var deburredLetters = {
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#96;': '`'
  };

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used to escape characters for inclusion in compiled regexes. */
  var regexpEscapes = {
    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

  /** Detect free variable `self`. */
  var freeSelf = objectTypes[typeof self] && self && self.Object && self;

  /** Detect free variable `window`. */
  var freeWindow = objectTypes[typeof window] && window && window.Object && window;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

  /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */
  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

  /*--------------------------------------------------------------------------*/

  /**
   * The base implementation of `compareAscending` which compares values and
   * sorts them in ascending order without guaranteeing a stable sort.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function baseCompareAscending(value, other) {
    if (value !== other) {
      var valIsNull = value === null,
          valIsUndef = value === undefined,
          valIsReflexive = value === value;

      var othIsNull = other === null,
          othIsUndef = other === undefined,
          othIsReflexive = other === other;

      if ((value > other && !othIsNull) || !valIsReflexive ||
          (valIsNull && !othIsUndef && othIsReflexive) ||
          (valIsUndef && othIsReflexive)) {
        return 1;
      }
      if ((value < other && !valIsNull) || !othIsReflexive ||
          (othIsNull && !valIsUndef && valIsReflexive) ||
          (othIsUndef && valIsReflexive)) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromRight) {
    var length = array.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without support for binary searches.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    if (value !== value) {
      return indexOfNaN(array, fromIndex);
    }
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isFunction` without support for environments
   * with incorrect `typeof` results.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   */
  function baseIsFunction(value) {
    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
    return typeof value == 'function' || false;
  }

  /**
   * Converts `value` to a string if it's not one. An empty string is returned
   * for `null` or `undefined` values.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    return value == null ? '' : (value + '');
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the first character not found in `chars`.
   */
  function charsLeftIndex(string, chars) {
    var index = -1,
        length = string.length;

    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the last character not found in `chars`.
   */
  function charsRightIndex(string, chars) {
    var index = string.length;

    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.sortBy` to compare transformed elements of a collection and stable
   * sort them in ascending order.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareAscending(object, other) {
    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
  }

  /**
   * Used by `_.sortByOrder` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
   * a value is sorted in ascending order if its corresponding order is "asc", and
   * descending if "desc".
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareMultiple(object, other, orders) {
    var index = -1,
        objCriteria = object.criteria,
        othCriteria = other.criteria,
        length = objCriteria.length,
        ordersLength = orders.length;

    while (++index < length) {
      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
      if (result) {
        if (index >= ordersLength) {
          return result;
        }
        var order = orders[index];
        return result * ((order === 'asc' || order === true) ? 1 : -1);
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
  }

  /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  function deburrLetter(letter) {
    return deburredLetters[letter];
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(chr) {
    return htmlEscapes[chr];
  }

  /**
   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @param {string} leadingChar The capture group for a leading character.
   * @param {string} whitespaceChar The capture group for a whitespace character.
   * @returns {string} Returns the escaped character.
   */
  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
    if (leadingChar) {
      chr = regexpEscapes[chr];
    } else if (whitespaceChar) {
      chr = stringEscapes[chr];
    }
    return '\\' + chr;
  }

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */
  function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 0 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      var other = array[index];
      if (other !== other) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Checks if `value` is object-like.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
   * character code is whitespace.
   *
   * @private
   * @param {number} charCode The character code to inspect.
   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
   */
  function isSpace(charCode) {
    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      if (array[index] === placeholder) {
        array[index] = PLACEHOLDER;
        result[++resIndex] = index;
      }
    }
    return result;
  }

  /**
   * An implementation of `_.uniq` optimized for sorted arrays without support
   * for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} [iteratee] The function invoked per iteration.
   * @returns {Array} Returns the new duplicate-value-free array.
   */
  function sortedUniq(array, iteratee) {
    var seen,
        index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      var value = array[index],
          computed = iteratee ? iteratee(value, index, array) : value;

      if (!index || seen !== computed) {
        seen = computed;
        result[++resIndex] = value;
      }
    }
    return result;
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the first non-whitespace character.
   */
  function trimmedLeftIndex(string) {
    var index = -1,
        length = string.length;

    while (++index < length && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedRightIndex(string) {
    var index = string.length;

    while (index-- && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(chr) {
    return htmlUnescapes[chr];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the given `context` object.
   *
   * @static
   * @memberOf _
   * @category Utility
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // using `context` to mock `Date#getTime` use in `_.now`
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // or creating a suped-up `defer` in Node.js
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  function runInContext(context) {
    // Avoid issues with some ES3 environments that attempt to use values, named
    // after built-in constructors like `Object`, for the creation of literals.
    // ES5 clears this up by stating that literals must use built-in constructors.
    // See https://es5.github.io/#x11.1.5 for more details.
    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;

    /** Native constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Number = context.Number,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for native method references. */
    var arrayProto = Array.prototype,
        objectProto = Object.prototype,
        stringProto = String.prototype;

    /** Used to resolve the decompiled source of functions. */
    var fnToString = Function.prototype.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /**
     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
     * of values.
     */
    var objToString = objectProto.toString;

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Native method references. */
    var ArrayBuffer = context.ArrayBuffer,
        clearTimeout = context.clearTimeout,
        parseFloat = context.parseFloat,
        pow = Math.pow,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        Set = getNative(context, 'Set'),
        setTimeout = context.setTimeout,
        splice = arrayProto.splice,
        Uint8Array = context.Uint8Array,
        WeakMap = getNative(context, 'WeakMap');

    /* Native method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeCreate = getNative(Object, 'create'),
        nativeFloor = Math.floor,
        nativeIsArray = getNative(Array, 'isArray'),
        nativeIsFinite = context.isFinite,
        nativeKeys = getNative(Object, 'keys'),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = getNative(Date, 'now'),
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random;

    /** Used as references for `-Infinity` and `Infinity`. */
    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

    /**
     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
     * of an array-like value.
     */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
     * Methods that operate on and return arrays, collections, and functions can
     * be chained together. Methods that retrieve a single value or may return a
     * primitive value will automatically end the chain returning the unwrapped
     * value. Explicit chaining may be enabled using `_.chain`. The execution of
     * chained methods is lazy, that is, execution is deferred until `_#value`
     * is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization strategy which merge iteratee calls; this can help
     * to avoid the creation of intermediate data structures and greatly reduce the
     * number of iteratee executions.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
     * `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
     * and `where`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
     * `unescape`, `uniqueId`, `value`, and `words`
     *
     * The wrapper method `sample` will return a wrapped value when `n` is provided,
     * otherwise an unwrapped value is returned.
     *
     * @name _
     * @constructor
     * @category Chain
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(total, n) {
     *   return total + n;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(n) {
     *   return n * n;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
     */
    function LodashWrapper(value, chainAll, actions) {
      this.__wrapped__ = value;
      this.__actions__ = actions || [];
      this.__chain__ = !!chainAll;
    }

    /**
     * An object environment feature flags.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    var support = lodash.support = {};

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */
        '_': lodash
      }
    };

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = POSITIVE_INFINITY;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = arrayCopy(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = arrayCopy(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = arrayCopy(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a cache object to store key/value pairs.
     *
     * @private
     * @static
     * @name Cache
     * @memberOf _.memoize
     */
    function MapCache() {
      this.__data__ = {};
    }

    /**
     * Removes `key` and its value from the cache.
     *
     * @private
     * @name delete
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
     */
    function mapDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }

    /**
     * Gets the cached value for `key`.
     *
     * @private
     * @name get
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the cached value.
     */
    function mapGet(key) {
      return key == '__proto__' ? undefined : this.__data__[key];
    }

    /**
     * Checks if a cached value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapHas(key) {
      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
    }

    /**
     * Sets `value` to `key` of the cache.
     *
     * @private
     * @name set
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to cache.
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache object.
     */
    function mapSet(key, value) {
      if (key != '__proto__') {
        this.__data__[key] = value;
      }
      return this;
    }

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates a cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var length = values ? values.length : 0;

      this.data = { 'hash': nativeCreate(null), 'set': new Set };
      while (length--) {
        this.push(values[length]);
      }
    }

    /**
     * Checks if `value` is in `cache` mimicking the return signature of
     * `_.indexOf` by returning `0` if the value is found, else `-1`.
     *
     * @private
     * @param {Object} cache The cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `0` if `value` is found, else `-1`.
     */
    function cacheIndexOf(cache, value) {
      var data = cache.data,
          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

      return result ? 0 : -1;
    }

    /**
     * Adds `value` to the cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */
    function cachePush(value) {
      var data = this.data;
      if (typeof value == 'string' || isObject(value)) {
        data.set.add(value);
      } else {
        data.hash[value] = true;
      }
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a new array joining `array` with `other`.
     *
     * @private
     * @param {Array} array The array to join.
     * @param {Array} other The other array to join.
     * @returns {Array} Returns the new concatenated array.
     */
    function arrayConcat(array, other) {
      var index = -1,
          length = array.length,
          othIndex = -1,
          othLength = other.length,
          result = Array(length + othLength);

      while (++index < length) {
        result[index] = array[index];
      }
      while (++othIndex < othLength) {
        result[index++] = other[othIndex];
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function arrayCopy(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
      var length = array.length;

      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.every` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
     * with one argument: (value).
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function arrayExtremum(array, iteratee, comparator, exValue) {
      var index = -1,
          length = array.length,
          computed = exValue,
          result = computed;

      while (++index < length) {
        var value = array[index],
            current = +iteratee(value);

        if (comparator(current, computed)) {
          computed = current;
          result = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
          length = array.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.map` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
          length = array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the first element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initFromArray) {
      var index = -1,
          length = array.length;

      if (initFromArray && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the last element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
      var length = array.length;
      if (initFromArray && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.some` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }

    /**
     * A specialized version of `_.sum` for arrays without support for callback
     * shorthands and `this` binding..
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function arraySum(array, iteratee) {
      var length = array.length,
          result = 0;

      while (length--) {
        result += +iteratee(array[length]) || 0;
      }
      return result;
    }

    /**
     * Used by `_.defaults` to customize its `_.assign` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : objectValue;
    }

    /**
     * Used by `_.template` to customize its `_.assign` use.
     *
     * **Note:** This function is like `assignDefaults` except that it ignores
     * inherited property values when checking if a property is `undefined`.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @param {string} key The key associated with the object and source values.
     * @param {Object} object The destination object.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignOwnDefaults(objectValue, sourceValue, key, object) {
      return (objectValue === undefined || !hasOwnProperty.call(object, key))
        ? sourceValue
        : objectValue;
    }

    /**
     * A specialized version of `_.assign` for customizing assigned values without
     * support for argument juggling, multiple sources, and `this` binding `customizer`
     * functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     */
    function assignWith(object, source, customizer) {
      var index = -1,
          props = keys(source),
          length = props.length;

      while (++index < length) {
        var key = props[index],
            value = object[key],
            result = customizer(value, source[key], key, object, source);

        if ((result === result ? (result !== value) : (value === value)) ||
            (value === undefined && !(key in object))) {
          object[key] = result;
        }
      }
      return object;
    }

    /**
     * The base implementation of `_.assign` without support for argument juggling,
     * multiple sources, and `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return source == null
        ? object
        : baseCopy(source, keys(source), object);
    }

    /**
     * The base implementation of `_.at` without support for string collections
     * and individual key arguments.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {number[]|string[]} props The property names or indexes of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */
    function baseAt(collection, props) {
      var index = -1,
          isNil = collection == null,
          isArr = !isNil && isArrayLike(collection),
          length = isArr ? collection.length : 0,
          propsLength = props.length,
          result = Array(propsLength);

      while(++index < propsLength) {
        var key = props[index];
        if (isArr) {
          result[index] = isIndex(key, length) ? collection[key] : undefined;
        } else {
          result[index] = isNil ? undefined : collection[key];
        }
      }
      return result;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */
    function baseCopy(source, props, object) {
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];
        object[key] = source[key];
      }
      return object;
    }

    /**
     * The base implementation of `_.callback` which supports specifying the
     * number of arguments to provide to `func`.
     *
     * @private
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function baseCallback(func, thisArg, argCount) {
      var type = typeof func;
      if (type == 'function') {
        return thisArg === undefined
          ? func
          : bindCallback(func, thisArg, argCount);
      }
      if (func == null) {
        return identity;
      }
      if (type == 'object') {
        return baseMatches(func);
      }
      return thisArg === undefined
        ? property(func)
        : baseMatchesProperty(func, thisArg);
    }

    /**
     * The base implementation of `_.clone` without support for argument juggling
     * and `this` binding `customizer` functions.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The object `value` belongs to.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return arrayCopy(value, result);
        }
      } else {
        var tag = objToString.call(value),
            isFunc = tag == funcTag;

        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return baseAssign(result, value);
          }
        } else {
          return cloneableTags[tag]
            ? initCloneByTag(value, tag, isDeep)
            : (object ? value : {});
        }
      }
      // Check for circular references and return its corresponding clone.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == value) {
          return stackB[length];
        }
      }
      // Add the source value to the stack of traversed objects and associate it with its clone.
      stackA.push(value);
      stackB.push(result);

      // Recursively populate clone (susceptible to call stack limits).
      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
      });
      return result;
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          object.prototype = prototype;
          var result = new object;
          object.prototype = undefined;
        }
        return result || {};
      };
    }());

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts an index
     * of where to slice the arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments provide to `func`.
     * @returns {number} Returns the timer id.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of `_.difference` which accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values) {
      var length = array ? array.length : 0,
          result = [];

      if (!length) {
        return result;
      }
      var index = -1,
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
          valuesLength = values.length;

      if (cache) {
        indexOf = cacheIndexOf;
        isCommon = false;
        values = cache;
      }
      outer:
      while (++index < length) {
        var value = array[index];

        if (isCommon && value === value) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === value) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (indexOf(values, value, 0) < 0) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * Gets the extremum value of `collection` invoking `iteratee` for each value
     * in `collection` to generate the criterion by which the value is ranked.
     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(collection, iteratee, comparator, exValue) {
      var computed = exValue,
          result = computed;

      baseEach(collection, function(value, index, collection) {
        var current = +iteratee(value, index, collection);
        if (comparator(current, computed) || (current === exValue && current === result)) {
          computed = current;
          result = value;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : (end >>> 0);
      start >>>= 0;

      while (start < length) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
     * without support for callback shorthands and `this` binding, which iterates
     * over `collection` using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @param {boolean} [retKey] Specify returning the key of the found element
     *  instead of the element itself.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFind(collection, predicate, eachFunc, retKey) {
      var result;
      eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
          result = retKey ? key : value;
          return false;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with added support for restricting
     * flattening and specifying the start index.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, isDeep, isStrict, result) {
      result || (result = []);

      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index];
        if (isObjectLike(value) && isArrayLike(value) &&
            (isStrict || isArray(value) || isArguments(value))) {
          if (isDeep) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, isDeep, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forIn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForIn(object, iteratee) {
      return baseFor(object, iteratee, keysIn);
    }

    /**
     * The base implementation of `_.forOwn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from those provided.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */
    function baseFunctions(object, props) {
      var index = -1,
          length = props.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var key = props[index];
        if (isFunction(object[key])) {
          result[++resIndex] = key;
        }
      }
      return result;
    }

    /**
     * The base implementation of `get` without support for string paths
     * and default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path of the property to get.
     * @param {string} [pathKey] The key representation of path.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path, pathKey) {
      if (object == null) {
        return;
      }
      if (pathKey !== undefined && pathKey in toObject(object)) {
        path = [pathKey];
      }
      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[path[index++]];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `_.isEqual` without support for `this` binding
     * `customizer` functions.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = arrayTag,
          othTag = arrayTag;

      if (!objIsArr) {
        objTag = objToString.call(object);
        if (objTag == argsTag) {
          objTag = objectTag;
        } else if (objTag != objectTag) {
          objIsArr = isTypedArray(object);
        }
      }
      if (!othIsArr) {
        othTag = objToString.call(other);
        if (othTag == argsTag) {
          othTag = objectTag;
        } else if (othTag != objectTag) {
          othIsArr = isTypedArray(other);
        }
      }
      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && !(objIsArr || objIsObj)) {
        return equalByTag(object, other, objTag);
      }
      if (!isLoose) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
        }
      }
      if (!isSameTag) {
        return false;
      }
      // Assume cyclic values are equal.
      // For more information on detecting circular references see https://es5.github.io/#JO.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == object) {
          return stackB[length] == other;
        }
      }
      // Add `object` and `other` to the stack of traversed objects.
      stackA.push(object);
      stackB.push(other);

      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

      stackA.pop();
      stackB.pop();

      return result;
    }

    /**
     * The base implementation of `_.isMatch` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} matchData The propery names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = toObject(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.map` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which does not clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        var key = matchData[0][0],
            value = matchData[0][1];

        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === value && (value !== undefined || (key in toObject(object)));
        };
      }
      return function(object) {
        return baseIsMatch(object, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to compare.
     * @returns {Function} Returns the new function.
     */
    function baseMatchesProperty(path, srcValue) {
      var isArr = isArray(path),
          isCommon = isKey(path) && isStrictComparable(srcValue),
          pathKey = (path + '');

      path = toPath(path);
      return function(object) {
        if (object == null) {
          return false;
        }
        var key = pathKey;
        object = toObject(object);
        if ((isArr || !isCommon) && !(key in object)) {
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          if (object == null) {
            return false;
          }
          key = last(path);
          object = toObject(object);
        }
        return object[key] === srcValue
          ? (srcValue !== undefined || (key in object))
          : baseIsEqual(srcValue, object[key], undefined, true);
      };
    }

    /**
     * The base implementation of `_.merge` without support for argument juggling,
     * multiple sources, and `this` binding `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {Object} Returns `object`.
     */
    function baseMerge(object, source, customizer, stackA, stackB) {
      if (!isObject(object)) {
        return object;
      }
      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
          props = isSrcArr ? undefined : keys(source);

      arrayEach(props || source, function(srcValue, key) {
        if (props) {
          key = srcValue;
          srcValue = source[key];
        }
        if (isObjectLike(srcValue)) {
          stackA || (stackA = []);
          stackB || (stackB = []);
          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
        }
        else {
          var value = object[key],
              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
              isCommon = result === undefined;

          if (isCommon) {
            result = srcValue;
          }
          if ((result !== undefined || (isSrcArr && !(key in object))) &&
              (isCommon || (result === result ? (result !== value) : (value === value)))) {
            object[key] = result;
          }
        }
      });
      return object;
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
      var length = stackA.length,
          srcValue = source[key];

      while (length--) {
        if (stackA[length] == srcValue) {
          object[key] = stackB[length];
          return;
        }
      }
      var value = object[key],
          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
          isCommon = result === undefined;

      if (isCommon) {
        result = srcValue;
        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
          result = isArray(value)
            ? value
            : (isArrayLike(value) ? arrayCopy(value) : []);
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          result = isArguments(value)
            ? toPlainObject(value)
            : (isPlainObject(value) ? value : {});
        }
        else {
          isCommon = false;
        }
      }
      // Add the source value to the stack of traversed objects and associate
      // it with its merged value.
      stackA.push(srcValue);
      stackB.push(result);

      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
      } else if (result === result ? (result !== value) : (value === value)) {
        object[key] = result;
      }
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined : object[key];
      };
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */
    function basePropertyDeep(path) {
      var pathKey = (path + '');
      path = toPath(path);
      return function(object) {
        return baseGet(object, path, pathKey);
      };
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * index arguments and capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0;
      while (length--) {
        var index = indexes[length];
        if (index != previous && isIndex(index)) {
          var previous = index;
          splice.call(array, index, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for argument juggling
     * and returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns the random number.
     */
    function baseRandom(min, max) {
      return min + nativeFloor(nativeRandom() * (max - min + 1));
    }

    /**
     * The base implementation of `_.reduce` and `_.reduceRight` without support
     * for callback shorthands and `this` binding, which iterates over `collection`
     * using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initFromCollection Specify using the first or last element
     *  of `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
      eachFunc(collection, function(value, index, collection) {
        accumulator = initFromCollection
          ? (initFromCollection = false, value)
          : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define
     * the sort order of `array` and replaces criteria objects with their
     * corresponding values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
      var length = array.length;

      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }

    /**
     * The base implementation of `_.sortByOrder` without param guards.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseSortByOrder(collection, iteratees, orders) {
      var callback = getCallback(),
          index = -1;

      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });

      var result = baseMap(collection, function(value) {
        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.sum` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(collection, iteratee) {
      var result = 0;
      baseEach(collection, function(value, index, collection) {
        result += +iteratee(value, index, collection) || 0;
      });
      return result;
    }

    /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The function invoked per iteration.
     * @returns {Array} Returns the new duplicate-value-free array.
     */
    function baseUniq(array, iteratee) {
      var index = -1,
          indexOf = getIndexOf(),
          length = array.length,
          isCommon = indexOf == baseIndexOf,
          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
          seen = isLarge ? createCache() : null,
          result = [];

      if (seen) {
        indexOf = cacheIndexOf;
        isCommon = false;
      } else {
        isLarge = false;
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value, index, array) : value;

        if (isCommon && value === value) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (indexOf(seen, computed, 0) < 0) {
          if (iteratee || isLarge) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      var index = -1,
          length = props.length,
          result = Array(length);

      while (++index < length) {
        result[index] = object[props[index]];
      }
      return result;
    }

    /**
     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
     * and `_.takeWhile` without support for callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to peform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      var index = -1,
          length = actions.length;

      while (++index < length) {
        var action = actions[index];
        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
      }
      return result;
    }

    /**
     * Performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndex(array, value, retHighest) {
      var low = 0,
          high = array ? array.length : low;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return binaryIndexBy(array, value, identity, retHighest);
    }

    /**
     * This function is like `binaryIndex` except that it invokes `iteratee` for
     * `value` and each element of `array` to compute their sort ranking. The
     * iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array ? array.length : 0,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsUndef = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            isDef = computed !== undefined,
            isReflexive = computed === computed;

        if (valIsNaN) {
          var setLow = isReflexive || retHighest;
        } else if (valIsNull) {
          setLow = isReflexive && isDef && (retHighest || computed != null);
        } else if (valIsUndef) {
          setLow = isReflexive && (retHighest || isDef);
        } else if (computed == null) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * A specialized version of `baseCallback` which only supports `this` binding
     * and specifying the number of arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function bindCallback(func, thisArg, argCount) {
      if (typeof func != 'function') {
        return identity;
      }
      if (thisArg === undefined) {
        return func;
      }
      switch (argCount) {
        case 1: return function(value) {
          return func.call(thisArg, value);
        };
        case 3: return function(value, index, collection) {
          return func.call(thisArg, value, index, collection);
        };
        case 4: return function(accumulator, value, index, collection) {
          return func.call(thisArg, accumulator, value, index, collection);
        };
        case 5: return function(value, other, key, object, source) {
          return func.call(thisArg, value, other, key, object, source);
        };
      }
      return function() {
        return func.apply(thisArg, arguments);
      };
    }

    /**
     * Creates a clone of the given array buffer.
     *
     * @private
     * @param {ArrayBuffer} buffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function bufferClone(buffer) {
      var result = new ArrayBuffer(buffer.byteLength),
          view = new Uint8Array(result);

      view.set(new Uint8Array(buffer));
      return result;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders) {
      var holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          leftIndex = -1,
          leftLength = partials.length,
          result = Array(leftLength + argsLength);

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        result[holders[argsIndex]] = args[argsIndex];
      }
      while (argsLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders) {
      var holdersIndex = -1,
          holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          rightIndex = -1,
          rightLength = partials.length,
          result = Array(argsLength + rightLength);

      while (++argsIndex < argsLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        result[offset + holders[holdersIndex]] = args[argsIndex++];
      }
      return result;
    }

    /**
     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
     *
     * @private
     * @param {Function} setter The function to set keys and values of the accumulator object.
     * @param {Function} [initializer] The function to initialize the accumulator object.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee, thisArg) {
        var result = initializer ? initializer() : {};
        iteratee = getCallback(iteratee, thisArg, 3);

        if (isArray(collection)) {
          var index = -1,
              length = collection.length;

          while (++index < length) {
            var value = collection[index];
            setter(result, value, iteratee(value, index, collection), collection);
          }
        } else {
          baseEach(collection, function(value, key, collection) {
            setter(result, value, iteratee(value, key, collection), collection);
          });
        }
        return result;
      };
    }

    /**
     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return restParam(function(object, sources) {
        var index = -1,
            length = object == null ? 0 : sources.length,
            customizer = length > 2 ? sources[length - 2] : undefined,
            guard = length > 2 ? sources[2] : undefined,
            thisArg = length > 1 ? sources[length - 1] : undefined;

        if (typeof customizer == 'function') {
          customizer = bindCallback(customizer, thisArg, 5);
          length -= 2;
        } else {
          customizer = typeof thisArg == 'function' ? thisArg : undefined;
          length -= (customizer ? 1 : 0);
        }
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        var length = collection ? getLength(collection) : 0;
        if (!isLength(length)) {
          return eachFunc(collection, iteratee);
        }
        var index = fromRight ? length : -1,
            iterable = toObject(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var iterable = toObject(object),
            props = keysFunc(object),
            length = props.length,
            index = fromRight ? length : -1;

        while ((fromRight ? index-- : ++index < length)) {
          var key = props[index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with the `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new bound function.
     */
    function createBindWrapper(func, thisArg) {
      var Ctor = createCtorWrapper(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(thisArg, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a `Set` cache object to optimize linear searches of large arrays.
     *
     * @private
     * @param {Array} [values] The values to cache.
     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
     */
    function createCache(values) {
      return (nativeCreate && Set) ? new SetCache(values) : null;
    }

    /**
     * Creates a function that produces compound words out of the words in a
     * given string.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        var index = -1,
            array = words(deburr(string)),
            length = array.length,
            result = '';

        while (++index < length) {
          result = callback(result, array[index], index);
        }
        return result;
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtorWrapper(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors.
        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a `_.curry` or `_.curryRight` function.
     *
     * @private
     * @param {boolean} flag The curry bit flag.
     * @returns {Function} Returns the new curry function.
     */
    function createCurry(flag) {
      function curryFunc(func, arity, guard) {
        if (guard && isIterateeCall(func, arity, guard)) {
          arity = undefined;
        }
        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
        result.placeholder = curryFunc.placeholder;
        return result;
      }
      return curryFunc;
    }

    /**
     * Creates a `_.defaults` or `_.defaultsDeep` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Function} Returns the new defaults function.
     */
    function createDefaults(assigner, customizer) {
      return restParam(function(args) {
        var object = args[0];
        if (object == null) {
          return object;
        }
        args.push(customizer);
        return assigner.apply(undefined, args);
      });
    }

    /**
     * Creates a `_.max` or `_.min` function.
     *
     * @private
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {Function} Returns the new extremum function.
     */
    function createExtremum(comparator, exValue) {
      return function(collection, iteratee, thisArg) {
        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
          iteratee = undefined;
        }
        iteratee = getCallback(iteratee, thisArg, 3);
        if (iteratee.length == 1) {
          collection = isArray(collection) ? collection : toIterable(collection);
          var result = arrayExtremum(collection, iteratee, comparator, exValue);
          if (!(collection.length && result === exValue)) {
            return result;
          }
        }
        return baseExtremum(collection, iteratee, comparator, exValue);
      };
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFind(eachFunc, fromRight) {
      return function(collection, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        if (isArray(collection)) {
          var index = baseFindIndex(collection, predicate, fromRight);
          return index > -1 ? collection[index] : undefined;
        }
        return baseFind(collection, predicate, eachFunc);
      };
    }

    /**
     * Creates a `_.findIndex` or `_.findLastIndex` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFindIndex(fromRight) {
      return function(array, predicate, thisArg) {
        if (!(array && array.length)) {
          return -1;
        }
        predicate = getCallback(predicate, thisArg, 3);
        return baseFindIndex(array, predicate, fromRight);
      };
    }

    /**
     * Creates a `_.findKey` or `_.findLastKey` function.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new find function.
     */
    function createFindKey(objectFunc) {
      return function(object, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        return baseFind(object, predicate, objectFunc, true);
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return function() {
        var wrapper,
            length = arguments.length,
            index = fromRight ? length : -1,
            leftIndex = 0,
            funcs = Array(length);

        while ((fromRight ? index-- : ++index < length)) {
          var func = funcs[leftIndex++] = arguments[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
            wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? -1 : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      };
    }

    /**
     * Creates a function for `_.forEach` or `_.forEachRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createForEach(arrayFunc, eachFunc) {
      return function(collection, iteratee, thisArg) {
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee)
          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
      };
    }

    /**
     * Creates a function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForIn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee, keysIn);
      };
    }

    /**
     * Creates a function for `_.forOwn` or `_.forOwnRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForOwn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee);
      };
    }

    /**
     * Creates a function for `_.mapKeys` or `_.mapValues`.
     *
     * @private
     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
     * @returns {Function} Returns the new map function.
     */
    function createObjectMapper(isMapKeys) {
      return function(object, iteratee, thisArg) {
        var result = {};
        iteratee = getCallback(iteratee, thisArg, 3);

        baseForOwn(object, function(value, key, object) {
          var mapped = iteratee(value, key, object);
          key = isMapKeys ? mapped : key;
          value = isMapKeys ? value : mapped;
          result[key] = value;
        });
        return result;
      };
    }

    /**
     * Creates a function for `_.padLeft` or `_.padRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify padding from the right.
     * @returns {Function} Returns the new pad function.
     */
    function createPadDir(fromRight) {
      return function(string, length, chars) {
        string = baseToString(string);
        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
      };
    }

    /**
     * Creates a `_.partial` or `_.partialRight` function.
     *
     * @private
     * @param {boolean} flag The partial bit flag.
     * @returns {Function} Returns the new partial function.
     */
    function createPartial(flag) {
      var partialFunc = restParam(function(func, partials) {
        var holders = replaceHolders(partials, partialFunc.placeholder);
        return createWrapper(func, flag, undefined, partials, holders);
      });
      return partialFunc;
    }

    /**
     * Creates a function for `_.reduce` or `_.reduceRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createReduce(arrayFunc, eachFunc) {
      return function(collection, iteratee, accumulator, thisArg) {
        var initFromArray = arguments.length < 3;
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with optional `this`
     * binding of, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
          isBind = bitmask & BIND_FLAG,
          isBindKey = bitmask & BIND_KEY_FLAG,
          isCurry = bitmask & CURRY_FLAG,
          isCurryBound = bitmask & CURRY_BOUND_FLAG,
          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
          Ctor = isBindKey ? undefined : createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it to other functions.
        var length = arguments.length,
            index = length,
            args = Array(length);

        while (index--) {
          args[index] = arguments[index];
        }
        if (partials) {
          args = composeArgs(args, partials, holders);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight);
        }
        if (isCurry || isCurryRight) {
          var placeholder = wrapper.placeholder,
              argsHolders = replaceHolders(args, placeholder);

          length -= argsHolders.length;
          if (length < arity) {
            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
                newArity = nativeMax(arity - length, 0),
                newsHolders = isCurry ? argsHolders : undefined,
                newHoldersRight = isCurry ? undefined : argsHolders,
                newPartials = isCurry ? args : undefined,
                newPartialsRight = isCurry ? undefined : args;

            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

            if (!isCurryBound) {
              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
            }
            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
                result = createHybridWrapper.apply(undefined, newData);

            if (isLaziable(func)) {
              setData(result, newData);
            }
            result.placeholder = placeholder;
            return result;
          }
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        if (argPos) {
          args = reorder(args, argPos);
        }
        if (isAry && ary < args.length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtorWrapper(func);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates the padding required for `string` based on the given `length`.
     * The `chars` string is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {string} string The string to create padding for.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the pad for `string`.
     */
    function createPadding(string, length, chars) {
      var strLength = string.length;
      length = +length;

      if (strLength >= length || !nativeIsFinite(length)) {
        return '';
      }
      var padLength = length - strLength;
      chars = chars == null ? ' ' : (chars + '');
      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
    }

    /**
     * Creates a function that wraps `func` and invokes it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to partially apply arguments to.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new bound function.
     */
    function createPartialWrapper(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it `func`.
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength);

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        precision = precision === undefined ? 0 : (+precision || 0);
        if (precision) {
          precision = pow(10, precision);
          return func(number * precision) / precision;
        }
        return func(number);
      };
    }

    /**
     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
     *
     * @private
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {Function} Returns the new index function.
     */
    function createSortedIndex(retHighest) {
      return function(array, value, iteratee, thisArg) {
        var callback = getCallback(iteratee);
        return (iteratee == null && callback === baseCallback)
          ? binaryIndex(array, value, retHighest)
          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      length -= (holders ? holders.length : 0);
      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func),
          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

      if (data) {
        mergeData(newData, data);
        bitmask = newData[1];
        arity = newData[9];
      }
      newData[9] = arity == null
        ? (isBindKey ? 0 : func.length)
        : (nativeMax(arity - length, 0) || 0);

      if (bitmask == BIND_FLAG) {
        var result = createBindWrapper(newData[0], newData[2]);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
        result = createPartialWrapper.apply(undefined, newData);
      } else {
        result = createHybridWrapper.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setter(result, newData);
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing arrays.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var index = -1,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
        return false;
      }
      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index],
            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

        if (result !== undefined) {
          if (result) {
            continue;
          }
          return false;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isLoose) {
          if (!arraySome(other, function(othValue) {
                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
              })) {
            return false;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag) {
      switch (tag) {
        case boolTag:
        case dateTag:
          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
          return +object == +other;

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case numberTag:
          // Treat `NaN` vs. `NaN` as equal.
          return (object != +object)
            ? other != +other
            : object == +other;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings primitives and string
          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
          return object == (other + '');
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objProps = keys(object),
          objLength = objProps.length,
          othProps = keys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isLoose) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var skipCtor = isLoose;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key],
            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

        // Recursively compare objects (susceptible to call stack limits).
        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
          return false;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (!skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Gets the appropriate "callback" function. If the `_.callback` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseCallback` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function} Returns the chosen function or its result.
     */
    function getCallback(func, thisArg, argCount) {
      var result = lodash.callback || callback;
      result = result === callback ? baseCallback : result;
      return argCount ? result(func, thisArg, argCount) : result;
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = func.name,
          array = realNames[result],
          length = array ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseIndexOf` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function|number} Returns the chosen function or its result.
     */
    function getIndexOf(collection, target, fromIndex) {
      var result = lodash.indexOf || indexOf;
      result = result === indexOf ? baseIndexOf : result;
      return collection ? result(collection, target, fromIndex) : result;
    }

    /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */
    var getLength = baseProperty('length');

    /**
     * Gets the propery names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = pairs(object),
          length = result.length;

      while (length--) {
        result[length][2] = isStrictComparable(result[length][1]);
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = object == null ? undefined : object[key];
      return isNative(value) ? value : undefined;
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add array properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      var Ctor = object.constructor;
      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
        Ctor = Object;
      }
      return new Ctor;
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return bufferClone(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          var buffer = object.buffer;
          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          var result = new Ctor(object.source, reFlags.exec(object));
          result.lastIndex = object.lastIndex;
      }
      return result;
    }

    /**
     * Invokes the method at `path` on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function invokePath(object, path, args) {
      if (object != null && !isKey(path, object)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        path = last(path);
      }
      var func = object == null ? object : object[path];
      return func == null ? undefined : func.apply(object, args);
    }

    /**
     * Checks if `value` is array-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     */
    function isArrayLike(value) {
      return value != null && isLength(getLength(value));
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return value > -1 && value % 1 == 0 && value < length;
    }

    /**
     * Checks if the provided arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)) {
        var other = object[index];
        return value === value ? (value === other) : (other !== other);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      var type = typeof value;
      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
        return true;
      }
      if (isArray(value)) {
        return false;
      }
      var result = !reIsDeepProp.test(value);
      return result || (object != null && value in toObject(object));
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func);
      if (!(funcName in LazyWrapper.prototype)) {
        return false;
      }
      var other = lodash[funcName];
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers required to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * augment function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * common case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < ARY_FLAG;

      var isCombo =
        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = arrayCopy(value);
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function mergeDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties specified
     * by `props`.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */
    function pickByArray(object, props) {
      object = toObject(object);

      var index = -1,
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index];
        if (key in object) {
          result[key] = object[key];
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties `predicate`
     * returns truthy for.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Object} Returns the new object.
     */
    function pickByCallback(object, predicate) {
      var result = {};
      baseForIn(object, function(value, key, object) {
        if (predicate(value, key, object)) {
          result[key] = value;
        }
      });
      return result;
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = arrayCopy(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = (function() {
      var count = 0,
          lastCalled = 0;

      return function(key, value) {
        var stamp = now(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return key;
          }
        } else {
          count = 0;
        }
        return baseSetData(key, value);
      };
    }());

    /**
     * A fallback implementation of `Object.keys` which creates an array of the
     * own enumerable property names of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function shimKeys(object) {
      var props = keysIn(object),
          propsLength = props.length,
          length = propsLength && object.length;

      var allowIndexes = !!length && isLength(length) &&
        (isArray(object) || isArguments(object));

      var index = -1,
          result = [];

      while (++index < propsLength) {
        var key = props[index];
        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to an array-like object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array|Object} Returns the array-like object.
     */
    function toIterable(value) {
      if (value == null) {
        return [];
      }
      if (!isArrayLike(value)) {
        return values(value);
      }
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to an object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Object} Returns the object.
     */
    function toObject(value) {
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to property path array if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */
    function toPath(value) {
      if (isArray(value)) {
        return value;
      }
      var result = [];
      baseToString(value).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      return wrapper instanceof LazyWrapper
        ? wrapper.clone()
        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `collection` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if (guard ? isIterateeCall(array, size, guard) : size == null) {
        size = 1;
      } else {
        size = nativeMax(nativeFloor(size) || 1, 1);
      }
      var index = 0,
          length = array ? array.length : 0,
          resIndex = -1,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[++resIndex] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array ? array.length : 0,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * Creates an array of unique `array` values not included in the other
     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3], [4, 2]);
     * // => [1, 3]
     */
    var difference = restParam(function(array, values) {
      return (isObjectLike(array) && isArrayLike(array))
        ? baseDifference(array, baseFlatten(values, false, true))
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that match the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [1]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
     * // => ['barney']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropWhile(users, 'active', false), 'user');
     * // => ['pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8], '*', 1, 2);
     * // => [4, '*', 8]
     */
    function fill(array, value, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(chr) {
     *   return chr.user == 'barney';
     * });
     * // => 0
     *
     * // using the `_.matches` callback shorthand
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findIndex(users, 'active', false);
     * // => 0
     *
     * // using the `_.property` callback shorthand
     * _.findIndex(users, 'active');
     * // => 2
     */
    var findIndex = createFindIndex();

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(chr) {
     *   return chr.user == 'pebbles';
     * });
     * // => 2
     *
     * // using the `_.matches` callback shorthand
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastIndex(users, 'active', false);
     * // => 2
     *
     * // using the `_.property` callback shorthand
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    var findLastIndex = createFindIndex(true);

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias head
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([]);
     * // => undefined
     */
    function first(array) {
      return array ? array[0] : undefined;
    }

    /**
     * Flattens a nested array. If `isDeep` is `true` the array is recursively
     * flattened, otherwise it is only flattened a single level.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, 3, [4]]]);
     * // => [1, 2, 3, [4]]
     *
     * // using `isDeep`
     * _.flatten([1, [2, 3, [4]]], true);
     * // => [1, 2, 3, 4]
     */
    function flatten(array, isDeep, guard) {
      var length = array ? array.length : 0;
      if (guard && isIterateeCall(array, isDeep, guard)) {
        isDeep = false;
      }
      return length ? baseFlatten(array, isDeep) : [];
    }

    /**
     * Recursively flattens a nested array.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to recursively flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, 3, [4]]]);
     * // => [1, 2, 3, 4]
     */
    function flattenDeep(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, true) : [];
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
     * performs a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // using `fromIndex`
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     *
     * // performing a binary search
     * _.indexOf([1, 1, 2, 2], 2, true);
     * // => 2
     */
    function indexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      if (typeof fromIndex == 'number') {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
      } else if (fromIndex) {
        var index = binaryIndex(array, value);
        if (index < length &&
            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
          return index;
        }
        return -1;
      }
      return baseIndexOf(array, value, fromIndex || 0);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      return dropRight(array, 1);
    }

    /**
     * Creates an array of unique values that are included in all of the provided
     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([1, 2], [4, 2], [2, 1]);
     * // => [2]
     */
    var intersection = restParam(function(arrays) {
      var othLength = arrays.length,
          othIndex = othLength,
          caches = Array(length),
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          result = [];

      while (othIndex--) {
        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
      }
      var array = arrays[0],
          index = -1,
          length = array ? array.length : 0,
          seen = caches[0];

      outer:
      while (++index < length) {
        value = array[index];
        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
          var othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(value);
          }
          result.push(value);
        }
      }
      return result;
    });

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array ? array.length : 0;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
     *  or `true` to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // using `fromIndex`
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     *
     * // performing a binary search
     * _.lastIndexOf([1, 1, 2, 2], 2, true);
     * // => 3
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      var index = length;
      if (typeof fromIndex == 'number') {
        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
      } else if (fromIndex) {
        index = binaryIndex(array, value, true) - 1;
        var other = array[index];
        if (value === value ? (value === other) : (other !== other)) {
          return index;
        }
        return -1;
      }
      if (value !== value) {
        return indexOfNaN(array, index, true);
      }
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * Removes all provided values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */
    function pull() {
      var args = arguments,
          array = args[0];

      if (!(array && array.length)) {
        return array;
      }
      var index = 0,
          indexOf = getIndexOf(),
          length = args.length;

      while (++index < length) {
        var fromIndex = 0,
            value = args[index];

        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * Removes elements from `array` corresponding to the given indexes and returns
     * an array of the removed elements. Indexes may be specified as an array of
     * indexes or as individual arguments.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */
    var pullAt = restParam(function(array, indexes) {
      indexes = baseFlatten(indexes);

      var result = baseAt(array, indexes);
      basePullAt(array, indexes.sort(baseCompareAscending));
      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate, thisArg) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getCallback(predicate, thisArg, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias tail
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     */
    function rest(array) {
      return drop(array, 1);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of `Array#slice` to support node
     * lists in IE < 9 and to ensure dense arrays are returned.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value` should
     * be inserted into `array` in order to maintain its sort order. If an iteratee
     * function is provided it is invoked for `value` and each element of `array`
     * to compute their sort ranking. The iteratee is bound to `thisArg` and
     * invoked with one argument; (value).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 4, 5, 5], 5);
     * // => 2
     *
     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
     *
     * // using an iteratee function
     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
     *   return this.data[word];
     * }, dict);
     * // => 1
     *
     * // using the `_.property` callback shorthand
     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 1
     */
    var sortedIndex = createSortedIndex();

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 4, 5, 5], 5);
     * // => 4
     */
    var sortedLastIndex = createSortedIndex(true);

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
     * and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [2, 3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
     * // => []
     */
    function takeRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [1, 2]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeWhile(users, 'active', false), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeWhile(users, 'active'), 'user');
     * // => []
     */
    function takeWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all of the provided arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([1, 2], [4, 2], [2, 1]);
     * // => [1, 2, 4]
     */
    var union = restParam(function(arrays) {
      return baseUniq(baseFlatten(arrays, false, true));
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurence of each element
     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
     * for sorted arrays. If an iteratee function is provided it is invoked for
     * each element in the array to generate the criterion by which uniqueness
     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, array).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {boolean} [isSorted] Specify the array is sorted.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new duplicate-value-free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     *
     * // using `isSorted`
     * _.uniq([1, 1, 2], true);
     * // => [1, 2]
     *
     * // using an iteratee function
     * _.uniq([1, 2.5, 1.5, 2], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => [1, 2.5]
     *
     * // using the `_.property` callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniq(array, isSorted, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (isSorted != null && typeof isSorted != 'boolean') {
        thisArg = iteratee;
        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
        isSorted = false;
      }
      var callback = getCallback();
      if (!(iteratee == null && callback === baseCallback)) {
        iteratee = callback(iteratee, thisArg, 3);
      }
      return (isSorted && getIndexOf() == baseIndexOf)
        ? sortedUniq(array, iteratee)
        : baseUniq(array, iteratee);
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var index = -1,
          length = 0;

      array = arrayFilter(array, function(group) {
        if (isArrayLike(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      var result = Array(length);
      while (++index < length) {
        result[index] = arrayMap(array, baseProperty(index));
      }
      return result;
    }

    /**
     * This method is like `_.unzip` except that it accepts an iteratee to specify
     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee] The function to combine regrouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      iteratee = bindCallback(iteratee, thisArg, 4);
      return arrayMap(result, function(group) {
        return arrayReduce(group, iteratee, undefined, true);
      });
    }

    /**
     * Creates an array excluding all provided values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */
    var without = restParam(function(array, values) {
      return isArrayLike(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the provided arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xor([1, 2], [4, 2]);
     * // => [1, 4]
     */
    function xor() {
      var index = -1,
          length = arguments.length;

      while (++index < length) {
        var array = arguments[index];
        if (isArrayLike(array)) {
          var result = result
            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
            : array;
        }
      }
      return result ? baseUniq(result) : [];
    }

    /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second elements
     * of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */
    var zip = restParam(unzip);

    /**
     * The inverse of `_.pairs`; this method returns an object composed from arrays
     * of property names and values. Provide either a single two dimensional array,
     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
     * and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Array
     * @param {Array} props The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */
    function zipObject(props, values) {
      var index = -1,
          length = props ? props.length : 0,
          result = {};

      if (length && !values && !isArray(props[0])) {
        values = [];
      }
      while (++index < length) {
        var key = props[index];
        if (values) {
          result[key] = values[index];
        } else if (key) {
          result[key[0]] = key[1];
        }
      }
      return result;
    }

    /**
     * This method is like `_.zip` except that it accepts an iteratee to specify
     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee] The function to combine grouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
     * // => [111, 222]
     */
    var zipWith = restParam(function(arrays) {
      var length = arrays.length,
          iteratee = length > 2 ? arrays[length - 2] : undefined,
          thisArg = length > 1 ? arrays[length - 1] : undefined;

      if (length > 2 && typeof iteratee == 'function') {
        length -= 2;
      } else {
        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
        thisArg = undefined;
      }
      arrays.length = length;
      return unzipWith(arrays, iteratee, thisArg);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object that wraps `value` with explicit method
     * chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(users)
     *   .sortBy('age')
     *   .map(function(chr) {
     *     return chr.user + ' is ' + chr.age;
     *   })
     *   .first()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor is
     * bound to `thisArg` and invoked with one argument; (value). The purpose of
     * this method is to "tap into" a method chain in order to perform operations
     * on intermediate results within the chain.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor, thisArg) {
      interceptor.call(thisArg, value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor, thisArg) {
      return interceptor.call(thisArg, value);
    }

    /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(users).first();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(users).chain()
     *   .first()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chained sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Creates a new array joining a wrapped array with any additional arrays
     * and/or values.
     *
     * @name concat
     * @memberOf _
     * @category Chain
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var wrapped = _(array).concat(2, [3], [[4]]);
     *
     * console.log(wrapped.value());
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    var wrapperConcat = restParam(function(values) {
      values = baseFlatten(values);
      return this.thru(function(array) {
        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
      });
    });

    /**
     * Creates a clone of the chained sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).map(function(value) {
     *   return Math.pow(value, 2);
     * });
     *
     * var other = [3, 4];
     * var otherWrapped = wrapped.plant(other);
     *
     * otherWrapped.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * Reverses the wrapped array so the first element becomes the last, the
     * second element becomes the second to last, and so on.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;

      var interceptor = function(value) {
        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
      };
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(interceptor);
    }

    /**
     * Produces the result of coercing the unwrapped value to a string.
     *
     * @name toString
     * @memberOf _
     * @category Chain
     * @returns {string} Returns the coerced string value.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */
    function wrapperToString() {
      return (this.value() + '');
    }

    /**
     * Executes the chained sequence to extract the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @alias run, toJSON, valueOf
     * @category Chain
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements corresponding to the given keys, or indexes,
     * of `collection`. Keys may be specified as individual arguments or as arrays
     * of keys.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [props] The property names
     *  or indexes of elements to pick, specified individually or in arrays.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * _.at(['a', 'b', 'c'], [0, 2]);
     * // => ['a', 'c']
     *
     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
     * // => ['barney', 'pebbles']
     */
    var at = restParam(function(collection, props) {
      return baseAt(collection, baseFlatten(props));
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the number of times the key was returned by `iteratee`.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * The predicate is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.every(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.filter([4, 5, 6], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [4, 6]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.filter(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.filter(users, 'active'), 'user');
     * // => ['barney']
     */
    function filter(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.result(_.find(users, function(chr) {
     *   return chr.age < 40;
     * }), 'user');
     * // => 'barney'
     *
     * // using the `_.matches` callback shorthand
     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.result(_.find(users, 'active', false), 'user');
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.result(_.find(users, 'active'), 'user');
     * // => 'barney'
     */
    var find = createFind(baseEach);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(baseEachRight, true);

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning the first element that has equivalent property
     * values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
     * // => 'barney'
     *
     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
     * // => 'fred'
     */
    function findWhere(collection, source) {
      return find(collection, baseMatches(source));
    }

    /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection). Iteratee functions may exit iteration early
     * by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from left to right and returns the array
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
     *   console.log(n, key);
     * });
     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
     */
    var forEach = createForEach(arrayEach, baseEach);

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEachRight(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from right to left and returns the array
     */
    var forEachRight = createForEach(arrayEachRight, baseEachRight);

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using the `_.property` callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        result[key] = [value];
      }
    });

    /**
     * Checks if `value` is in `collection` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @alias contains, include
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} target The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */
    function includes(collection, target, fromIndex, guard) {
      var length = collection ? getLength(collection) : 0;
      if (!isLength(length)) {
        collection = values(collection);
        length = collection.length;
      }
      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
        fromIndex = 0;
      } else {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
      }
      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the last element responsible for generating the key. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keyData = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keyData, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return String.fromCharCode(object.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return this.fromCharCode(object.code);
     * }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */
    var indexBy = createAggregator(function(result, value, key) {
      result[key] = value;
    });

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it is
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invoke = restParam(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          isProp = isKey(path),
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
      });
      return result;
    });

    /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
     * `sum`, `uniq`, and `words`
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function timesThree(n) {
     *   return n * 3;
     * }
     *
     * _.map([1, 2], timesThree);
     * // => [3, 6]
     *
     * _.map({ 'a': 1, 'b': 2 }, timesThree);
     * // => [3, 6] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee, thisArg) {
      var func = isArray(collection) ? arrayMap : baseMap;
      iteratee = getCallback(iteratee, thisArg, 3);
      return func(collection, iteratee);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, while the second of which
     * contains elements `predicate` returns falsey for. The predicate is bound
     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * _.partition([1, 2, 3], function(n) {
     *   return n % 2;
     * });
     * // => [[1, 3], [2]]
     *
     * _.partition([1.2, 2.3, 3.4], function(n) {
     *   return this.floor(n) % 2;
     * }, Math);
     * // => [[1.2, 3.4], [2.3]]
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * var mapper = function(array) {
     *   return _.pluck(array, 'user');
     * };
     *
     * // using the `_.matches` callback shorthand
     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
     * // => [['pebbles'], ['barney', 'fred']]
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.map(_.partition(users, 'active', false), mapper);
     * // => [['barney', 'pebbles'], ['fred']]
     *
     * // using the `_.property` callback shorthand
     * _.map(_.partition(users, 'active'), mapper);
     * // => [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Gets the property value of `path` from all elements in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|string} path The path of the property to pluck.
     * @returns {Array} Returns the property values.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(users, 'user');
     * // => ['barney', 'fred']
     *
     * var userIndex = _.indexBy(users, 'user');
     * _.pluck(userIndex, 'age');
     * // => [36, 40] (iteration order is not guaranteed)
     */
    function pluck(collection, path) {
      return map(collection, property(path));
    }

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not provided the first element of `collection` is used as the initial
     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
     * and `sortByOrder`
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(total, n) {
     *   return total + n;
     * });
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
     */
    var reduce = createReduce(arrayReduce, baseEach);

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    var reduceRight = createReduce(arrayReduceRight, baseEachRight);

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.reject([1, 2, 3, 4], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [1, 3]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.reject(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.reject(users, 'active'), 'user');
     * // => ['barney']
     */
    function reject(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, function(value, index, collection) {
        return !predicate(value, index, collection);
      });
    }

    /**
     * Gets a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {*} Returns the random sample(s).
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */
    function sample(collection, n, guard) {
      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
        collection = toIterable(collection);
        var length = collection.length;
        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
      }
      var index = -1,
          result = toArray(collection),
          length = result.length,
          lastIndex = length - 1;

      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
      while (++index < n) {
        var rand = baseRandom(index, lastIndex),
            value = result[rand];

        result[rand] = result[index];
        result[index] = value;
      }
      result.length = n;
      return result;
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      return sample(collection, POSITIVE_INFINITY);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the size of `collection`.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      var length = collection ? getLength(collection) : 0;
      return isLength(length) ? length : keys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * The function returns as soon as it finds a passing value and does not iterate
     * over the entire collection. The predicate is bound to `thisArg` and invoked
     * with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.some(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, thisArg) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through `iteratee`. This method performs
     * a stable sort, that is, it preserves the original sort order of equal elements.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return Math.sin(n);
     * });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return this.sin(n);
     * }, Math);
     * // => [3, 1, 2]
     *
     * var users = [
     *   { 'user': 'fred' },
     *   { 'user': 'pebbles' },
     *   { 'user': 'barney' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.sortBy(users, 'user'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function sortBy(collection, iteratee, thisArg) {
      if (collection == null) {
        return [];
      }
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      var index = -1;
      iteratee = getCallback(iteratee, thisArg, 3);

      var result = baseMap(collection, function(value, key, collection) {
        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
      });
      return baseSortBy(result, compareAscending);
    }

    /**
     * This method is like `_.sortBy` except that it can sort by multiple iteratees
     * or property names.
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
     *  The iteratees to sort by, specified as individual values or arrays of values.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
     *
     * _.map(_.sortByAll(users, 'user', function(chr) {
     *   return Math.floor(chr.age / 10);
     * }), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    var sortByAll = restParam(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var guard = iteratees[2];
      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
        iteratees.length = 1;
      }
      return baseSortByOrder(collection, baseFlatten(iteratees), []);
    });

    /**
     * This method is like `_.sortByAll` except that it allows specifying the
     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
     * values are sorted in ascending order. Otherwise, a value is sorted in
     * ascending order if its corresponding order is "asc", and descending if "desc".
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // sort by `user` in ascending order and by `age` in descending order
     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    function sortByOrder(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (guard && isIterateeCall(iteratees, orders, guard)) {
        orders = undefined;
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseSortByOrder(collection, iteratees, orders);
    }

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning an array of all elements that have equivalent
     * property values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
     * // => ['barney']
     *
     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
     * // => ['fred']
     */
    function where(collection, source) {
      return filter(collection, baseMatches(source));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Date
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */
    var now = nativeNow || function() {
      return new Date().getTime();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it is called `n` or more times.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'done saving!' after the two async saves have completed
     */
    function after(n, func) {
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      n = nativeIsFinite(n = +n) ? n : 0;
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that accepts up to `n` arguments ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      if (guard && isIterateeCall(func, n, guard)) {
        n = undefined;
      }
      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it is called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery('#add').on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method does not set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // using placeholders
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = restParam(function(func, thisArg, partials) {
      var bitmask = BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bind.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all enumerable function
     * properties, own and inherited, of `object` are bound.
     *
     * **Note:** This method does not set the "length" property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} [methodNames] The object method names to bind,
     *  specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs' when the element is clicked
     */
    var bindAll = restParam(function(object, methodNames) {
      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);

      var index = -1,
          length = methodNames.length;

      while (++index < length) {
        var key = methodNames[index];
        object[key] = createWrapper(object[key], BIND_FLAG, object);
      }
      return object;
    });

    /**
     * Creates a function that invokes the method at `object[key]` and prepends
     * any additional `_.bindKey` arguments to those provided to the bound function.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist.
     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // using placeholders
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = restParam(function(object, key, partials) {
      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bindKey.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts one or more arguments of `func` that when
     * called either invokes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` may be specified
     * if `func.length` is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    var curry = createCurry(CURRY_FLAG);

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    var curryRight = createCurry(CURRY_RIGHT_FLAG);

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed invocations. Provide an options object to indicate that `func`
     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
     * Subsequent calls to the debounced function return the result of the last
     * `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify invoking on the leading
     *  edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
     *  delayed before it is invoked.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // ensure `batchLog` is invoked once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }));
     *
     * // cancel a debounced call
     * var todoChanges = _.debounce(batchLog, 1000);
     * Object.observe(models.todo, todoChanges);
     *
     * Object.observe(models, function(changes) {
     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
     *     todoChanges.cancel();
     *   }
     * }, ['delete']);
     *
     * // ...at some point `models.todo` is changed
     * models.todo.completed = true;
     *
     * // ...before 1 second has passed `models.todo` is deleted
     * // which cancels the debounced `todoChanges` call
     * delete models.todo;
     */
    function debounce(func, wait, options) {
      var args,
          maxTimeoutId,
          result,
          stamp,
          thisArg,
          timeoutId,
          trailingCall,
          lastCalled = 0,
          maxWait = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = wait < 0 ? 0 : (+wait || 0);
      if (options === true) {
        var leading = true;
        trailing = false;
      } else if (isObject(options)) {
        leading = !!options.leading;
        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function cancel() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        if (maxTimeoutId) {
          clearTimeout(maxTimeoutId);
        }
        lastCalled = 0;
        maxTimeoutId = timeoutId = trailingCall = undefined;
      }

      function complete(isCalled, id) {
        if (id) {
          clearTimeout(id);
        }
        maxTimeoutId = timeoutId = trailingCall = undefined;
        if (isCalled) {
          lastCalled = now();
          result = func.apply(thisArg, args);
          if (!timeoutId && !maxTimeoutId) {
            args = thisArg = undefined;
          }
        }
      }

      function delayed() {
        var remaining = wait - (now() - stamp);
        if (remaining <= 0 || remaining > wait) {
          complete(trailingCall, maxTimeoutId);
        } else {
          timeoutId = setTimeout(delayed, remaining);
        }
      }

      function maxDelayed() {
        complete(trailing, timeoutId);
      }

      function debounced() {
        args = arguments;
        stamp = now();
        thisArg = this;
        trailingCall = trailing && (timeoutId || !leading);

        if (maxWait === false) {
          var leadingCall = leading && !timeoutId;
        } else {
          if (!maxTimeoutId && !leading) {
            lastCalled = stamp;
          }
          var remaining = maxWait - (stamp - lastCalled),
              isCalled = remaining <= 0 || remaining > maxWait;

          if (isCalled) {
            if (maxTimeoutId) {
              maxTimeoutId = clearTimeout(maxTimeoutId);
            }
            lastCalled = stamp;
            result = func.apply(thisArg, args);
          }
          else if (!maxTimeoutId) {
            maxTimeoutId = setTimeout(maxDelayed, remaining);
          }
        }
        if (isCalled && timeoutId) {
          timeoutId = clearTimeout(timeoutId);
        }
        else if (!timeoutId && wait !== maxWait) {
          timeoutId = setTimeout(delayed, wait);
        }
        if (leadingCall) {
          isCalled = true;
          result = func.apply(thisArg, args);
        }
        if (isCalled && !timeoutId && !maxTimeoutId) {
          args = thisArg = undefined;
        }
        return result;
      }
      debounced.cancel = cancel;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */
    var defer = restParam(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => logs 'later' after one second
     */
    var delay = restParam(function(func, wait, args) {
      return baseDelay(func, wait, args);
    });

    /**
     * Creates a function that returns the result of invoking the provided
     * functions with the `this` binding of the created function, where each
     * successive invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the provided functions from right to left.
     *
     * @static
     * @memberOf _
     * @alias backflow, compose
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is coerced to a string and used as the
     * cache key. The `func` is invoked with the `this` binding of the memoized
     * function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var upperCase = _.memoize(function(string) {
     *   return string.toUpperCase();
     * });
     *
     * upperCase('fred');
     * // => 'FRED'
     *
     * // modifying the result cache
     * upperCase.cache.set('fred', 'BARNEY');
     * upperCase('fred');
     * // => 'BARNEY'
     *
     * // replacing `_.memoize.Cache`
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'barney' };
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'fred' }
     *
     * _.memoize.Cache = WeakMap;
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'barney' }
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new memoize.Cache;
      return memoized;
    }

    /**
     * Creates a function that runs each argument through a corresponding
     * transform function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms] The functions to transform
     * arguments, specified as individual functions or arrays of functions.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var modded = _.modArgs(function(x, y) {
     *   return [x, y];
     * }, square, doubled);
     *
     * modded(1, 2);
     * // => [1, 4]
     *
     * modded(5, 10);
     * // => [25, 20]
     */
    var modArgs = restParam(function(func, transforms) {
      transforms = baseFlatten(transforms);
      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = transforms.length;
      return restParam(function(args) {
        var index = nativeMin(args.length, length);
        while (index--) {
          args[index] = transforms[index](args[index]);
        }
        return func.apply(this, args);
      });
    });

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        return !predicate.apply(this, arguments);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first call. The `func` is invoked
     * with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // using placeholders
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = createPartial(PARTIAL_FLAG);

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to those provided to the new function.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // using placeholders
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified indexes where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     *
     * var map = _.rearg(_.map, [1, 0]);
     * map(function(n) {
     *   return n * 3;
     * }, [1, 2, 3]);
     * // => [3, 6, 9]
     */
    var rearg = restParam(function(func, indexes) {
      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.restParam(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function restParam(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            rest = Array(length);

        while (++index < length) {
          rest[index] = args[start + index];
        }
        switch (start) {
          case 0: return func.call(this, rest);
          case 1: return func.call(this, args[0], rest);
          case 2: return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the created
     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
     *
     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * // with a Promise
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function(array) {
        return func.apply(this, array);
      };
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed invocations. Provide an options object to indicate
     * that `func` should be invoked on the leading and/or trailing edge of the
     * `wait` timeout. Subsequent calls to the throttled function return the
     * result of the last `func` call.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify invoking on the leading
     *  edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     *
     * // cancel a trailing throttled call
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (options === false) {
        leading = false;
      } else if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
    }

    /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      wrapper = wrapper == null ? identity : wrapper;
      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
     * otherwise they are assigned by reference. If `customizer` is provided it is
     * invoked to produce the cloned values. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is bound to
     * `thisArg` and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var shallow = _.clone(users);
     * shallow[0] === users[0];
     * // => true
     *
     * var deep = _.clone(users, true);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.clone(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 0
     */
    function clone(value, isDeep, customizer, thisArg) {
      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
        isDeep = false;
      }
      else if (typeof isDeep == 'function') {
        thisArg = customizer;
        customizer = isDeep;
        isDeep = false;
      }
      return typeof customizer == 'function'
        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
        : baseClone(value, isDeep);
    }

    /**
     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
     * to produce the cloned values. If `customizer` returns `undefined` cloning
     * is handled by the method instead. The `customizer` is bound to `thisArg`
     * and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var deep = _.cloneDeep(users);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.cloneDeep(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 20
     */
    function cloneDeep(value, customizer, thisArg) {
      return typeof customizer == 'function'
        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
        : baseClone(value, true);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    function gt(value, other) {
      return value > other;
    }

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    function gte(value, other) {
      return value >= other;
    }

    /**
     * Checks if `value` is classified as an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    function isArguments(value) {
      return isObjectLike(value) && isArrayLike(value) &&
        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(function() { return arguments; }());
     * // => false
     */
    var isArray = nativeIsArray || function(value) {
      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
    };

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
    }

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    function isDate(value) {
      return isObjectLike(value) && objToString.call(value) == dateTag;
    }

    /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
    }

    /**
     * Checks if `value` is empty. A value is considered empty unless it is an
     * `arguments` object, array, string, or jQuery-like collection with a length
     * greater than `0` or an object with own enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
          (isObjectLike(value) && isFunction(value.splice)))) {
        return !value.length;
      }
      return !keys(value).length;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent. If `customizer` is provided it is invoked to compare values.
     * If `customizer` returns `undefined` comparisons are handled by the method
     * instead. The `customizer` is bound to `thisArg` and invoked with three
     * arguments: (value, other [, index|key]).
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. Functions and DOM nodes
     * are **not** supported. Provide a customizer function to extend support
     * for comparing other values.
     *
     * @static
     * @memberOf _
     * @alias eq
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * object == other;
     * // => false
     *
     * _.isEqual(object, other);
     * // => true
     *
     * // using a customizer callback
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqual(array, other, function(value, other) {
     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
     *     return true;
     *   }
     * });
     * // => true
     */
    function isEqual(value, other, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(10);
     * // => true
     *
     * _.isFinite('10');
     * // => false
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite(Object(10));
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in older versions of Chrome and Safari which return 'function' for regexes
      // and Safari 8 equivalents which return 'object' for typed array constructors.
      return isObject(value) && objToString.call(value) == funcTag;
    }

    /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */
    function isObject(value) {
      // Avoid a V8 JIT bug in Chrome 19-20.
      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }

    /**
     * Performs a deep comparison between `object` and `source` to determine if
     * `object` contains equivalent property values. If `customizer` is provided
     * it is invoked to compare values. If `customizer` returns `undefined`
     * comparisons are handled by the method instead. The `customizer` is bound
     * to `thisArg` and invoked with three arguments: (value, other, index|key).
     *
     * **Note:** This method supports comparing properties of arrays, booleans,
     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
     * and DOM nodes are **not** supported. Provide a customizer function to extend
     * support for comparing other values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     *
     * // using a customizer callback
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatch(object, source, function(value, other) {
     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
     * });
     * // => true
     */
    function isMatch(object, source, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      return baseIsMatch(object, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
     * which returns `true` for `undefined` and other non-numeric values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (value == null) {
        return false;
      }
      if (isFunction(value)) {
        return reIsNative.test(fnToString.call(value));
      }
      return isObjectLike(value) && reIsHostCtor.test(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(8.4);
     * // => true
     *
     * _.isNumber(NaN);
     * // => true
     *
     * _.isNumber('8.4');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * **Note:** This method assumes objects created by the `Object` constructor
     * have no inherited enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      var Ctor;

      // Exit early for non `Object` objects.
      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
        return false;
      }
      // IE < 9 iterates inherited properties before own properties. If the first
      // iterated property is an object's own property then there are no inherited
      // enumerable properties.
      var result;
      // In most environments an object's own properties are iterated before
      // its inherited properties. If the last iterated property is an object's
      // own property then there are no inherited enumerable properties.
      baseForIn(value, function(subValue, key) {
        result = key;
      });
      return result === undefined || hasOwnProperty.call(value, result);
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    function isRegExp(value) {
      return isObject(value) && objToString.call(value) == regexpTag;
    }

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    function isTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
    }

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    function lt(value, other) {
      return value < other;
    }

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    function lte(value, other) {
      return value <= other;
    }

    /**
     * Converts `value` to an array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * (function() {
     *   return _.toArray(arguments).slice(1);
     * }(1, 2, 3));
     * // => [2, 3]
     */
    function toArray(value) {
      var length = value ? getLength(value) : 0;
      if (!isLength(length)) {
        return values(value);
      }
      if (!length) {
        return [];
      }
      return arrayCopy(value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable
     * properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return baseCopy(value, keysIn(value));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * overwrite property assignments of previous sources. If `customizer` is
     * provided it is invoked to produce the merged values of the destination and
     * source properties. If `customizer` returns `undefined` merging is handled
     * by the method instead. The `customizer` is bound to `thisArg` and invoked
     * with five arguments: (objectValue, sourceValue, key, object, source).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     *
     * // using a customizer callback
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(object, other, function(a, b) {
     *   if (_.isArray(a)) {
     *     return a.concat(b);
     *   }
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */
    var merge = createAssigner(baseMerge);

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources overwrite property assignments of previous sources.
     * If `customizer` is provided it is invoked to produce the assigned values.
     * The `customizer` is bound to `thisArg` and invoked with five arguments:
     * (objectValue, sourceValue, key, object, source).
     *
     * **Note:** This method mutates `object` and is based on
     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using a customizer callback
     * var defaults = _.partialRight(_.assign, function(value, other) {
     *   return _.isUndefined(value) ? other : value;
     * });
     *
     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var assign = createAssigner(function(object, source, customizer) {
      return customizer
        ? assignWith(object, source, customizer)
        : baseAssign(object, source);
    });

    /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties, guard) {
      var result = baseCreate(prototype);
      if (guard && isIterateeCall(prototype, properties, guard)) {
        properties = undefined;
      }
      return properties ? baseAssign(result, properties) : result;
    }

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var defaults = createDefaults(assign, assignDefaults);

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
     * // => { 'user': { 'name': 'barney', 'age': 36 } }
     *
     */
    var defaultsDeep = createDefaults(merge, mergeDefaults);

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // using the `_.matches` callback shorthand
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    var findKey = createFindKey(baseForOwn);

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles` assuming `_.findKey` returns `barney`
     *
     * // using the `_.matches` callback shorthand
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    var findLastKey = createFindKey(baseForOwnRight);

    /**
     * Iterates over own and inherited enumerable properties of an object invoking
     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
     */
    var forIn = createForIn(baseFor);

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
     */
    var forInRight = createForIn(baseForRight);

    /**
     * Iterates over own enumerable properties of an object invoking `iteratee`
     * for each property. The `iteratee` is bound to `thisArg` and invoked with
     * three arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' and 'b' (iteration order is not guaranteed)
     */
    var forOwn = createForOwn(baseForOwn);

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
     */
    var forOwnRight = createForOwn(baseForOwnRight);

    /**
     * Creates an array of function property names from all enumerable properties,
     * own and inherited, of `object`.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * _.functions(_);
     * // => ['after', 'ary', 'assign', ...]
     */
    function functions(object) {
      return baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the property value at `path` of `object`. If the resolved value is
     * `undefined` the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': { 'c': 3 } } };
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b.c');
     * // => true
     *
     * _.has(object, ['a', 'b', 'c']);
     * // => true
     */
    function has(object, path) {
      if (object == null) {
        return false;
      }
      var result = hasOwnProperty.call(object, path);
      if (!result && !isKey(path)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        if (object == null) {
          return false;
        }
        path = last(path);
        result = hasOwnProperty.call(object, path);
      }
      return result || (isLength(object.length) && isIndex(path, object.length) &&
        (isArray(object) || isArguments(object)));
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite property
     * assignments of previous values unless `multiValue` is `true`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @param {boolean} [multiValue] Allow multiple values per key.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     *
     * // with `multiValue`
     * _.invert(object, true);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function invert(object, multiValue, guard) {
      if (guard && isIterateeCall(object, multiValue, guard)) {
        multiValue = undefined;
      }
      var index = -1,
          props = keys(object),
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index],
            value = object[key];

        if (multiValue) {
          if (hasOwnProperty.call(result, value)) {
            result[value].push(key);
          } else {
            result[value] = [key];
          }
        }
        else {
          result[value] = key;
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    var keys = !nativeKeys ? shimKeys : function(object) {
      var Ctor = object == null ? undefined : object.constructor;
      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
          (typeof object != 'function' && isArrayLike(object))) {
        return shimKeys(object);
      }
      return isObject(object) ? nativeKeys(object) : [];
    };

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      if (object == null) {
        return [];
      }
      if (!isObject(object)) {
        object = Object(object);
      }
      var length = object.length;
      length = (length && isLength(length) &&
        (isArray(object) || isArguments(object)) && length) || 0;

      var Ctor = object.constructor,
          index = -1,
          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
          result = Array(length),
          skipIndexes = length > 0;

      while (++index < length) {
        result[index] = (index + '');
      }
      for (var key in object) {
        if (!(skipIndexes && isIndex(key, length)) &&
            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * property of `object` through `iteratee`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    var mapKeys = createObjectMapper(true);

    /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through `iteratee`. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, key, object).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
     *   return n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * // using the `_.property` callback shorthand
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    var mapValues = createObjectMapper();

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to omit, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.omit(object, 'age');
     * // => { 'user': 'fred' }
     *
     * _.omit(object, _.isNumber);
     * // => { 'user': 'fred' }
     */
    var omit = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      if (typeof props[0] != 'function') {
        var props = arrayMap(baseFlatten(props), String);
        return pickByArray(object, baseDifference(keysIn(object), props));
      }
      var predicate = bindCallback(props[0], props[1], 3);
      return pickByCallback(object, function(value, key, object) {
        return !predicate(value, key, object);
      });
    });

    /**
     * Creates a two dimensional array of the key-value pairs for `object`,
     * e.g. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
     */
    function pairs(object) {
      object = toObject(object);

      var index = -1,
          props = keys(object),
          length = props.length,
          result = Array(length);

      while (++index < length) {
        var key = props[index];
        result[index] = [key, object[key]];
      }
      return result;
    }

    /**
     * Creates an object composed of the picked `object` properties. Property
     * names may be specified as individual arguments or as arrays of property
     * names. If `predicate` is provided it is invoked for each property of `object`
     * picking the properties `predicate` returns truthy for. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.pick(object, 'user');
     * // => { 'user': 'fred' }
     *
     * _.pick(object, _.isString);
     * // => { 'user': 'fred' }
     */
    var pick = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      return typeof props[0] == 'function'
        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
        : pickByArray(object, baseFlatten(props));
    });

    /**
     * This method is like `_.get` except that if the resolved value is a function
     * it is invoked with the `this` binding of its parent object and its result
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a.b.c', 'default');
     * // => 'default'
     *
     * _.result(object, 'a.b.c', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      var result = object == null ? undefined : object[path];
      if (result === undefined) {
        if (object != null && !isKey(path, object)) {
          path = toPath(path);
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          result = object == null ? undefined : object[last(path)];
        }
        result = result === undefined ? defaultValue : result;
      }
      return isFunction(result) ? result.call(object) : result;
    }

    /**
     * Sets the property value of `path` on `object`. If a portion of `path`
     * does not exist it is created.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to augment.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, 'x[0].y.z', 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      if (object == null) {
        return object;
      }
      var pathKey = (path + '');
      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = path[index];
        if (isObject(nested)) {
          if (index == lastIndex) {
            nested[key] = value;
          } else if (nested[key] == null) {
            nested[key] = isIndex(path[index + 1]) ? [] : {};
          }
        }
        nested = nested[key];
      }
      return object;
    }

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own enumerable
     * properties through `iteratee`, with each invocation potentially mutating
     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
     * with four arguments: (accumulator, value, key, object). Iteratee functions
     * may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * });
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     */
    function transform(object, iteratee, accumulator, thisArg) {
      var isArr = isArray(object) || isTypedArray(object);
      iteratee = getCallback(iteratee, thisArg, 4);

      if (accumulator == null) {
        if (isArr || isObject(object)) {
          var Ctor = object.constructor;
          if (isArr) {
            accumulator = isArray(object) ? new Ctor : [];
          } else {
            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
          }
        } else {
          accumulator = {};
        }
      }
      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable property values
     * of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Checks if `n` is between `start` and up to but not including, `end`. If
     * `end` is not specified it is set to `start` with `start` then set to `0`.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} n The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     */
    function inRange(value, start, end) {
      start = +start || 0;
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      return value >= nativeMin(start, end) && value < nativeMax(start, end);
    }

    /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number is returned.
     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
     * number is returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(min, max, floating) {
      if (floating && isIterateeCall(min, max, floating)) {
        max = floating = undefined;
      }
      var noMin = min == null,
          noMax = max == null;

      if (floating == null) {
        if (noMax && typeof min == 'boolean') {
          floating = min;
          min = 1;
        }
        else if (typeof max == 'boolean') {
          floating = max;
          noMax = true;
        }
      }
      if (noMin && noMax) {
        max = 1;
        noMax = false;
      }
      min = +min || 0;
      if (noMax) {
        max = min;
        min = 0;
      } else {
        max = +max || 0;
      }
      if (floating || min % 1 || max % 1) {
        var rand = nativeRandom();
        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
      }
      return baseRandom(min, max);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar');
     * // => 'fooBar'
     *
     * _.camelCase('__foo_bar__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
    });

    /**
     * Capitalizes the first character of `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('fred');
     * // => 'Fred'
     */
    function capitalize(string) {
      string = baseToString(string);
      return string && (string.charAt(0).toUpperCase() + string.slice(1));
    }

    /**
     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = baseToString(string);
      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = baseToString(string);
      target = (target + '');

      var length = string.length;
      position = position === undefined
        ? length
        : nativeMin(position < 0 ? 0 : (+position || 0), length);

      position -= target.length;
      return position >= 0 && string.indexOf(target, position) == position;
    }

    /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional characters
     * use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value.
     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in Internet Explorer < 9, they can break out
     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
     * for more details.
     *
     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
     * to reduce XSS vectors.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
      string = baseToString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
     */
    function escapeRegExp(string) {
      string = baseToString(string);
      return (string && reHasRegExpChars.test(string))
        ? string.replace(reRegExpChars, escapeRegExpChar)
        : (string || '(?:)');
    }

    /**
     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__foo_bar__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = baseToString(string);
      length = +length;

      var strLength = string.length;
      if (strLength >= length || !nativeIsFinite(length)) {
        return string;
      }
      var mid = (length - strLength) / 2,
          leftLength = nativeFloor(mid),
          rightLength = nativeCeil(mid);

      chars = createPadding('', rightLength, chars);
      return chars.slice(0, leftLength) + string + chars;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padLeft('abc', 6);
     * // => '   abc'
     *
     * _.padLeft('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padLeft('abc', 3);
     * // => 'abc'
     */
    var padLeft = createPadDir();

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padRight('abc', 6);
     * // => 'abc   '
     *
     * _.padRight('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padRight('abc', 3);
     * // => 'abc'
     */
    var padRight = createPadDir(true);

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
     * in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
     * of `parseInt`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
      // Chrome fails to trim leading <BOM> whitespace characters.
      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      string = trim(string);
      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=0] The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n) {
      var result = '';
      string = baseToString(string);
      n = +n;
      if (n < 1 || !string || !nativeIsFinite(n)) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        string += string;
      } while (n);

      return result;
    }

    /**
     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--foo-bar');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__foo_bar__');
     * // => 'Foo Bar'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = baseToString(string);
      position = position == null
        ? 0
        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);

      return string.lastIndexOf(target, position) == position;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is provided it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [options.variable] The data object variable name.
     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // using the HTML "escape" delimiter to escape data property values
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // using custom template delimiters
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using backslashes to treat delimiters as plain text
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // using the `imports` option to import `jQuery` as `jq`
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, otherOptions) {
      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
        options = otherOptions = undefined;
      }
      string = baseToString(string);
      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);

      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products requires returning the `match`
        // string in order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
      }
      chars = (chars + '');
      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimLeft('  abc  ');
     * // => 'abc  '
     *
     * _.trimLeft('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimLeft(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string));
      }
      return string.slice(charsLeftIndex(string, (chars + '')));
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimRight('  abc  ');
     * // => '  abc'
     *
     * _.trimRight('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimRight(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(0, trimmedRightIndex(string) + 1);
      }
      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object|number} [options] The options object or maximum string length.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.trunc('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', 24);
     * // => 'hi-diddly-ho there, n...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function trunc(string, options, guard) {
      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (options != null) {
        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? (+options.length || 0) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        } else {
          length = +options || 0;
        }
      }
      string = baseToString(string);
      if (length >= string.length) {
        return string;
      }
      var end = length - omission.length;
      if (end < 1) {
        return omission;
      }
      var result = string.slice(0, end);
      if (separator == null) {
        return result + omission;
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              newEnd,
              substring = string.slice(0, end);

          if (!separator.global) {
            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            newEnd = match.index;
          }
          result = result.slice(0, newEnd == null ? end : newEnd);
        }
      } else if (string.indexOf(separator, end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
     * corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
     * entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = baseToString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      if (guard && isIterateeCall(string, pattern, guard)) {
        pattern = undefined;
      }
      string = baseToString(string);
      return string.match(pattern || reWords) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function} func The function to attempt.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // avoid throwing errors for invalid selectors
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = restParam(function(func, args) {
      try {
        return func.apply(undefined, args);
      } catch(e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and arguments of the created function. If `func` is a property name the
     * created callback returns the property value for a given element. If `func`
     * is an object the created callback returns `true` for elements that contain
     * the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @alias iteratee
     * @category Utility
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
     *   if (!match) {
     *     return callback(func, thisArg);
     *   }
     *   return function(object) {
     *     return match[2] == 'gt'
     *       ? object[match[1]] > match[3]
     *       : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(users, 'age__gt36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function callback(func, thisArg, guard) {
      if (guard && isIterateeCall(func, thisArg, guard)) {
        thisArg = undefined;
      }
      return isObjectLike(func)
        ? matches(func)
        : baseCallback(func, thisArg);
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that performs a deep comparison between a given object
     * and `source`, returning `true` if the given object has equivalent property
     * values, else `false`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, true));
    }

    /**
     * Creates a function that compares the property value of `path` on a given
     * object to `value`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, true));
    }

    /**
     * Creates a function that invokes the method at `path` on a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': _.constant(2) } } },
     *   { 'a': { 'b': { 'c': _.constant(1) } } }
     * ];
     *
     * _.map(objects, _.method('a.b.c'));
     * // => [2, 1]
     *
     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    var method = restParam(function(path, args) {
      return function(object) {
        return invokePath(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path on `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = restParam(function(object, args) {
      return function(path) {
        return invokePath(object, path, args);
      };
    });

    /**
     * Adds all own enumerable function properties of a source object to the
     * destination object. If `object` is a function then methods are added to
     * its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added
     *  are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      if (options == null) {
        var isObj = isObject(source),
            props = isObj ? keys(source) : undefined,
            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;

        if (!(methodNames ? methodNames.length : isObj)) {
          methodNames = false;
          options = source;
          source = object;
          object = this;
        }
      }
      if (!methodNames) {
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = true,
          index = -1,
          isFunc = isFunction(object),
          length = methodNames.length;

      if (options === false) {
        chain = false;
      } else if (isObject(options) && 'chain' in options) {
        chain = options.chain;
      }
      while (++index < length) {
        var methodName = methodNames[index],
            func = source[methodName];

        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = (function(func) {
            return function() {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                    actions = result.__actions__ = arrayCopy(this.__actions__);

                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }(func));
        }
      }
      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      root._ = oldDash;
      return this;
    }

    /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that returns the property value at `path` on a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the property value at a given path on `object`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return baseGet(object, toPath(path), path + '');
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. If `end` is not specified it is
     * set to `start` with `start` then set to `0`. If `end` is less than `start`
     * a zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    function range(start, end, step) {
      if (step && isIterateeCall(start, end, step)) {
        end = step = undefined;
      }
      start = +start || 0;
      step = step == null ? 1 : (+step || 0);

      if (end == null) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (++index < length) {
        result[index] = start;
        start += step;
      }
      return result;
    }

    /**
     * Invokes the iteratee function `n` times, returning an array of the results
     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
     * one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) {
     *   mage.castSpell(n);
     * });
     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
     *
     * _.times(3, function(n) {
     *   this.cast(n);
     * }, mage);
     * // => also invokes `mage.castSpell(n)` three times
     */
    function times(n, iteratee, thisArg) {
      n = nativeFloor(n);

      // Exit early to avoid a JSC JIT bug in Safari 8
      // where `Array(0)` is treated as `Array(1)`.
      if (n < 1 || !nativeIsFinite(n)) {
        return [];
      }
      var index = -1,
          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));

      iteratee = bindCallback(iteratee, thisArg, 1);
      while (++index < n) {
        if (index < MAX_ARRAY_LENGTH) {
          result[index] = iteratee(index);
        } else {
          iteratee(index);
        }
      }
      return result;
    }

    /**
     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return baseToString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} augend The first number to add.
     * @param {number} addend The second number to add.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    function add(augend, addend) {
      return (+augend || 0) + (+addend || 0);
    }

    /**
     * Calculates `n` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Calculates `n` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Gets the maximum value of `collection`. If `collection` is empty or falsey
     * `-Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => -Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.max(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using the `_.property` callback shorthand
     * _.max(users, 'age');
     * // => { 'user': 'fred', 'age': 40 }
     */
    var max = createExtremum(gt, NEGATIVE_INFINITY);

    /**
     * Gets the minimum value of `collection`. If `collection` is empty or falsey
     * `Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.min(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // using the `_.property` callback shorthand
     * _.min(users, 'age');
     * // => { 'user': 'barney', 'age': 36 }
     */
    var min = createExtremum(lt, POSITIVE_INFINITY);

    /**
     * Calculates `n` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Gets the sum of the values in `collection`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 6]);
     * // => 10
     *
     * _.sum({ 'a': 4, 'b': 6 });
     * // => 10
     *
     * var objects = [
     *   { 'n': 4 },
     *   { 'n': 6 }
     * ];
     *
     * _.sum(objects, function(object) {
     *   return object.n;
     * });
     * // => 10
     *
     * // using the `_.property` callback shorthand
     * _.sum(objects, 'n');
     * // => 10
     */
    function sum(collection, iteratee, thisArg) {
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      iteratee = getCallback(iteratee, thisArg, 3);
      return iteratee.length == 1
        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
        : baseSum(collection, iteratee);
    }

    /*------------------------------------------------------------------------*/

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    // Add functions to the `Map` cache.
    MapCache.prototype['delete'] = mapDelete;
    MapCache.prototype.get = mapGet;
    MapCache.prototype.has = mapHas;
    MapCache.prototype.set = mapSet;

    // Add functions to the `Set` cache.
    SetCache.prototype.push = cachePush;

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    // Add functions that return wrapped values when chaining.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.callback = callback;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.functions = functions;
    lodash.groupBy = groupBy;
    lodash.indexBy = indexBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.invert = invert;
    lodash.invoke = invoke;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.modArgs = modArgs;
    lodash.negate = negate;
    lodash.omit = omit;
    lodash.once = once;
    lodash.pairs = pairs;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pluck = pluck;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.restParam = restParam;
    lodash.set = set;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortByAll = sortByAll;
    lodash.sortByOrder = sortByOrder;
    lodash.spread = spread;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.times = times;
    lodash.toArray = toArray;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.union = union;
    lodash.uniq = uniq;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.where = where;
    lodash.without = without;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.backflow = flowRight;
    lodash.collect = map;
    lodash.compose = flowRight;
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.extend = assign;
    lodash.iteratee = callback;
    lodash.methods = functions;
    lodash.object = zipObject;
    lodash.select = filter;
    lodash.tail = rest;
    lodash.unique = uniq;

    // Add functions to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add functions that return unwrapped values when chaining.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.deburr = deburr;
    lodash.endsWith = endsWith;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.findWhere = findWhere;
    lodash.first = first;
    lodash.floor = floor;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isBoolean = isBoolean;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isMatch = isMatch;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isString = isString;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.min = min;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padLeft = padLeft;
    lodash.padRight = padRight;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.sum = sum;
    lodash.template = template;
    lodash.trim = trim;
    lodash.trimLeft = trimLeft;
    lodash.trimRight = trimRight;
    lodash.trunc = trunc;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.words = words;

    // Add aliases.
    lodash.all = every;
    lodash.any = some;
    lodash.contains = includes;
    lodash.eq = isEqual;
    lodash.detect = find;
    lodash.foldl = reduce;
    lodash.foldr = reduceRight;
    lodash.head = first;
    lodash.include = includes;
    lodash.inject = reduce;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!lodash.prototype[methodName]) {
          source[methodName] = func;
        }
      });
      return source;
    }()), false);

    /*------------------------------------------------------------------------*/

    // Add functions capable of returning wrapped and unwrapped values when chaining.
    lodash.sample = sample;

    lodash.prototype.sample = function(n) {
      if (!this.__chain__ && n == null) {
        return sample(this.value());
      }
      return this.thru(function(value) {
        return sample(value, n);
      });
    };

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        var filtered = this.__filtered__;
        if (filtered && !index) {
          return new LazyWrapper(this);
        }
        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);

        var result = this.clone();
        if (filtered) {
          result.__takeCount__ = nativeMin(result.__takeCount__, n);
        } else {
          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type != LAZY_MAP_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
        var result = this.clone();
        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.first` and `_.last`.
    arrayEach(['first', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
    arrayEach(['initial', 'rest'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
    arrayEach(['pluck', 'where'], function(methodName, index) {
      var operationName = index ? 'filter' : 'map',
          createCallback = index ? baseMatches : property;

      LazyWrapper.prototype[methodName] = function(value) {
        return this[operationName](createCallback(value));
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.reject = function(predicate, thisArg) {
      predicate = getCallback(predicate, thisArg, 1);
      return this.filter(function(value) {
        return !predicate(value);
      });
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = start == null ? 0 : (+start || 0);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = (+end || 0);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
      return this.reverse().takeWhile(predicate, thisArg).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(POSITIVE_INFINITY);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
          retUnwrapped = /^(?:first|last)$/.test(methodName),
          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var args = retUnwrapped ? [1] : arguments,
            chainAll = this.__chain__,
            value = this.__wrapped__,
            isHybrid = !!this.__actions__.length,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var interceptor = function(value) {
          return (retUnwrapped && chainAll)
            ? lodashFunc(value, 1)[0]
            : lodashFunc.apply(undefined, arrayPush([value], args));
        };

        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
            onlyLazy = isLazy && !isHybrid;

        if (retUnwrapped && !chainAll) {
          if (onlyLazy) {
            value = value.clone();
            value.__actions__.push(action);
            return func.call(value);
          }
          return lodashFunc.call(undefined, this.value())[0];
        }
        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push(action);
          return new LodashWrapper(result, chainAll);
        }
        return this.thru(interceptor);
      };
    });

    // Add `Array` and `String` methods to `lodash.prototype`.
    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          return func.apply(this.value(), args);
        }
        return this[chainName](function(value) {
          return func.apply(value, args);
        });
      };
    });

    // Map minified function names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name,
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];

    // Add functions to the lazy wrapper.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chaining functions to the `lodash` wrapper.
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.concat = wrapperConcat;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toString = wrapperToString;
    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add function aliases to the `lodash` wrapper.
    lodash.prototype.collect = lodash.prototype.map;
    lodash.prototype.head = lodash.prototype.first;
    lodash.prototype.select = lodash.prototype.filter;
    lodash.prototype.tail = lodash.prototype.rest;

    return lodash;
  }

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers like r.js check for condition patterns like the following:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose lodash to the global object when an AMD loader is present to avoid
    // errors in cases where lodash is loaded by a script tag and not intended
    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
    // more details.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for Node.js or RingoJS.
    if (moduleExports) {
      (freeModule.exports = _)._ = _;
    }
    // Export for Rhino with CommonJS support.
    else {
      freeExports._ = _;
    }
  }
  else {
    // Export for a browser or Rhino.
    root._ = _;
  }
}.call(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],106:[function(require,module,exports){
//! moment.js
//! version : 2.14.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, function () { 'use strict';

    var hookCallback;

    function utils_hooks__hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        return Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        var k;
        for (k in obj) {
            // even if its not own property I'd still call it non-empty
            return false;
        }
        return true;
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function create_utc__createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function valid__isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            m._isValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                m._isValid = m._isValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        return m._isValid;
    }

    function valid__createInvalid (flags) {
        var m = create_utc__createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    function isUndefined(input) {
        return input === void 0;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = utils_hooks__hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i in momentProperties) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            utils_hooks__hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (utils_hooks__hooks.deprecationHandler != null) {
                utils_hooks__hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(arguments).join(', ') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (utils_hooks__hooks.deprecationHandler != null) {
            utils_hooks__hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    utils_hooks__hooks.suppressDeprecationWarnings = false;
    utils_hooks__hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function locale_set__set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _ordinalParseLenient.
        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function locale_calendar__calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                get_set__set(this, unit, value);
                utils_hooks__hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get_set__get(this, unit);
            }
        };
    }

    function get_set__get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function get_set__set (mom, unit, value) {
        if (mom.isValid()) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (typeof callback === 'number') {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function units_month__handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = create_utc__createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return units_month__handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (typeof value !== 'number') {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            utils_hooks__hooks.updateOffset(this, true);
            return this;
        } else {
            return get_set__get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    utils_hooks__hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function createDate (y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        //the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return this._weekdaysShort[m.day()];
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return this._weekdaysMin[m.day()];
    }

    function day_of_week__handleStrictParse(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = create_utc__createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return day_of_week__handleStrictParse.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = create_utc__createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        ordinalParse: defaultOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                require('./locale/' + name);
                // because defineLocale currently also sets the global locale, we
                // want to undo that for lazy loaded locales
                locale_locales__getSetGlobalLocale(oldLocale);
            } catch (e) { }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function locale_locales__getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = locale_locales__getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    // treat as if there is no base config
                    deprecateSimple('parentLocaleUndefined',
                            'specified parentLocale is not defined yet. See http://momentjs.com/guides/#/warnings/parent-locale/');
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            // backwards compat for now: also set the locale
            locale_locales__getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, parentConfig = baseConfig;
            // MERGE
            if (locales[name] != null) {
                parentConfig = locales[name]._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            locale_locales__getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function locale_locales__getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function locale_locales__listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    utils_hooks__hooks.createFromInputFallback = deprecate(
        'moment construction falls back to js Date. This is ' +
        'discouraged and will be removed in upcoming major ' +
        'release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(utils_hooks__hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse)) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
            week = defaults(w.w, 1);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    utils_hooks__hooks.ISO_8601 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === utils_hooks__hooks.ISO_8601) {
            configFromISO(config);
            return;
        }

        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!valid__isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || locale_locales__getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return valid__createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (isDate(input)) {
            config._d = input;
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!valid__isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (input === undefined) {
            config._d = new Date(utils_hooks__hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (typeof(input) === 'object') {
            configFromObject(config);
        } else if (typeof(input) === 'number') {
            // from milliseconds
            config._d = new Date(input);
        } else {
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (typeof(locale) === 'boolean') {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function local__createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = local__createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return valid__createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = local__createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return valid__createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return local__createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = locale_locales__getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = ((string || '').match(matcher) || []);
        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : local__createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            utils_hooks__hooks.updateOffset(res, false);
            return res;
        } else {
            return local__createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    utils_hooks__hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
            } else if (Math.abs(input) < 16) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    utils_hooks__hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm) {
            this.utcOffset(this._tzm);
        } else if (typeof this._i === 'string') {
            this.utcOffset(offsetFromString(matchOffset, this._i));
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? local__createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?\d*)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

    function create__createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (typeof input === 'number') {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])        * sign,
                h  : toInt(match[HOUR])        * sign,
                m  : toInt(match[MINUTE])      * sign,
                s  : toInt(match[SECOND])      * sign,
                ms : toInt(match[MILLISECOND]) * sign
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    create__createDuration.fn = Duration.prototype;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = create__createDuration(val, period);
            add_subtract__addSubtract(this, dur, direction);
            return this;
        };
    }

    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (days) {
            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
        }
        if (months) {
            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            utils_hooks__hooks.updateOffset(mom, days || months);
        }
    }

    var add_subtract__add      = createAdder(1, 'add');
    var add_subtract__subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function moment_calendar__calendar (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || local__createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = utils_hooks__hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            delta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        if (units === 'year' || units === 'month' || units === 'quarter') {
            output = monthDiff(this, that);
            if (units === 'quarter') {
                output = output / 3;
            } else if (units === 'year') {
                output = output / 12;
            }
        } else {
            delta = this - that;
            output = units === 'second' ? delta / 1e3 : // 1000
                units === 'minute' ? delta / 6e4 : // 1000 * 60
                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                delta;
        }
        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    utils_hooks__hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function moment_format__toISOString () {
        var m = this.clone().utc();
        if (0 < m.year() && m.year() <= 9999) {
            if (isFunction(Date.prototype.toISOString)) {
                // native implementation is ~50x faster, use it when we can
                return this.toDate().toISOString();
            } else {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        } else {
            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? utils_hooks__hooks.defaultFormatUtc : utils_hooks__hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(local__createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(local__createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = locale_locales__getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function to_type__valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function moment_valid__isValid () {
        return valid__isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIOROITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0], 10);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var momentPrototype__proto = Moment.prototype;

    momentPrototype__proto.add               = add_subtract__add;
    momentPrototype__proto.calendar          = moment_calendar__calendar;
    momentPrototype__proto.clone             = clone;
    momentPrototype__proto.diff              = diff;
    momentPrototype__proto.endOf             = endOf;
    momentPrototype__proto.format            = format;
    momentPrototype__proto.from              = from;
    momentPrototype__proto.fromNow           = fromNow;
    momentPrototype__proto.to                = to;
    momentPrototype__proto.toNow             = toNow;
    momentPrototype__proto.get               = stringGet;
    momentPrototype__proto.invalidAt         = invalidAt;
    momentPrototype__proto.isAfter           = isAfter;
    momentPrototype__proto.isBefore          = isBefore;
    momentPrototype__proto.isBetween         = isBetween;
    momentPrototype__proto.isSame            = isSame;
    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
    momentPrototype__proto.isValid           = moment_valid__isValid;
    momentPrototype__proto.lang              = lang;
    momentPrototype__proto.locale            = locale;
    momentPrototype__proto.localeData        = localeData;
    momentPrototype__proto.max               = prototypeMax;
    momentPrototype__proto.min               = prototypeMin;
    momentPrototype__proto.parsingFlags      = parsingFlags;
    momentPrototype__proto.set               = stringSet;
    momentPrototype__proto.startOf           = startOf;
    momentPrototype__proto.subtract          = add_subtract__subtract;
    momentPrototype__proto.toArray           = toArray;
    momentPrototype__proto.toObject          = toObject;
    momentPrototype__proto.toDate            = toDate;
    momentPrototype__proto.toISOString       = moment_format__toISOString;
    momentPrototype__proto.toJSON            = toJSON;
    momentPrototype__proto.toString          = toString;
    momentPrototype__proto.unix              = unix;
    momentPrototype__proto.valueOf           = to_type__valueOf;
    momentPrototype__proto.creationData      = creationData;

    // Year
    momentPrototype__proto.year       = getSetYear;
    momentPrototype__proto.isLeapYear = getIsLeapYear;

    // Week Year
    momentPrototype__proto.weekYear    = getSetWeekYear;
    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;

    // Quarter
    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;

    // Month
    momentPrototype__proto.month       = getSetMonth;
    momentPrototype__proto.daysInMonth = getDaysInMonth;

    // Week
    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
    momentPrototype__proto.weeksInYear    = getWeeksInYear;
    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;

    // Day
    momentPrototype__proto.date       = getSetDayOfMonth;
    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
    momentPrototype__proto.dayOfYear  = getSetDayOfYear;

    // Hour
    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;

    // Minute
    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;

    // Second
    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;

    // Millisecond
    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;

    // Offset
    momentPrototype__proto.utcOffset            = getSetOffset;
    momentPrototype__proto.utc                  = setOffsetToUTC;
    momentPrototype__proto.local                = setOffsetToLocal;
    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
    momentPrototype__proto.isDST                = isDaylightSavingTime;
    momentPrototype__proto.isLocal              = isLocal;
    momentPrototype__proto.isUtcOffset          = isUtcOffset;
    momentPrototype__proto.isUtc                = isUtc;
    momentPrototype__proto.isUTC                = isUtc;

    // Timezone
    momentPrototype__proto.zoneAbbr = getZoneAbbr;
    momentPrototype__proto.zoneName = getZoneName;

    // Deprecations
    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    momentPrototype__proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    var momentPrototype = momentPrototype__proto;

    function moment__createUnix (input) {
        return local__createLocal(input * 1000);
    }

    function moment__createInZone () {
        return local__createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var prototype__proto = Locale.prototype;

    prototype__proto.calendar        = locale_calendar__calendar;
    prototype__proto.longDateFormat  = longDateFormat;
    prototype__proto.invalidDate     = invalidDate;
    prototype__proto.ordinal         = ordinal;
    prototype__proto.preparse        = preParsePostFormat;
    prototype__proto.postformat      = preParsePostFormat;
    prototype__proto.relativeTime    = relative__relativeTime;
    prototype__proto.pastFuture      = pastFuture;
    prototype__proto.set             = locale_set__set;

    // Month
    prototype__proto.months            =        localeMonths;
    prototype__proto.monthsShort       =        localeMonthsShort;
    prototype__proto.monthsParse       =        localeMonthsParse;
    prototype__proto.monthsRegex       = monthsRegex;
    prototype__proto.monthsShortRegex  = monthsShortRegex;

    // Week
    prototype__proto.week = localeWeek;
    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;

    // Day of Week
    prototype__proto.weekdays       =        localeWeekdays;
    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
    prototype__proto.weekdaysParse  =        localeWeekdaysParse;

    prototype__proto.weekdaysRegex       =        weekdaysRegex;
    prototype__proto.weekdaysShortRegex  =        weekdaysShortRegex;
    prototype__proto.weekdaysMinRegex    =        weekdaysMinRegex;

    // Hours
    prototype__proto.isPM = localeIsPM;
    prototype__proto.meridiem = localeMeridiem;

    function lists__get (format, index, field, setter) {
        var locale = locale_locales__getLocale();
        var utc = create_utc__createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (typeof format === 'number') {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return lists__get(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = lists__get(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (typeof format === 'number') {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (typeof format === 'number') {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = locale_locales__getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return lists__get(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = lists__get(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function lists__listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function lists__listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function lists__listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function lists__listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function lists__listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    locale_locales__getSetGlobalLocale('en', {
        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports
    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);

    var mathAbs = Math.abs;

    function duration_abs__abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function duration_add_subtract__addSubtract (duration, input, value, direction) {
        var other = create__createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function duration_add_subtract__add (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function duration_add_subtract__subtract (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function duration_as__valueOf () {
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function duration_get__get (units) {
        units = normalizeUnits(units);
        return this[units + 's']();
    }

    function makeGetter(name) {
        return function () {
            return this._data[name];
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        s: 45,  // seconds to minute
        m: 45,  // minutes to hour
        h: 22,  // hours to day
        d: 26,  // days to month
        M: 11   // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
        var duration = create__createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds < thresholds.s && ['s', seconds]  ||
                minutes <= 1           && ['m']           ||
                minutes < thresholds.m && ['mm', minutes] ||
                hours   <= 1           && ['h']           ||
                hours   < thresholds.h && ['hh', hours]   ||
                days    <= 1           && ['d']           ||
                days    < thresholds.d && ['dd', days]    ||
                months  <= 1           && ['M']           ||
                months  < thresholds.M && ['MM', months]  ||
                years   <= 1           && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function duration_humanize__getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        return true;
    }

    function humanize (withSuffix) {
        var locale = this.localeData();
        var output = duration_humanize__relativeTime(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var iso_string__abs = Math.abs;

    function iso_string__toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        var seconds = iso_string__abs(this._milliseconds) / 1000;
        var days         = iso_string__abs(this._days);
        var months       = iso_string__abs(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds;
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        return (total < 0 ? '-' : '') +
            'P' +
            (Y ? Y + 'Y' : '') +
            (M ? M + 'M' : '') +
            (D ? D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? h + 'H' : '') +
            (m ? m + 'M' : '') +
            (s ? s + 'S' : '');
    }

    var duration_prototype__proto = Duration.prototype;

    duration_prototype__proto.abs            = duration_abs__abs;
    duration_prototype__proto.add            = duration_add_subtract__add;
    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
    duration_prototype__proto.as             = as;
    duration_prototype__proto.asMilliseconds = asMilliseconds;
    duration_prototype__proto.asSeconds      = asSeconds;
    duration_prototype__proto.asMinutes      = asMinutes;
    duration_prototype__proto.asHours        = asHours;
    duration_prototype__proto.asDays         = asDays;
    duration_prototype__proto.asWeeks        = asWeeks;
    duration_prototype__proto.asMonths       = asMonths;
    duration_prototype__proto.asYears        = asYears;
    duration_prototype__proto.valueOf        = duration_as__valueOf;
    duration_prototype__proto._bubble        = bubble;
    duration_prototype__proto.get            = duration_get__get;
    duration_prototype__proto.milliseconds   = milliseconds;
    duration_prototype__proto.seconds        = seconds;
    duration_prototype__proto.minutes        = minutes;
    duration_prototype__proto.hours          = hours;
    duration_prototype__proto.days           = days;
    duration_prototype__proto.weeks          = weeks;
    duration_prototype__proto.months         = months;
    duration_prototype__proto.years          = years;
    duration_prototype__proto.humanize       = humanize;
    duration_prototype__proto.toISOString    = iso_string__toISOString;
    duration_prototype__proto.toString       = iso_string__toISOString;
    duration_prototype__proto.toJSON         = iso_string__toISOString;
    duration_prototype__proto.locale         = locale;
    duration_prototype__proto.localeData     = localeData;

    // Deprecations
    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
    duration_prototype__proto.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    utils_hooks__hooks.version = '2.14.1';

    setHookCallback(local__createLocal);

    utils_hooks__hooks.fn                    = momentPrototype;
    utils_hooks__hooks.min                   = min;
    utils_hooks__hooks.max                   = max;
    utils_hooks__hooks.now                   = now;
    utils_hooks__hooks.utc                   = create_utc__createUTC;
    utils_hooks__hooks.unix                  = moment__createUnix;
    utils_hooks__hooks.months                = lists__listMonths;
    utils_hooks__hooks.isDate                = isDate;
    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
    utils_hooks__hooks.invalid               = valid__createInvalid;
    utils_hooks__hooks.duration              = create__createDuration;
    utils_hooks__hooks.isMoment              = isMoment;
    utils_hooks__hooks.weekdays              = lists__listWeekdays;
    utils_hooks__hooks.parseZone             = moment__createInZone;
    utils_hooks__hooks.localeData            = locale_locales__getLocale;
    utils_hooks__hooks.isDuration            = isDuration;
    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
    utils_hooks__hooks.defineLocale          = defineLocale;
    utils_hooks__hooks.updateLocale          = updateLocale;
    utils_hooks__hooks.locales               = locale_locales__listLocales;
    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
    utils_hooks__hooks.relativeTimeRounding = duration_humanize__getSetRelativeTimeRounding;
    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
    utils_hooks__hooks.calendarFormat        = getCalendarFormat;
    utils_hooks__hooks.prototype             = momentPrototype;

    var _moment = utils_hooks__hooks;

    return _moment;

}));
},{}],107:[function(require,module,exports){
// Generated by CoffeeScript 2.0.0-beta7
exports.V2 = {
  construct: require('./v2/construct'),
  parse: require('./v2/parse')
};
exports.V1 = {
  construct: require('./v1/construct'),
  parse: require('./v1/parse')
};
exports.helpers = {
  parsedParams: require('./parsed_params'),
  UrlString: require('./url')
};

},{"./parsed_params":109,"./url":110,"./v1/construct":111,"./v1/parse":112,"./v2/construct":113,"./v2/parse":115}],108:[function(require,module,exports){
// Generated by CoffeeScript 2.0.0-beta7
module.exports = {
  pickAndExecute: function (hash, keyList, cb) {
    return function (accum$) {
      var key, value;
      for (var i$ = 0, length$ = keyList.length; i$ < length$; ++i$) {
        key = keyList[i$];
        value = hash[key];
        accum$.push(cb(key, value));
      }
      return accum$;
    }.call(this, []);
  }
};

},{}],109:[function(require,module,exports){
(function (global){
// Generated by CoffeeScript 2.0.0-beta7
void function () {
  var any, cache$, isArray, isString;
  cache$ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
  isArray = cache$.isArray;
  isString = cache$.isString;
  any = cache$.any;
  exports.ParsedParams = function () {
    var doesParamExist;
    function class$(paramArgs, param$) {
      var cache$1, paramName;
      if (null == param$)
        param$ = [];
      this.paramList = param$;
      cache$1 = paramArgs;
      this.partySize = cache$1.partySize;
      this.date = cache$1.date;
      this.time = cache$1.time;
      this.l1Category = cache$1.l1Category;
      this.l2Categories = cache$1.l2Categories;
      this.l3Categories = cache$1.l3Categories;
      this.l4Categories = cache$1.l4Categories;
      this.interests = cache$1.interests;
      this.discounts = cache$1.discounts;
      this.minPrice = cache$1.minPrice;
      this.maxPrice = cache$1.maxPrice;
      this.brands = cache$1.brands;
      this.locations = cache$1.locations;
      this.mainLocation = cache$1.mainLocation;
      if (null != this.l2Categories)
        this.l2Categories;
      else
        this.l2Categories = [];
      if (null != this.l3Categories)
        this.l3Categories;
      else
        this.l3Categories = [];
      if (null != this.l4Categories)
        this.l4Categories;
      else
        this.l4Categories = [];
      if (null != this.interests)
        this.interests;
      else
        this.interests = [];
      if (null != this.discounts)
        this.discounts;
      else
        this.discounts = [];
      if (null != this.locations)
        this.locations;
      else
        this.locations = [];
      for (var i$ = 0, length$ = this.paramList.length; i$ < length$; ++i$) {
        paramName = this.paramList[i$];
        this[paramName] = null != paramArgs[paramName] ? paramArgs[paramName] : [];
      }
    }
    class$.prototype.applyImplicitCategory2 = function (l2Category) {
      return this._implicitL2Category = l2Category;
    };
    class$.prototype.getCategory2 = function () {
      return null != this.l2Categories[0] ? this.l2Categories[0] : this._implicitL2Category;
    };
    class$.prototype.anyL1Categories = function () {
      return doesParamExist(this.l1Category);
    };
    class$.prototype.anyL2Categories = function () {
      return doesParamExist(this.l2Categories);
    };
    class$.prototype.anyL3Categories = function () {
      return doesParamExist(this.l3Categories);
    };
    class$.prototype.anyL4Categories = function () {
      return doesParamExist(this.l4Categories);
    };
    class$.prototype.anyCategoriesPresent = function () {
      return any([
        this.anyL4Categories(),
        this.anyL3Categories(),
        this.anyL2Categories(),
        this.anyL1Categories()
      ]);
    };
    class$.prototype.anyFiltersPresent = function () {
      return any([
        this.anyCategoriesPresent(),
        this.anyInterests(),
        this.anyDiscounts(),
        this.anyPrices(),
        this.anyLocations(),
        this.anyAvailabilities(),
        this.anyBrands(),
        this.anyExtraParams()
      ]);
    };
    class$.prototype.anyExtraParams = function () {
      return any(this.paramList.map(function (this$) {
        return function (paramName) {
          return this$.anyParamsByName(paramName);
        };
      }(this)));
    };
    class$.prototype.anyParamsByName = function (paramName) {
      return doesParamExist(this[paramName]);
    };
    class$.prototype.anyAvailabilities = function () {
      return doesParamExist(this.date) || doesParamExist(this.time) || doesParamExist(this.partySize);
    };
    class$.prototype.anyInterests = function () {
      return doesParamExist(this.interests);
    };
    class$.prototype.anyDiscounts = function () {
      return doesParamExist(this.discounts);
    };
    class$.prototype.anyPrices = function () {
      return !!this.minPrice || !!this.maxPrice;
    };
    class$.prototype.anyBrands = function () {
      return doesParamExist(this.brands);
    };
    class$.prototype.anyLocations = function () {
      return doesParamExist(this.locations) || doesParamExist(this.mainLocation);
    };
    doesParamExist = function (inputParam) {
      if (isArray(inputParam) || isString(inputParam)) {
        return inputParam.length > 0;
      } else {
        return false;
      }
    };
    return class$;
  }();
}.call(this);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],110:[function(require,module,exports){
(function (global){
// Generated by CoffeeScript 2.0.0-beta7
void function () {
  var cache$, each, keys, omit;
  cache$ = 'undefined' !== typeof _ && null != _ ? _ : (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
  keys = cache$.keys;
  each = cache$.each;
  omit = cache$.omit;
  exports.UrlString = function () {
    class$.prototype.RESERVED_PARAMS = [
      'partySize',
      'date',
      'time',
      'brand',
      'category',
      'category2',
      'category3',
      'interest',
      'location',
      'topcategory'
    ];
    function class$(baseURL) {
      this.url = '';
      if (null != baseURL)
        this.append(baseURL);
    }
    class$.prototype.appendPath = function (pathValue) {
      return this.url += '/' + pathValue;
    };
    class$.prototype.appendQuery = function (hash) {
      return this.url += '?' + this.stringifyQS(hash);
    };
    class$.prototype.append = function (newValue) {
      return this.url += newValue;
    };
    class$.prototype.removeReservedQS = function (QS) {
      return omit(QS, this.RESERVED_PARAMS);
    };
    class$.prototype.getUrl = function () {
      return this.url;
    };
    class$.prototype.stringifyQS = function (hash) {
      var cache$2, encodedValue, hashKey, hashValue, stingifiedQS;
      stingifiedQS = '';
      for (var cache$1 = (cache$2 = keys(hash).sort(), null != cache$2 ? cache$2 : []), i$ = 0, length$ = cache$1.length; i$ < length$; ++i$) {
        hashKey = cache$1[i$];
        if (stingifiedQS.length > 0)
          stingifiedQS += '&';
        hashValue = hash[hashKey];
        encodedValue = encodeURIComponent(hashValue);
        stingifiedQS += '' + hashKey + '=' + encodedValue;
      }
      return stingifiedQS;
    };
    return class$;
  }();
}.call(this);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],111:[function(require,module,exports){
(function (global){
// Generated by CoffeeScript 2.0.0-beta7
void function () {
  var cache$, compact, each, extend, isEmpty, joinParam, omitUndefined, pickAndExecute, UrlString;
  cache$ = 'undefined' !== typeof _ && null != _ ? _ : (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
  isEmpty = cache$.isEmpty;
  each = cache$.each;
  extend = cache$.extend;
  compact = cache$.compact;
  UrlString = require('../url').UrlString;
  pickAndExecute = require('../param_list_helper').pickAndExecute;
  module.exports = function (queryParams, paramList) {
    var baseURL, brands, cache$1, clonedQS, date, discounts, division, extraQS, interests, l2Categories, l3Categories, l4Categories, locations, maxPrice, minPrice, partySize, time, topcategory, urlInstance;
    cache$1 = queryParams;
    partySize = cache$1.partySize;
    date = cache$1.date;
    time = cache$1.time;
    topcategory = cache$1.topcategory;
    l2Categories = cache$1.l2Categories;
    l3Categories = cache$1.l3Categories;
    l4Categories = cache$1.l4Categories;
    interests = cache$1.interests;
    discounts = cache$1.discounts;
    minPrice = cache$1.minPrice;
    maxPrice = cache$1.maxPrice;
    brands = cache$1.brands;
    locations = cache$1.locations;
    division = cache$1.division;
    extraQS = cache$1.extraQS;
    baseURL = cache$1.baseURL;
    urlInstance = new UrlString(baseURL);
    if (null != division)
      urlInstance.appendPath(division);
    clonedQS = extend({}, urlInstance.removeReservedQS(extraQS), omitUndefined({
      partySize: partySize,
      date: date,
      time: time,
      brand: joinParam(brands),
      category: joinParam(l2Categories),
      category2: joinParam(l3Categories),
      category3: joinParam(l4Categories),
      interest: joinParam(interests),
      discount: joinParam(discounts),
      location: joinParam(locations),
      topcategory: topcategory
    }));
    if (null != paramList)
      pickAndExecute(queryParams, paramList, function (paramName, paramValue) {
        var joinedValue;
        joinedValue = joinParam(paramValue);
        if (null != joinedValue)
          return clonedQS[paramName] = joinedValue;
      });
    if (!isEmpty(clonedQS))
      urlInstance.appendQuery(clonedQS);
    return urlInstance.getUrl();
  };
  joinParam = function (array) {
    var compactedArray;
    compactedArray = compact(array);
    if (isEmpty(compactedArray))
      return;
    return compactedArray.sort().join(',');
  };
  omitUndefined = function (hash) {
    var filteredObj, key, value;
    filteredObj = {};
    for (key in hash) {
      value = hash[key];
      if ('undefined' !== typeof value && null != value)
        filteredObj[key] = value;
    }
    return filteredObj;
  };
}.call(this);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../param_list_helper":108,"../url":110}],112:[function(require,module,exports){
(function (global){
// Generated by CoffeeScript 2.0.0-beta7
void function () {
  var defaults, ParsedParams, pickAndExecute;
  defaults = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null).defaults;
  ParsedParams = require('../parsed_params').ParsedParams;
  pickAndExecute = require('../param_list_helper').pickAndExecute;
  module.exports = function (queryParams, paramList) {
    var brand, cache$, category, category2, category3, date, discount, interest, location, maxPrice, minPrice, parsedParamArgs, parsedParams, partySize, time, topcategory;
    cache$ = queryParams;
    partySize = cache$.partySize;
    date = cache$.date;
    time = cache$.time;
    category = cache$.category;
    category2 = cache$.category2;
    category3 = cache$.category3;
    interest = cache$.interest;
    discount = cache$.discount;
    minPrice = cache$.minPrice;
    maxPrice = cache$.maxPrice;
    brand = cache$.brand;
    location = cache$.location;
    topcategory = cache$.topcategory;
    parsedParamArgs = {
      partySize: partySize,
      date: date,
      time: time,
      l1Category: topcategory,
      l2Categories: (null != category ? category.split(',') : void 0) || [],
      l3Categories: (null != category2 ? category2.split(',') : void 0) || [],
      l4Categories: (null != category3 ? category3.split(',') : void 0) || [],
      interests: (null != interest ? interest.split(',') : void 0) || [],
      discounts: (null != discount ? discount.split(',') : void 0) || [],
      locations: (null != location ? location.split(',') : void 0) || [],
      minPrice: minPrice,
      maxPrice: maxPrice,
      brands: (null != brand ? brand.split(',') : void 0) || []
    };
    parsedParams = new ParsedParams(parsedParamArgs);
    if (null != paramList) {
      pickAndExecute(queryParams, paramList, function (paramName, paramValue) {
        return parsedParams[paramName] = (null != paramValue ? paramValue.split(',') : void 0) || [];
      });
      parsedParams.paramList = paramList;
    }
    return parsedParams;
  };
}.call(this);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../param_list_helper":108,"../parsed_params":109}],113:[function(require,module,exports){
(function (global){
// Generated by CoffeeScript 2.0.0-beta7
void function () {
  var addLeadingCategoryToUrl, aggregateRootPaths, cache$, cache$1, clone, constructQueryCategories, constructQueryParams, contains, defaults, each, filterMissingAndDuplicateCategories, groupBy, intersection, isEmpty, keys, last, parseCategories, pickAndExecute, removeVirtualPrefix, UrlString, without;
  cache$ = 'undefined' !== typeof _ && null != _ ? _ : (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
  each = cache$.each;
  clone = cache$.clone;
  groupBy = cache$.groupBy;
  intersection = cache$.intersection;
  contains = cache$.contains;
  without = cache$.without;
  isEmpty = cache$.isEmpty;
  defaults = cache$.defaults;
  last = cache$.last;
  keys = cache$.keys;
  UrlString = require('../url').UrlString;
  cache$1 = require('./helpers');
  aggregateRootPaths = cache$1.aggregateRootPaths;
  removeVirtualPrefix = cache$1.removeVirtualPrefix;
  pickAndExecute = require('../param_list_helper').pickAndExecute;
  module.exports = function (flatCategories, queryParams, paramList) {
    var baseURL, cache$2, cache$3, clonedQS, extraQS, leadingCategory, leveledCategories, mainLocation, rewriteVirtualCategoryUrls, secondaryLocations, selectedBrands, selectedCategories, selectedInterests, urlInstance;
    cache$2 = queryParams;
    mainLocation = cache$2.mainLocation;
    secondaryLocations = cache$2.secondaryLocations;
    selectedCategories = cache$2.selectedCategories;
    selectedInterests = cache$2.selectedInterests;
    selectedBrands = cache$2.selectedBrands;
    baseURL = cache$2.baseURL;
    extraQS = cache$2.extraQS;
    rewriteVirtualCategoryUrls = cache$2.rewriteVirtualCategoryUrls;
    urlInstance = new UrlString(baseURL);
    clonedQS = clone(null != extraQS ? extraQS : {});
    clonedQS = urlInstance.removeReservedQS(clonedQS);
    selectedCategories = filterMissingAndDuplicateCategories(flatCategories, selectedCategories);
    cache$3 = parseCategories(flatCategories, selectedCategories);
    leadingCategory = cache$3.leadingCategory;
    leveledCategories = cache$3.leveledCategories;
    if (!(null != leadingCategory) && baseURL === '/goods')
      leadingCategory = 'all';
    if (null != mainLocation)
      urlInstance.appendPath(mainLocation);
    constructQueryParams('location', urlInstance, secondaryLocations, clonedQS, true);
    if (null != leadingCategory)
      addLeadingCategoryToUrl(leadingCategory, rewriteVirtualCategoryUrls, urlInstance);
    constructQueryCategories('category', leveledCategories['2'], leadingCategory, clonedQS);
    constructQueryCategories('category2', leveledCategories['3'], leadingCategory, clonedQS);
    constructQueryCategories('category3', leveledCategories['4'], leadingCategory, clonedQS);
    constructQueryParams('interest', urlInstance, selectedInterests, clonedQS);
    constructQueryParams('brand', urlInstance, selectedBrands, clonedQS);
    if (null != paramList)
      pickAndExecute(queryParams, paramList, function (paramName, paramValue) {
        return constructQueryParams(paramName, urlInstance, paramValue, clonedQS);
      });
    if (!isEmpty(clonedQS))
      urlInstance.appendQuery(clonedQS);
    return urlInstance.getUrl();
  };
  addLeadingCategoryToUrl = function (leadingCategory, rewriteVirtualCategoryUrls, urlInstance) {
    var categoryPermalink;
    categoryPermalink = leadingCategory;
    if (rewriteVirtualCategoryUrls)
      categoryPermalink = removeVirtualPrefix(leadingCategory);
    return urlInstance.appendPath(categoryPermalink);
  };
  constructQueryCategories = function (queryParam, selectedCategories, leadingCategory, clonedQS) {
    var strippedLeading;
    strippedLeading = without(selectedCategories, leadingCategory).sort(function (a, b) {
      return b <= a;
    });
    if ((null != strippedLeading ? strippedLeading.length : void 0) > 0)
      return clonedQS[queryParam] = strippedLeading.join(',');
  };
  constructQueryParams = function (queryParam, urlInstance, selectedItems, clonedQS, shouldAppend) {
    if (null == shouldAppend)
      shouldAppend = false;
    if (isEmpty(selectedItems))
      return;
    if (shouldAppend && selectedItems.length === 1) {
      return urlInstance.appendPath(selectedItems[0]);
    } else {
      return clonedQS[queryParam] = selectedItems.sort(function (a, b) {
        return b <= a;
      }).join(',');
    }
  };
  parseCategories = function (flatCategories, selectedCategories) {
    var groupedCategories, leadingCategory, leadingRoot;
    leadingCategory = void 0;
    leadingRoot = false;
    groupedCategories = groupBy(selectedCategories, function (selectedCategory) {
      return null != flatCategories[selectedCategory] ? flatCategories[selectedCategory].level : void 0;
    });
    defaults(groupedCategories, {
      2: [],
      3: [],
      4: []
    });
    each(selectedCategories, function (selectedCategory) {
      var categoryInfo, intersectedPaths, possibleLeadingCategory;
      categoryInfo = flatCategories[selectedCategory];
      if (!(null != categoryInfo) || leadingRoot)
        return;
      if (!(null != leadingCategory)) {
        leadingCategory = categoryInfo;
        return;
      }
      intersectedPaths = intersection(leadingCategory.rootPath, categoryInfo.rootPath);
      if (intersectedPaths.length > 0) {
        possibleLeadingCategory = flatCategories[last(intersectedPaths)];
        if (possibleLeadingCategory.level === 1)
          return;
        return leadingCategory = possibleLeadingCategory;
      } else if (!contains(categoryInfo.rootPath, leadingCategory.id)) {
        leadingRoot = true;
        return leadingCategory = void 0;
      }
    });
    return {
      leadingCategory: null != leadingCategory ? leadingCategory.id : void 0,
      leveledCategories: groupedCategories
    };
  };
  filterMissingAndDuplicateCategories = function (flatCategories, selectedCategories) {
    var filteredCategories, rootPaths;
    filteredCategories = {};
    rootPaths = aggregateRootPaths(flatCategories, selectedCategories);
    each(selectedCategories, function (selectedCategory) {
      if (!(null != flatCategories[selectedCategory]))
        return;
      if (null != rootPaths[selectedCategory])
        return;
      if (null != filteredCategories[selectedCategory])
        return;
      return filteredCategories[selectedCategory] = selectedCategory;
    });
    return keys(filteredCategories);
  };
}.call(this);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../param_list_helper":108,"../url":110,"./helpers":114}],114:[function(require,module,exports){
(function (global){
// Generated by CoffeeScript 2.0.0-beta7
void function () {
  var cache$, extend, indexArray, initial, object, reduce, VIRTUAL_CATEGORY_PREFIX_REGEX;
  cache$ = 'undefined' !== typeof _ && null != _ ? _ : (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
  extend = cache$.extend;
  initial = cache$.initial;
  object = cache$.object;
  reduce = cache$.reduce;
  VIRTUAL_CATEGORY_PREFIX_REGEX = /^(v[0-9]?-)/gi;
  indexArray = function (array) {
    return object(array, array);
  };
  module.exports = {
    aggregateRootPaths: function (flatCategories, selectedCategories) {
      return reduce(selectedCategories, function (allPaths, selectedCategory) {
        var parsedCategory;
        parsedCategory = flatCategories[selectedCategory];
        if (!(null != parsedCategory))
          return allPaths;
        return extend(allPaths, indexArray(initial(parsedCategory.rootPath)));
      }, {});
    },
    removeVirtualPrefix: function (categoryId) {
      return categoryId.replace(VIRTUAL_CATEGORY_PREFIX_REGEX, '');
    }
  };
}.call(this);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],115:[function(require,module,exports){
(function (global){
// Generated by CoffeeScript 2.0.0-beta7
void function () {
  var _, aggregateRootPaths, anyCategoryChildSelected, fetchImplicitL2, isCategory, isInterest, ParsedParams, parsePathPortion, pickAndExecute;
  _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
  ParsedParams = require('../parsed_params').ParsedParams;
  aggregateRootPaths = require('./helpers').aggregateRootPaths;
  pickAndExecute = require('../param_list_helper').pickAndExecute;
  module.exports = function (flatInterests, flatCategories, splitPath, queryParams, paramList) {
    var brand, cache$, category, category2, category3, discount, implicitL2Category, interest, location, maxPrice, minPrice, parsedParamArgs, parsedParams, rootPaths;
    cache$ = queryParams;
    category = cache$.category;
    category2 = cache$.category2;
    category3 = cache$.category3;
    interest = cache$.interest;
    discount = cache$.discount;
    location = cache$.location;
    minPrice = cache$.minPrice;
    maxPrice = cache$.maxPrice;
    brand = cache$.brand;
    parsedParamArgs = {
      l1Category: void 0,
      l2Categories: (null != category ? category.split(',') : void 0) || [],
      l3Categories: (null != category2 ? category2.split(',') : void 0) || [],
      l4Categories: (null != category3 ? category3.split(',') : void 0) || [],
      interests: (null != interest ? interest.split(',') : void 0) || [],
      discounts: (null != discount ? discount.split(',') : void 0) || [],
      locations: (null != location ? location.split(',') : void 0) || [],
      mainLocation: void 0,
      minPrice: minPrice,
      maxPrice: maxPrice,
      brands: (null != brand ? brand.split(',') : void 0) || []
    };
    parsedParams = new ParsedParams(parsedParamArgs);
    if (null != paramList) {
      pickAndExecute(queryParams, paramList, function (paramName, paramValue) {
        return parsedParams[paramName] = (null != paramValue ? paramValue.split(',') : void 0) || [];
      });
      parsedParams.paramList = paramList;
    }
    rootPaths = aggregateRootPaths(flatCategories, _.union(parsedParams.l3Categories, parsedParams.l4Categories));
    _.each(splitPath, function (pathPortion) {
      return parsePathPortion(flatInterests, flatCategories, pathPortion, parsedParams, rootPaths);
    });
    implicitL2Category = fetchImplicitL2(flatCategories, parsedParams);
    if (implicitL2Category)
      parsedParams.applyImplicitCategory2(implicitL2Category);
    return parsedParams;
  };
  parsePathPortion = function (flatInterests, flatCategories, pathPortion, parsedParams, rootPaths) {
    if (isCategory(flatCategories, pathPortion) && anyCategoryChildSelected(rootPaths, pathPortion))
      return;
    if (pathPortion.indexOf('--') >= 0) {
      return _.each(pathPortion.split('--'), function (splitDashedPath) {
        return parsePathPortion(flatInterests, flatCategories, splitDashedPath, parsedParams, rootPaths);
      });
    } else if (isInterest(flatInterests, pathPortion)) {
      return parsedParams.interests.push(pathPortion);
    } else if (isCategory(flatCategories, pathPortion)) {
      switch (flatCategories[pathPortion].level) {
      case 1:
        return parsedParams.l1Category = pathPortion;
      case 2:
        return parsedParams.l2Categories.push(pathPortion);
      case 3:
        return parsedParams.l3Categories.push(pathPortion);
      case 4:
        return parsedParams.l4Categories.push(pathPortion);
      }
    } else if (!parsedParams.mainLocation) {
      return parsedParams.mainLocation = pathPortion;
    } else {
      return parsedParams.locations.push(pathPortion);
    }
  };
  fetchImplicitL2 = function (flatCategories, parsedParams) {
    var l2Keys, l2Matches;
    if (parsedParams.anyL2Categories())
      return parsedParams.l2Categories[0];
    l2Matches = {};
    _.each(_.union(parsedParams.l3Categories, parsedParams.l4Categories), function (indexedCategory) {
      var possibleL2Match;
      if (!(possibleL2Match = null != flatCategories[indexedCategory] && null != flatCategories[indexedCategory].rootPath ? flatCategories[indexedCategory].rootPath[1] : void 0))
        return;
      return l2Matches[possibleL2Match] = true;
    });
    l2Keys = _.keys(l2Matches);
    if (l2Keys.length === 1) {
      return l2Keys[0];
    } else {
      return void 0;
    }
  };
  isInterest = function (flatInterests, item) {
    return null != flatInterests[item];
  };
  isCategory = function (flatCategories, item) {
    return null != flatCategories[item];
  };
  anyCategoryChildSelected = function (rootPaths, possibleCategory) {
    return null != rootPaths[possibleCategory];
  };
}.call(this);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../param_list_helper":108,"../parsed_params":109,"./helpers":114}],116:[function(require,module,exports){
module.exports = require('./lib');

},{"./lib":117}],117:[function(require,module,exports){
// Load modules

var Stringify = require('./stringify');
var Parse = require('./parse');


// Declare internals

var internals = {};


module.exports = {
    stringify: Stringify,
    parse: Parse
};

},{"./parse":118,"./stringify":119}],118:[function(require,module,exports){
// Load modules

var Utils = require('./utils');


// Declare internals

var internals = {
    depth: 5,
    arrayLimit: 20,
    parametersLimit: 1000
};


internals.parseValues = function (str) {

    var obj = {};
    var parts = str.split('&').slice(0, internals.parametersLimit);

    for (var i = 0, il = parts.length; i < il; ++i) {
        var part = parts[i];
        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;

        if (pos === -1) {
            obj[Utils.decode(part)] = '';
        }
        else {
            var key = Utils.decode(part.slice(0, pos));
            var val = Utils.decode(part.slice(pos + 1));

            if (!obj[key]) {
                obj[key] = val;
            }
            else {
                obj[key] = [].concat(obj[key]).concat(val);
            }
        }
    }

    return obj;
};


internals.parseObject = function (chain, val) {

    if (!chain.length) {
        return val;
    }

    var root = chain.shift();

    var obj = {};
    if (root === '[]') {
        obj = [];
        obj = obj.concat(internals.parseObject(chain, val));
    }
    else {
        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
        var index = parseInt(cleanRoot, 10);
        if (!isNaN(index) &&
            root !== cleanRoot &&
            index <= internals.arrayLimit) {

            obj = [];
            obj[index] = internals.parseObject(chain, val);
        }
        else {
            obj[cleanRoot] = internals.parseObject(chain, val);
        }
    }

    return obj;
};


internals.parseKeys = function (key, val, depth) {

    if (!key) {
        return;
    }

    depth = typeof depth === 'undefined' ? internals.depth : depth;

    // The regex chunks

    var parent = /^([^\[\]]*)/;
    var child = /(\[[^\[\]]*\])/g;

    // Get the parent

    var segment = parent.exec(key);

    // Don't allow them to overwrite object prototype properties

    if (Object.prototype.hasOwnProperty(segment[1])) {
        return;
    }

    // Stash the parent if it exists

    var keys = [];
    if (segment[1]) {
        keys.push(segment[1]);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < depth) {

        ++i;
        if (!Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {
            keys.push(segment[1]);
        }
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return internals.parseObject(keys, val);
};


module.exports = function (str, depth) {

    if (str === '' ||
        str === null ||
        typeof str === 'undefined') {

        return {};
    }

    var tempObj = typeof str === 'string' ? internals.parseValues(str) : Utils.clone(str);
    var obj = {};

    // Iterate over the keys and setup the new object

    for (var key in tempObj) {
        if (tempObj.hasOwnProperty(key)) {
            var newObj = internals.parseKeys(key, tempObj[key], depth);
            obj = Utils.merge(obj, newObj);
        }
    }

    return Utils.compact(obj);
};



},{"./utils":120}],119:[function(require,module,exports){
(function (Buffer){
// Load modules


// Declare internals

var internals = {};


internals.stringify = function (obj, prefix) {

    if (Buffer.isBuffer(obj)) {
        obj = obj.toString();
    }
    else if (obj instanceof Date) {
        obj = obj.toISOString();
    }
    else if (obj === null) {
        obj = '';
    }

    if (typeof obj === 'string' ||
        typeof obj === 'number' ||
        typeof obj === 'boolean') {

        return [encodeURIComponent(prefix) + '=' + encodeURIComponent(obj)];
    }

    var values = [];

    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']'));
        }
    }

    return values;
};


module.exports = function (obj) {

    var keys = [];

    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys = keys.concat(internals.stringify(obj[key], key));
        }
    }

    return keys.join('&');
};

}).call(this,{"isBuffer":require("../../is-buffer/index.js")})

},{"../../is-buffer/index.js":104}],120:[function(require,module,exports){
(function (Buffer){
// Load modules


// Declare internals

var internals = {};


exports.arrayToObject = function (source) {

    var obj = {};
    for (var i = 0, il = source.length; i < il; ++i) {
        if (source[i] !== undefined &&
            source[i] !== null) {

            obj[i] = source[i];
        }
    }

    return obj;
};


exports.clone = function (source) {

    if (typeof source !== 'object' ||
        source === null) {

        return source;
    }

    if (Buffer.isBuffer(source)) {
        return source.toString();
    }

    var obj = Array.isArray(source) ? [] : {};
    for (var i in source) {
        if (source.hasOwnProperty(i)) {
            obj[i] = exports.clone(source[i]);
        }
    }

    return obj;
};


exports.merge = function (target, source) {

    if (!source) {
        return target;
    }

    var obj = exports.clone(target);

    if (Array.isArray(source)) {
        for (var i = 0, il = source.length; i < il; ++i) {
            if (source[i] !== undefined) {
                obj[i] = source[i];
            }
        }

        return obj;
    }

    if (Array.isArray(obj)) {
        obj = exports.arrayToObject(obj);
    }

    var keys = Object.keys(source);
    for (var k = 0, kl = keys.length; k < kl; ++k) {
        var key = keys[k];
        var value = source[key];

        if (value &&
            typeof value === 'object') {

            if (!obj[key]) {
                obj[key] = exports.clone(value);
            }
            else {
                obj[key] = exports.merge(obj[key], value);
            }
        }
        else {
            obj[key] = value;
        }
    }

    return obj;
};


exports.decode = function (str) {

    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};


exports.compact = function (obj) {

    if (typeof obj !== 'object') {
        return obj;
    }

    var compacted = {};

    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (Array.isArray(obj[key])) {
                compacted[key] = [];

                for (var i = 0, l = obj[key].length; i < l; i++) {
                    if (obj[key].hasOwnProperty(i) &&
                        obj[key][i] !== null) {

                        compacted[key].push(obj[key][i]);
                    }
                }
            }
            else {
                compacted[key] = exports.compact(obj[key]);
            }
        }
    }

    return compacted;
};

}).call(this,{"isBuffer":require("../../is-buffer/index.js")})

},{"../../is-buffer/index.js":104}]},{},[4])

